var Sd = Object.defineProperty;
var Id = (e, n, r) => n in e ? Sd(e, n, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[n] = r;
var xt = (e, n, r) => Id(e, typeof n != "symbol" ? n + "" : n, r);
import yt, { useContext as Ko, useMemo as qt, useRef as we, createElement as $d, createContext as Ed, useEffect as kd, useLayoutEffect as Nd, useCallback as Rn, useDebugValue as Od, useState as Qe } from "react";
import { r as Td, p as W, T as le } from "./twinklResourceTypes.data-nGBA1g_Q.js";
import { jsx as wd } from "react/jsx-runtime";
var Mt = { exports: {} }, zn = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lo;
function Ad() {
  if (lo) return zn;
  lo = 1;
  var e = yt;
  function n(c, p) {
    return c === p && (c !== 0 || 1 / c === 1 / p) || c !== c && p !== p;
  }
  var r = typeof Object.is == "function" ? Object.is : n, i = e.useState, t = e.useEffect, o = e.useLayoutEffect, a = e.useDebugValue;
  function u(c, p) {
    var _ = p(), h = i({ inst: { value: _, getSnapshot: p } }), $ = h[0].inst, v = h[1];
    return o(
      function() {
        $.value = _, $.getSnapshot = p, s($) && v({ inst: $ });
      },
      [c, _, p]
    ), t(
      function() {
        return s($) && v({ inst: $ }), c(function() {
          s($) && v({ inst: $ });
        });
      },
      [c]
    ), a(_), _;
  }
  function s(c) {
    var p = c.getSnapshot;
    c = c.value;
    try {
      var _ = p();
      return !r(c, _);
    } catch {
      return !0;
    }
  }
  function l(c, p) {
    return p();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : u;
  return zn.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : f, zn;
}
var Cn = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var so;
function Ud() {
  return so || (so = 1, process.env.NODE_ENV !== "production" && function() {
    function e(_, h) {
      return _ === h && (_ !== 0 || 1 / _ === 1 / h) || _ !== _ && h !== h;
    }
    function n(_, h) {
      f || t.startTransition === void 0 || (f = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var $ = h();
      if (!c) {
        var v = h();
        o($, v) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), c = !0);
      }
      v = a({
        inst: { value: $, getSnapshot: h }
      });
      var m = v[0].inst, g = v[1];
      return s(
        function() {
          m.value = $, m.getSnapshot = h, r(m) && g({ inst: m });
        },
        [_, $, h]
      ), u(
        function() {
          return r(m) && g({ inst: m }), _(function() {
            r(m) && g({ inst: m });
          });
        },
        [_]
      ), l($), $;
    }
    function r(_) {
      var h = _.getSnapshot;
      _ = _.value;
      try {
        var $ = h();
        return !o(_, $);
      } catch {
        return !0;
      }
    }
    function i(_, h) {
      return h();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = yt, o = typeof Object.is == "function" ? Object.is : e, a = t.useState, u = t.useEffect, s = t.useLayoutEffect, l = t.useDebugValue, f = !1, c = !1, p = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? i : n;
    Cn.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : p, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Cn;
}
var co;
function Pd() {
  return co || (co = 1, process.env.NODE_ENV === "production" ? Mt.exports = Ad() : Mt.exports = Ud()), Mt.exports;
}
var mo = Pd();
const Wo = 0, Jo = 1, qo = 2, go = 3;
var fo = Object.prototype.hasOwnProperty;
function Hn(e, n) {
  var r, i;
  if (e === n) return !0;
  if (e && n && (r = e.constructor) === n.constructor) {
    if (r === Date) return e.getTime() === n.getTime();
    if (r === RegExp) return e.toString() === n.toString();
    if (r === Array) {
      if ((i = e.length) === n.length)
        for (; i-- && Hn(e[i], n[i]); ) ;
      return i === -1;
    }
    if (!r || typeof e == "object") {
      i = 0;
      for (r in e)
        if (fo.call(e, r) && ++i && !fo.call(n, r) || !(r in n) || !Hn(e[r], n[r])) return !1;
      return Object.keys(n).length === i;
    }
  }
  return e !== e && n !== n;
}
const $e = /* @__PURE__ */ new WeakMap(), Ee = () => {
}, V = (
  /*#__NOINLINE__*/
  Ee()
), Xt = Object, P = (e) => e === V, ge = (e) => typeof e == "function", Ne = (e, n) => ({
  ...e,
  ...n
}), Xo = (e) => ge(e.then), jn = {}, Zt = {}, ar = "undefined", St = typeof window != ar, Bn = typeof document != ar, Dd = St && "Deno" in window, Rd = () => St && typeof window.requestAnimationFrame != ar, Qo = (e, n) => {
  const r = $e.get(e);
  return [
    // Getter
    () => !P(n) && e.get(n) || jn,
    // Setter
    (i) => {
      if (!P(n)) {
        const t = e.get(n);
        n in Zt || (Zt[n] = t), r[5](n, Ne(t, i), t || jn);
      }
    },
    // Subscriber
    r[6],
    // Get server cache snapshot
    () => !P(n) && n in Zt ? Zt[n] : !P(n) && e.get(n) || jn
  ];
};
let Vn = !0;
const zd = () => Vn, [Yn, Kn] = St && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  Ee,
  Ee
], Cd = () => {
  const e = Bn && document.visibilityState;
  return P(e) || e !== "hidden";
}, jd = (e) => (Bn && document.addEventListener("visibilitychange", e), Yn("focus", e), () => {
  Bn && document.removeEventListener("visibilitychange", e), Kn("focus", e);
}), Ld = (e) => {
  const n = () => {
    Vn = !0, e();
  }, r = () => {
    Vn = !1;
  };
  return Yn("online", n), Yn("offline", r), () => {
    Kn("online", n), Kn("offline", r);
  };
}, xd = {
  isOnline: zd,
  isVisible: Cd
}, Md = {
  initFocus: jd,
  initReconnect: Ld
}, po = !yt.useId, qe = !St || Dd, Zd = (e) => Rd() ? window.requestAnimationFrame(e) : setTimeout(e, 1), Kt = qe ? kd : Nd, Ln = typeof navigator < "u" && navigator.connection, vo = !qe && Ln && ([
  "slow-2g",
  "2g"
].includes(Ln.effectiveType) || Ln.saveData), Gt = /* @__PURE__ */ new WeakMap(), Gd = (e) => Xt.prototype.toString.call(e), xn = (e, n) => e === `[object ${n}]`;
let Fd = 0;
const Wn = (e) => {
  const n = typeof e, r = Gd(e), i = xn(r, "Date"), t = xn(r, "RegExp"), o = xn(r, "Object");
  let a, u;
  if (Xt(e) === e && !i && !t) {
    if (a = Gt.get(e), a) return a;
    if (a = ++Fd + "~", Gt.set(e, a), Array.isArray(e)) {
      for (a = "@", u = 0; u < e.length; u++)
        a += Wn(e[u]) + ",";
      Gt.set(e, a);
    }
    if (o) {
      a = "#";
      const s = Xt.keys(e).sort();
      for (; !P(u = s.pop()); )
        P(e[u]) || (a += u + ":" + Wn(e[u]) + ",");
      Gt.set(e, a);
    }
  } else
    a = i ? e.toJSON() : n == "symbol" ? e.toString() : n == "string" ? JSON.stringify(e) : "" + e;
  return a;
}, ur = (e) => {
  if (ge(e))
    try {
      e = e();
    } catch {
      e = "";
    }
  const n = e;
  return e = typeof e == "string" ? e : (Array.isArray(e) ? e.length : e) ? Wn(e) : "", [
    e,
    n
  ];
};
let Hd = 0;
const Jn = () => ++Hd;
async function ea(...e) {
  const [n, r, i, t] = e, o = Ne({
    populateCache: !0,
    throwOnError: !0
  }, typeof t == "boolean" ? {
    revalidate: t
  } : t || {});
  let a = o.populateCache;
  const u = o.rollbackOnError;
  let s = o.optimisticData;
  const l = (p) => typeof u == "function" ? u(p) : u !== !1, f = o.throwOnError;
  if (ge(r)) {
    const p = r, _ = [], h = n.keys();
    for (const $ of h)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test($) && p(n.get($)._k) && _.push($);
    return Promise.all(_.map(c));
  }
  return c(r);
  async function c(p) {
    const [_] = ur(p);
    if (!_) return;
    const [h, $] = Qo(n, _), [v, m, g, S] = $e.get(n), k = () => {
      const ce = v[_];
      return (ge(o.revalidate) ? o.revalidate(h().data, p) : o.revalidate !== !1) && (delete g[_], delete S[_], ce && ce[0]) ? ce[0](qo).then(() => h().data) : h().data;
    };
    if (e.length < 3)
      return k();
    let E = i, A, z = !1;
    const te = Jn();
    m[_] = [
      te,
      0
    ];
    const j = !P(s), Be = h(), ye = Be.data, Ve = Be._c, ze = P(Ve) ? ye : Ve;
    if (j && (s = ge(s) ? s(ze, ye) : s, $({
      data: s,
      _c: ze
    })), ge(E))
      try {
        E = E(ze);
      } catch (ce) {
        A = ce, z = !0;
      }
    if (E && Xo(E))
      if (E = await E.catch((ce) => {
        A = ce, z = !0;
      }), te !== m[_][0]) {
        if (z) throw A;
        return E;
      } else z && j && l(A) && (a = !0, $({
        data: ze,
        _c: V
      }));
    if (a && !z)
      if (ge(a)) {
        const ce = a(E, ze);
        $({
          data: ce,
          error: V,
          _c: V
        });
      } else
        $({
          data: E,
          error: V,
          _c: V
        });
    if (m[_][1] = Jn(), Promise.resolve(k()).then(() => {
      $({
        _c: V
      });
    }), z) {
      if (f) throw A;
      return;
    }
    return E;
  }
}
const ho = (e, n) => {
  for (const r in e)
    e[r][0] && e[r][0](n);
}, ta = (e, n) => {
  if (!$e.has(e)) {
    const r = Ne(Md, n), i = /* @__PURE__ */ Object.create(null), t = ea.bind(V, e);
    let o = Ee;
    const a = /* @__PURE__ */ Object.create(null), u = (f, c) => {
      const p = a[f] || [];
      return a[f] = p, p.push(c), () => p.splice(p.indexOf(c), 1);
    }, s = (f, c, p) => {
      e.set(f, c);
      const _ = a[f];
      if (_)
        for (const h of _)
          h(c, p);
    }, l = () => {
      if (!$e.has(e) && ($e.set(e, [
        i,
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        t,
        s,
        u
      ]), !qe)) {
        const f = r.initFocus(setTimeout.bind(V, ho.bind(V, i, Wo))), c = r.initReconnect(setTimeout.bind(V, ho.bind(V, i, Jo)));
        o = () => {
          f && f(), c && c(), $e.delete(e);
        };
      }
    };
    return l(), [
      e,
      t,
      l,
      o
    ];
  }
  return [
    e,
    $e.get(e)[4]
  ];
}, Bd = (e, n, r, i, t) => {
  const o = r.errorRetryCount, a = t.retryCount, u = ~~((Math.random() + 0.5) * (1 << (a < 8 ? a : 8))) * r.errorRetryInterval;
  !P(o) && a > o || setTimeout(i, u, t);
}, Vd = Hn, [lr, Yd] = ta(/* @__PURE__ */ new Map()), na = Ne(
  {
    // events
    onLoadingSlow: Ee,
    onSuccess: Ee,
    onError: Ee,
    onErrorRetry: Bd,
    onDiscarded: Ee,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: vo ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: vo ? 5e3 : 3e3,
    // providers
    compare: Vd,
    isPaused: () => !1,
    cache: lr,
    mutate: Yd,
    fallback: {}
  },
  // use web preset by default
  xd
), ra = (e, n) => {
  const r = Ne(e, n);
  if (n) {
    const { use: i, fallback: t } = e, { use: o, fallback: a } = n;
    i && o && (r.use = i.concat(o)), t && a && (r.fallback = Ne(t, a));
  }
  return r;
}, qn = Ed({}), Kd = (e) => {
  const { value: n } = e, r = Ko(qn), i = ge(n), t = qt(() => i ? n(r) : n, [
    i,
    r,
    n
  ]), o = qt(() => i ? t : ra(r, t), [
    i,
    r,
    t
  ]), a = t && t.provider, u = we(V);
  a && !u.current && (u.current = ta(a(o.cache || lr), t));
  const s = u.current;
  return s && (o.cache = s[0], o.mutate = s[1]), Kt(() => {
    if (s)
      return s[2] && s[2](), s[3];
  }, []), $d(qn.Provider, Ne(e, {
    value: o
  }));
}, Wd = "$inf$", ia = St && window.__SWR_DEVTOOLS_USE__, Jd = ia ? window.__SWR_DEVTOOLS_USE__ : [], qd = () => {
  ia && (window.__SWR_DEVTOOLS_REACT__ = yt);
}, oa = (e) => ge(e[1]) ? [
  e[0],
  e[1],
  e[2] || {}
] : [
  e[0],
  null,
  (e[1] === null ? e[2] : e[1]) || {}
], cn = () => {
  const e = Ko(qn);
  return qt(() => Ne(na, e), [
    e
  ]);
}, Xd = (e) => (n, r, i) => e(n, r && ((...o) => {
  const [a] = ur(n), [, , , u] = $e.get(lr);
  if (a.startsWith(Wd))
    return r(...o);
  const s = u[a];
  return P(s) ? r(...o) : (delete u[a], s);
}), i), Qd = Jd.concat(Xd), em = (e) => function(...r) {
  const i = cn(), [t, o, a] = oa(r), u = ra(i, a);
  let s = e;
  const { use: l } = u, f = (l || []).concat(Qd);
  for (let c = f.length; c--; )
    s = f[c](s);
  return s(t, o || u.fetcher || null, u);
}, tm = (e, n, r) => {
  const i = n[e] || (n[e] = []);
  return i.push(r), () => {
    const t = i.indexOf(r);
    t >= 0 && (i[t] = i[i.length - 1], i.pop());
  };
}, nm = (e, n) => (...r) => {
  const [i, t, o] = oa(r), a = (o.use || []).concat(n);
  return e(i, t, {
    ...o,
    use: a
  });
};
qd();
const Mn = yt.use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((e) => {
  switch (e.status) {
    case "pending":
      throw e;
    case "fulfilled":
      return e.value;
    case "rejected":
      throw e.reason;
    default:
      throw e.status = "pending", e.then((n) => {
        e.status = "fulfilled", e.value = n;
      }, (n) => {
        e.status = "rejected", e.reason = n;
      }), e;
  }
}), Zn = {
  dedupe: !0
}, bo = Promise.resolve(V), rm = (e, n, r) => {
  const { cache: i, compare: t, suspense: o, fallbackData: a, revalidateOnMount: u, revalidateIfStale: s, refreshInterval: l, refreshWhenHidden: f, refreshWhenOffline: c, keepPreviousData: p, strictServerPrefetchWarning: _ } = r, [h, $, v, m] = $e.get(i), [g, S] = ur(e), k = we(!1), E = we(!1), A = we(g), z = we(n), te = we(r), j = () => te.current, Be = () => j().isVisible() && j().isOnline(), [ye, Ve, ze, ce] = Qo(i, g), Ye = we({}).current, Ct = P(a) ? P(r.fallback) ? V : r.fallback[g] : a, Qi = (x, Z) => {
    for (const F in Ye) {
      const G = F;
      if (G === "data") {
        if (!t(x[G], Z[G]) && (!P(x[G]) || !t(Lt, Z[G])))
          return !1;
      } else if (Z[G] !== x[G])
        return !1;
    }
    return !0;
  }, eo = qt(() => {
    const x = !g || !n ? !1 : P(u) ? j().isPaused() || o ? !1 : s !== !1 : u, Z = (J) => {
      const Se = Ne(J);
      return delete Se._k, x ? {
        isValidating: !0,
        isLoading: !0,
        ...Se
      } : Se;
    }, F = ye(), G = ce(), de = Z(F), Je = F === G ? de : Z(G);
    let B = de;
    return [
      () => {
        const J = Z(ye());
        return Qi(J, B) ? (B.data = J.data, B.isLoading = J.isLoading, B.isValidating = J.isValidating, B.error = J.error, B) : (B = J, J);
      },
      () => Je
    ];
  }, [
    i,
    g
  ]), Ke = mo.useSyncExternalStore(Rn(
    (x) => ze(g, (Z, F) => {
      Qi(F, Z) || x();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      i,
      g
    ]
  ), eo[0], eo[1]), to = !k.current, vd = h[g] && h[g].length > 0, We = Ke.data, Ce = P(We) ? Ct && Xo(Ct) ? Mn(Ct) : Ct : We, jt = Ke.error, Un = we(Ce), Lt = p ? P(We) ? P(Un.current) ? Ce : Un.current : We : Ce, je = g && P(Ce), hd = !qe && // eslint-disable-next-line react-hooks/rules-of-hooks
  mo.useSyncExternalStore(() => Ee, () => !1, () => !0);
  _ && hd && !o && je && console.warn(`Missing pre-initiated data for serialized key "${g}" during server-side rendering. Data fethcing should be initiated on the server and provided to SWR via fallback data. You can set "strictServerPrefetchWarning: false" to disable this warning.`);
  const no = vd && !P(jt) ? !1 : to && !P(u) ? u : j().isPaused() ? !1 : o ? P(Ce) ? !1 : s : P(Ce) || s, ro = !!(g && n && to && no), bd = P(Ke.isValidating) ? ro : Ke.isValidating, _d = P(Ke.isLoading) ? ro : Ke.isLoading, ct = Rn(
    async (x) => {
      const Z = z.current;
      if (!g || !Z || E.current || j().isPaused())
        return !1;
      let F, G, de = !0;
      const Je = x || {}, B = !v[g] || !Je.dedupe, J = () => po ? !E.current && g === A.current && k.current : g === A.current, Se = {
        isValidating: !1,
        isLoading: !1
      }, oo = () => {
        Ve(Se);
      }, ao = () => {
        const ue = v[g];
        ue && ue[1] === G && delete v[g];
      }, uo = {
        isValidating: !0
      };
      P(ye().data) && (uo.isLoading = !0);
      try {
        if (B && (Ve(uo), r.loadingTimeout && P(ye().data) && setTimeout(() => {
          de && J() && j().onLoadingSlow(g, r);
        }, r.loadingTimeout), v[g] = [
          Z(S),
          Jn()
        ]), [F, G] = v[g], F = await F, B && setTimeout(ao, r.dedupingInterval), !v[g] || v[g][1] !== G)
          return B && J() && j().onDiscarded(g), !1;
        Se.error = V;
        const ue = $[g];
        if (!P(ue) && // case 1
        (G <= ue[0] || // case 2
        G <= ue[1] || // case 3
        ue[1] === 0))
          return oo(), B && J() && j().onDiscarded(g), !1;
        const Ie = ye().data;
        Se.data = t(Ie, F) ? Ie : F, B && J() && j().onSuccess(F, g, r);
      } catch (ue) {
        ao();
        const Ie = j(), { shouldRetryOnError: Pn } = Ie;
        Ie.isPaused() || (Se.error = ue, B && J() && (Ie.onError(ue, g, Ie), (Pn === !0 || ge(Pn) && Pn(ue)) && (!j().revalidateOnFocus || !j().revalidateOnReconnect || Be()) && Ie.onErrorRetry(ue, g, Ie, (yd) => {
          const Dn = h[g];
          Dn && Dn[0] && Dn[0](go, yd);
        }, {
          retryCount: (Je.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return de = !1, oo(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      g,
      i
    ]
  ), io = Rn(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...x) => ea(i, A.current, ...x),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (Kt(() => {
    z.current = n, te.current = r, P(We) || (Un.current = We);
  }), Kt(() => {
    if (!g) return;
    const x = ct.bind(V, Zn);
    let Z = 0;
    j().revalidateOnFocus && (Z = Date.now() + j().focusThrottleInterval);
    const G = tm(g, h, (de, Je = {}) => {
      if (de == Wo) {
        const B = Date.now();
        j().revalidateOnFocus && B > Z && Be() && (Z = B + j().focusThrottleInterval, x());
      } else if (de == Jo)
        j().revalidateOnReconnect && Be() && x();
      else {
        if (de == qo)
          return ct();
        if (de == go)
          return ct(Je);
      }
    });
    return E.current = !1, A.current = g, k.current = !0, Ve({
      _k: S
    }), no && (v[g] || (P(Ce) || qe ? x() : Zd(x))), () => {
      E.current = !0, G();
    };
  }, [
    g
  ]), Kt(() => {
    let x;
    function Z() {
      const G = ge(l) ? l(ye().data) : l;
      G && x !== -1 && (x = setTimeout(F, G));
    }
    function F() {
      !ye().error && (f || j().isVisible()) && (c || j().isOnline()) ? ct(Zn).then(Z) : Z();
    }
    return Z(), () => {
      x && (clearTimeout(x), x = -1);
    };
  }, [
    l,
    f,
    c,
    g
  ]), Od(Lt), o) {
    if (!po && qe && je)
      throw new Error("Fallback data is required when using Suspense in SSR.");
    je && (z.current = n, te.current = r, E.current = !1);
    const x = m[g], Z = !P(x) && je ? io(x) : bo;
    if (Mn(Z), !P(jt) && je)
      throw jt;
    const F = je ? ct(Zn) : bo;
    !P(Lt) && je && (F.status = "fulfilled", F.value = !0), Mn(F);
  }
  return {
    mutate: io,
    get data() {
      return Ye.data = !0, Lt;
    },
    get error() {
      return Ye.error = !0, jt;
    },
    get isValidating() {
      return Ye.isValidating = !0, bd;
    },
    get isLoading() {
      return Ye.isLoading = !0, _d;
    }
  };
}, im = Xt.defineProperty(Kd, "defaultValue", {
  value: na
}), Pe = em(rm), aa = Object.freeze({
  status: "aborted"
});
function d(e, n, r) {
  function i(u, s) {
    if (u._zod || Object.defineProperty(u, "_zod", {
      value: {
        def: s,
        constr: a,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), u._zod.traits.has(e))
      return;
    u._zod.traits.add(e), n(u, s);
    const l = a.prototype, f = Object.keys(l);
    for (let c = 0; c < f.length; c++) {
      const p = f[c];
      p in u || (u[p] = l[p].bind(u));
    }
  }
  const t = (r == null ? void 0 : r.Parent) ?? Object;
  class o extends t {
  }
  Object.defineProperty(o, "name", { value: e });
  function a(u) {
    var s;
    const l = r != null && r.Parent ? new o() : this;
    i(l, u), (s = l._zod).deferred ?? (s.deferred = []);
    for (const f of l._zod.deferred)
      f();
    return l;
  }
  return Object.defineProperty(a, "init", { value: i }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (u) => {
      var s, l;
      return r != null && r.Parent && u instanceof r.Parent ? !0 : (l = (s = u == null ? void 0 : u._zod) == null ? void 0 : s.traits) == null ? void 0 : l.has(e);
    }
  }), Object.defineProperty(a, "name", { value: e }), a;
}
const ua = Symbol("zod_brand");
class xe extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class dn extends Error {
  constructor(n) {
    super(`Encountered unidirectional transform during encode: ${n}`), this.name = "ZodEncodeError";
  }
}
const Qt = {};
function ee(e) {
  return e && Object.assign(Qt, e), Qt;
}
function om(e) {
  return e;
}
function am(e) {
  return e;
}
function um(e) {
}
function lm(e) {
  throw new Error();
}
function sm(e) {
}
function sr(e) {
  const n = Object.values(e).filter((i) => typeof i == "number");
  return Object.entries(e).filter(([i, t]) => n.indexOf(+i) === -1).map(([i, t]) => t);
}
function I(e, n = "|") {
  return e.map((r) => N(r)).join(n);
}
function en(e, n) {
  return typeof n == "bigint" ? n.toString() : n;
}
function It(e) {
  return {
    get value() {
      {
        const n = e();
        return Object.defineProperty(this, "value", { value: n }), n;
      }
    }
  };
}
function He(e) {
  return e == null;
}
function mn(e) {
  const n = e.startsWith("^") ? 1 : 0, r = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(n, r);
}
function la(e, n) {
  const r = (e.toString().split(".")[1] || "").length, i = n.toString();
  let t = (i.split(".")[1] || "").length;
  if (t === 0 && /\d?e-\d?/.test(i)) {
    const s = i.match(/\d?e-(\d?)/);
    s != null && s[1] && (t = Number.parseInt(s[1]));
  }
  const o = r > t ? r : t, a = Number.parseInt(e.toFixed(o).replace(".", "")), u = Number.parseInt(n.toFixed(o).replace(".", ""));
  return a % u / 10 ** o;
}
const _o = Symbol("evaluating");
function U(e, n, r) {
  let i;
  Object.defineProperty(e, n, {
    get() {
      if (i !== _o)
        return i === void 0 && (i = _o, i = r()), i;
    },
    set(t) {
      Object.defineProperty(e, n, {
        value: t
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function cm(e) {
  return Object.create(Object.getPrototypeOf(e), Object.getOwnPropertyDescriptors(e));
}
function De(e, n, r) {
  Object.defineProperty(e, n, {
    value: r,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Te(...e) {
  const n = {};
  for (const r of e) {
    const i = Object.getOwnPropertyDescriptors(r);
    Object.assign(n, i);
  }
  return Object.defineProperties({}, n);
}
function dm(e) {
  return Te(e._zod.def);
}
function mm(e, n) {
  return n ? n.reduce((r, i) => r == null ? void 0 : r[i], e) : e;
}
function gm(e) {
  const n = Object.keys(e), r = n.map((i) => e[i]);
  return Promise.all(r).then((i) => {
    const t = {};
    for (let o = 0; o < n.length; o++)
      t[n[o]] = i[o];
    return t;
  });
}
function fm(e = 10) {
  const n = "abcdefghijklmnopqrstuvwxyz";
  let r = "";
  for (let i = 0; i < e; i++)
    r += n[Math.floor(Math.random() * n.length)];
  return r;
}
function Xn(e) {
  return JSON.stringify(e);
}
function sa(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const cr = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function et(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const ca = It(() => {
  var e;
  if (typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const n = Function;
    return new n(""), !0;
  } catch {
    return !1;
  }
});
function Ze(e) {
  if (et(e) === !1)
    return !1;
  const n = e.constructor;
  if (n === void 0 || typeof n != "function")
    return !0;
  const r = n.prototype;
  return !(et(r) === !1 || Object.prototype.hasOwnProperty.call(r, "isPrototypeOf") === !1);
}
function gn(e) {
  return Ze(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
function pm(e) {
  let n = 0;
  for (const r in e)
    Object.prototype.hasOwnProperty.call(e, r) && n++;
  return n;
}
const vm = (e) => {
  const n = typeof e;
  switch (n) {
    case "undefined":
      return "undefined";
    case "string":
      return "string";
    case "number":
      return Number.isNaN(e) ? "nan" : "number";
    case "boolean":
      return "boolean";
    case "function":
      return "function";
    case "bigint":
      return "bigint";
    case "symbol":
      return "symbol";
    case "object":
      return Array.isArray(e) ? "array" : e === null ? "null" : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? "promise" : typeof Map < "u" && e instanceof Map ? "map" : typeof Set < "u" && e instanceof Set ? "set" : typeof Date < "u" && e instanceof Date ? "date" : typeof File < "u" && e instanceof File ? "file" : "object";
    default:
      throw new Error(`Unknown data type: ${n}`);
  }
}, tn = /* @__PURE__ */ new Set(["string", "number", "symbol"]), da = /* @__PURE__ */ new Set(["string", "number", "bigint", "boolean", "symbol", "undefined"]);
function Oe(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function se(e, n, r) {
  const i = new e._zod.constr(n ?? e._zod.def);
  return (!n || r != null && r.parent) && (i._zod.parent = e), i;
}
function y(e) {
  const n = e;
  if (!n)
    return {};
  if (typeof n == "string")
    return { error: () => n };
  if ((n == null ? void 0 : n.message) !== void 0) {
    if ((n == null ? void 0 : n.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    n.error = n.message;
  }
  return delete n.message, typeof n.error == "string" ? { ...n, error: () => n.error } : n;
}
function hm(e) {
  let n;
  return new Proxy({}, {
    get(r, i, t) {
      return n ?? (n = e()), Reflect.get(n, i, t);
    },
    set(r, i, t, o) {
      return n ?? (n = e()), Reflect.set(n, i, t, o);
    },
    has(r, i) {
      return n ?? (n = e()), Reflect.has(n, i);
    },
    deleteProperty(r, i) {
      return n ?? (n = e()), Reflect.deleteProperty(n, i);
    },
    ownKeys(r) {
      return n ?? (n = e()), Reflect.ownKeys(n);
    },
    getOwnPropertyDescriptor(r, i) {
      return n ?? (n = e()), Reflect.getOwnPropertyDescriptor(n, i);
    },
    defineProperty(r, i, t) {
      return n ?? (n = e()), Reflect.defineProperty(n, i, t);
    }
  });
}
function N(e) {
  return typeof e == "bigint" ? e.toString() + "n" : typeof e == "string" ? `"${e}"` : `${e}`;
}
function ma(e) {
  return Object.keys(e).filter((n) => e[n]._zod.optin === "optional" && e[n]._zod.optout === "optional");
}
const ga = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
}, fa = {
  int64: [/* @__PURE__ */ BigInt("-9223372036854775808"), /* @__PURE__ */ BigInt("9223372036854775807")],
  uint64: [/* @__PURE__ */ BigInt(0), /* @__PURE__ */ BigInt("18446744073709551615")]
};
function pa(e, n) {
  const r = e._zod.def, i = Te(e._zod.def, {
    get shape() {
      const t = {};
      for (const o in n) {
        if (!(o in r.shape))
          throw new Error(`Unrecognized key: "${o}"`);
        n[o] && (t[o] = r.shape[o]);
      }
      return De(this, "shape", t), t;
    },
    checks: []
  });
  return se(e, i);
}
function va(e, n) {
  const r = e._zod.def, i = Te(e._zod.def, {
    get shape() {
      const t = { ...e._zod.def.shape };
      for (const o in n) {
        if (!(o in r.shape))
          throw new Error(`Unrecognized key: "${o}"`);
        n[o] && delete t[o];
      }
      return De(this, "shape", t), t;
    },
    checks: []
  });
  return se(e, i);
}
function ha(e, n) {
  if (!Ze(n))
    throw new Error("Invalid input to extend: expected a plain object");
  const r = e._zod.def.checks;
  if (r && r.length > 0)
    throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
  const t = Te(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...n };
      return De(this, "shape", o), o;
    },
    checks: []
  });
  return se(e, t);
}
function ba(e, n) {
  if (!Ze(n))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const r = {
    ...e._zod.def,
    get shape() {
      const i = { ...e._zod.def.shape, ...n };
      return De(this, "shape", i), i;
    },
    checks: e._zod.def.checks
  };
  return se(e, r);
}
function _a(e, n) {
  const r = Te(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape, ...n._zod.def.shape };
      return De(this, "shape", i), i;
    },
    get catchall() {
      return n._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return se(e, r);
}
function ya(e, n, r) {
  const i = Te(n._zod.def, {
    get shape() {
      const t = n._zod.def.shape, o = { ...t };
      if (r)
        for (const a in r) {
          if (!(a in t))
            throw new Error(`Unrecognized key: "${a}"`);
          r[a] && (o[a] = e ? new e({
            type: "optional",
            innerType: t[a]
          }) : t[a]);
        }
      else
        for (const a in t)
          o[a] = e ? new e({
            type: "optional",
            innerType: t[a]
          }) : t[a];
      return De(this, "shape", o), o;
    },
    checks: []
  });
  return se(n, i);
}
function Sa(e, n, r) {
  const i = Te(n._zod.def, {
    get shape() {
      const t = n._zod.def.shape, o = { ...t };
      if (r)
        for (const a in r) {
          if (!(a in o))
            throw new Error(`Unrecognized key: "${a}"`);
          r[a] && (o[a] = new e({
            type: "nonoptional",
            innerType: t[a]
          }));
        }
      else
        for (const a in t)
          o[a] = new e({
            type: "nonoptional",
            innerType: t[a]
          });
      return De(this, "shape", o), o;
    },
    checks: []
  });
  return se(n, i);
}
function Le(e, n = 0) {
  var r;
  if (e.aborted === !0)
    return !0;
  for (let i = n; i < e.issues.length; i++)
    if (((r = e.issues[i]) == null ? void 0 : r.continue) !== !0)
      return !0;
  return !1;
}
function pe(e, n) {
  return n.map((r) => {
    var i;
    return (i = r).path ?? (i.path = []), r.path.unshift(e), r;
  });
}
function mt(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function be(e, n, r) {
  var t, o, a, u, s, l;
  const i = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const f = mt((a = (o = (t = e.inst) == null ? void 0 : t._zod.def) == null ? void 0 : o.error) == null ? void 0 : a.call(o, e)) ?? mt((u = n == null ? void 0 : n.error) == null ? void 0 : u.call(n, e)) ?? mt((s = r.customError) == null ? void 0 : s.call(r, e)) ?? mt((l = r.localeError) == null ? void 0 : l.call(r, e)) ?? "Invalid input";
    i.message = f;
  }
  return delete i.inst, delete i.continue, n != null && n.reportInput || delete i.input, i;
}
function fn(e) {
  return e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof File ? "file" : "unknown";
}
function pn(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function tt(...e) {
  const [n, r, i] = e;
  return typeof n == "string" ? {
    message: n,
    code: "custom",
    input: r,
    inst: i
  } : { ...n };
}
function bm(e) {
  return Object.entries(e).filter(([n, r]) => Number.isNaN(Number.parseInt(n, 10))).map((n) => n[1]);
}
function Ia(e) {
  const n = atob(e), r = new Uint8Array(n.length);
  for (let i = 0; i < n.length; i++)
    r[i] = n.charCodeAt(i);
  return r;
}
function $a(e) {
  let n = "";
  for (let r = 0; r < e.length; r++)
    n += String.fromCharCode(e[r]);
  return btoa(n);
}
function _m(e) {
  const n = e.replace(/-/g, "+").replace(/_/g, "/"), r = "=".repeat((4 - n.length % 4) % 4);
  return Ia(n + r);
}
function ym(e) {
  return $a(e).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function Sm(e) {
  const n = e.replace(/^0x/, "");
  if (n.length % 2 !== 0)
    throw new Error("Invalid hex string length");
  const r = new Uint8Array(n.length / 2);
  for (let i = 0; i < n.length; i += 2)
    r[i / 2] = Number.parseInt(n.slice(i, i + 2), 16);
  return r;
}
function Im(e) {
  return Array.from(e).map((n) => n.toString(16).padStart(2, "0")).join("");
}
class $m {
  constructor(...n) {
  }
}
const Ea = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BIGINT_FORMAT_RANGES: fa,
  Class: $m,
  NUMBER_FORMAT_RANGES: ga,
  aborted: Le,
  allowsEval: ca,
  assert: sm,
  assertEqual: om,
  assertIs: um,
  assertNever: lm,
  assertNotEqual: am,
  assignProp: De,
  base64ToUint8Array: Ia,
  base64urlToUint8Array: _m,
  cached: It,
  captureStackTrace: cr,
  cleanEnum: bm,
  cleanRegex: mn,
  clone: se,
  cloneDef: dm,
  createTransparentProxy: hm,
  defineLazy: U,
  esc: Xn,
  escapeRegex: Oe,
  extend: ha,
  finalizeIssue: be,
  floatSafeRemainder: la,
  getElementAtPath: mm,
  getEnumValues: sr,
  getLengthableOrigin: pn,
  getParsedType: vm,
  getSizableOrigin: fn,
  hexToUint8Array: Sm,
  isObject: et,
  isPlainObject: Ze,
  issue: tt,
  joinValues: I,
  jsonStringifyReplacer: en,
  merge: _a,
  mergeDefs: Te,
  normalizeParams: y,
  nullish: He,
  numKeys: pm,
  objectClone: cm,
  omit: va,
  optionalKeys: ma,
  partial: ya,
  pick: pa,
  prefixIssues: pe,
  primitiveTypes: da,
  promiseAllObject: gm,
  propertyKeyTypes: tn,
  randomString: fm,
  required: Sa,
  safeExtend: ba,
  shallowClone: gn,
  slugify: sa,
  stringifyPrimitive: N,
  uint8ArrayToBase64: $a,
  uint8ArrayToBase64url: ym,
  uint8ArrayToHex: Im,
  unwrapMessage: mt
}, Symbol.toStringTag, { value: "Module" })), ka = (e, n) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: n,
    enumerable: !1
  }), e.message = JSON.stringify(n, en, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, dr = d("$ZodError", ka), oe = d("$ZodError", ka, { Parent: Error });
function mr(e, n = (r) => r.message) {
  const r = {}, i = [];
  for (const t of e.issues)
    t.path.length > 0 ? (r[t.path[0]] = r[t.path[0]] || [], r[t.path[0]].push(n(t))) : i.push(n(t));
  return { formErrors: i, fieldErrors: r };
}
function gr(e, n = (r) => r.message) {
  const r = { _errors: [] }, i = (t) => {
    for (const o of t.issues)
      if (o.code === "invalid_union" && o.errors.length)
        o.errors.map((a) => i({ issues: a }));
      else if (o.code === "invalid_key")
        i({ issues: o.issues });
      else if (o.code === "invalid_element")
        i({ issues: o.issues });
      else if (o.path.length === 0)
        r._errors.push(n(o));
      else {
        let a = r, u = 0;
        for (; u < o.path.length; ) {
          const s = o.path[u];
          u === o.path.length - 1 ? (a[s] = a[s] || { _errors: [] }, a[s]._errors.push(n(o))) : a[s] = a[s] || { _errors: [] }, a = a[s], u++;
        }
      }
  };
  return i(e), r;
}
function Na(e, n = (r) => r.message) {
  const r = { errors: [] }, i = (t, o = []) => {
    var a, u;
    for (const s of t.issues)
      if (s.code === "invalid_union" && s.errors.length)
        s.errors.map((l) => i({ issues: l }, s.path));
      else if (s.code === "invalid_key")
        i({ issues: s.issues }, s.path);
      else if (s.code === "invalid_element")
        i({ issues: s.issues }, s.path);
      else {
        const l = [...o, ...s.path];
        if (l.length === 0) {
          r.errors.push(n(s));
          continue;
        }
        let f = r, c = 0;
        for (; c < l.length; ) {
          const p = l[c], _ = c === l.length - 1;
          typeof p == "string" ? (f.properties ?? (f.properties = {}), (a = f.properties)[p] ?? (a[p] = { errors: [] }), f = f.properties[p]) : (f.items ?? (f.items = []), (u = f.items)[p] ?? (u[p] = { errors: [] }), f = f.items[p]), _ && f.errors.push(n(s)), c++;
        }
      }
  };
  return i(e), r;
}
function Oa(e) {
  const n = [], r = e.map((i) => typeof i == "object" ? i.key : i);
  for (const i of r)
    typeof i == "number" ? n.push(`[${i}]`) : typeof i == "symbol" ? n.push(`[${JSON.stringify(String(i))}]`) : /[^\w$]/.test(i) ? n.push(`[${JSON.stringify(i)}]`) : (n.length && n.push("."), n.push(i));
  return n.join("");
}
function Ta(e) {
  var i;
  const n = [], r = [...e.issues].sort((t, o) => (t.path ?? []).length - (o.path ?? []).length);
  for (const t of r)
    n.push(`✖ ${t.message}`), (i = t.path) != null && i.length && n.push(`  → at ${Oa(t.path)}`);
  return n.join(`
`);
}
const $t = (e) => (n, r, i, t) => {
  const o = i ? Object.assign(i, { async: !1 }) : { async: !1 }, a = n._zod.run({ value: r, issues: [] }, o);
  if (a instanceof Promise)
    throw new xe();
  if (a.issues.length) {
    const u = new ((t == null ? void 0 : t.Err) ?? e)(a.issues.map((s) => be(s, o, ee())));
    throw cr(u, t == null ? void 0 : t.callee), u;
  }
  return a.value;
}, Qn = /* @__PURE__ */ $t(oe), Et = (e) => async (n, r, i, t) => {
  const o = i ? Object.assign(i, { async: !0 }) : { async: !0 };
  let a = n._zod.run({ value: r, issues: [] }, o);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const u = new ((t == null ? void 0 : t.Err) ?? e)(a.issues.map((s) => be(s, o, ee())));
    throw cr(u, t == null ? void 0 : t.callee), u;
  }
  return a.value;
}, er = /* @__PURE__ */ Et(oe), kt = (e) => (n, r, i) => {
  const t = i ? { ...i, async: !1 } : { async: !1 }, o = n._zod.run({ value: r, issues: [] }, t);
  if (o instanceof Promise)
    throw new xe();
  return o.issues.length ? {
    success: !1,
    error: new (e ?? dr)(o.issues.map((a) => be(a, t, ee())))
  } : { success: !0, data: o.value };
}, wa = /* @__PURE__ */ kt(oe), Nt = (e) => async (n, r, i) => {
  const t = i ? Object.assign(i, { async: !0 }) : { async: !0 };
  let o = n._zod.run({ value: r, issues: [] }, t);
  return o instanceof Promise && (o = await o), o.issues.length ? {
    success: !1,
    error: new e(o.issues.map((a) => be(a, t, ee())))
  } : { success: !0, data: o.value };
}, Aa = /* @__PURE__ */ Nt(oe), fr = (e) => (n, r, i) => {
  const t = i ? Object.assign(i, { direction: "backward" }) : { direction: "backward" };
  return $t(e)(n, r, t);
}, Em = /* @__PURE__ */ fr(oe), pr = (e) => (n, r, i) => $t(e)(n, r, i), km = /* @__PURE__ */ pr(oe), vr = (e) => async (n, r, i) => {
  const t = i ? Object.assign(i, { direction: "backward" }) : { direction: "backward" };
  return Et(e)(n, r, t);
}, Nm = /* @__PURE__ */ vr(oe), hr = (e) => async (n, r, i) => Et(e)(n, r, i), Om = /* @__PURE__ */ hr(oe), br = (e) => (n, r, i) => {
  const t = i ? Object.assign(i, { direction: "backward" }) : { direction: "backward" };
  return kt(e)(n, r, t);
}, Tm = /* @__PURE__ */ br(oe), _r = (e) => (n, r, i) => kt(e)(n, r, i), wm = /* @__PURE__ */ _r(oe), yr = (e) => async (n, r, i) => {
  const t = i ? Object.assign(i, { direction: "backward" }) : { direction: "backward" };
  return Nt(e)(n, r, t);
}, Am = /* @__PURE__ */ yr(oe), Sr = (e) => async (n, r, i) => Nt(e)(n, r, i), Um = /* @__PURE__ */ Sr(oe), Ua = /^[cC][^\s-]{8,}$/, Pa = /^[0-9a-z]+$/, Da = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, Ra = /^[0-9a-vA-V]{20}$/, za = /^[A-Za-z0-9]{27}$/, Ca = /^[a-zA-Z0-9_-]{21}$/, ja = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Pm = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, La = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, nt = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, Dm = /* @__PURE__ */ nt(4), Rm = /* @__PURE__ */ nt(6), zm = /* @__PURE__ */ nt(7), xa = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Cm = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, jm = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, Ma = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u, Lm = Ma, xm = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, Mm = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function Za() {
  return new RegExp(Mm, "u");
}
const Ga = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Fa = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Ha = (e) => {
  const n = Oe(e ?? ":");
  return new RegExp(`^(?:[0-9A-F]{2}${n}){5}[0-9A-F]{2}$|^(?:[0-9a-f]{2}${n}){5}[0-9a-f]{2}$`);
}, Ba = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Va = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Ya = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Ir = /^[A-Za-z0-9_-]*$/, Ka = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, Wa = /^([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/, Ja = /^\+(?:[0-9]){6,14}[0-9]$/, qa = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Xa = /* @__PURE__ */ new RegExp(`^${qa}$`);
function Qa(e) {
  const n = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${n}` : e.precision === 0 ? `${n}:[0-5]\\d` : `${n}:[0-5]\\d\\.\\d{${e.precision}}` : `${n}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function eu(e) {
  return new RegExp(`^${Qa(e)}$`);
}
function tu(e) {
  const n = Qa({ precision: e.precision }), r = ["Z"];
  e.local && r.push(""), e.offset && r.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const i = `${n}(?:${r.join("|")})`;
  return new RegExp(`^${qa}T(?:${i})$`);
}
const nu = (e) => {
  const n = e ? `[\\s\\S]{${(e == null ? void 0 : e.minimum) ?? 0},${(e == null ? void 0 : e.maximum) ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${n}$`);
}, ru = /^-?\d+n?$/, iu = /^-?\d+$/, ou = /^-?\d+(?:\.\d+)?/, au = /^(?:true|false)$/i, uu = /^null$/i, lu = /^undefined$/i, su = /^[^A-Z]*$/, cu = /^[^a-z]*$/, du = /^[0-9a-fA-F]*$/;
function Ot(e, n) {
  return new RegExp(`^[A-Za-z0-9+/]{${e}}${n}$`);
}
function Tt(e) {
  return new RegExp(`^[A-Za-z0-9_-]{${e}}$`);
}
const Zm = /^[0-9a-fA-F]{32}$/, Gm = /* @__PURE__ */ Ot(22, "=="), Fm = /* @__PURE__ */ Tt(22), Hm = /^[0-9a-fA-F]{40}$/, Bm = /* @__PURE__ */ Ot(27, "="), Vm = /* @__PURE__ */ Tt(27), Ym = /^[0-9a-fA-F]{64}$/, Km = /* @__PURE__ */ Ot(43, "="), Wm = /* @__PURE__ */ Tt(43), Jm = /^[0-9a-fA-F]{96}$/, qm = /* @__PURE__ */ Ot(64, ""), Xm = /* @__PURE__ */ Tt(64), Qm = /^[0-9a-fA-F]{128}$/, eg = /* @__PURE__ */ Ot(86, "=="), tg = /* @__PURE__ */ Tt(86), $r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base64: Ya,
  base64url: Ir,
  bigint: ru,
  boolean: au,
  browserEmail: xm,
  cidrv4: Ba,
  cidrv6: Va,
  cuid: Ua,
  cuid2: Pa,
  date: Xa,
  datetime: tu,
  domain: Wa,
  duration: ja,
  e164: Ja,
  email: xa,
  emoji: Za,
  extendedDuration: Pm,
  guid: La,
  hex: du,
  hostname: Ka,
  html5Email: Cm,
  idnEmail: Lm,
  integer: iu,
  ipv4: Ga,
  ipv6: Fa,
  ksuid: za,
  lowercase: su,
  mac: Ha,
  md5_base64: Gm,
  md5_base64url: Fm,
  md5_hex: Zm,
  nanoid: Ca,
  null: uu,
  number: ou,
  rfc5322Email: jm,
  sha1_base64: Bm,
  sha1_base64url: Vm,
  sha1_hex: Hm,
  sha256_base64: Km,
  sha256_base64url: Wm,
  sha256_hex: Ym,
  sha384_base64: qm,
  sha384_base64url: Xm,
  sha384_hex: Jm,
  sha512_base64: eg,
  sha512_base64url: tg,
  sha512_hex: Qm,
  string: nu,
  time: eu,
  ulid: Da,
  undefined: lu,
  unicodeEmail: Ma,
  uppercase: cu,
  uuid: nt,
  uuid4: Dm,
  uuid6: Rm,
  uuid7: zm,
  xid: Ra
}, Symbol.toStringTag, { value: "Module" })), M = /* @__PURE__ */ d("$ZodCheck", (e, n) => {
  var r;
  e._zod ?? (e._zod = {}), e._zod.def = n, (r = e._zod).onattach ?? (r.onattach = []);
}), mu = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, Er = /* @__PURE__ */ d("$ZodCheckLessThan", (e, n) => {
  M.init(e, n);
  const r = mu[typeof n.value];
  e._zod.onattach.push((i) => {
    const t = i._zod.bag, o = (n.inclusive ? t.maximum : t.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    n.value < o && (n.inclusive ? t.maximum = n.value : t.exclusiveMaximum = n.value);
  }), e._zod.check = (i) => {
    (n.inclusive ? i.value <= n.value : i.value < n.value) || i.issues.push({
      origin: r,
      code: "too_big",
      maximum: n.value,
      input: i.value,
      inclusive: n.inclusive,
      inst: e,
      continue: !n.abort
    });
  };
}), kr = /* @__PURE__ */ d("$ZodCheckGreaterThan", (e, n) => {
  M.init(e, n);
  const r = mu[typeof n.value];
  e._zod.onattach.push((i) => {
    const t = i._zod.bag, o = (n.inclusive ? t.minimum : t.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    n.value > o && (n.inclusive ? t.minimum = n.value : t.exclusiveMinimum = n.value);
  }), e._zod.check = (i) => {
    (n.inclusive ? i.value >= n.value : i.value > n.value) || i.issues.push({
      origin: r,
      code: "too_small",
      minimum: n.value,
      input: i.value,
      inclusive: n.inclusive,
      inst: e,
      continue: !n.abort
    });
  };
}), gu = /* @__PURE__ */ d("$ZodCheckMultipleOf", (e, n) => {
  M.init(e, n), e._zod.onattach.push((r) => {
    var i;
    (i = r._zod.bag).multipleOf ?? (i.multipleOf = n.value);
  }), e._zod.check = (r) => {
    if (typeof r.value != typeof n.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof r.value == "bigint" ? r.value % n.value === BigInt(0) : la(r.value, n.value) === 0) || r.issues.push({
      origin: typeof r.value,
      code: "not_multiple_of",
      divisor: n.value,
      input: r.value,
      inst: e,
      continue: !n.abort
    });
  };
}), fu = /* @__PURE__ */ d("$ZodCheckNumberFormat", (e, n) => {
  var a;
  M.init(e, n), n.format = n.format || "float64";
  const r = (a = n.format) == null ? void 0 : a.includes("int"), i = r ? "int" : "number", [t, o] = ga[n.format];
  e._zod.onattach.push((u) => {
    const s = u._zod.bag;
    s.format = n.format, s.minimum = t, s.maximum = o, r && (s.pattern = iu);
  }), e._zod.check = (u) => {
    const s = u.value;
    if (r) {
      if (!Number.isInteger(s)) {
        u.issues.push({
          expected: i,
          format: n.format,
          code: "invalid_type",
          continue: !1,
          input: s,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(s)) {
        s > 0 ? u.issues.push({
          input: s,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          continue: !n.abort
        }) : u.issues.push({
          input: s,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          continue: !n.abort
        });
        return;
      }
    }
    s < t && u.issues.push({
      origin: "number",
      input: s,
      code: "too_small",
      minimum: t,
      inclusive: !0,
      inst: e,
      continue: !n.abort
    }), s > o && u.issues.push({
      origin: "number",
      input: s,
      code: "too_big",
      maximum: o,
      inst: e
    });
  };
}), pu = /* @__PURE__ */ d("$ZodCheckBigIntFormat", (e, n) => {
  M.init(e, n);
  const [r, i] = fa[n.format];
  e._zod.onattach.push((t) => {
    const o = t._zod.bag;
    o.format = n.format, o.minimum = r, o.maximum = i;
  }), e._zod.check = (t) => {
    const o = t.value;
    o < r && t.issues.push({
      origin: "bigint",
      input: o,
      code: "too_small",
      minimum: r,
      inclusive: !0,
      inst: e,
      continue: !n.abort
    }), o > i && t.issues.push({
      origin: "bigint",
      input: o,
      code: "too_big",
      maximum: i,
      inst: e
    });
  };
}), vu = /* @__PURE__ */ d("$ZodCheckMaxSize", (e, n) => {
  var r;
  M.init(e, n), (r = e._zod.def).when ?? (r.when = (i) => {
    const t = i.value;
    return !He(t) && t.size !== void 0;
  }), e._zod.onattach.push((i) => {
    const t = i._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    n.maximum < t && (i._zod.bag.maximum = n.maximum);
  }), e._zod.check = (i) => {
    const t = i.value;
    t.size <= n.maximum || i.issues.push({
      origin: fn(t),
      code: "too_big",
      maximum: n.maximum,
      inclusive: !0,
      input: t,
      inst: e,
      continue: !n.abort
    });
  };
}), hu = /* @__PURE__ */ d("$ZodCheckMinSize", (e, n) => {
  var r;
  M.init(e, n), (r = e._zod.def).when ?? (r.when = (i) => {
    const t = i.value;
    return !He(t) && t.size !== void 0;
  }), e._zod.onattach.push((i) => {
    const t = i._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    n.minimum > t && (i._zod.bag.minimum = n.minimum);
  }), e._zod.check = (i) => {
    const t = i.value;
    t.size >= n.minimum || i.issues.push({
      origin: fn(t),
      code: "too_small",
      minimum: n.minimum,
      inclusive: !0,
      input: t,
      inst: e,
      continue: !n.abort
    });
  };
}), bu = /* @__PURE__ */ d("$ZodCheckSizeEquals", (e, n) => {
  var r;
  M.init(e, n), (r = e._zod.def).when ?? (r.when = (i) => {
    const t = i.value;
    return !He(t) && t.size !== void 0;
  }), e._zod.onattach.push((i) => {
    const t = i._zod.bag;
    t.minimum = n.size, t.maximum = n.size, t.size = n.size;
  }), e._zod.check = (i) => {
    const t = i.value, o = t.size;
    if (o === n.size)
      return;
    const a = o > n.size;
    i.issues.push({
      origin: fn(t),
      ...a ? { code: "too_big", maximum: n.size } : { code: "too_small", minimum: n.size },
      inclusive: !0,
      exact: !0,
      input: i.value,
      inst: e,
      continue: !n.abort
    });
  };
}), _u = /* @__PURE__ */ d("$ZodCheckMaxLength", (e, n) => {
  var r;
  M.init(e, n), (r = e._zod.def).when ?? (r.when = (i) => {
    const t = i.value;
    return !He(t) && t.length !== void 0;
  }), e._zod.onattach.push((i) => {
    const t = i._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    n.maximum < t && (i._zod.bag.maximum = n.maximum);
  }), e._zod.check = (i) => {
    const t = i.value;
    if (t.length <= n.maximum)
      return;
    const a = pn(t);
    i.issues.push({
      origin: a,
      code: "too_big",
      maximum: n.maximum,
      inclusive: !0,
      input: t,
      inst: e,
      continue: !n.abort
    });
  };
}), yu = /* @__PURE__ */ d("$ZodCheckMinLength", (e, n) => {
  var r;
  M.init(e, n), (r = e._zod.def).when ?? (r.when = (i) => {
    const t = i.value;
    return !He(t) && t.length !== void 0;
  }), e._zod.onattach.push((i) => {
    const t = i._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    n.minimum > t && (i._zod.bag.minimum = n.minimum);
  }), e._zod.check = (i) => {
    const t = i.value;
    if (t.length >= n.minimum)
      return;
    const a = pn(t);
    i.issues.push({
      origin: a,
      code: "too_small",
      minimum: n.minimum,
      inclusive: !0,
      input: t,
      inst: e,
      continue: !n.abort
    });
  };
}), Su = /* @__PURE__ */ d("$ZodCheckLengthEquals", (e, n) => {
  var r;
  M.init(e, n), (r = e._zod.def).when ?? (r.when = (i) => {
    const t = i.value;
    return !He(t) && t.length !== void 0;
  }), e._zod.onattach.push((i) => {
    const t = i._zod.bag;
    t.minimum = n.length, t.maximum = n.length, t.length = n.length;
  }), e._zod.check = (i) => {
    const t = i.value, o = t.length;
    if (o === n.length)
      return;
    const a = pn(t), u = o > n.length;
    i.issues.push({
      origin: a,
      ...u ? { code: "too_big", maximum: n.length } : { code: "too_small", minimum: n.length },
      inclusive: !0,
      exact: !0,
      input: i.value,
      inst: e,
      continue: !n.abort
    });
  };
}), wt = /* @__PURE__ */ d("$ZodCheckStringFormat", (e, n) => {
  var r, i;
  M.init(e, n), e._zod.onattach.push((t) => {
    const o = t._zod.bag;
    o.format = n.format, n.pattern && (o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n.pattern));
  }), n.pattern ? (r = e._zod).check ?? (r.check = (t) => {
    n.pattern.lastIndex = 0, !n.pattern.test(t.value) && t.issues.push({
      origin: "string",
      code: "invalid_format",
      format: n.format,
      input: t.value,
      ...n.pattern ? { pattern: n.pattern.toString() } : {},
      inst: e,
      continue: !n.abort
    });
  }) : (i = e._zod).check ?? (i.check = () => {
  });
}), Iu = /* @__PURE__ */ d("$ZodCheckRegex", (e, n) => {
  wt.init(e, n), e._zod.check = (r) => {
    n.pattern.lastIndex = 0, !n.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: r.value,
      pattern: n.pattern.toString(),
      inst: e,
      continue: !n.abort
    });
  };
}), $u = /* @__PURE__ */ d("$ZodCheckLowerCase", (e, n) => {
  n.pattern ?? (n.pattern = su), wt.init(e, n);
}), Eu = /* @__PURE__ */ d("$ZodCheckUpperCase", (e, n) => {
  n.pattern ?? (n.pattern = cu), wt.init(e, n);
}), ku = /* @__PURE__ */ d("$ZodCheckIncludes", (e, n) => {
  M.init(e, n);
  const r = Oe(n.includes), i = new RegExp(typeof n.position == "number" ? `^.{${n.position}}${r}` : r);
  n.pattern = i, e._zod.onattach.push((t) => {
    const o = t._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(i);
  }), e._zod.check = (t) => {
    t.value.includes(n.includes, n.position) || t.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: n.includes,
      input: t.value,
      inst: e,
      continue: !n.abort
    });
  };
}), Nu = /* @__PURE__ */ d("$ZodCheckStartsWith", (e, n) => {
  M.init(e, n);
  const r = new RegExp(`^${Oe(n.prefix)}.*`);
  n.pattern ?? (n.pattern = r), e._zod.onattach.push((i) => {
    const t = i._zod.bag;
    t.patterns ?? (t.patterns = /* @__PURE__ */ new Set()), t.patterns.add(r);
  }), e._zod.check = (i) => {
    i.value.startsWith(n.prefix) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: n.prefix,
      input: i.value,
      inst: e,
      continue: !n.abort
    });
  };
}), Ou = /* @__PURE__ */ d("$ZodCheckEndsWith", (e, n) => {
  M.init(e, n);
  const r = new RegExp(`.*${Oe(n.suffix)}$`);
  n.pattern ?? (n.pattern = r), e._zod.onattach.push((i) => {
    const t = i._zod.bag;
    t.patterns ?? (t.patterns = /* @__PURE__ */ new Set()), t.patterns.add(r);
  }), e._zod.check = (i) => {
    i.value.endsWith(n.suffix) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: n.suffix,
      input: i.value,
      inst: e,
      continue: !n.abort
    });
  };
});
function yo(e, n, r) {
  e.issues.length && n.issues.push(...pe(r, e.issues));
}
const Tu = /* @__PURE__ */ d("$ZodCheckProperty", (e, n) => {
  M.init(e, n), e._zod.check = (r) => {
    const i = n.schema._zod.run({
      value: r.value[n.property],
      issues: []
    }, {});
    if (i instanceof Promise)
      return i.then((t) => yo(t, r, n.property));
    yo(i, r, n.property);
  };
}), wu = /* @__PURE__ */ d("$ZodCheckMimeType", (e, n) => {
  M.init(e, n);
  const r = new Set(n.mime);
  e._zod.onattach.push((i) => {
    i._zod.bag.mime = n.mime;
  }), e._zod.check = (i) => {
    r.has(i.value.type) || i.issues.push({
      code: "invalid_value",
      values: n.mime,
      input: i.value.type,
      inst: e,
      continue: !n.abort
    });
  };
}), Au = /* @__PURE__ */ d("$ZodCheckOverwrite", (e, n) => {
  M.init(e, n), e._zod.check = (r) => {
    r.value = n.tx(r.value);
  };
});
class Uu {
  constructor(n = []) {
    this.content = [], this.indent = 0, this && (this.args = n);
  }
  indented(n) {
    this.indent += 1, n(this), this.indent -= 1;
  }
  write(n) {
    if (typeof n == "function") {
      n(this, { execution: "sync" }), n(this, { execution: "async" });
      return;
    }
    const i = n.split(`
`).filter((a) => a), t = Math.min(...i.map((a) => a.length - a.trimStart().length)), o = i.map((a) => a.slice(t)).map((a) => " ".repeat(this.indent * 2) + a);
    for (const a of o)
      this.content.push(a);
  }
  compile() {
    const n = Function, r = this == null ? void 0 : this.args, t = [...((this == null ? void 0 : this.content) ?? [""]).map((o) => `  ${o}`)];
    return new n(...r, t.join(`
`));
  }
}
const Pu = {
  major: 4,
  minor: 1,
  patch: 13
}, T = /* @__PURE__ */ d("$ZodType", (e, n) => {
  var t;
  var r;
  e ?? (e = {}), e._zod.def = n, e._zod.bag = e._zod.bag || {}, e._zod.version = Pu;
  const i = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && i.unshift(e);
  for (const o of i)
    for (const a of o._zod.onattach)
      a(e);
  if (i.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (t = e._zod.deferred) == null || t.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (u, s, l) => {
      let f = Le(u), c;
      for (const p of s) {
        if (p._zod.def.when) {
          if (!p._zod.def.when(u))
            continue;
        } else if (f)
          continue;
        const _ = u.issues.length, h = p._zod.check(u);
        if (h instanceof Promise && (l == null ? void 0 : l.async) === !1)
          throw new xe();
        if (c || h instanceof Promise)
          c = (c ?? Promise.resolve()).then(async () => {
            await h, u.issues.length !== _ && (f || (f = Le(u, _)));
          });
        else {
          if (u.issues.length === _)
            continue;
          f || (f = Le(u, _));
        }
      }
      return c ? c.then(() => u) : u;
    }, a = (u, s, l) => {
      if (Le(u))
        return u.aborted = !0, u;
      const f = o(s, i, l);
      if (f instanceof Promise) {
        if (l.async === !1)
          throw new xe();
        return f.then((c) => e._zod.parse(c, l));
      }
      return e._zod.parse(f, l);
    };
    e._zod.run = (u, s) => {
      if (s.skipChecks)
        return e._zod.parse(u, s);
      if (s.direction === "backward") {
        const f = e._zod.parse({ value: u.value, issues: [] }, { ...s, skipChecks: !0 });
        return f instanceof Promise ? f.then((c) => a(c, u, s)) : a(f, u, s);
      }
      const l = e._zod.parse(u, s);
      if (l instanceof Promise) {
        if (s.async === !1)
          throw new xe();
        return l.then((f) => o(f, i, s));
      }
      return o(l, i, s);
    };
  }
  e["~standard"] = {
    validate: (o) => {
      var a;
      try {
        const u = wa(e, o);
        return u.success ? { value: u.data } : { issues: (a = u.error) == null ? void 0 : a.issues };
      } catch {
        return Aa(e, o).then((s) => {
          var l;
          return s.success ? { value: s.data } : { issues: (l = s.error) == null ? void 0 : l.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  };
}), At = /* @__PURE__ */ d("$ZodString", (e, n) => {
  var r;
  T.init(e, n), e._zod.pattern = [...((r = e == null ? void 0 : e._zod.bag) == null ? void 0 : r.patterns) ?? []].pop() ?? nu(e._zod.bag), e._zod.parse = (i, t) => {
    if (n.coerce)
      try {
        i.value = String(i.value);
      } catch {
      }
    return typeof i.value == "string" || i.issues.push({
      expected: "string",
      code: "invalid_type",
      input: i.value,
      inst: e
    }), i;
  };
}), C = /* @__PURE__ */ d("$ZodStringFormat", (e, n) => {
  wt.init(e, n), At.init(e, n);
}), Du = /* @__PURE__ */ d("$ZodGUID", (e, n) => {
  n.pattern ?? (n.pattern = La), C.init(e, n);
}), Ru = /* @__PURE__ */ d("$ZodUUID", (e, n) => {
  if (n.version) {
    const i = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[n.version];
    if (i === void 0)
      throw new Error(`Invalid UUID version: "${n.version}"`);
    n.pattern ?? (n.pattern = nt(i));
  } else
    n.pattern ?? (n.pattern = nt());
  C.init(e, n);
}), zu = /* @__PURE__ */ d("$ZodEmail", (e, n) => {
  n.pattern ?? (n.pattern = xa), C.init(e, n);
}), Cu = /* @__PURE__ */ d("$ZodURL", (e, n) => {
  C.init(e, n), e._zod.check = (r) => {
    try {
      const i = r.value.trim(), t = new URL(i);
      n.hostname && (n.hostname.lastIndex = 0, n.hostname.test(t.hostname) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: n.hostname.source,
        input: r.value,
        inst: e,
        continue: !n.abort
      })), n.protocol && (n.protocol.lastIndex = 0, n.protocol.test(t.protocol.endsWith(":") ? t.protocol.slice(0, -1) : t.protocol) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: n.protocol.source,
        input: r.value,
        inst: e,
        continue: !n.abort
      })), n.normalize ? r.value = t.href : r.value = i;
      return;
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "url",
        input: r.value,
        inst: e,
        continue: !n.abort
      });
    }
  };
}), ju = /* @__PURE__ */ d("$ZodEmoji", (e, n) => {
  n.pattern ?? (n.pattern = Za()), C.init(e, n);
}), Lu = /* @__PURE__ */ d("$ZodNanoID", (e, n) => {
  n.pattern ?? (n.pattern = Ca), C.init(e, n);
}), xu = /* @__PURE__ */ d("$ZodCUID", (e, n) => {
  n.pattern ?? (n.pattern = Ua), C.init(e, n);
}), Mu = /* @__PURE__ */ d("$ZodCUID2", (e, n) => {
  n.pattern ?? (n.pattern = Pa), C.init(e, n);
}), Zu = /* @__PURE__ */ d("$ZodULID", (e, n) => {
  n.pattern ?? (n.pattern = Da), C.init(e, n);
}), Gu = /* @__PURE__ */ d("$ZodXID", (e, n) => {
  n.pattern ?? (n.pattern = Ra), C.init(e, n);
}), Fu = /* @__PURE__ */ d("$ZodKSUID", (e, n) => {
  n.pattern ?? (n.pattern = za), C.init(e, n);
}), Hu = /* @__PURE__ */ d("$ZodISODateTime", (e, n) => {
  n.pattern ?? (n.pattern = tu(n)), C.init(e, n);
}), Bu = /* @__PURE__ */ d("$ZodISODate", (e, n) => {
  n.pattern ?? (n.pattern = Xa), C.init(e, n);
}), Vu = /* @__PURE__ */ d("$ZodISOTime", (e, n) => {
  n.pattern ?? (n.pattern = eu(n)), C.init(e, n);
}), Yu = /* @__PURE__ */ d("$ZodISODuration", (e, n) => {
  n.pattern ?? (n.pattern = ja), C.init(e, n);
}), Ku = /* @__PURE__ */ d("$ZodIPv4", (e, n) => {
  n.pattern ?? (n.pattern = Ga), C.init(e, n), e._zod.bag.format = "ipv4";
}), Wu = /* @__PURE__ */ d("$ZodIPv6", (e, n) => {
  n.pattern ?? (n.pattern = Fa), C.init(e, n), e._zod.bag.format = "ipv6", e._zod.check = (r) => {
    try {
      new URL(`http://[${r.value}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: r.value,
        inst: e,
        continue: !n.abort
      });
    }
  };
}), Ju = /* @__PURE__ */ d("$ZodMAC", (e, n) => {
  n.pattern ?? (n.pattern = Ha(n.delimiter)), C.init(e, n), e._zod.bag.format = "mac";
}), qu = /* @__PURE__ */ d("$ZodCIDRv4", (e, n) => {
  n.pattern ?? (n.pattern = Ba), C.init(e, n);
}), Xu = /* @__PURE__ */ d("$ZodCIDRv6", (e, n) => {
  n.pattern ?? (n.pattern = Va), C.init(e, n), e._zod.check = (r) => {
    const i = r.value.split("/");
    try {
      if (i.length !== 2)
        throw new Error();
      const [t, o] = i;
      if (!o)
        throw new Error();
      const a = Number(o);
      if (`${a}` !== o)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${t}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: r.value,
        inst: e,
        continue: !n.abort
      });
    }
  };
});
function Nr(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const Qu = /* @__PURE__ */ d("$ZodBase64", (e, n) => {
  n.pattern ?? (n.pattern = Ya), C.init(e, n), e._zod.bag.contentEncoding = "base64", e._zod.check = (r) => {
    Nr(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64",
      input: r.value,
      inst: e,
      continue: !n.abort
    });
  };
});
function el(e) {
  if (!Ir.test(e))
    return !1;
  const n = e.replace(/[-_]/g, (i) => i === "-" ? "+" : "/"), r = n.padEnd(Math.ceil(n.length / 4) * 4, "=");
  return Nr(r);
}
const tl = /* @__PURE__ */ d("$ZodBase64URL", (e, n) => {
  n.pattern ?? (n.pattern = Ir), C.init(e, n), e._zod.bag.contentEncoding = "base64url", e._zod.check = (r) => {
    el(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: r.value,
      inst: e,
      continue: !n.abort
    });
  };
}), nl = /* @__PURE__ */ d("$ZodE164", (e, n) => {
  n.pattern ?? (n.pattern = Ja), C.init(e, n);
});
function rl(e, n = null) {
  try {
    const r = e.split(".");
    if (r.length !== 3)
      return !1;
    const [i] = r;
    if (!i)
      return !1;
    const t = JSON.parse(atob(i));
    return !("typ" in t && (t == null ? void 0 : t.typ) !== "JWT" || !t.alg || n && (!("alg" in t) || t.alg !== n));
  } catch {
    return !1;
  }
}
const il = /* @__PURE__ */ d("$ZodJWT", (e, n) => {
  C.init(e, n), e._zod.check = (r) => {
    rl(r.value, n.alg) || r.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: r.value,
      inst: e,
      continue: !n.abort
    });
  };
}), ol = /* @__PURE__ */ d("$ZodCustomStringFormat", (e, n) => {
  C.init(e, n), e._zod.check = (r) => {
    n.fn(r.value) || r.issues.push({
      code: "invalid_format",
      format: n.format,
      input: r.value,
      inst: e,
      continue: !n.abort
    });
  };
}), Or = /* @__PURE__ */ d("$ZodNumber", (e, n) => {
  T.init(e, n), e._zod.pattern = e._zod.bag.pattern ?? ou, e._zod.parse = (r, i) => {
    if (n.coerce)
      try {
        r.value = Number(r.value);
      } catch {
      }
    const t = r.value;
    if (typeof t == "number" && !Number.isNaN(t) && Number.isFinite(t))
      return r;
    const o = typeof t == "number" ? Number.isNaN(t) ? "NaN" : Number.isFinite(t) ? void 0 : "Infinity" : void 0;
    return r.issues.push({
      expected: "number",
      code: "invalid_type",
      input: t,
      inst: e,
      ...o ? { received: o } : {}
    }), r;
  };
}), al = /* @__PURE__ */ d("$ZodNumberFormat", (e, n) => {
  fu.init(e, n), Or.init(e, n);
}), Tr = /* @__PURE__ */ d("$ZodBoolean", (e, n) => {
  T.init(e, n), e._zod.pattern = au, e._zod.parse = (r, i) => {
    if (n.coerce)
      try {
        r.value = !!r.value;
      } catch {
      }
    const t = r.value;
    return typeof t == "boolean" || r.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: t,
      inst: e
    }), r;
  };
}), wr = /* @__PURE__ */ d("$ZodBigInt", (e, n) => {
  T.init(e, n), e._zod.pattern = ru, e._zod.parse = (r, i) => {
    if (n.coerce)
      try {
        r.value = BigInt(r.value);
      } catch {
      }
    return typeof r.value == "bigint" || r.issues.push({
      expected: "bigint",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), ul = /* @__PURE__ */ d("$ZodBigIntFormat", (e, n) => {
  pu.init(e, n), wr.init(e, n);
}), ll = /* @__PURE__ */ d("$ZodSymbol", (e, n) => {
  T.init(e, n), e._zod.parse = (r, i) => {
    const t = r.value;
    return typeof t == "symbol" || r.issues.push({
      expected: "symbol",
      code: "invalid_type",
      input: t,
      inst: e
    }), r;
  };
}), sl = /* @__PURE__ */ d("$ZodUndefined", (e, n) => {
  T.init(e, n), e._zod.pattern = lu, e._zod.values = /* @__PURE__ */ new Set([void 0]), e._zod.optin = "optional", e._zod.optout = "optional", e._zod.parse = (r, i) => {
    const t = r.value;
    return typeof t > "u" || r.issues.push({
      expected: "undefined",
      code: "invalid_type",
      input: t,
      inst: e
    }), r;
  };
}), cl = /* @__PURE__ */ d("$ZodNull", (e, n) => {
  T.init(e, n), e._zod.pattern = uu, e._zod.values = /* @__PURE__ */ new Set([null]), e._zod.parse = (r, i) => {
    const t = r.value;
    return t === null || r.issues.push({
      expected: "null",
      code: "invalid_type",
      input: t,
      inst: e
    }), r;
  };
}), dl = /* @__PURE__ */ d("$ZodAny", (e, n) => {
  T.init(e, n), e._zod.parse = (r) => r;
}), ml = /* @__PURE__ */ d("$ZodUnknown", (e, n) => {
  T.init(e, n), e._zod.parse = (r) => r;
}), gl = /* @__PURE__ */ d("$ZodNever", (e, n) => {
  T.init(e, n), e._zod.parse = (r, i) => (r.issues.push({
    expected: "never",
    code: "invalid_type",
    input: r.value,
    inst: e
  }), r);
}), fl = /* @__PURE__ */ d("$ZodVoid", (e, n) => {
  T.init(e, n), e._zod.parse = (r, i) => {
    const t = r.value;
    return typeof t > "u" || r.issues.push({
      expected: "void",
      code: "invalid_type",
      input: t,
      inst: e
    }), r;
  };
}), pl = /* @__PURE__ */ d("$ZodDate", (e, n) => {
  T.init(e, n), e._zod.parse = (r, i) => {
    if (n.coerce)
      try {
        r.value = new Date(r.value);
      } catch {
      }
    const t = r.value, o = t instanceof Date;
    return o && !Number.isNaN(t.getTime()) || r.issues.push({
      expected: "date",
      code: "invalid_type",
      input: t,
      ...o ? { received: "Invalid Date" } : {},
      inst: e
    }), r;
  };
});
function So(e, n, r) {
  e.issues.length && n.issues.push(...pe(r, e.issues)), n.value[r] = e.value;
}
const vl = /* @__PURE__ */ d("$ZodArray", (e, n) => {
  T.init(e, n), e._zod.parse = (r, i) => {
    const t = r.value;
    if (!Array.isArray(t))
      return r.issues.push({
        expected: "array",
        code: "invalid_type",
        input: t,
        inst: e
      }), r;
    r.value = Array(t.length);
    const o = [];
    for (let a = 0; a < t.length; a++) {
      const u = t[a], s = n.element._zod.run({
        value: u,
        issues: []
      }, i);
      s instanceof Promise ? o.push(s.then((l) => So(l, r, a))) : So(s, r, a);
    }
    return o.length ? Promise.all(o).then(() => r) : r;
  };
});
function nn(e, n, r, i) {
  e.issues.length && n.issues.push(...pe(r, e.issues)), e.value === void 0 ? r in i && (n.value[r] = void 0) : n.value[r] = e.value;
}
function hl(e) {
  var i, t, o, a;
  const n = Object.keys(e.shape);
  for (const u of n)
    if (!((a = (o = (t = (i = e.shape) == null ? void 0 : i[u]) == null ? void 0 : t._zod) == null ? void 0 : o.traits) != null && a.has("$ZodType")))
      throw new Error(`Invalid element at key "${u}": expected a Zod schema`);
  const r = ma(e.shape);
  return {
    ...e,
    keys: n,
    keySet: new Set(n),
    numKeys: n.length,
    optionalKeys: new Set(r)
  };
}
function bl(e, n, r, i, t, o) {
  const a = [], u = t.keySet, s = t.catchall._zod, l = s.def.type;
  for (const f in n) {
    if (u.has(f))
      continue;
    if (l === "never") {
      a.push(f);
      continue;
    }
    const c = s.run({ value: n[f], issues: [] }, i);
    c instanceof Promise ? e.push(c.then((p) => nn(p, r, f, n))) : nn(c, r, f, n);
  }
  return a.length && r.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: n,
    inst: o
  }), e.length ? Promise.all(e).then(() => r) : r;
}
const _l = /* @__PURE__ */ d("$ZodObject", (e, n) => {
  T.init(e, n);
  const r = Object.getOwnPropertyDescriptor(n, "shape");
  if (!(r != null && r.get)) {
    const u = n.shape;
    Object.defineProperty(n, "shape", {
      get: () => {
        const s = { ...u };
        return Object.defineProperty(n, "shape", {
          value: s
        }), s;
      }
    });
  }
  const i = It(() => hl(n));
  U(e._zod, "propValues", () => {
    const u = n.shape, s = {};
    for (const l in u) {
      const f = u[l]._zod;
      if (f.values) {
        s[l] ?? (s[l] = /* @__PURE__ */ new Set());
        for (const c of f.values)
          s[l].add(c);
      }
    }
    return s;
  });
  const t = et, o = n.catchall;
  let a;
  e._zod.parse = (u, s) => {
    a ?? (a = i.value);
    const l = u.value;
    if (!t(l))
      return u.issues.push({
        expected: "object",
        code: "invalid_type",
        input: l,
        inst: e
      }), u;
    u.value = {};
    const f = [], c = a.shape;
    for (const p of a.keys) {
      const h = c[p]._zod.run({ value: l[p], issues: [] }, s);
      h instanceof Promise ? f.push(h.then(($) => nn($, u, p, l))) : nn(h, u, p, l);
    }
    return o ? bl(f, l, u, s, i.value, e) : f.length ? Promise.all(f).then(() => u) : u;
  };
}), yl = /* @__PURE__ */ d("$ZodObjectJIT", (e, n) => {
  _l.init(e, n);
  const r = e._zod.parse, i = It(() => hl(n)), t = (p) => {
    const _ = new Uu(["shape", "payload", "ctx"]), h = i.value, $ = (S) => {
      const k = Xn(S);
      return `shape[${k}]._zod.run({ value: input[${k}], issues: [] }, ctx)`;
    };
    _.write("const input = payload.value;");
    const v = /* @__PURE__ */ Object.create(null);
    let m = 0;
    for (const S of h.keys)
      v[S] = `key_${m++}`;
    _.write("const newResult = {};");
    for (const S of h.keys) {
      const k = v[S], E = Xn(S);
      _.write(`const ${k} = ${$(S)};`), _.write(`
        if (${k}.issues.length) {
          payload.issues = payload.issues.concat(${k}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${E}, ...iss.path] : [${E}]
          })));
        }
        
        
        if (${k}.value === undefined) {
          if (${E} in input) {
            newResult[${E}] = undefined;
          }
        } else {
          newResult[${E}] = ${k}.value;
        }
        
      `);
    }
    _.write("payload.value = newResult;"), _.write("return payload;");
    const g = _.compile();
    return (S, k) => g(p, S, k);
  };
  let o;
  const a = et, u = !Qt.jitless, l = u && ca.value, f = n.catchall;
  let c;
  e._zod.parse = (p, _) => {
    c ?? (c = i.value);
    const h = p.value;
    return a(h) ? u && l && (_ == null ? void 0 : _.async) === !1 && _.jitless !== !0 ? (o || (o = t(n.shape)), p = o(p, _), f ? bl([], h, p, _, c, e) : p) : r(p, _) : (p.issues.push({
      expected: "object",
      code: "invalid_type",
      input: h,
      inst: e
    }), p);
  };
});
function Io(e, n, r, i) {
  for (const o of e)
    if (o.issues.length === 0)
      return n.value = o.value, n;
  const t = e.filter((o) => !Le(o));
  return t.length === 1 ? (n.value = t[0].value, t[0]) : (n.issues.push({
    code: "invalid_union",
    input: n.value,
    inst: r,
    errors: e.map((o) => o.issues.map((a) => be(a, i, ee())))
  }), n);
}
const Ar = /* @__PURE__ */ d("$ZodUnion", (e, n) => {
  T.init(e, n), U(e._zod, "optin", () => n.options.some((t) => t._zod.optin === "optional") ? "optional" : void 0), U(e._zod, "optout", () => n.options.some((t) => t._zod.optout === "optional") ? "optional" : void 0), U(e._zod, "values", () => {
    if (n.options.every((t) => t._zod.values))
      return new Set(n.options.flatMap((t) => Array.from(t._zod.values)));
  }), U(e._zod, "pattern", () => {
    if (n.options.every((t) => t._zod.pattern)) {
      const t = n.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${t.map((o) => mn(o.source)).join("|")})$`);
    }
  });
  const r = n.options.length === 1, i = n.options[0]._zod.run;
  e._zod.parse = (t, o) => {
    if (r)
      return i(t, o);
    let a = !1;
    const u = [];
    for (const s of n.options) {
      const l = s._zod.run({
        value: t.value,
        issues: []
      }, o);
      if (l instanceof Promise)
        u.push(l), a = !0;
      else {
        if (l.issues.length === 0)
          return l;
        u.push(l);
      }
    }
    return a ? Promise.all(u).then((s) => Io(s, t, e, o)) : Io(u, t, e, o);
  };
}), Sl = /* @__PURE__ */ d("$ZodDiscriminatedUnion", (e, n) => {
  Ar.init(e, n);
  const r = e._zod.parse;
  U(e._zod, "propValues", () => {
    const t = {};
    for (const o of n.options) {
      const a = o._zod.propValues;
      if (!a || Object.keys(a).length === 0)
        throw new Error(`Invalid discriminated union option at index "${n.options.indexOf(o)}"`);
      for (const [u, s] of Object.entries(a)) {
        t[u] || (t[u] = /* @__PURE__ */ new Set());
        for (const l of s)
          t[u].add(l);
      }
    }
    return t;
  });
  const i = It(() => {
    var a;
    const t = n.options, o = /* @__PURE__ */ new Map();
    for (const u of t) {
      const s = (a = u._zod.propValues) == null ? void 0 : a[n.discriminator];
      if (!s || s.size === 0)
        throw new Error(`Invalid discriminated union option at index "${n.options.indexOf(u)}"`);
      for (const l of s) {
        if (o.has(l))
          throw new Error(`Duplicate discriminator value "${String(l)}"`);
        o.set(l, u);
      }
    }
    return o;
  });
  e._zod.parse = (t, o) => {
    const a = t.value;
    if (!et(a))
      return t.issues.push({
        code: "invalid_type",
        expected: "object",
        input: a,
        inst: e
      }), t;
    const u = i.value.get(a == null ? void 0 : a[n.discriminator]);
    return u ? u._zod.run(t, o) : n.unionFallback ? r(t, o) : (t.issues.push({
      code: "invalid_union",
      errors: [],
      note: "No matching discriminator",
      discriminator: n.discriminator,
      input: a,
      path: [n.discriminator],
      inst: e
    }), t);
  };
}), Il = /* @__PURE__ */ d("$ZodIntersection", (e, n) => {
  T.init(e, n), e._zod.parse = (r, i) => {
    const t = r.value, o = n.left._zod.run({ value: t, issues: [] }, i), a = n.right._zod.run({ value: t, issues: [] }, i);
    return o instanceof Promise || a instanceof Promise ? Promise.all([o, a]).then(([s, l]) => $o(r, s, l)) : $o(r, o, a);
  };
});
function tr(e, n) {
  if (e === n)
    return { valid: !0, data: e };
  if (e instanceof Date && n instanceof Date && +e == +n)
    return { valid: !0, data: e };
  if (Ze(e) && Ze(n)) {
    const r = Object.keys(n), i = Object.keys(e).filter((o) => r.indexOf(o) !== -1), t = { ...e, ...n };
    for (const o of i) {
      const a = tr(e[o], n[o]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...a.mergeErrorPath]
        };
      t[o] = a.data;
    }
    return { valid: !0, data: t };
  }
  if (Array.isArray(e) && Array.isArray(n)) {
    if (e.length !== n.length)
      return { valid: !1, mergeErrorPath: [] };
    const r = [];
    for (let i = 0; i < e.length; i++) {
      const t = e[i], o = n[i], a = tr(t, o);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [i, ...a.mergeErrorPath]
        };
      r.push(a.data);
    }
    return { valid: !0, data: r };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function $o(e, n, r) {
  if (n.issues.length && e.issues.push(...n.issues), r.issues.length && e.issues.push(...r.issues), Le(e))
    return e;
  const i = tr(n.value, r.value);
  if (!i.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(i.mergeErrorPath)}`);
  return e.value = i.data, e;
}
const Ur = /* @__PURE__ */ d("$ZodTuple", (e, n) => {
  T.init(e, n);
  const r = n.items;
  e._zod.parse = (i, t) => {
    const o = i.value;
    if (!Array.isArray(o))
      return i.issues.push({
        input: o,
        inst: e,
        expected: "tuple",
        code: "invalid_type"
      }), i;
    i.value = [];
    const a = [], u = [...r].reverse().findIndex((f) => f._zod.optin !== "optional"), s = u === -1 ? 0 : r.length - u;
    if (!n.rest) {
      const f = o.length > r.length, c = o.length < s - 1;
      if (f || c)
        return i.issues.push({
          ...f ? { code: "too_big", maximum: r.length } : { code: "too_small", minimum: r.length },
          input: o,
          inst: e,
          origin: "array"
        }), i;
    }
    let l = -1;
    for (const f of r) {
      if (l++, l >= o.length && l >= s)
        continue;
      const c = f._zod.run({
        value: o[l],
        issues: []
      }, t);
      c instanceof Promise ? a.push(c.then((p) => Ft(p, i, l))) : Ft(c, i, l);
    }
    if (n.rest) {
      const f = o.slice(r.length);
      for (const c of f) {
        l++;
        const p = n.rest._zod.run({
          value: c,
          issues: []
        }, t);
        p instanceof Promise ? a.push(p.then((_) => Ft(_, i, l))) : Ft(p, i, l);
      }
    }
    return a.length ? Promise.all(a).then(() => i) : i;
  };
});
function Ft(e, n, r) {
  e.issues.length && n.issues.push(...pe(r, e.issues)), n.value[r] = e.value;
}
const $l = /* @__PURE__ */ d("$ZodRecord", (e, n) => {
  T.init(e, n), e._zod.parse = (r, i) => {
    const t = r.value;
    if (!Ze(t))
      return r.issues.push({
        expected: "record",
        code: "invalid_type",
        input: t,
        inst: e
      }), r;
    const o = [], a = n.keyType._zod.values;
    if (a) {
      r.value = {};
      const u = /* @__PURE__ */ new Set();
      for (const l of a)
        if (typeof l == "string" || typeof l == "number" || typeof l == "symbol") {
          u.add(typeof l == "number" ? l.toString() : l);
          const f = n.valueType._zod.run({ value: t[l], issues: [] }, i);
          f instanceof Promise ? o.push(f.then((c) => {
            c.issues.length && r.issues.push(...pe(l, c.issues)), r.value[l] = c.value;
          })) : (f.issues.length && r.issues.push(...pe(l, f.issues)), r.value[l] = f.value);
        }
      let s;
      for (const l in t)
        u.has(l) || (s = s ?? [], s.push(l));
      s && s.length > 0 && r.issues.push({
        code: "unrecognized_keys",
        input: t,
        inst: e,
        keys: s
      });
    } else {
      r.value = {};
      for (const u of Reflect.ownKeys(t)) {
        if (u === "__proto__")
          continue;
        const s = n.keyType._zod.run({ value: u, issues: [] }, i);
        if (s instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (s.issues.length) {
          r.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: s.issues.map((f) => be(f, i, ee())),
            input: u,
            path: [u],
            inst: e
          }), r.value[s.value] = s.value;
          continue;
        }
        const l = n.valueType._zod.run({ value: t[u], issues: [] }, i);
        l instanceof Promise ? o.push(l.then((f) => {
          f.issues.length && r.issues.push(...pe(u, f.issues)), r.value[s.value] = f.value;
        })) : (l.issues.length && r.issues.push(...pe(u, l.issues)), r.value[s.value] = l.value);
      }
    }
    return o.length ? Promise.all(o).then(() => r) : r;
  };
}), El = /* @__PURE__ */ d("$ZodMap", (e, n) => {
  T.init(e, n), e._zod.parse = (r, i) => {
    const t = r.value;
    if (!(t instanceof Map))
      return r.issues.push({
        expected: "map",
        code: "invalid_type",
        input: t,
        inst: e
      }), r;
    const o = [];
    r.value = /* @__PURE__ */ new Map();
    for (const [a, u] of t) {
      const s = n.keyType._zod.run({ value: a, issues: [] }, i), l = n.valueType._zod.run({ value: u, issues: [] }, i);
      s instanceof Promise || l instanceof Promise ? o.push(Promise.all([s, l]).then(([f, c]) => {
        Eo(f, c, r, a, t, e, i);
      })) : Eo(s, l, r, a, t, e, i);
    }
    return o.length ? Promise.all(o).then(() => r) : r;
  };
});
function Eo(e, n, r, i, t, o, a) {
  e.issues.length && (tn.has(typeof i) ? r.issues.push(...pe(i, e.issues)) : r.issues.push({
    code: "invalid_key",
    origin: "map",
    input: t,
    inst: o,
    issues: e.issues.map((u) => be(u, a, ee()))
  })), n.issues.length && (tn.has(typeof i) ? r.issues.push(...pe(i, n.issues)) : r.issues.push({
    origin: "map",
    code: "invalid_element",
    input: t,
    inst: o,
    key: i,
    issues: n.issues.map((u) => be(u, a, ee()))
  })), r.value.set(e.value, n.value);
}
const kl = /* @__PURE__ */ d("$ZodSet", (e, n) => {
  T.init(e, n), e._zod.parse = (r, i) => {
    const t = r.value;
    if (!(t instanceof Set))
      return r.issues.push({
        input: t,
        inst: e,
        expected: "set",
        code: "invalid_type"
      }), r;
    const o = [];
    r.value = /* @__PURE__ */ new Set();
    for (const a of t) {
      const u = n.valueType._zod.run({ value: a, issues: [] }, i);
      u instanceof Promise ? o.push(u.then((s) => ko(s, r))) : ko(u, r);
    }
    return o.length ? Promise.all(o).then(() => r) : r;
  };
});
function ko(e, n) {
  e.issues.length && n.issues.push(...e.issues), n.value.add(e.value);
}
const Nl = /* @__PURE__ */ d("$ZodEnum", (e, n) => {
  T.init(e, n);
  const r = sr(n.entries), i = new Set(r);
  e._zod.values = i, e._zod.pattern = new RegExp(`^(${r.filter((t) => tn.has(typeof t)).map((t) => typeof t == "string" ? Oe(t) : t.toString()).join("|")})$`), e._zod.parse = (t, o) => {
    const a = t.value;
    return i.has(a) || t.issues.push({
      code: "invalid_value",
      values: r,
      input: a,
      inst: e
    }), t;
  };
}), Ol = /* @__PURE__ */ d("$ZodLiteral", (e, n) => {
  if (T.init(e, n), n.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const r = new Set(n.values);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${n.values.map((i) => typeof i == "string" ? Oe(i) : i ? Oe(i.toString()) : String(i)).join("|")})$`), e._zod.parse = (i, t) => {
    const o = i.value;
    return r.has(o) || i.issues.push({
      code: "invalid_value",
      values: n.values,
      input: o,
      inst: e
    }), i;
  };
}), Tl = /* @__PURE__ */ d("$ZodFile", (e, n) => {
  T.init(e, n), e._zod.parse = (r, i) => {
    const t = r.value;
    return t instanceof File || r.issues.push({
      expected: "file",
      code: "invalid_type",
      input: t,
      inst: e
    }), r;
  };
}), wl = /* @__PURE__ */ d("$ZodTransform", (e, n) => {
  T.init(e, n), e._zod.parse = (r, i) => {
    if (i.direction === "backward")
      throw new dn(e.constructor.name);
    const t = n.transform(r.value, r);
    if (i.async)
      return (t instanceof Promise ? t : Promise.resolve(t)).then((a) => (r.value = a, r));
    if (t instanceof Promise)
      throw new xe();
    return r.value = t, r;
  };
});
function No(e, n) {
  return e.issues.length && n === void 0 ? { issues: [], value: void 0 } : e;
}
const Al = /* @__PURE__ */ d("$ZodOptional", (e, n) => {
  T.init(e, n), e._zod.optin = "optional", e._zod.optout = "optional", U(e._zod, "values", () => n.innerType._zod.values ? /* @__PURE__ */ new Set([...n.innerType._zod.values, void 0]) : void 0), U(e._zod, "pattern", () => {
    const r = n.innerType._zod.pattern;
    return r ? new RegExp(`^(${mn(r.source)})?$`) : void 0;
  }), e._zod.parse = (r, i) => {
    if (n.innerType._zod.optin === "optional") {
      const t = n.innerType._zod.run(r, i);
      return t instanceof Promise ? t.then((o) => No(o, r.value)) : No(t, r.value);
    }
    return r.value === void 0 ? r : n.innerType._zod.run(r, i);
  };
}), Ul = /* @__PURE__ */ d("$ZodNullable", (e, n) => {
  T.init(e, n), U(e._zod, "optin", () => n.innerType._zod.optin), U(e._zod, "optout", () => n.innerType._zod.optout), U(e._zod, "pattern", () => {
    const r = n.innerType._zod.pattern;
    return r ? new RegExp(`^(${mn(r.source)}|null)$`) : void 0;
  }), U(e._zod, "values", () => n.innerType._zod.values ? /* @__PURE__ */ new Set([...n.innerType._zod.values, null]) : void 0), e._zod.parse = (r, i) => r.value === null ? r : n.innerType._zod.run(r, i);
}), Pl = /* @__PURE__ */ d("$ZodDefault", (e, n) => {
  T.init(e, n), e._zod.optin = "optional", U(e._zod, "values", () => n.innerType._zod.values), e._zod.parse = (r, i) => {
    if (i.direction === "backward")
      return n.innerType._zod.run(r, i);
    if (r.value === void 0)
      return r.value = n.defaultValue, r;
    const t = n.innerType._zod.run(r, i);
    return t instanceof Promise ? t.then((o) => Oo(o, n)) : Oo(t, n);
  };
});
function Oo(e, n) {
  return e.value === void 0 && (e.value = n.defaultValue), e;
}
const Dl = /* @__PURE__ */ d("$ZodPrefault", (e, n) => {
  T.init(e, n), e._zod.optin = "optional", U(e._zod, "values", () => n.innerType._zod.values), e._zod.parse = (r, i) => (i.direction === "backward" || r.value === void 0 && (r.value = n.defaultValue), n.innerType._zod.run(r, i));
}), Rl = /* @__PURE__ */ d("$ZodNonOptional", (e, n) => {
  T.init(e, n), U(e._zod, "values", () => {
    const r = n.innerType._zod.values;
    return r ? new Set([...r].filter((i) => i !== void 0)) : void 0;
  }), e._zod.parse = (r, i) => {
    const t = n.innerType._zod.run(r, i);
    return t instanceof Promise ? t.then((o) => To(o, e)) : To(t, e);
  };
});
function To(e, n) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: n
  }), e;
}
const zl = /* @__PURE__ */ d("$ZodSuccess", (e, n) => {
  T.init(e, n), e._zod.parse = (r, i) => {
    if (i.direction === "backward")
      throw new dn("ZodSuccess");
    const t = n.innerType._zod.run(r, i);
    return t instanceof Promise ? t.then((o) => (r.value = o.issues.length === 0, r)) : (r.value = t.issues.length === 0, r);
  };
}), Cl = /* @__PURE__ */ d("$ZodCatch", (e, n) => {
  T.init(e, n), U(e._zod, "optin", () => n.innerType._zod.optin), U(e._zod, "optout", () => n.innerType._zod.optout), U(e._zod, "values", () => n.innerType._zod.values), e._zod.parse = (r, i) => {
    if (i.direction === "backward")
      return n.innerType._zod.run(r, i);
    const t = n.innerType._zod.run(r, i);
    return t instanceof Promise ? t.then((o) => (r.value = o.value, o.issues.length && (r.value = n.catchValue({
      ...r,
      error: {
        issues: o.issues.map((a) => be(a, i, ee()))
      },
      input: r.value
    }), r.issues = []), r)) : (r.value = t.value, t.issues.length && (r.value = n.catchValue({
      ...r,
      error: {
        issues: t.issues.map((o) => be(o, i, ee()))
      },
      input: r.value
    }), r.issues = []), r);
  };
}), jl = /* @__PURE__ */ d("$ZodNaN", (e, n) => {
  T.init(e, n), e._zod.parse = (r, i) => ((typeof r.value != "number" || !Number.isNaN(r.value)) && r.issues.push({
    input: r.value,
    inst: e,
    expected: "nan",
    code: "invalid_type"
  }), r);
}), Ll = /* @__PURE__ */ d("$ZodPipe", (e, n) => {
  T.init(e, n), U(e._zod, "values", () => n.in._zod.values), U(e._zod, "optin", () => n.in._zod.optin), U(e._zod, "optout", () => n.out._zod.optout), U(e._zod, "propValues", () => n.in._zod.propValues), e._zod.parse = (r, i) => {
    if (i.direction === "backward") {
      const o = n.out._zod.run(r, i);
      return o instanceof Promise ? o.then((a) => Ht(a, n.in, i)) : Ht(o, n.in, i);
    }
    const t = n.in._zod.run(r, i);
    return t instanceof Promise ? t.then((o) => Ht(o, n.out, i)) : Ht(t, n.out, i);
  };
});
function Ht(e, n, r) {
  return e.issues.length ? (e.aborted = !0, e) : n._zod.run({ value: e.value, issues: e.issues }, r);
}
const Pr = /* @__PURE__ */ d("$ZodCodec", (e, n) => {
  T.init(e, n), U(e._zod, "values", () => n.in._zod.values), U(e._zod, "optin", () => n.in._zod.optin), U(e._zod, "optout", () => n.out._zod.optout), U(e._zod, "propValues", () => n.in._zod.propValues), e._zod.parse = (r, i) => {
    if ((i.direction || "forward") === "forward") {
      const o = n.in._zod.run(r, i);
      return o instanceof Promise ? o.then((a) => Bt(a, n, i)) : Bt(o, n, i);
    } else {
      const o = n.out._zod.run(r, i);
      return o instanceof Promise ? o.then((a) => Bt(a, n, i)) : Bt(o, n, i);
    }
  };
});
function Bt(e, n, r) {
  if (e.issues.length)
    return e.aborted = !0, e;
  if ((r.direction || "forward") === "forward") {
    const t = n.transform(e.value, e);
    return t instanceof Promise ? t.then((o) => Vt(e, o, n.out, r)) : Vt(e, t, n.out, r);
  } else {
    const t = n.reverseTransform(e.value, e);
    return t instanceof Promise ? t.then((o) => Vt(e, o, n.in, r)) : Vt(e, t, n.in, r);
  }
}
function Vt(e, n, r, i) {
  return e.issues.length ? (e.aborted = !0, e) : r._zod.run({ value: n, issues: e.issues }, i);
}
const xl = /* @__PURE__ */ d("$ZodReadonly", (e, n) => {
  T.init(e, n), U(e._zod, "propValues", () => n.innerType._zod.propValues), U(e._zod, "values", () => n.innerType._zod.values), U(e._zod, "optin", () => {
    var r, i;
    return (i = (r = n.innerType) == null ? void 0 : r._zod) == null ? void 0 : i.optin;
  }), U(e._zod, "optout", () => {
    var r, i;
    return (i = (r = n.innerType) == null ? void 0 : r._zod) == null ? void 0 : i.optout;
  }), e._zod.parse = (r, i) => {
    if (i.direction === "backward")
      return n.innerType._zod.run(r, i);
    const t = n.innerType._zod.run(r, i);
    return t instanceof Promise ? t.then(wo) : wo(t);
  };
});
function wo(e) {
  return e.value = Object.freeze(e.value), e;
}
const Ml = /* @__PURE__ */ d("$ZodTemplateLiteral", (e, n) => {
  T.init(e, n);
  const r = [];
  for (const i of n.parts)
    if (typeof i == "object" && i !== null) {
      if (!i._zod.pattern)
        throw new Error(`Invalid template literal part, no pattern found: ${[...i._zod.traits].shift()}`);
      const t = i._zod.pattern instanceof RegExp ? i._zod.pattern.source : i._zod.pattern;
      if (!t)
        throw new Error(`Invalid template literal part: ${i._zod.traits}`);
      const o = t.startsWith("^") ? 1 : 0, a = t.endsWith("$") ? t.length - 1 : t.length;
      r.push(t.slice(o, a));
    } else if (i === null || da.has(typeof i))
      r.push(Oe(`${i}`));
    else
      throw new Error(`Invalid template literal part: ${i}`);
  e._zod.pattern = new RegExp(`^${r.join("")}$`), e._zod.parse = (i, t) => typeof i.value != "string" ? (i.issues.push({
    input: i.value,
    inst: e,
    expected: "template_literal",
    code: "invalid_type"
  }), i) : (e._zod.pattern.lastIndex = 0, e._zod.pattern.test(i.value) || i.issues.push({
    input: i.value,
    inst: e,
    code: "invalid_format",
    format: n.format ?? "template_literal",
    pattern: e._zod.pattern.source
  }), i);
}), Zl = /* @__PURE__ */ d("$ZodFunction", (e, n) => (T.init(e, n), e._def = n, e._zod.def = n, e.implement = (r) => {
  if (typeof r != "function")
    throw new Error("implement() must be called with a function");
  return function(...i) {
    const t = e._def.input ? Qn(e._def.input, i) : i, o = Reflect.apply(r, this, t);
    return e._def.output ? Qn(e._def.output, o) : o;
  };
}, e.implementAsync = (r) => {
  if (typeof r != "function")
    throw new Error("implementAsync() must be called with a function");
  return async function(...i) {
    const t = e._def.input ? await er(e._def.input, i) : i, o = await Reflect.apply(r, this, t);
    return e._def.output ? await er(e._def.output, o) : o;
  };
}, e._zod.parse = (r, i) => typeof r.value != "function" ? (r.issues.push({
  code: "invalid_type",
  expected: "function",
  input: r.value,
  inst: e
}), r) : (e._def.output && e._def.output._zod.def.type === "promise" ? r.value = e.implementAsync(r.value) : r.value = e.implement(r.value), r), e.input = (...r) => {
  const i = e.constructor;
  return Array.isArray(r[0]) ? new i({
    type: "function",
    input: new Ur({
      type: "tuple",
      items: r[0],
      rest: r[1]
    }),
    output: e._def.output
  }) : new i({
    type: "function",
    input: r[0],
    output: e._def.output
  });
}, e.output = (r) => {
  const i = e.constructor;
  return new i({
    type: "function",
    input: e._def.input,
    output: r
  });
}, e)), Gl = /* @__PURE__ */ d("$ZodPromise", (e, n) => {
  T.init(e, n), e._zod.parse = (r, i) => Promise.resolve(r.value).then((t) => n.innerType._zod.run({ value: t, issues: [] }, i));
}), Fl = /* @__PURE__ */ d("$ZodLazy", (e, n) => {
  T.init(e, n), U(e._zod, "innerType", () => n.getter()), U(e._zod, "pattern", () => {
    var r, i;
    return (i = (r = e._zod.innerType) == null ? void 0 : r._zod) == null ? void 0 : i.pattern;
  }), U(e._zod, "propValues", () => {
    var r, i;
    return (i = (r = e._zod.innerType) == null ? void 0 : r._zod) == null ? void 0 : i.propValues;
  }), U(e._zod, "optin", () => {
    var r, i;
    return ((i = (r = e._zod.innerType) == null ? void 0 : r._zod) == null ? void 0 : i.optin) ?? void 0;
  }), U(e._zod, "optout", () => {
    var r, i;
    return ((i = (r = e._zod.innerType) == null ? void 0 : r._zod) == null ? void 0 : i.optout) ?? void 0;
  }), e._zod.parse = (r, i) => e._zod.innerType._zod.run(r, i);
}), Hl = /* @__PURE__ */ d("$ZodCustom", (e, n) => {
  M.init(e, n), T.init(e, n), e._zod.parse = (r, i) => r, e._zod.check = (r) => {
    const i = r.value, t = n.fn(i);
    if (t instanceof Promise)
      return t.then((o) => Ao(o, r, i, e));
    Ao(t, r, i, e);
  };
});
function Ao(e, n, r, i) {
  if (!e) {
    const t = {
      code: "custom",
      input: r,
      inst: i,
      // incorporates params.error into issue reporting
      path: [...i._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !i._zod.def.abort
      // params: inst._zod.def.params,
    };
    i._zod.def.params && (t.params = i._zod.def.params), n.issues.push(tt(t));
  }
}
const ng = () => {
  const e = {
    string: { unit: "حرف", verb: "أن يحوي" },
    file: { unit: "بايت", verb: "أن يحوي" },
    array: { unit: "عنصر", verb: "أن يحوي" },
    set: { unit: "عنصر", verb: "أن يحوي" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "مدخل",
    email: "بريد إلكتروني",
    url: "رابط",
    emoji: "إيموجي",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "تاريخ ووقت بمعيار ISO",
    date: "تاريخ بمعيار ISO",
    time: "وقت بمعيار ISO",
    duration: "مدة بمعيار ISO",
    ipv4: "عنوان IPv4",
    ipv6: "عنوان IPv6",
    cidrv4: "مدى عناوين بصيغة IPv4",
    cidrv6: "مدى عناوين بصيغة IPv6",
    base64: "نَص بترميز base64-encoded",
    base64url: "نَص بترميز base64url-encoded",
    json_string: "نَص على هيئة JSON",
    e164: "رقم هاتف بمعيار E.164",
    jwt: "JWT",
    template_literal: "مدخل"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `مدخلات غير مقبولة: يفترض إدخال ${t.expected}، ولكن تم إدخال ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `مدخلات غير مقبولة: يفترض إدخال ${N(t.values[0])}` : `اختيار غير مقبول: يتوقع انتقاء أحد هذه الخيارات: ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? ` أكبر من اللازم: يفترض أن تكون ${t.origin ?? "القيمة"} ${o} ${t.maximum.toString()} ${a.unit ?? "عنصر"}` : `أكبر من اللازم: يفترض أن تكون ${t.origin ?? "القيمة"} ${o} ${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `أصغر من اللازم: يفترض لـ ${t.origin} أن يكون ${o} ${t.minimum.toString()} ${a.unit}` : `أصغر من اللازم: يفترض لـ ${t.origin} أن يكون ${o} ${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `نَص غير مقبول: يجب أن يبدأ بـ "${t.prefix}"` : o.format === "ends_with" ? `نَص غير مقبول: يجب أن ينتهي بـ "${o.suffix}"` : o.format === "includes" ? `نَص غير مقبول: يجب أن يتضمَّن "${o.includes}"` : o.format === "regex" ? `نَص غير مقبول: يجب أن يطابق النمط ${o.pattern}` : `${i[o.format] ?? t.format} غير مقبول`;
      }
      case "not_multiple_of":
        return `رقم غير مقبول: يجب أن يكون من مضاعفات ${t.divisor}`;
      case "unrecognized_keys":
        return `معرف${t.keys.length > 1 ? "ات" : ""} غريب${t.keys.length > 1 ? "ة" : ""}: ${I(t.keys, "، ")}`;
      case "invalid_key":
        return `معرف غير مقبول في ${t.origin}`;
      case "invalid_union":
        return "مدخل غير مقبول";
      case "invalid_element":
        return `مدخل غير مقبول في ${t.origin}`;
      default:
        return "مدخل غير مقبول";
    }
  };
};
function rg() {
  return {
    localeError: ng()
  };
}
const ig = () => {
  const e = {
    string: { unit: "simvol", verb: "olmalıdır" },
    file: { unit: "bayt", verb: "olmalıdır" },
    array: { unit: "element", verb: "olmalıdır" },
    set: { unit: "element", verb: "olmalıdır" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "input",
    email: "email address",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datetime",
    date: "ISO date",
    time: "ISO time",
    duration: "ISO duration",
    ipv4: "IPv4 address",
    ipv6: "IPv6 address",
    cidrv4: "IPv4 range",
    cidrv6: "IPv6 range",
    base64: "base64-encoded string",
    base64url: "base64url-encoded string",
    json_string: "JSON string",
    e164: "E.164 number",
    jwt: "JWT",
    template_literal: "input"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Yanlış dəyər: gözlənilən ${t.expected}, daxil olan ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Yanlış dəyər: gözlənilən ${N(t.values[0])}` : `Yanlış seçim: aşağıdakılardan biri olmalıdır: ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Çox böyük: gözlənilən ${t.origin ?? "dəyər"} ${o}${t.maximum.toString()} ${a.unit ?? "element"}` : `Çox böyük: gözlənilən ${t.origin ?? "dəyər"} ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Çox kiçik: gözlənilən ${t.origin} ${o}${t.minimum.toString()} ${a.unit}` : `Çox kiçik: gözlənilən ${t.origin} ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Yanlış mətn: "${o.prefix}" ilə başlamalıdır` : o.format === "ends_with" ? `Yanlış mətn: "${o.suffix}" ilə bitməlidir` : o.format === "includes" ? `Yanlış mətn: "${o.includes}" daxil olmalıdır` : o.format === "regex" ? `Yanlış mətn: ${o.pattern} şablonuna uyğun olmalıdır` : `Yanlış ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Yanlış ədəd: ${t.divisor} ilə bölünə bilən olmalıdır`;
      case "unrecognized_keys":
        return `Tanınmayan açar${t.keys.length > 1 ? "lar" : ""}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `${t.origin} daxilində yanlış açar`;
      case "invalid_union":
        return "Yanlış dəyər";
      case "invalid_element":
        return `${t.origin} daxilində yanlış dəyər`;
      default:
        return "Yanlış dəyər";
    }
  };
};
function og() {
  return {
    localeError: ig()
  };
}
function Uo(e, n, r, i) {
  const t = Math.abs(e), o = t % 10, a = t % 100;
  return a >= 11 && a <= 19 ? i : o === 1 ? n : o >= 2 && o <= 4 ? r : i;
}
const ag = () => {
  const e = {
    string: {
      unit: {
        one: "сімвал",
        few: "сімвалы",
        many: "сімвалаў"
      },
      verb: "мець"
    },
    array: {
      unit: {
        one: "элемент",
        few: "элементы",
        many: "элементаў"
      },
      verb: "мець"
    },
    set: {
      unit: {
        one: "элемент",
        few: "элементы",
        many: "элементаў"
      },
      verb: "мець"
    },
    file: {
      unit: {
        one: "байт",
        few: "байты",
        many: "байтаў"
      },
      verb: "мець"
    }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "лік";
      case "object": {
        if (Array.isArray(t))
          return "масіў";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "увод",
    email: "email адрас",
    url: "URL",
    emoji: "эмодзі",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO дата і час",
    date: "ISO дата",
    time: "ISO час",
    duration: "ISO працягласць",
    ipv4: "IPv4 адрас",
    ipv6: "IPv6 адрас",
    cidrv4: "IPv4 дыяпазон",
    cidrv6: "IPv6 дыяпазон",
    base64: "радок у фармаце base64",
    base64url: "радок у фармаце base64url",
    json_string: "JSON радок",
    e164: "нумар E.164",
    jwt: "JWT",
    template_literal: "увод"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Няправільны ўвод: чакаўся ${t.expected}, атрымана ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Няправільны ўвод: чакалася ${N(t.values[0])}` : `Няправільны варыянт: чакаўся адзін з ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        if (a) {
          const u = Number(t.maximum), s = Uo(u, a.unit.one, a.unit.few, a.unit.many);
          return `Занадта вялікі: чакалася, што ${t.origin ?? "значэнне"} павінна ${a.verb} ${o}${t.maximum.toString()} ${s}`;
        }
        return `Занадта вялікі: чакалася, што ${t.origin ?? "значэнне"} павінна быць ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        if (a) {
          const u = Number(t.minimum), s = Uo(u, a.unit.one, a.unit.few, a.unit.many);
          return `Занадта малы: чакалася, што ${t.origin} павінна ${a.verb} ${o}${t.minimum.toString()} ${s}`;
        }
        return `Занадта малы: чакалася, што ${t.origin} павінна быць ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Няправільны радок: павінен пачынацца з "${o.prefix}"` : o.format === "ends_with" ? `Няправільны радок: павінен заканчвацца на "${o.suffix}"` : o.format === "includes" ? `Няправільны радок: павінен змяшчаць "${o.includes}"` : o.format === "regex" ? `Няправільны радок: павінен адпавядаць шаблону ${o.pattern}` : `Няправільны ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Няправільны лік: павінен быць кратным ${t.divisor}`;
      case "unrecognized_keys":
        return `Нераспазнаны ${t.keys.length > 1 ? "ключы" : "ключ"}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Няправільны ключ у ${t.origin}`;
      case "invalid_union":
        return "Няправільны ўвод";
      case "invalid_element":
        return `Няправільнае значэнне ў ${t.origin}`;
      default:
        return "Няправільны ўвод";
    }
  };
};
function ug() {
  return {
    localeError: ag()
  };
}
const lg = (e) => {
  const n = typeof e;
  switch (n) {
    case "number":
      return Number.isNaN(e) ? "NaN" : "число";
    case "object": {
      if (Array.isArray(e))
        return "масив";
      if (e === null)
        return "null";
      if (Object.getPrototypeOf(e) !== Object.prototype && e.constructor)
        return e.constructor.name;
    }
  }
  return n;
}, sg = () => {
  const e = {
    string: { unit: "символа", verb: "да съдържа" },
    file: { unit: "байта", verb: "да съдържа" },
    array: { unit: "елемента", verb: "да съдържа" },
    set: { unit: "елемента", verb: "да съдържа" }
  };
  function n(i) {
    return e[i] ?? null;
  }
  const r = {
    regex: "вход",
    email: "имейл адрес",
    url: "URL",
    emoji: "емоджи",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO време",
    date: "ISO дата",
    time: "ISO време",
    duration: "ISO продължителност",
    ipv4: "IPv4 адрес",
    ipv6: "IPv6 адрес",
    cidrv4: "IPv4 диапазон",
    cidrv6: "IPv6 диапазон",
    base64: "base64-кодиран низ",
    base64url: "base64url-кодиран низ",
    json_string: "JSON низ",
    e164: "E.164 номер",
    jwt: "JWT",
    template_literal: "вход"
  };
  return (i) => {
    switch (i.code) {
      case "invalid_type":
        return `Невалиден вход: очакван ${i.expected}, получен ${lg(i.input)}`;
      case "invalid_value":
        return i.values.length === 1 ? `Невалиден вход: очакван ${N(i.values[0])}` : `Невалидна опция: очаквано едно от ${I(i.values, "|")}`;
      case "too_big": {
        const t = i.inclusive ? "<=" : "<", o = n(i.origin);
        return o ? `Твърде голямо: очаква се ${i.origin ?? "стойност"} да съдържа ${t}${i.maximum.toString()} ${o.unit ?? "елемента"}` : `Твърде голямо: очаква се ${i.origin ?? "стойност"} да бъде ${t}${i.maximum.toString()}`;
      }
      case "too_small": {
        const t = i.inclusive ? ">=" : ">", o = n(i.origin);
        return o ? `Твърде малко: очаква се ${i.origin} да съдържа ${t}${i.minimum.toString()} ${o.unit}` : `Твърде малко: очаква се ${i.origin} да бъде ${t}${i.minimum.toString()}`;
      }
      case "invalid_format": {
        const t = i;
        if (t.format === "starts_with")
          return `Невалиден низ: трябва да започва с "${t.prefix}"`;
        if (t.format === "ends_with")
          return `Невалиден низ: трябва да завършва с "${t.suffix}"`;
        if (t.format === "includes")
          return `Невалиден низ: трябва да включва "${t.includes}"`;
        if (t.format === "regex")
          return `Невалиден низ: трябва да съвпада с ${t.pattern}`;
        let o = "Невалиден";
        return t.format === "emoji" && (o = "Невалидно"), t.format === "datetime" && (o = "Невалидно"), t.format === "date" && (o = "Невалидна"), t.format === "time" && (o = "Невалидно"), t.format === "duration" && (o = "Невалидна"), `${o} ${r[t.format] ?? i.format}`;
      }
      case "not_multiple_of":
        return `Невалидно число: трябва да бъде кратно на ${i.divisor}`;
      case "unrecognized_keys":
        return `Неразпознат${i.keys.length > 1 ? "и" : ""} ключ${i.keys.length > 1 ? "ове" : ""}: ${I(i.keys, ", ")}`;
      case "invalid_key":
        return `Невалиден ключ в ${i.origin}`;
      case "invalid_union":
        return "Невалиден вход";
      case "invalid_element":
        return `Невалидна стойност в ${i.origin}`;
      default:
        return "Невалиден вход";
    }
  };
};
function cg() {
  return {
    localeError: sg()
  };
}
const dg = () => {
  const e = {
    string: { unit: "caràcters", verb: "contenir" },
    file: { unit: "bytes", verb: "contenir" },
    array: { unit: "elements", verb: "contenir" },
    set: { unit: "elements", verb: "contenir" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "entrada",
    email: "adreça electrònica",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "data i hora ISO",
    date: "data ISO",
    time: "hora ISO",
    duration: "durada ISO",
    ipv4: "adreça IPv4",
    ipv6: "adreça IPv6",
    cidrv4: "rang IPv4",
    cidrv6: "rang IPv6",
    base64: "cadena codificada en base64",
    base64url: "cadena codificada en base64url",
    json_string: "cadena JSON",
    e164: "número E.164",
    jwt: "JWT",
    template_literal: "entrada"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Tipus invàlid: s'esperava ${t.expected}, s'ha rebut ${r(t.input)}`;
      // return `Tipus invàlid: s'esperava ${issue.expected}, s'ha rebut ${util.getParsedType(issue.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Valor invàlid: s'esperava ${N(t.values[0])}` : `Opció invàlida: s'esperava una de ${I(t.values, " o ")}`;
      case "too_big": {
        const o = t.inclusive ? "com a màxim" : "menys de", a = n(t.origin);
        return a ? `Massa gran: s'esperava que ${t.origin ?? "el valor"} contingués ${o} ${t.maximum.toString()} ${a.unit ?? "elements"}` : `Massa gran: s'esperava que ${t.origin ?? "el valor"} fos ${o} ${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? "com a mínim" : "més de", a = n(t.origin);
        return a ? `Massa petit: s'esperava que ${t.origin} contingués ${o} ${t.minimum.toString()} ${a.unit}` : `Massa petit: s'esperava que ${t.origin} fos ${o} ${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Format invàlid: ha de començar amb "${o.prefix}"` : o.format === "ends_with" ? `Format invàlid: ha d'acabar amb "${o.suffix}"` : o.format === "includes" ? `Format invàlid: ha d'incloure "${o.includes}"` : o.format === "regex" ? `Format invàlid: ha de coincidir amb el patró ${o.pattern}` : `Format invàlid per a ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Número invàlid: ha de ser múltiple de ${t.divisor}`;
      case "unrecognized_keys":
        return `Clau${t.keys.length > 1 ? "s" : ""} no reconeguda${t.keys.length > 1 ? "s" : ""}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Clau invàlida a ${t.origin}`;
      case "invalid_union":
        return "Entrada invàlida";
      // Could also be "Tipus d'unió invàlid" but "Entrada invàlida" is more general
      case "invalid_element":
        return `Element invàlid a ${t.origin}`;
      default:
        return "Entrada invàlida";
    }
  };
};
function mg() {
  return {
    localeError: dg()
  };
}
const gg = () => {
  const e = {
    string: { unit: "znaků", verb: "mít" },
    file: { unit: "bajtů", verb: "mít" },
    array: { unit: "prvků", verb: "mít" },
    set: { unit: "prvků", verb: "mít" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "číslo";
      case "string":
        return "řetězec";
      case "boolean":
        return "boolean";
      case "bigint":
        return "bigint";
      case "function":
        return "funkce";
      case "symbol":
        return "symbol";
      case "undefined":
        return "undefined";
      case "object": {
        if (Array.isArray(t))
          return "pole";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "regulární výraz",
    email: "e-mailová adresa",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "datum a čas ve formátu ISO",
    date: "datum ve formátu ISO",
    time: "čas ve formátu ISO",
    duration: "doba trvání ISO",
    ipv4: "IPv4 adresa",
    ipv6: "IPv6 adresa",
    cidrv4: "rozsah IPv4",
    cidrv6: "rozsah IPv6",
    base64: "řetězec zakódovaný ve formátu base64",
    base64url: "řetězec zakódovaný ve formátu base64url",
    json_string: "řetězec ve formátu JSON",
    e164: "číslo E.164",
    jwt: "JWT",
    template_literal: "vstup"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Neplatný vstup: očekáváno ${t.expected}, obdrženo ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Neplatný vstup: očekáváno ${N(t.values[0])}` : `Neplatná možnost: očekávána jedna z hodnot ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Hodnota je příliš velká: ${t.origin ?? "hodnota"} musí mít ${o}${t.maximum.toString()} ${a.unit ?? "prvků"}` : `Hodnota je příliš velká: ${t.origin ?? "hodnota"} musí být ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Hodnota je příliš malá: ${t.origin ?? "hodnota"} musí mít ${o}${t.minimum.toString()} ${a.unit ?? "prvků"}` : `Hodnota je příliš malá: ${t.origin ?? "hodnota"} musí být ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Neplatný řetězec: musí začínat na "${o.prefix}"` : o.format === "ends_with" ? `Neplatný řetězec: musí končit na "${o.suffix}"` : o.format === "includes" ? `Neplatný řetězec: musí obsahovat "${o.includes}"` : o.format === "regex" ? `Neplatný řetězec: musí odpovídat vzoru ${o.pattern}` : `Neplatný formát ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Neplatné číslo: musí být násobkem ${t.divisor}`;
      case "unrecognized_keys":
        return `Neznámé klíče: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Neplatný klíč v ${t.origin}`;
      case "invalid_union":
        return "Neplatný vstup";
      case "invalid_element":
        return `Neplatná hodnota v ${t.origin}`;
      default:
        return "Neplatný vstup";
    }
  };
};
function fg() {
  return {
    localeError: gg()
  };
}
const pg = () => {
  const e = {
    string: { unit: "tegn", verb: "havde" },
    file: { unit: "bytes", verb: "havde" },
    array: { unit: "elementer", verb: "indeholdt" },
    set: { unit: "elementer", verb: "indeholdt" }
  }, n = {
    string: "streng",
    number: "tal",
    boolean: "boolean",
    array: "liste",
    object: "objekt",
    set: "sæt",
    file: "fil"
  };
  function r(a) {
    return e[a] ?? null;
  }
  function i(a) {
    return n[a] ?? a;
  }
  const t = (a) => {
    const u = typeof a;
    switch (u) {
      case "number":
        return Number.isNaN(a) ? "NaN" : "tal";
      case "object":
        return Array.isArray(a) ? "liste" : a === null ? "null" : Object.getPrototypeOf(a) !== Object.prototype && a.constructor ? a.constructor.name : "objekt";
    }
    return u;
  }, o = {
    regex: "input",
    email: "e-mailadresse",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO dato- og klokkeslæt",
    date: "ISO-dato",
    time: "ISO-klokkeslæt",
    duration: "ISO-varighed",
    ipv4: "IPv4-område",
    ipv6: "IPv6-område",
    cidrv4: "IPv4-spektrum",
    cidrv6: "IPv6-spektrum",
    base64: "base64-kodet streng",
    base64url: "base64url-kodet streng",
    json_string: "JSON-streng",
    e164: "E.164-nummer",
    jwt: "JWT",
    template_literal: "input"
  };
  return (a) => {
    switch (a.code) {
      case "invalid_type":
        return `Ugyldigt input: forventede ${i(a.expected)}, fik ${i(t(a.input))}`;
      case "invalid_value":
        return a.values.length === 1 ? `Ugyldig værdi: forventede ${N(a.values[0])}` : `Ugyldigt valg: forventede en af følgende ${I(a.values, "|")}`;
      case "too_big": {
        const u = a.inclusive ? "<=" : "<", s = r(a.origin), l = i(a.origin);
        return s ? `For stor: forventede ${l ?? "value"} ${s.verb} ${u} ${a.maximum.toString()} ${s.unit ?? "elementer"}` : `For stor: forventede ${l ?? "value"} havde ${u} ${a.maximum.toString()}`;
      }
      case "too_small": {
        const u = a.inclusive ? ">=" : ">", s = r(a.origin), l = i(a.origin);
        return s ? `For lille: forventede ${l} ${s.verb} ${u} ${a.minimum.toString()} ${s.unit}` : `For lille: forventede ${l} havde ${u} ${a.minimum.toString()}`;
      }
      case "invalid_format": {
        const u = a;
        return u.format === "starts_with" ? `Ugyldig streng: skal starte med "${u.prefix}"` : u.format === "ends_with" ? `Ugyldig streng: skal ende med "${u.suffix}"` : u.format === "includes" ? `Ugyldig streng: skal indeholde "${u.includes}"` : u.format === "regex" ? `Ugyldig streng: skal matche mønsteret ${u.pattern}` : `Ugyldig ${o[u.format] ?? a.format}`;
      }
      case "not_multiple_of":
        return `Ugyldigt tal: skal være deleligt med ${a.divisor}`;
      case "unrecognized_keys":
        return `${a.keys.length > 1 ? "Ukendte nøgler" : "Ukendt nøgle"}: ${I(a.keys, ", ")}`;
      case "invalid_key":
        return `Ugyldig nøgle i ${a.origin}`;
      case "invalid_union":
        return "Ugyldigt input: matcher ingen af de tilladte typer";
      case "invalid_element":
        return `Ugyldig værdi i ${a.origin}`;
      default:
        return "Ugyldigt input";
    }
  };
};
function vg() {
  return {
    localeError: pg()
  };
}
const hg = () => {
  const e = {
    string: { unit: "Zeichen", verb: "zu haben" },
    file: { unit: "Bytes", verb: "zu haben" },
    array: { unit: "Elemente", verb: "zu haben" },
    set: { unit: "Elemente", verb: "zu haben" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "Zahl";
      case "object": {
        if (Array.isArray(t))
          return "Array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "Eingabe",
    email: "E-Mail-Adresse",
    url: "URL",
    emoji: "Emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO-Datum und -Uhrzeit",
    date: "ISO-Datum",
    time: "ISO-Uhrzeit",
    duration: "ISO-Dauer",
    ipv4: "IPv4-Adresse",
    ipv6: "IPv6-Adresse",
    cidrv4: "IPv4-Bereich",
    cidrv6: "IPv6-Bereich",
    base64: "Base64-codierter String",
    base64url: "Base64-URL-codierter String",
    json_string: "JSON-String",
    e164: "E.164-Nummer",
    jwt: "JWT",
    template_literal: "Eingabe"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Ungültige Eingabe: erwartet ${t.expected}, erhalten ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Ungültige Eingabe: erwartet ${N(t.values[0])}` : `Ungültige Option: erwartet eine von ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Zu groß: erwartet, dass ${t.origin ?? "Wert"} ${o}${t.maximum.toString()} ${a.unit ?? "Elemente"} hat` : `Zu groß: erwartet, dass ${t.origin ?? "Wert"} ${o}${t.maximum.toString()} ist`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Zu klein: erwartet, dass ${t.origin} ${o}${t.minimum.toString()} ${a.unit} hat` : `Zu klein: erwartet, dass ${t.origin} ${o}${t.minimum.toString()} ist`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Ungültiger String: muss mit "${o.prefix}" beginnen` : o.format === "ends_with" ? `Ungültiger String: muss mit "${o.suffix}" enden` : o.format === "includes" ? `Ungültiger String: muss "${o.includes}" enthalten` : o.format === "regex" ? `Ungültiger String: muss dem Muster ${o.pattern} entsprechen` : `Ungültig: ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Ungültige Zahl: muss ein Vielfaches von ${t.divisor} sein`;
      case "unrecognized_keys":
        return `${t.keys.length > 1 ? "Unbekannte Schlüssel" : "Unbekannter Schlüssel"}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Ungültiger Schlüssel in ${t.origin}`;
      case "invalid_union":
        return "Ungültige Eingabe";
      case "invalid_element":
        return `Ungültiger Wert in ${t.origin}`;
      default:
        return "Ungültige Eingabe";
    }
  };
};
function bg() {
  return {
    localeError: hg()
  };
}
const _g = (e) => {
  const n = typeof e;
  switch (n) {
    case "number":
      return Number.isNaN(e) ? "NaN" : "number";
    case "object": {
      if (Array.isArray(e))
        return "array";
      if (e === null)
        return "null";
      if (Object.getPrototypeOf(e) !== Object.prototype && e.constructor)
        return e.constructor.name;
    }
  }
  return n;
}, yg = () => {
  const e = {
    string: { unit: "characters", verb: "to have" },
    file: { unit: "bytes", verb: "to have" },
    array: { unit: "items", verb: "to have" },
    set: { unit: "items", verb: "to have" }
  };
  function n(i) {
    return e[i] ?? null;
  }
  const r = {
    regex: "input",
    email: "email address",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datetime",
    date: "ISO date",
    time: "ISO time",
    duration: "ISO duration",
    ipv4: "IPv4 address",
    ipv6: "IPv6 address",
    mac: "MAC address",
    cidrv4: "IPv4 range",
    cidrv6: "IPv6 range",
    base64: "base64-encoded string",
    base64url: "base64url-encoded string",
    json_string: "JSON string",
    e164: "E.164 number",
    jwt: "JWT",
    template_literal: "input"
  };
  return (i) => {
    switch (i.code) {
      case "invalid_type":
        return `Invalid input: expected ${i.expected}, received ${_g(i.input)}`;
      case "invalid_value":
        return i.values.length === 1 ? `Invalid input: expected ${N(i.values[0])}` : `Invalid option: expected one of ${I(i.values, "|")}`;
      case "too_big": {
        const t = i.inclusive ? "<=" : "<", o = n(i.origin);
        return o ? `Too big: expected ${i.origin ?? "value"} to have ${t}${i.maximum.toString()} ${o.unit ?? "elements"}` : `Too big: expected ${i.origin ?? "value"} to be ${t}${i.maximum.toString()}`;
      }
      case "too_small": {
        const t = i.inclusive ? ">=" : ">", o = n(i.origin);
        return o ? `Too small: expected ${i.origin} to have ${t}${i.minimum.toString()} ${o.unit}` : `Too small: expected ${i.origin} to be ${t}${i.minimum.toString()}`;
      }
      case "invalid_format": {
        const t = i;
        return t.format === "starts_with" ? `Invalid string: must start with "${t.prefix}"` : t.format === "ends_with" ? `Invalid string: must end with "${t.suffix}"` : t.format === "includes" ? `Invalid string: must include "${t.includes}"` : t.format === "regex" ? `Invalid string: must match pattern ${t.pattern}` : `Invalid ${r[t.format] ?? i.format}`;
      }
      case "not_multiple_of":
        return `Invalid number: must be a multiple of ${i.divisor}`;
      case "unrecognized_keys":
        return `Unrecognized key${i.keys.length > 1 ? "s" : ""}: ${I(i.keys, ", ")}`;
      case "invalid_key":
        return `Invalid key in ${i.origin}`;
      case "invalid_union":
        return "Invalid input";
      case "invalid_element":
        return `Invalid value in ${i.origin}`;
      default:
        return "Invalid input";
    }
  };
};
function Bl() {
  return {
    localeError: yg()
  };
}
const Sg = (e) => {
  const n = typeof e;
  switch (n) {
    case "number":
      return Number.isNaN(e) ? "NaN" : "nombro";
    case "object": {
      if (Array.isArray(e))
        return "tabelo";
      if (e === null)
        return "senvalora";
      if (Object.getPrototypeOf(e) !== Object.prototype && e.constructor)
        return e.constructor.name;
    }
  }
  return n;
}, Ig = () => {
  const e = {
    string: { unit: "karaktrojn", verb: "havi" },
    file: { unit: "bajtojn", verb: "havi" },
    array: { unit: "elementojn", verb: "havi" },
    set: { unit: "elementojn", verb: "havi" }
  };
  function n(i) {
    return e[i] ?? null;
  }
  const r = {
    regex: "enigo",
    email: "retadreso",
    url: "URL",
    emoji: "emoĝio",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO-datotempo",
    date: "ISO-dato",
    time: "ISO-tempo",
    duration: "ISO-daŭro",
    ipv4: "IPv4-adreso",
    ipv6: "IPv6-adreso",
    cidrv4: "IPv4-rango",
    cidrv6: "IPv6-rango",
    base64: "64-ume kodita karaktraro",
    base64url: "URL-64-ume kodita karaktraro",
    json_string: "JSON-karaktraro",
    e164: "E.164-nombro",
    jwt: "JWT",
    template_literal: "enigo"
  };
  return (i) => {
    switch (i.code) {
      case "invalid_type":
        return `Nevalida enigo: atendiĝis ${i.expected}, riceviĝis ${Sg(i.input)}`;
      case "invalid_value":
        return i.values.length === 1 ? `Nevalida enigo: atendiĝis ${N(i.values[0])}` : `Nevalida opcio: atendiĝis unu el ${I(i.values, "|")}`;
      case "too_big": {
        const t = i.inclusive ? "<=" : "<", o = n(i.origin);
        return o ? `Tro granda: atendiĝis ke ${i.origin ?? "valoro"} havu ${t}${i.maximum.toString()} ${o.unit ?? "elementojn"}` : `Tro granda: atendiĝis ke ${i.origin ?? "valoro"} havu ${t}${i.maximum.toString()}`;
      }
      case "too_small": {
        const t = i.inclusive ? ">=" : ">", o = n(i.origin);
        return o ? `Tro malgranda: atendiĝis ke ${i.origin} havu ${t}${i.minimum.toString()} ${o.unit}` : `Tro malgranda: atendiĝis ke ${i.origin} estu ${t}${i.minimum.toString()}`;
      }
      case "invalid_format": {
        const t = i;
        return t.format === "starts_with" ? `Nevalida karaktraro: devas komenciĝi per "${t.prefix}"` : t.format === "ends_with" ? `Nevalida karaktraro: devas finiĝi per "${t.suffix}"` : t.format === "includes" ? `Nevalida karaktraro: devas inkluzivi "${t.includes}"` : t.format === "regex" ? `Nevalida karaktraro: devas kongrui kun la modelo ${t.pattern}` : `Nevalida ${r[t.format] ?? i.format}`;
      }
      case "not_multiple_of":
        return `Nevalida nombro: devas esti oblo de ${i.divisor}`;
      case "unrecognized_keys":
        return `Nekonata${i.keys.length > 1 ? "j" : ""} ŝlosilo${i.keys.length > 1 ? "j" : ""}: ${I(i.keys, ", ")}`;
      case "invalid_key":
        return `Nevalida ŝlosilo en ${i.origin}`;
      case "invalid_union":
        return "Nevalida enigo";
      case "invalid_element":
        return `Nevalida valoro en ${i.origin}`;
      default:
        return "Nevalida enigo";
    }
  };
};
function $g() {
  return {
    localeError: Ig()
  };
}
const Eg = () => {
  const e = {
    string: { unit: "caracteres", verb: "tener" },
    file: { unit: "bytes", verb: "tener" },
    array: { unit: "elementos", verb: "tener" },
    set: { unit: "elementos", verb: "tener" }
  }, n = {
    string: "texto",
    number: "número",
    boolean: "booleano",
    array: "arreglo",
    object: "objeto",
    set: "conjunto",
    file: "archivo",
    date: "fecha",
    bigint: "número grande",
    symbol: "símbolo",
    undefined: "indefinido",
    null: "nulo",
    function: "función",
    map: "mapa",
    record: "registro",
    tuple: "tupla",
    enum: "enumeración",
    union: "unión",
    literal: "literal",
    promise: "promesa",
    void: "vacío",
    never: "nunca",
    unknown: "desconocido",
    any: "cualquiera"
  };
  function r(a) {
    return e[a] ?? null;
  }
  function i(a) {
    return n[a] ?? a;
  }
  const t = (a) => {
    const u = typeof a;
    switch (u) {
      case "number":
        return Number.isNaN(a) ? "NaN" : "number";
      case "object":
        return Array.isArray(a) ? "array" : a === null ? "null" : Object.getPrototypeOf(a) !== Object.prototype ? a.constructor.name : "object";
    }
    return u;
  }, o = {
    regex: "entrada",
    email: "dirección de correo electrónico",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "fecha y hora ISO",
    date: "fecha ISO",
    time: "hora ISO",
    duration: "duración ISO",
    ipv4: "dirección IPv4",
    ipv6: "dirección IPv6",
    cidrv4: "rango IPv4",
    cidrv6: "rango IPv6",
    base64: "cadena codificada en base64",
    base64url: "URL codificada en base64",
    json_string: "cadena JSON",
    e164: "número E.164",
    jwt: "JWT",
    template_literal: "entrada"
  };
  return (a) => {
    switch (a.code) {
      case "invalid_type":
        return `Entrada inválida: se esperaba ${i(a.expected)}, recibido ${i(t(a.input))}`;
      // return `Entrada inválida: se esperaba ${issue.expected}, recibido ${util.getParsedType(issue.input)}`;
      case "invalid_value":
        return a.values.length === 1 ? `Entrada inválida: se esperaba ${N(a.values[0])}` : `Opción inválida: se esperaba una de ${I(a.values, "|")}`;
      case "too_big": {
        const u = a.inclusive ? "<=" : "<", s = r(a.origin), l = i(a.origin);
        return s ? `Demasiado grande: se esperaba que ${l ?? "valor"} tuviera ${u}${a.maximum.toString()} ${s.unit ?? "elementos"}` : `Demasiado grande: se esperaba que ${l ?? "valor"} fuera ${u}${a.maximum.toString()}`;
      }
      case "too_small": {
        const u = a.inclusive ? ">=" : ">", s = r(a.origin), l = i(a.origin);
        return s ? `Demasiado pequeño: se esperaba que ${l} tuviera ${u}${a.minimum.toString()} ${s.unit}` : `Demasiado pequeño: se esperaba que ${l} fuera ${u}${a.minimum.toString()}`;
      }
      case "invalid_format": {
        const u = a;
        return u.format === "starts_with" ? `Cadena inválida: debe comenzar con "${u.prefix}"` : u.format === "ends_with" ? `Cadena inválida: debe terminar en "${u.suffix}"` : u.format === "includes" ? `Cadena inválida: debe incluir "${u.includes}"` : u.format === "regex" ? `Cadena inválida: debe coincidir con el patrón ${u.pattern}` : `Inválido ${o[u.format] ?? a.format}`;
      }
      case "not_multiple_of":
        return `Número inválido: debe ser múltiplo de ${a.divisor}`;
      case "unrecognized_keys":
        return `Llave${a.keys.length > 1 ? "s" : ""} desconocida${a.keys.length > 1 ? "s" : ""}: ${I(a.keys, ", ")}`;
      case "invalid_key":
        return `Llave inválida en ${i(a.origin)}`;
      case "invalid_union":
        return "Entrada inválida";
      case "invalid_element":
        return `Valor inválido en ${i(a.origin)}`;
      default:
        return "Entrada inválida";
    }
  };
};
function kg() {
  return {
    localeError: Eg()
  };
}
const Ng = () => {
  const e = {
    string: { unit: "کاراکتر", verb: "داشته باشد" },
    file: { unit: "بایت", verb: "داشته باشد" },
    array: { unit: "آیتم", verb: "داشته باشد" },
    set: { unit: "آیتم", verb: "داشته باشد" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "عدد";
      case "object": {
        if (Array.isArray(t))
          return "آرایه";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "ورودی",
    email: "آدرس ایمیل",
    url: "URL",
    emoji: "ایموجی",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "تاریخ و زمان ایزو",
    date: "تاریخ ایزو",
    time: "زمان ایزو",
    duration: "مدت زمان ایزو",
    ipv4: "IPv4 آدرس",
    ipv6: "IPv6 آدرس",
    cidrv4: "IPv4 دامنه",
    cidrv6: "IPv6 دامنه",
    base64: "base64-encoded رشته",
    base64url: "base64url-encoded رشته",
    json_string: "JSON رشته",
    e164: "E.164 عدد",
    jwt: "JWT",
    template_literal: "ورودی"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `ورودی نامعتبر: می‌بایست ${t.expected} می‌بود، ${r(t.input)} دریافت شد`;
      case "invalid_value":
        return t.values.length === 1 ? `ورودی نامعتبر: می‌بایست ${N(t.values[0])} می‌بود` : `گزینه نامعتبر: می‌بایست یکی از ${I(t.values, "|")} می‌بود`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `خیلی بزرگ: ${t.origin ?? "مقدار"} باید ${o}${t.maximum.toString()} ${a.unit ?? "عنصر"} باشد` : `خیلی بزرگ: ${t.origin ?? "مقدار"} باید ${o}${t.maximum.toString()} باشد`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `خیلی کوچک: ${t.origin} باید ${o}${t.minimum.toString()} ${a.unit} باشد` : `خیلی کوچک: ${t.origin} باید ${o}${t.minimum.toString()} باشد`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `رشته نامعتبر: باید با "${o.prefix}" شروع شود` : o.format === "ends_with" ? `رشته نامعتبر: باید با "${o.suffix}" تمام شود` : o.format === "includes" ? `رشته نامعتبر: باید شامل "${o.includes}" باشد` : o.format === "regex" ? `رشته نامعتبر: باید با الگوی ${o.pattern} مطابقت داشته باشد` : `${i[o.format] ?? t.format} نامعتبر`;
      }
      case "not_multiple_of":
        return `عدد نامعتبر: باید مضرب ${t.divisor} باشد`;
      case "unrecognized_keys":
        return `کلید${t.keys.length > 1 ? "های" : ""} ناشناس: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `کلید ناشناس در ${t.origin}`;
      case "invalid_union":
        return "ورودی نامعتبر";
      case "invalid_element":
        return `مقدار نامعتبر در ${t.origin}`;
      default:
        return "ورودی نامعتبر";
    }
  };
};
function Og() {
  return {
    localeError: Ng()
  };
}
const Tg = () => {
  const e = {
    string: { unit: "merkkiä", subject: "merkkijonon" },
    file: { unit: "tavua", subject: "tiedoston" },
    array: { unit: "alkiota", subject: "listan" },
    set: { unit: "alkiota", subject: "joukon" },
    number: { unit: "", subject: "luvun" },
    bigint: { unit: "", subject: "suuren kokonaisluvun" },
    int: { unit: "", subject: "kokonaisluvun" },
    date: { unit: "", subject: "päivämäärän" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "säännöllinen lauseke",
    email: "sähköpostiosoite",
    url: "URL-osoite",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO-aikaleima",
    date: "ISO-päivämäärä",
    time: "ISO-aika",
    duration: "ISO-kesto",
    ipv4: "IPv4-osoite",
    ipv6: "IPv6-osoite",
    cidrv4: "IPv4-alue",
    cidrv6: "IPv6-alue",
    base64: "base64-koodattu merkkijono",
    base64url: "base64url-koodattu merkkijono",
    json_string: "JSON-merkkijono",
    e164: "E.164-luku",
    jwt: "JWT",
    template_literal: "templaattimerkkijono"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Virheellinen tyyppi: odotettiin ${t.expected}, oli ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Virheellinen syöte: täytyy olla ${N(t.values[0])}` : `Virheellinen valinta: täytyy olla yksi seuraavista: ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Liian suuri: ${a.subject} täytyy olla ${o}${t.maximum.toString()} ${a.unit}`.trim() : `Liian suuri: arvon täytyy olla ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Liian pieni: ${a.subject} täytyy olla ${o}${t.minimum.toString()} ${a.unit}`.trim() : `Liian pieni: arvon täytyy olla ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Virheellinen syöte: täytyy alkaa "${o.prefix}"` : o.format === "ends_with" ? `Virheellinen syöte: täytyy loppua "${o.suffix}"` : o.format === "includes" ? `Virheellinen syöte: täytyy sisältää "${o.includes}"` : o.format === "regex" ? `Virheellinen syöte: täytyy vastata säännöllistä lauseketta ${o.pattern}` : `Virheellinen ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Virheellinen luku: täytyy olla luvun ${t.divisor} monikerta`;
      case "unrecognized_keys":
        return `${t.keys.length > 1 ? "Tuntemattomat avaimet" : "Tuntematon avain"}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return "Virheellinen avain tietueessa";
      case "invalid_union":
        return "Virheellinen unioni";
      case "invalid_element":
        return "Virheellinen arvo joukossa";
      default:
        return "Virheellinen syöte";
    }
  };
};
function wg() {
  return {
    localeError: Tg()
  };
}
const Ag = () => {
  const e = {
    string: { unit: "caractères", verb: "avoir" },
    file: { unit: "octets", verb: "avoir" },
    array: { unit: "éléments", verb: "avoir" },
    set: { unit: "éléments", verb: "avoir" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "nombre";
      case "object": {
        if (Array.isArray(t))
          return "tableau";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "entrée",
    email: "adresse e-mail",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "date et heure ISO",
    date: "date ISO",
    time: "heure ISO",
    duration: "durée ISO",
    ipv4: "adresse IPv4",
    ipv6: "adresse IPv6",
    cidrv4: "plage IPv4",
    cidrv6: "plage IPv6",
    base64: "chaîne encodée en base64",
    base64url: "chaîne encodée en base64url",
    json_string: "chaîne JSON",
    e164: "numéro E.164",
    jwt: "JWT",
    template_literal: "entrée"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Entrée invalide : ${t.expected} attendu, ${r(t.input)} reçu`;
      case "invalid_value":
        return t.values.length === 1 ? `Entrée invalide : ${N(t.values[0])} attendu` : `Option invalide : une valeur parmi ${I(t.values, "|")} attendue`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Trop grand : ${t.origin ?? "valeur"} doit ${a.verb} ${o}${t.maximum.toString()} ${a.unit ?? "élément(s)"}` : `Trop grand : ${t.origin ?? "valeur"} doit être ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Trop petit : ${t.origin} doit ${a.verb} ${o}${t.minimum.toString()} ${a.unit}` : `Trop petit : ${t.origin} doit être ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Chaîne invalide : doit commencer par "${o.prefix}"` : o.format === "ends_with" ? `Chaîne invalide : doit se terminer par "${o.suffix}"` : o.format === "includes" ? `Chaîne invalide : doit inclure "${o.includes}"` : o.format === "regex" ? `Chaîne invalide : doit correspondre au modèle ${o.pattern}` : `${i[o.format] ?? t.format} invalide`;
      }
      case "not_multiple_of":
        return `Nombre invalide : doit être un multiple de ${t.divisor}`;
      case "unrecognized_keys":
        return `Clé${t.keys.length > 1 ? "s" : ""} non reconnue${t.keys.length > 1 ? "s" : ""} : ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Clé invalide dans ${t.origin}`;
      case "invalid_union":
        return "Entrée invalide";
      case "invalid_element":
        return `Valeur invalide dans ${t.origin}`;
      default:
        return "Entrée invalide";
    }
  };
};
function Ug() {
  return {
    localeError: Ag()
  };
}
const Pg = () => {
  const e = {
    string: { unit: "caractères", verb: "avoir" },
    file: { unit: "octets", verb: "avoir" },
    array: { unit: "éléments", verb: "avoir" },
    set: { unit: "éléments", verb: "avoir" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "entrée",
    email: "adresse courriel",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "date-heure ISO",
    date: "date ISO",
    time: "heure ISO",
    duration: "durée ISO",
    ipv4: "adresse IPv4",
    ipv6: "adresse IPv6",
    cidrv4: "plage IPv4",
    cidrv6: "plage IPv6",
    base64: "chaîne encodée en base64",
    base64url: "chaîne encodée en base64url",
    json_string: "chaîne JSON",
    e164: "numéro E.164",
    jwt: "JWT",
    template_literal: "entrée"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Entrée invalide : attendu ${t.expected}, reçu ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Entrée invalide : attendu ${N(t.values[0])}` : `Option invalide : attendu l'une des valeurs suivantes ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "≤" : "<", a = n(t.origin);
        return a ? `Trop grand : attendu que ${t.origin ?? "la valeur"} ait ${o}${t.maximum.toString()} ${a.unit}` : `Trop grand : attendu que ${t.origin ?? "la valeur"} soit ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? "≥" : ">", a = n(t.origin);
        return a ? `Trop petit : attendu que ${t.origin} ait ${o}${t.minimum.toString()} ${a.unit}` : `Trop petit : attendu que ${t.origin} soit ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Chaîne invalide : doit commencer par "${o.prefix}"` : o.format === "ends_with" ? `Chaîne invalide : doit se terminer par "${o.suffix}"` : o.format === "includes" ? `Chaîne invalide : doit inclure "${o.includes}"` : o.format === "regex" ? `Chaîne invalide : doit correspondre au motif ${o.pattern}` : `${i[o.format] ?? t.format} invalide`;
      }
      case "not_multiple_of":
        return `Nombre invalide : doit être un multiple de ${t.divisor}`;
      case "unrecognized_keys":
        return `Clé${t.keys.length > 1 ? "s" : ""} non reconnue${t.keys.length > 1 ? "s" : ""} : ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Clé invalide dans ${t.origin}`;
      case "invalid_union":
        return "Entrée invalide";
      case "invalid_element":
        return `Valeur invalide dans ${t.origin}`;
      default:
        return "Entrée invalide";
    }
  };
};
function Dg() {
  return {
    localeError: Pg()
  };
}
const Rg = () => {
  const e = {
    string: { label: "מחרוזת", gender: "f" },
    number: { label: "מספר", gender: "m" },
    boolean: { label: "ערך בוליאני", gender: "m" },
    bigint: { label: "BigInt", gender: "m" },
    date: { label: "תאריך", gender: "m" },
    array: { label: "מערך", gender: "m" },
    object: { label: "אובייקט", gender: "m" },
    null: { label: "ערך ריק (null)", gender: "m" },
    undefined: { label: "ערך לא מוגדר (undefined)", gender: "m" },
    symbol: { label: "סימבול (Symbol)", gender: "m" },
    function: { label: "פונקציה", gender: "f" },
    map: { label: "מפה (Map)", gender: "f" },
    set: { label: "קבוצה (Set)", gender: "f" },
    file: { label: "קובץ", gender: "m" },
    promise: { label: "Promise", gender: "m" },
    NaN: { label: "NaN", gender: "m" },
    unknown: { label: "ערך לא ידוע", gender: "m" },
    value: { label: "ערך", gender: "m" }
  }, n = {
    string: { unit: "תווים", shortLabel: "קצר", longLabel: "ארוך" },
    file: { unit: "בייטים", shortLabel: "קטן", longLabel: "גדול" },
    array: { unit: "פריטים", shortLabel: "קטן", longLabel: "גדול" },
    set: { unit: "פריטים", shortLabel: "קטן", longLabel: "גדול" },
    number: { unit: "", shortLabel: "קטן", longLabel: "גדול" }
    // no unit
  }, r = (l) => l ? e[l] : void 0, i = (l) => {
    const f = r(l);
    return f ? f.label : l ?? e.unknown.label;
  }, t = (l) => `ה${i(l)}`, o = (l) => {
    const f = r(l);
    return ((f == null ? void 0 : f.gender) ?? "m") === "f" ? "צריכה להיות" : "צריך להיות";
  }, a = (l) => l ? n[l] ?? null : null, u = (l) => {
    const f = typeof l;
    switch (f) {
      case "number":
        return Number.isNaN(l) ? "NaN" : "number";
      case "object":
        return Array.isArray(l) ? "array" : l === null ? "null" : Object.getPrototypeOf(l) !== Object.prototype && l.constructor ? l.constructor.name : "object";
      default:
        return f;
    }
  }, s = {
    regex: { label: "קלט", gender: "m" },
    email: { label: "כתובת אימייל", gender: "f" },
    url: { label: "כתובת רשת", gender: "f" },
    emoji: { label: "אימוג'י", gender: "m" },
    uuid: { label: "UUID", gender: "m" },
    nanoid: { label: "nanoid", gender: "m" },
    guid: { label: "GUID", gender: "m" },
    cuid: { label: "cuid", gender: "m" },
    cuid2: { label: "cuid2", gender: "m" },
    ulid: { label: "ULID", gender: "m" },
    xid: { label: "XID", gender: "m" },
    ksuid: { label: "KSUID", gender: "m" },
    datetime: { label: "תאריך וזמן ISO", gender: "m" },
    date: { label: "תאריך ISO", gender: "m" },
    time: { label: "זמן ISO", gender: "m" },
    duration: { label: "משך זמן ISO", gender: "m" },
    ipv4: { label: "כתובת IPv4", gender: "f" },
    ipv6: { label: "כתובת IPv6", gender: "f" },
    cidrv4: { label: "טווח IPv4", gender: "m" },
    cidrv6: { label: "טווח IPv6", gender: "m" },
    base64: { label: "מחרוזת בבסיס 64", gender: "f" },
    base64url: { label: "מחרוזת בבסיס 64 לכתובות רשת", gender: "f" },
    json_string: { label: "מחרוזת JSON", gender: "f" },
    e164: { label: "מספר E.164", gender: "m" },
    jwt: { label: "JWT", gender: "m" },
    ends_with: { label: "קלט", gender: "m" },
    includes: { label: "קלט", gender: "m" },
    lowercase: { label: "קלט", gender: "m" },
    starts_with: { label: "קלט", gender: "m" },
    uppercase: { label: "קלט", gender: "m" }
  };
  return (l) => {
    var f;
    switch (l.code) {
      case "invalid_type": {
        const c = l.expected, p = i(c), _ = u(l.input), h = ((f = e[_]) == null ? void 0 : f.label) ?? _;
        return `קלט לא תקין: צריך להיות ${p}, התקבל ${h}`;
      }
      case "invalid_value": {
        if (l.values.length === 1)
          return `ערך לא תקין: הערך חייב להיות ${N(l.values[0])}`;
        const c = l.values.map((h) => N(h));
        if (l.values.length === 2)
          return `ערך לא תקין: האפשרויות המתאימות הן ${c[0]} או ${c[1]}`;
        const p = c[c.length - 1];
        return `ערך לא תקין: האפשרויות המתאימות הן ${c.slice(0, -1).join(", ")} או ${p}`;
      }
      case "too_big": {
        const c = a(l.origin), p = t(l.origin ?? "value");
        if (l.origin === "string")
          return `${(c == null ? void 0 : c.longLabel) ?? "ארוך"} מדי: ${p} צריכה להכיל ${l.maximum.toString()} ${(c == null ? void 0 : c.unit) ?? ""} ${l.inclusive ? "או פחות" : "לכל היותר"}`.trim();
        if (l.origin === "number") {
          const $ = l.inclusive ? `קטן או שווה ל-${l.maximum}` : `קטן מ-${l.maximum}`;
          return `גדול מדי: ${p} צריך להיות ${$}`;
        }
        if (l.origin === "array" || l.origin === "set") {
          const $ = l.origin === "set" ? "צריכה" : "צריך", v = l.inclusive ? `${l.maximum} ${(c == null ? void 0 : c.unit) ?? ""} או פחות` : `פחות מ-${l.maximum} ${(c == null ? void 0 : c.unit) ?? ""}`;
          return `גדול מדי: ${p} ${$} להכיל ${v}`.trim();
        }
        const _ = l.inclusive ? "<=" : "<", h = o(l.origin ?? "value");
        return c != null && c.unit ? `${c.longLabel} מדי: ${p} ${h} ${_}${l.maximum.toString()} ${c.unit}` : `${(c == null ? void 0 : c.longLabel) ?? "גדול"} מדי: ${p} ${h} ${_}${l.maximum.toString()}`;
      }
      case "too_small": {
        const c = a(l.origin), p = t(l.origin ?? "value");
        if (l.origin === "string")
          return `${(c == null ? void 0 : c.shortLabel) ?? "קצר"} מדי: ${p} צריכה להכיל ${l.minimum.toString()} ${(c == null ? void 0 : c.unit) ?? ""} ${l.inclusive ? "או יותר" : "לפחות"}`.trim();
        if (l.origin === "number") {
          const $ = l.inclusive ? `גדול או שווה ל-${l.minimum}` : `גדול מ-${l.minimum}`;
          return `קטן מדי: ${p} צריך להיות ${$}`;
        }
        if (l.origin === "array" || l.origin === "set") {
          const $ = l.origin === "set" ? "צריכה" : "צריך";
          if (l.minimum === 1 && l.inclusive) {
            const m = (l.origin === "set", "לפחות פריט אחד");
            return `קטן מדי: ${p} ${$} להכיל ${m}`;
          }
          const v = l.inclusive ? `${l.minimum} ${(c == null ? void 0 : c.unit) ?? ""} או יותר` : `יותר מ-${l.minimum} ${(c == null ? void 0 : c.unit) ?? ""}`;
          return `קטן מדי: ${p} ${$} להכיל ${v}`.trim();
        }
        const _ = l.inclusive ? ">=" : ">", h = o(l.origin ?? "value");
        return c != null && c.unit ? `${c.shortLabel} מדי: ${p} ${h} ${_}${l.minimum.toString()} ${c.unit}` : `${(c == null ? void 0 : c.shortLabel) ?? "קטן"} מדי: ${p} ${h} ${_}${l.minimum.toString()}`;
      }
      case "invalid_format": {
        const c = l;
        if (c.format === "starts_with")
          return `המחרוזת חייבת להתחיל ב "${c.prefix}"`;
        if (c.format === "ends_with")
          return `המחרוזת חייבת להסתיים ב "${c.suffix}"`;
        if (c.format === "includes")
          return `המחרוזת חייבת לכלול "${c.includes}"`;
        if (c.format === "regex")
          return `המחרוזת חייבת להתאים לתבנית ${c.pattern}`;
        const p = s[c.format], _ = (p == null ? void 0 : p.label) ?? c.format, $ = ((p == null ? void 0 : p.gender) ?? "m") === "f" ? "תקינה" : "תקין";
        return `${_} לא ${$}`;
      }
      case "not_multiple_of":
        return `מספר לא תקין: חייב להיות מכפלה של ${l.divisor}`;
      case "unrecognized_keys":
        return `מפתח${l.keys.length > 1 ? "ות" : ""} לא מזוה${l.keys.length > 1 ? "ים" : "ה"}: ${I(l.keys, ", ")}`;
      case "invalid_key":
        return "שדה לא תקין באובייקט";
      case "invalid_union":
        return "קלט לא תקין";
      case "invalid_element":
        return `ערך לא תקין ב${t(l.origin ?? "array")}`;
      default:
        return "קלט לא תקין";
    }
  };
};
function zg() {
  return {
    localeError: Rg()
  };
}
const Cg = () => {
  const e = {
    string: { unit: "karakter", verb: "legyen" },
    file: { unit: "byte", verb: "legyen" },
    array: { unit: "elem", verb: "legyen" },
    set: { unit: "elem", verb: "legyen" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "szám";
      case "object": {
        if (Array.isArray(t))
          return "tömb";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "bemenet",
    email: "email cím",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO időbélyeg",
    date: "ISO dátum",
    time: "ISO idő",
    duration: "ISO időintervallum",
    ipv4: "IPv4 cím",
    ipv6: "IPv6 cím",
    cidrv4: "IPv4 tartomány",
    cidrv6: "IPv6 tartomány",
    base64: "base64-kódolt string",
    base64url: "base64url-kódolt string",
    json_string: "JSON string",
    e164: "E.164 szám",
    jwt: "JWT",
    template_literal: "bemenet"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Érvénytelen bemenet: a várt érték ${t.expected}, a kapott érték ${r(t.input)}`;
      // return `Invalid input: expected ${issue.expected}, received ${util.getParsedType(issue.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Érvénytelen bemenet: a várt érték ${N(t.values[0])}` : `Érvénytelen opció: valamelyik érték várt ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Túl nagy: ${t.origin ?? "érték"} mérete túl nagy ${o}${t.maximum.toString()} ${a.unit ?? "elem"}` : `Túl nagy: a bemeneti érték ${t.origin ?? "érték"} túl nagy: ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Túl kicsi: a bemeneti érték ${t.origin} mérete túl kicsi ${o}${t.minimum.toString()} ${a.unit}` : `Túl kicsi: a bemeneti érték ${t.origin} túl kicsi ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Érvénytelen string: "${o.prefix}" értékkel kell kezdődnie` : o.format === "ends_with" ? `Érvénytelen string: "${o.suffix}" értékkel kell végződnie` : o.format === "includes" ? `Érvénytelen string: "${o.includes}" értéket kell tartalmaznia` : o.format === "regex" ? `Érvénytelen string: ${o.pattern} mintának kell megfelelnie` : `Érvénytelen ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Érvénytelen szám: ${t.divisor} többszörösének kell lennie`;
      case "unrecognized_keys":
        return `Ismeretlen kulcs${t.keys.length > 1 ? "s" : ""}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Érvénytelen kulcs ${t.origin}`;
      case "invalid_union":
        return "Érvénytelen bemenet";
      case "invalid_element":
        return `Érvénytelen érték: ${t.origin}`;
      default:
        return "Érvénytelen bemenet";
    }
  };
};
function jg() {
  return {
    localeError: Cg()
  };
}
const Lg = () => {
  const e = {
    string: { unit: "karakter", verb: "memiliki" },
    file: { unit: "byte", verb: "memiliki" },
    array: { unit: "item", verb: "memiliki" },
    set: { unit: "item", verb: "memiliki" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "input",
    email: "alamat email",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "tanggal dan waktu format ISO",
    date: "tanggal format ISO",
    time: "jam format ISO",
    duration: "durasi format ISO",
    ipv4: "alamat IPv4",
    ipv6: "alamat IPv6",
    cidrv4: "rentang alamat IPv4",
    cidrv6: "rentang alamat IPv6",
    base64: "string dengan enkode base64",
    base64url: "string dengan enkode base64url",
    json_string: "string JSON",
    e164: "angka E.164",
    jwt: "JWT",
    template_literal: "input"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Input tidak valid: diharapkan ${t.expected}, diterima ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Input tidak valid: diharapkan ${N(t.values[0])}` : `Pilihan tidak valid: diharapkan salah satu dari ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Terlalu besar: diharapkan ${t.origin ?? "value"} memiliki ${o}${t.maximum.toString()} ${a.unit ?? "elemen"}` : `Terlalu besar: diharapkan ${t.origin ?? "value"} menjadi ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Terlalu kecil: diharapkan ${t.origin} memiliki ${o}${t.minimum.toString()} ${a.unit}` : `Terlalu kecil: diharapkan ${t.origin} menjadi ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `String tidak valid: harus dimulai dengan "${o.prefix}"` : o.format === "ends_with" ? `String tidak valid: harus berakhir dengan "${o.suffix}"` : o.format === "includes" ? `String tidak valid: harus menyertakan "${o.includes}"` : o.format === "regex" ? `String tidak valid: harus sesuai pola ${o.pattern}` : `${i[o.format] ?? t.format} tidak valid`;
      }
      case "not_multiple_of":
        return `Angka tidak valid: harus kelipatan dari ${t.divisor}`;
      case "unrecognized_keys":
        return `Kunci tidak dikenali ${t.keys.length > 1 ? "s" : ""}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Kunci tidak valid di ${t.origin}`;
      case "invalid_union":
        return "Input tidak valid";
      case "invalid_element":
        return `Nilai tidak valid di ${t.origin}`;
      default:
        return "Input tidak valid";
    }
  };
};
function xg() {
  return {
    localeError: Lg()
  };
}
const Mg = (e) => {
  const n = typeof e;
  switch (n) {
    case "number":
      return Number.isNaN(e) ? "NaN" : "númer";
    case "object": {
      if (Array.isArray(e))
        return "fylki";
      if (e === null)
        return "null";
      if (Object.getPrototypeOf(e) !== Object.prototype && e.constructor)
        return e.constructor.name;
    }
  }
  return n;
}, Zg = () => {
  const e = {
    string: { unit: "stafi", verb: "að hafa" },
    file: { unit: "bæti", verb: "að hafa" },
    array: { unit: "hluti", verb: "að hafa" },
    set: { unit: "hluti", verb: "að hafa" }
  };
  function n(i) {
    return e[i] ?? null;
  }
  const r = {
    regex: "gildi",
    email: "netfang",
    url: "vefslóð",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO dagsetning og tími",
    date: "ISO dagsetning",
    time: "ISO tími",
    duration: "ISO tímalengd",
    ipv4: "IPv4 address",
    ipv6: "IPv6 address",
    cidrv4: "IPv4 range",
    cidrv6: "IPv6 range",
    base64: "base64-encoded strengur",
    base64url: "base64url-encoded strengur",
    json_string: "JSON strengur",
    e164: "E.164 tölugildi",
    jwt: "JWT",
    template_literal: "gildi"
  };
  return (i) => {
    switch (i.code) {
      case "invalid_type":
        return `Rangt gildi: Þú slóst inn ${Mg(i.input)} þar sem á að vera ${i.expected}`;
      case "invalid_value":
        return i.values.length === 1 ? `Rangt gildi: gert ráð fyrir ${N(i.values[0])}` : `Ógilt val: má vera eitt af eftirfarandi ${I(i.values, "|")}`;
      case "too_big": {
        const t = i.inclusive ? "<=" : "<", o = n(i.origin);
        return o ? `Of stórt: gert er ráð fyrir að ${i.origin ?? "gildi"} hafi ${t}${i.maximum.toString()} ${o.unit ?? "hluti"}` : `Of stórt: gert er ráð fyrir að ${i.origin ?? "gildi"} sé ${t}${i.maximum.toString()}`;
      }
      case "too_small": {
        const t = i.inclusive ? ">=" : ">", o = n(i.origin);
        return o ? `Of lítið: gert er ráð fyrir að ${i.origin} hafi ${t}${i.minimum.toString()} ${o.unit}` : `Of lítið: gert er ráð fyrir að ${i.origin} sé ${t}${i.minimum.toString()}`;
      }
      case "invalid_format": {
        const t = i;
        return t.format === "starts_with" ? `Ógildur strengur: verður að byrja á "${t.prefix}"` : t.format === "ends_with" ? `Ógildur strengur: verður að enda á "${t.suffix}"` : t.format === "includes" ? `Ógildur strengur: verður að innihalda "${t.includes}"` : t.format === "regex" ? `Ógildur strengur: verður að fylgja mynstri ${t.pattern}` : `Rangt ${r[t.format] ?? i.format}`;
      }
      case "not_multiple_of":
        return `Röng tala: verður að vera margfeldi af ${i.divisor}`;
      case "unrecognized_keys":
        return `Óþekkt ${i.keys.length > 1 ? "ir lyklar" : "ur lykill"}: ${I(i.keys, ", ")}`;
      case "invalid_key":
        return `Rangur lykill í ${i.origin}`;
      case "invalid_union":
        return "Rangt gildi";
      case "invalid_element":
        return `Rangt gildi í ${i.origin}`;
      default:
        return "Rangt gildi";
    }
  };
};
function Gg() {
  return {
    localeError: Zg()
  };
}
const Fg = () => {
  const e = {
    string: { unit: "caratteri", verb: "avere" },
    file: { unit: "byte", verb: "avere" },
    array: { unit: "elementi", verb: "avere" },
    set: { unit: "elementi", verb: "avere" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "numero";
      case "object": {
        if (Array.isArray(t))
          return "vettore";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "input",
    email: "indirizzo email",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "data e ora ISO",
    date: "data ISO",
    time: "ora ISO",
    duration: "durata ISO",
    ipv4: "indirizzo IPv4",
    ipv6: "indirizzo IPv6",
    cidrv4: "intervallo IPv4",
    cidrv6: "intervallo IPv6",
    base64: "stringa codificata in base64",
    base64url: "URL codificata in base64",
    json_string: "stringa JSON",
    e164: "numero E.164",
    jwt: "JWT",
    template_literal: "input"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Input non valido: atteso ${t.expected}, ricevuto ${r(t.input)}`;
      // return `Input non valido: atteso ${issue.expected}, ricevuto ${util.getParsedType(issue.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Input non valido: atteso ${N(t.values[0])}` : `Opzione non valida: atteso uno tra ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Troppo grande: ${t.origin ?? "valore"} deve avere ${o}${t.maximum.toString()} ${a.unit ?? "elementi"}` : `Troppo grande: ${t.origin ?? "valore"} deve essere ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Troppo piccolo: ${t.origin} deve avere ${o}${t.minimum.toString()} ${a.unit}` : `Troppo piccolo: ${t.origin} deve essere ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Stringa non valida: deve iniziare con "${o.prefix}"` : o.format === "ends_with" ? `Stringa non valida: deve terminare con "${o.suffix}"` : o.format === "includes" ? `Stringa non valida: deve includere "${o.includes}"` : o.format === "regex" ? `Stringa non valida: deve corrispondere al pattern ${o.pattern}` : `Invalid ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Numero non valido: deve essere un multiplo di ${t.divisor}`;
      case "unrecognized_keys":
        return `Chiav${t.keys.length > 1 ? "i" : "e"} non riconosciut${t.keys.length > 1 ? "e" : "a"}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Chiave non valida in ${t.origin}`;
      case "invalid_union":
        return "Input non valido";
      case "invalid_element":
        return `Valore non valido in ${t.origin}`;
      default:
        return "Input non valido";
    }
  };
};
function Hg() {
  return {
    localeError: Fg()
  };
}
const Bg = () => {
  const e = {
    string: { unit: "文字", verb: "である" },
    file: { unit: "バイト", verb: "である" },
    array: { unit: "要素", verb: "である" },
    set: { unit: "要素", verb: "である" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "数値";
      case "object": {
        if (Array.isArray(t))
          return "配列";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "入力値",
    email: "メールアドレス",
    url: "URL",
    emoji: "絵文字",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO日時",
    date: "ISO日付",
    time: "ISO時刻",
    duration: "ISO期間",
    ipv4: "IPv4アドレス",
    ipv6: "IPv6アドレス",
    cidrv4: "IPv4範囲",
    cidrv6: "IPv6範囲",
    base64: "base64エンコード文字列",
    base64url: "base64urlエンコード文字列",
    json_string: "JSON文字列",
    e164: "E.164番号",
    jwt: "JWT",
    template_literal: "入力値"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `無効な入力: ${t.expected}が期待されましたが、${r(t.input)}が入力されました`;
      case "invalid_value":
        return t.values.length === 1 ? `無効な入力: ${N(t.values[0])}が期待されました` : `無効な選択: ${I(t.values, "、")}のいずれかである必要があります`;
      case "too_big": {
        const o = t.inclusive ? "以下である" : "より小さい", a = n(t.origin);
        return a ? `大きすぎる値: ${t.origin ?? "値"}は${t.maximum.toString()}${a.unit ?? "要素"}${o}必要があります` : `大きすぎる値: ${t.origin ?? "値"}は${t.maximum.toString()}${o}必要があります`;
      }
      case "too_small": {
        const o = t.inclusive ? "以上である" : "より大きい", a = n(t.origin);
        return a ? `小さすぎる値: ${t.origin}は${t.minimum.toString()}${a.unit}${o}必要があります` : `小さすぎる値: ${t.origin}は${t.minimum.toString()}${o}必要があります`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `無効な文字列: "${o.prefix}"で始まる必要があります` : o.format === "ends_with" ? `無効な文字列: "${o.suffix}"で終わる必要があります` : o.format === "includes" ? `無効な文字列: "${o.includes}"を含む必要があります` : o.format === "regex" ? `無効な文字列: パターン${o.pattern}に一致する必要があります` : `無効な${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `無効な数値: ${t.divisor}の倍数である必要があります`;
      case "unrecognized_keys":
        return `認識されていないキー${t.keys.length > 1 ? "群" : ""}: ${I(t.keys, "、")}`;
      case "invalid_key":
        return `${t.origin}内の無効なキー`;
      case "invalid_union":
        return "無効な入力";
      case "invalid_element":
        return `${t.origin}内の無効な値`;
      default:
        return "無効な入力";
    }
  };
};
function Vg() {
  return {
    localeError: Bg()
  };
}
const Yg = (e) => {
  const n = typeof e;
  switch (n) {
    case "number":
      return Number.isNaN(e) ? "NaN" : "რიცხვი";
    case "object": {
      if (Array.isArray(e))
        return "მასივი";
      if (e === null)
        return "null";
      if (Object.getPrototypeOf(e) !== Object.prototype && e.constructor)
        return e.constructor.name;
    }
  }
  return {
    string: "სტრინგი",
    boolean: "ბულეანი",
    undefined: "undefined",
    bigint: "bigint",
    symbol: "symbol",
    function: "ფუნქცია"
  }[n] ?? n;
}, Kg = () => {
  const e = {
    string: { unit: "სიმბოლო", verb: "უნდა შეიცავდეს" },
    file: { unit: "ბაიტი", verb: "უნდა შეიცავდეს" },
    array: { unit: "ელემენტი", verb: "უნდა შეიცავდეს" },
    set: { unit: "ელემენტი", verb: "უნდა შეიცავდეს" }
  };
  function n(i) {
    return e[i] ?? null;
  }
  const r = {
    regex: "შეყვანა",
    email: "ელ-ფოსტის მისამართი",
    url: "URL",
    emoji: "ემოჯი",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "თარიღი-დრო",
    date: "თარიღი",
    time: "დრო",
    duration: "ხანგრძლივობა",
    ipv4: "IPv4 მისამართი",
    ipv6: "IPv6 მისამართი",
    cidrv4: "IPv4 დიაპაზონი",
    cidrv6: "IPv6 დიაპაზონი",
    base64: "base64-კოდირებული სტრინგი",
    base64url: "base64url-კოდირებული სტრინგი",
    json_string: "JSON სტრინგი",
    e164: "E.164 ნომერი",
    jwt: "JWT",
    template_literal: "შეყვანა"
  };
  return (i) => {
    switch (i.code) {
      case "invalid_type":
        return `არასწორი შეყვანა: მოსალოდნელი ${i.expected}, მიღებული ${Yg(i.input)}`;
      case "invalid_value":
        return i.values.length === 1 ? `არასწორი შეყვანა: მოსალოდნელი ${N(i.values[0])}` : `არასწორი ვარიანტი: მოსალოდნელია ერთ-ერთი ${I(i.values, "|")}-დან`;
      case "too_big": {
        const t = i.inclusive ? "<=" : "<", o = n(i.origin);
        return o ? `ზედმეტად დიდი: მოსალოდნელი ${i.origin ?? "მნიშვნელობა"} ${o.verb} ${t}${i.maximum.toString()} ${o.unit}` : `ზედმეტად დიდი: მოსალოდნელი ${i.origin ?? "მნიშვნელობა"} იყოს ${t}${i.maximum.toString()}`;
      }
      case "too_small": {
        const t = i.inclusive ? ">=" : ">", o = n(i.origin);
        return o ? `ზედმეტად პატარა: მოსალოდნელი ${i.origin} ${o.verb} ${t}${i.minimum.toString()} ${o.unit}` : `ზედმეტად პატარა: მოსალოდნელი ${i.origin} იყოს ${t}${i.minimum.toString()}`;
      }
      case "invalid_format": {
        const t = i;
        return t.format === "starts_with" ? `არასწორი სტრინგი: უნდა იწყებოდეს "${t.prefix}"-ით` : t.format === "ends_with" ? `არასწორი სტრინგი: უნდა მთავრდებოდეს "${t.suffix}"-ით` : t.format === "includes" ? `არასწორი სტრინგი: უნდა შეიცავდეს "${t.includes}"-ს` : t.format === "regex" ? `არასწორი სტრინგი: უნდა შეესაბამებოდეს შაბლონს ${t.pattern}` : `არასწორი ${r[t.format] ?? i.format}`;
      }
      case "not_multiple_of":
        return `არასწორი რიცხვი: უნდა იყოს ${i.divisor}-ის ჯერადი`;
      case "unrecognized_keys":
        return `უცნობი გასაღებ${i.keys.length > 1 ? "ები" : "ი"}: ${I(i.keys, ", ")}`;
      case "invalid_key":
        return `არასწორი გასაღები ${i.origin}-ში`;
      case "invalid_union":
        return "არასწორი შეყვანა";
      case "invalid_element":
        return `არასწორი მნიშვნელობა ${i.origin}-ში`;
      default:
        return "არასწორი შეყვანა";
    }
  };
};
function Wg() {
  return {
    localeError: Kg()
  };
}
const Jg = () => {
  const e = {
    string: { unit: "តួអក្សរ", verb: "គួរមាន" },
    file: { unit: "បៃ", verb: "គួរមាន" },
    array: { unit: "ធាតុ", verb: "គួរមាន" },
    set: { unit: "ធាតុ", verb: "គួរមាន" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "មិនមែនជាលេខ (NaN)" : "លេខ";
      case "object": {
        if (Array.isArray(t))
          return "អារេ (Array)";
        if (t === null)
          return "គ្មានតម្លៃ (null)";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "ទិន្នន័យបញ្ចូល",
    email: "អាសយដ្ឋានអ៊ីមែល",
    url: "URL",
    emoji: "សញ្ញាអារម្មណ៍",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "កាលបរិច្ឆេទ និងម៉ោង ISO",
    date: "កាលបរិច្ឆេទ ISO",
    time: "ម៉ោង ISO",
    duration: "រយៈពេល ISO",
    ipv4: "អាសយដ្ឋាន IPv4",
    ipv6: "អាសយដ្ឋាន IPv6",
    cidrv4: "ដែនអាសយដ្ឋាន IPv4",
    cidrv6: "ដែនអាសយដ្ឋាន IPv6",
    base64: "ខ្សែអក្សរអ៊ិកូដ base64",
    base64url: "ខ្សែអក្សរអ៊ិកូដ base64url",
    json_string: "ខ្សែអក្សរ JSON",
    e164: "លេខ E.164",
    jwt: "JWT",
    template_literal: "ទិន្នន័យបញ្ចូល"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `ទិន្នន័យបញ្ចូលមិនត្រឹមត្រូវ៖ ត្រូវការ ${t.expected} ប៉ុន្តែទទួលបាន ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `ទិន្នន័យបញ្ចូលមិនត្រឹមត្រូវ៖ ត្រូវការ ${N(t.values[0])}` : `ជម្រើសមិនត្រឹមត្រូវ៖ ត្រូវជាមួយក្នុងចំណោម ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `ធំពេក៖ ត្រូវការ ${t.origin ?? "តម្លៃ"} ${o} ${t.maximum.toString()} ${a.unit ?? "ធាតុ"}` : `ធំពេក៖ ត្រូវការ ${t.origin ?? "តម្លៃ"} ${o} ${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `តូចពេក៖ ត្រូវការ ${t.origin} ${o} ${t.minimum.toString()} ${a.unit}` : `តូចពេក៖ ត្រូវការ ${t.origin} ${o} ${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវចាប់ផ្តើមដោយ "${o.prefix}"` : o.format === "ends_with" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវបញ្ចប់ដោយ "${o.suffix}"` : o.format === "includes" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវមាន "${o.includes}"` : o.format === "regex" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវតែផ្គូផ្គងនឹងទម្រង់ដែលបានកំណត់ ${o.pattern}` : `មិនត្រឹមត្រូវ៖ ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `លេខមិនត្រឹមត្រូវ៖ ត្រូវតែជាពហុគុណនៃ ${t.divisor}`;
      case "unrecognized_keys":
        return `រកឃើញសោមិនស្គាល់៖ ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `សោមិនត្រឹមត្រូវនៅក្នុង ${t.origin}`;
      case "invalid_union":
        return "ទិន្នន័យមិនត្រឹមត្រូវ";
      case "invalid_element":
        return `ទិន្នន័យមិនត្រឹមត្រូវនៅក្នុង ${t.origin}`;
      default:
        return "ទិន្នន័យមិនត្រឹមត្រូវ";
    }
  };
};
function Vl() {
  return {
    localeError: Jg()
  };
}
function qg() {
  return Vl();
}
const Xg = () => {
  const e = {
    string: { unit: "문자", verb: "to have" },
    file: { unit: "바이트", verb: "to have" },
    array: { unit: "개", verb: "to have" },
    set: { unit: "개", verb: "to have" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "입력",
    email: "이메일 주소",
    url: "URL",
    emoji: "이모지",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO 날짜시간",
    date: "ISO 날짜",
    time: "ISO 시간",
    duration: "ISO 기간",
    ipv4: "IPv4 주소",
    ipv6: "IPv6 주소",
    cidrv4: "IPv4 범위",
    cidrv6: "IPv6 범위",
    base64: "base64 인코딩 문자열",
    base64url: "base64url 인코딩 문자열",
    json_string: "JSON 문자열",
    e164: "E.164 번호",
    jwt: "JWT",
    template_literal: "입력"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `잘못된 입력: 예상 타입은 ${t.expected}, 받은 타입은 ${r(t.input)}입니다`;
      case "invalid_value":
        return t.values.length === 1 ? `잘못된 입력: 값은 ${N(t.values[0])} 이어야 합니다` : `잘못된 옵션: ${I(t.values, "또는 ")} 중 하나여야 합니다`;
      case "too_big": {
        const o = t.inclusive ? "이하" : "미만", a = o === "미만" ? "이어야 합니다" : "여야 합니다", u = n(t.origin), s = (u == null ? void 0 : u.unit) ?? "요소";
        return u ? `${t.origin ?? "값"}이 너무 큽니다: ${t.maximum.toString()}${s} ${o}${a}` : `${t.origin ?? "값"}이 너무 큽니다: ${t.maximum.toString()} ${o}${a}`;
      }
      case "too_small": {
        const o = t.inclusive ? "이상" : "초과", a = o === "이상" ? "이어야 합니다" : "여야 합니다", u = n(t.origin), s = (u == null ? void 0 : u.unit) ?? "요소";
        return u ? `${t.origin ?? "값"}이 너무 작습니다: ${t.minimum.toString()}${s} ${o}${a}` : `${t.origin ?? "값"}이 너무 작습니다: ${t.minimum.toString()} ${o}${a}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `잘못된 문자열: "${o.prefix}"(으)로 시작해야 합니다` : o.format === "ends_with" ? `잘못된 문자열: "${o.suffix}"(으)로 끝나야 합니다` : o.format === "includes" ? `잘못된 문자열: "${o.includes}"을(를) 포함해야 합니다` : o.format === "regex" ? `잘못된 문자열: 정규식 ${o.pattern} 패턴과 일치해야 합니다` : `잘못된 ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `잘못된 숫자: ${t.divisor}의 배수여야 합니다`;
      case "unrecognized_keys":
        return `인식할 수 없는 키: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `잘못된 키: ${t.origin}`;
      case "invalid_union":
        return "잘못된 입력";
      case "invalid_element":
        return `잘못된 값: ${t.origin}`;
      default:
        return "잘못된 입력";
    }
  };
};
function Qg() {
  return {
    localeError: Xg()
  };
}
const ef = (e) => gt(typeof e, e), gt = (e, n = void 0) => {
  switch (e) {
    case "number":
      return Number.isNaN(n) ? "NaN" : "skaičius";
    case "bigint":
      return "sveikasis skaičius";
    case "string":
      return "eilutė";
    case "boolean":
      return "loginė reikšmė";
    case "undefined":
    case "void":
      return "neapibrėžta reikšmė";
    case "function":
      return "funkcija";
    case "symbol":
      return "simbolis";
    case "object":
      return n === void 0 ? "nežinomas objektas" : n === null ? "nulinė reikšmė" : Array.isArray(n) ? "masyvas" : Object.getPrototypeOf(n) !== Object.prototype && n.constructor ? n.constructor.name : "objektas";
    //Zod types below
    case "null":
      return "nulinė reikšmė";
  }
  return e;
}, dt = (e) => e.charAt(0).toUpperCase() + e.slice(1);
function Po(e) {
  const n = Math.abs(e), r = n % 10, i = n % 100;
  return i >= 11 && i <= 19 || r === 0 ? "many" : r === 1 ? "one" : "few";
}
const tf = () => {
  const e = {
    string: {
      unit: {
        one: "simbolis",
        few: "simboliai",
        many: "simbolių"
      },
      verb: {
        smaller: {
          inclusive: "turi būti ne ilgesnė kaip",
          notInclusive: "turi būti trumpesnė kaip"
        },
        bigger: {
          inclusive: "turi būti ne trumpesnė kaip",
          notInclusive: "turi būti ilgesnė kaip"
        }
      }
    },
    file: {
      unit: {
        one: "baitas",
        few: "baitai",
        many: "baitų"
      },
      verb: {
        smaller: {
          inclusive: "turi būti ne didesnis kaip",
          notInclusive: "turi būti mažesnis kaip"
        },
        bigger: {
          inclusive: "turi būti ne mažesnis kaip",
          notInclusive: "turi būti didesnis kaip"
        }
      }
    },
    array: {
      unit: {
        one: "elementą",
        few: "elementus",
        many: "elementų"
      },
      verb: {
        smaller: {
          inclusive: "turi turėti ne daugiau kaip",
          notInclusive: "turi turėti mažiau kaip"
        },
        bigger: {
          inclusive: "turi turėti ne mažiau kaip",
          notInclusive: "turi turėti daugiau kaip"
        }
      }
    },
    set: {
      unit: {
        one: "elementą",
        few: "elementus",
        many: "elementų"
      },
      verb: {
        smaller: {
          inclusive: "turi turėti ne daugiau kaip",
          notInclusive: "turi turėti mažiau kaip"
        },
        bigger: {
          inclusive: "turi turėti ne mažiau kaip",
          notInclusive: "turi turėti daugiau kaip"
        }
      }
    }
  };
  function n(i, t, o, a) {
    const u = e[i] ?? null;
    return u === null ? u : {
      unit: u.unit[t],
      verb: u.verb[a][o ? "inclusive" : "notInclusive"]
    };
  }
  const r = {
    regex: "įvestis",
    email: "el. pašto adresas",
    url: "URL",
    emoji: "jaustukas",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO data ir laikas",
    date: "ISO data",
    time: "ISO laikas",
    duration: "ISO trukmė",
    ipv4: "IPv4 adresas",
    ipv6: "IPv6 adresas",
    cidrv4: "IPv4 tinklo prefiksas (CIDR)",
    cidrv6: "IPv6 tinklo prefiksas (CIDR)",
    base64: "base64 užkoduota eilutė",
    base64url: "base64url užkoduota eilutė",
    json_string: "JSON eilutė",
    e164: "E.164 numeris",
    jwt: "JWT",
    template_literal: "įvestis"
  };
  return (i) => {
    switch (i.code) {
      case "invalid_type":
        return `Gautas tipas ${ef(i.input)}, o tikėtasi - ${gt(i.expected)}`;
      case "invalid_value":
        return i.values.length === 1 ? `Privalo būti ${N(i.values[0])}` : `Privalo būti vienas iš ${I(i.values, "|")} pasirinkimų`;
      case "too_big": {
        const t = gt(i.origin), o = n(i.origin, Po(Number(i.maximum)), i.inclusive ?? !1, "smaller");
        if (o != null && o.verb)
          return `${dt(t ?? i.origin ?? "reikšmė")} ${o.verb} ${i.maximum.toString()} ${o.unit ?? "elementų"}`;
        const a = i.inclusive ? "ne didesnis kaip" : "mažesnis kaip";
        return `${dt(t ?? i.origin ?? "reikšmė")} turi būti ${a} ${i.maximum.toString()} ${o == null ? void 0 : o.unit}`;
      }
      case "too_small": {
        const t = gt(i.origin), o = n(i.origin, Po(Number(i.minimum)), i.inclusive ?? !1, "bigger");
        if (o != null && o.verb)
          return `${dt(t ?? i.origin ?? "reikšmė")} ${o.verb} ${i.minimum.toString()} ${o.unit ?? "elementų"}`;
        const a = i.inclusive ? "ne mažesnis kaip" : "didesnis kaip";
        return `${dt(t ?? i.origin ?? "reikšmė")} turi būti ${a} ${i.minimum.toString()} ${o == null ? void 0 : o.unit}`;
      }
      case "invalid_format": {
        const t = i;
        return t.format === "starts_with" ? `Eilutė privalo prasidėti "${t.prefix}"` : t.format === "ends_with" ? `Eilutė privalo pasibaigti "${t.suffix}"` : t.format === "includes" ? `Eilutė privalo įtraukti "${t.includes}"` : t.format === "regex" ? `Eilutė privalo atitikti ${t.pattern}` : `Neteisingas ${r[t.format] ?? i.format}`;
      }
      case "not_multiple_of":
        return `Skaičius privalo būti ${i.divisor} kartotinis.`;
      case "unrecognized_keys":
        return `Neatpažint${i.keys.length > 1 ? "i" : "as"} rakt${i.keys.length > 1 ? "ai" : "as"}: ${I(i.keys, ", ")}`;
      case "invalid_key":
        return "Rastas klaidingas raktas";
      case "invalid_union":
        return "Klaidinga įvestis";
      case "invalid_element": {
        const t = gt(i.origin);
        return `${dt(t ?? i.origin ?? "reikšmė")} turi klaidingą įvestį`;
      }
      default:
        return "Klaidinga įvestis";
    }
  };
};
function nf() {
  return {
    localeError: tf()
  };
}
const rf = () => {
  const e = {
    string: { unit: "знаци", verb: "да имаат" },
    file: { unit: "бајти", verb: "да имаат" },
    array: { unit: "ставки", verb: "да имаат" },
    set: { unit: "ставки", verb: "да имаат" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "број";
      case "object": {
        if (Array.isArray(t))
          return "низа";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "внес",
    email: "адреса на е-пошта",
    url: "URL",
    emoji: "емоџи",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO датум и време",
    date: "ISO датум",
    time: "ISO време",
    duration: "ISO времетраење",
    ipv4: "IPv4 адреса",
    ipv6: "IPv6 адреса",
    cidrv4: "IPv4 опсег",
    cidrv6: "IPv6 опсег",
    base64: "base64-енкодирана низа",
    base64url: "base64url-енкодирана низа",
    json_string: "JSON низа",
    e164: "E.164 број",
    jwt: "JWT",
    template_literal: "внес"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Грешен внес: се очекува ${t.expected}, примено ${r(t.input)}`;
      // return `Invalid input: expected ${issue.expected}, received ${util.getParsedType(issue.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Invalid input: expected ${N(t.values[0])}` : `Грешана опција: се очекува една ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Премногу голем: се очекува ${t.origin ?? "вредноста"} да има ${o}${t.maximum.toString()} ${a.unit ?? "елементи"}` : `Премногу голем: се очекува ${t.origin ?? "вредноста"} да биде ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Премногу мал: се очекува ${t.origin} да има ${o}${t.minimum.toString()} ${a.unit}` : `Премногу мал: се очекува ${t.origin} да биде ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Неважечка низа: мора да започнува со "${o.prefix}"` : o.format === "ends_with" ? `Неважечка низа: мора да завршува со "${o.suffix}"` : o.format === "includes" ? `Неважечка низа: мора да вклучува "${o.includes}"` : o.format === "regex" ? `Неважечка низа: мора да одгоара на патернот ${o.pattern}` : `Invalid ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Грешен број: мора да биде делив со ${t.divisor}`;
      case "unrecognized_keys":
        return `${t.keys.length > 1 ? "Непрепознаени клучеви" : "Непрепознаен клуч"}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Грешен клуч во ${t.origin}`;
      case "invalid_union":
        return "Грешен внес";
      case "invalid_element":
        return `Грешна вредност во ${t.origin}`;
      default:
        return "Грешен внес";
    }
  };
};
function of() {
  return {
    localeError: rf()
  };
}
const af = () => {
  const e = {
    string: { unit: "aksara", verb: "mempunyai" },
    file: { unit: "bait", verb: "mempunyai" },
    array: { unit: "elemen", verb: "mempunyai" },
    set: { unit: "elemen", verb: "mempunyai" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "nombor";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "input",
    email: "alamat e-mel",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "tarikh masa ISO",
    date: "tarikh ISO",
    time: "masa ISO",
    duration: "tempoh ISO",
    ipv4: "alamat IPv4",
    ipv6: "alamat IPv6",
    cidrv4: "julat IPv4",
    cidrv6: "julat IPv6",
    base64: "string dikodkan base64",
    base64url: "string dikodkan base64url",
    json_string: "string JSON",
    e164: "nombor E.164",
    jwt: "JWT",
    template_literal: "input"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Input tidak sah: dijangka ${t.expected}, diterima ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Input tidak sah: dijangka ${N(t.values[0])}` : `Pilihan tidak sah: dijangka salah satu daripada ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Terlalu besar: dijangka ${t.origin ?? "nilai"} ${a.verb} ${o}${t.maximum.toString()} ${a.unit ?? "elemen"}` : `Terlalu besar: dijangka ${t.origin ?? "nilai"} adalah ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Terlalu kecil: dijangka ${t.origin} ${a.verb} ${o}${t.minimum.toString()} ${a.unit}` : `Terlalu kecil: dijangka ${t.origin} adalah ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `String tidak sah: mesti bermula dengan "${o.prefix}"` : o.format === "ends_with" ? `String tidak sah: mesti berakhir dengan "${o.suffix}"` : o.format === "includes" ? `String tidak sah: mesti mengandungi "${o.includes}"` : o.format === "regex" ? `String tidak sah: mesti sepadan dengan corak ${o.pattern}` : `${i[o.format] ?? t.format} tidak sah`;
      }
      case "not_multiple_of":
        return `Nombor tidak sah: perlu gandaan ${t.divisor}`;
      case "unrecognized_keys":
        return `Kunci tidak dikenali: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Kunci tidak sah dalam ${t.origin}`;
      case "invalid_union":
        return "Input tidak sah";
      case "invalid_element":
        return `Nilai tidak sah dalam ${t.origin}`;
      default:
        return "Input tidak sah";
    }
  };
};
function uf() {
  return {
    localeError: af()
  };
}
const lf = () => {
  const e = {
    string: { unit: "tekens", verb: "te hebben" },
    file: { unit: "bytes", verb: "te hebben" },
    array: { unit: "elementen", verb: "te hebben" },
    set: { unit: "elementen", verb: "te hebben" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "getal";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "invoer",
    email: "emailadres",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datum en tijd",
    date: "ISO datum",
    time: "ISO tijd",
    duration: "ISO duur",
    ipv4: "IPv4-adres",
    ipv6: "IPv6-adres",
    cidrv4: "IPv4-bereik",
    cidrv6: "IPv6-bereik",
    base64: "base64-gecodeerde tekst",
    base64url: "base64 URL-gecodeerde tekst",
    json_string: "JSON string",
    e164: "E.164-nummer",
    jwt: "JWT",
    template_literal: "invoer"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Ongeldige invoer: verwacht ${t.expected}, ontving ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Ongeldige invoer: verwacht ${N(t.values[0])}` : `Ongeldige optie: verwacht één van ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Te groot: verwacht dat ${t.origin ?? "waarde"} ${a.verb} ${o}${t.maximum.toString()} ${a.unit ?? "elementen"}` : `Te groot: verwacht dat ${t.origin ?? "waarde"} ${o}${t.maximum.toString()} is`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Te klein: verwacht dat ${t.origin} ${a.verb} ${o}${t.minimum.toString()} ${a.unit}` : `Te klein: verwacht dat ${t.origin} ${o}${t.minimum.toString()} is`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Ongeldige tekst: moet met "${o.prefix}" beginnen` : o.format === "ends_with" ? `Ongeldige tekst: moet op "${o.suffix}" eindigen` : o.format === "includes" ? `Ongeldige tekst: moet "${o.includes}" bevatten` : o.format === "regex" ? `Ongeldige tekst: moet overeenkomen met patroon ${o.pattern}` : `Ongeldig: ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Ongeldig getal: moet een veelvoud van ${t.divisor} zijn`;
      case "unrecognized_keys":
        return `Onbekende key${t.keys.length > 1 ? "s" : ""}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Ongeldige key in ${t.origin}`;
      case "invalid_union":
        return "Ongeldige invoer";
      case "invalid_element":
        return `Ongeldige waarde in ${t.origin}`;
      default:
        return "Ongeldige invoer";
    }
  };
};
function sf() {
  return {
    localeError: lf()
  };
}
const cf = () => {
  const e = {
    string: { unit: "tegn", verb: "å ha" },
    file: { unit: "bytes", verb: "å ha" },
    array: { unit: "elementer", verb: "å inneholde" },
    set: { unit: "elementer", verb: "å inneholde" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "tall";
      case "object": {
        if (Array.isArray(t))
          return "liste";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "input",
    email: "e-postadresse",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO dato- og klokkeslett",
    date: "ISO-dato",
    time: "ISO-klokkeslett",
    duration: "ISO-varighet",
    ipv4: "IPv4-område",
    ipv6: "IPv6-område",
    cidrv4: "IPv4-spekter",
    cidrv6: "IPv6-spekter",
    base64: "base64-enkodet streng",
    base64url: "base64url-enkodet streng",
    json_string: "JSON-streng",
    e164: "E.164-nummer",
    jwt: "JWT",
    template_literal: "input"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Ugyldig input: forventet ${t.expected}, fikk ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Ugyldig verdi: forventet ${N(t.values[0])}` : `Ugyldig valg: forventet en av ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `For stor(t): forventet ${t.origin ?? "value"} til å ha ${o}${t.maximum.toString()} ${a.unit ?? "elementer"}` : `For stor(t): forventet ${t.origin ?? "value"} til å ha ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `For lite(n): forventet ${t.origin} til å ha ${o}${t.minimum.toString()} ${a.unit}` : `For lite(n): forventet ${t.origin} til å ha ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Ugyldig streng: må starte med "${o.prefix}"` : o.format === "ends_with" ? `Ugyldig streng: må ende med "${o.suffix}"` : o.format === "includes" ? `Ugyldig streng: må inneholde "${o.includes}"` : o.format === "regex" ? `Ugyldig streng: må matche mønsteret ${o.pattern}` : `Ugyldig ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Ugyldig tall: må være et multiplum av ${t.divisor}`;
      case "unrecognized_keys":
        return `${t.keys.length > 1 ? "Ukjente nøkler" : "Ukjent nøkkel"}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Ugyldig nøkkel i ${t.origin}`;
      case "invalid_union":
        return "Ugyldig input";
      case "invalid_element":
        return `Ugyldig verdi i ${t.origin}`;
      default:
        return "Ugyldig input";
    }
  };
};
function df() {
  return {
    localeError: cf()
  };
}
const mf = () => {
  const e = {
    string: { unit: "harf", verb: "olmalıdır" },
    file: { unit: "bayt", verb: "olmalıdır" },
    array: { unit: "unsur", verb: "olmalıdır" },
    set: { unit: "unsur", verb: "olmalıdır" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "numara";
      case "object": {
        if (Array.isArray(t))
          return "saf";
        if (t === null)
          return "gayb";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "giren",
    email: "epostagâh",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO hengâmı",
    date: "ISO tarihi",
    time: "ISO zamanı",
    duration: "ISO müddeti",
    ipv4: "IPv4 nişânı",
    ipv6: "IPv6 nişânı",
    cidrv4: "IPv4 menzili",
    cidrv6: "IPv6 menzili",
    base64: "base64-şifreli metin",
    base64url: "base64url-şifreli metin",
    json_string: "JSON metin",
    e164: "E.164 sayısı",
    jwt: "JWT",
    template_literal: "giren"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Fâsit giren: umulan ${t.expected}, alınan ${r(t.input)}`;
      // return `Fâsit giren: umulan ${issue.expected}, alınan ${util.getParsedType(issue.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Fâsit giren: umulan ${N(t.values[0])}` : `Fâsit tercih: mûteberler ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Fazla büyük: ${t.origin ?? "value"}, ${o}${t.maximum.toString()} ${a.unit ?? "elements"} sahip olmalıydı.` : `Fazla büyük: ${t.origin ?? "value"}, ${o}${t.maximum.toString()} olmalıydı.`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Fazla küçük: ${t.origin}, ${o}${t.minimum.toString()} ${a.unit} sahip olmalıydı.` : `Fazla küçük: ${t.origin}, ${o}${t.minimum.toString()} olmalıydı.`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Fâsit metin: "${o.prefix}" ile başlamalı.` : o.format === "ends_with" ? `Fâsit metin: "${o.suffix}" ile bitmeli.` : o.format === "includes" ? `Fâsit metin: "${o.includes}" ihtivâ etmeli.` : o.format === "regex" ? `Fâsit metin: ${o.pattern} nakşına uymalı.` : `Fâsit ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Fâsit sayı: ${t.divisor} katı olmalıydı.`;
      case "unrecognized_keys":
        return `Tanınmayan anahtar ${t.keys.length > 1 ? "s" : ""}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `${t.origin} için tanınmayan anahtar var.`;
      case "invalid_union":
        return "Giren tanınamadı.";
      case "invalid_element":
        return `${t.origin} için tanınmayan kıymet var.`;
      default:
        return "Kıymet tanınamadı.";
    }
  };
};
function gf() {
  return {
    localeError: mf()
  };
}
const ff = () => {
  const e = {
    string: { unit: "توکي", verb: "ولري" },
    file: { unit: "بایټس", verb: "ولري" },
    array: { unit: "توکي", verb: "ولري" },
    set: { unit: "توکي", verb: "ولري" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "عدد";
      case "object": {
        if (Array.isArray(t))
          return "ارې";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "ورودي",
    email: "بریښنالیک",
    url: "یو آر ال",
    emoji: "ایموجي",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "نیټه او وخت",
    date: "نېټه",
    time: "وخت",
    duration: "موده",
    ipv4: "د IPv4 پته",
    ipv6: "د IPv6 پته",
    cidrv4: "د IPv4 ساحه",
    cidrv6: "د IPv6 ساحه",
    base64: "base64-encoded متن",
    base64url: "base64url-encoded متن",
    json_string: "JSON متن",
    e164: "د E.164 شمېره",
    jwt: "JWT",
    template_literal: "ورودي"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `ناسم ورودي: باید ${t.expected} وای, مګر ${r(t.input)} ترلاسه شو`;
      case "invalid_value":
        return t.values.length === 1 ? `ناسم ورودي: باید ${N(t.values[0])} وای` : `ناسم انتخاب: باید یو له ${I(t.values, "|")} څخه وای`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `ډیر لوی: ${t.origin ?? "ارزښت"} باید ${o}${t.maximum.toString()} ${a.unit ?? "عنصرونه"} ولري` : `ډیر لوی: ${t.origin ?? "ارزښت"} باید ${o}${t.maximum.toString()} وي`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `ډیر کوچنی: ${t.origin} باید ${o}${t.minimum.toString()} ${a.unit} ولري` : `ډیر کوچنی: ${t.origin} باید ${o}${t.minimum.toString()} وي`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `ناسم متن: باید د "${o.prefix}" سره پیل شي` : o.format === "ends_with" ? `ناسم متن: باید د "${o.suffix}" سره پای ته ورسيږي` : o.format === "includes" ? `ناسم متن: باید "${o.includes}" ولري` : o.format === "regex" ? `ناسم متن: باید د ${o.pattern} سره مطابقت ولري` : `${i[o.format] ?? t.format} ناسم دی`;
      }
      case "not_multiple_of":
        return `ناسم عدد: باید د ${t.divisor} مضرب وي`;
      case "unrecognized_keys":
        return `ناسم ${t.keys.length > 1 ? "کلیډونه" : "کلیډ"}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `ناسم کلیډ په ${t.origin} کې`;
      case "invalid_union":
        return "ناسمه ورودي";
      case "invalid_element":
        return `ناسم عنصر په ${t.origin} کې`;
      default:
        return "ناسمه ورودي";
    }
  };
};
function pf() {
  return {
    localeError: ff()
  };
}
const vf = () => {
  const e = {
    string: { unit: "znaków", verb: "mieć" },
    file: { unit: "bajtów", verb: "mieć" },
    array: { unit: "elementów", verb: "mieć" },
    set: { unit: "elementów", verb: "mieć" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "liczba";
      case "object": {
        if (Array.isArray(t))
          return "tablica";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "wyrażenie",
    email: "adres email",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "data i godzina w formacie ISO",
    date: "data w formacie ISO",
    time: "godzina w formacie ISO",
    duration: "czas trwania ISO",
    ipv4: "adres IPv4",
    ipv6: "adres IPv6",
    cidrv4: "zakres IPv4",
    cidrv6: "zakres IPv6",
    base64: "ciąg znaków zakodowany w formacie base64",
    base64url: "ciąg znaków zakodowany w formacie base64url",
    json_string: "ciąg znaków w formacie JSON",
    e164: "liczba E.164",
    jwt: "JWT",
    template_literal: "wejście"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Nieprawidłowe dane wejściowe: oczekiwano ${t.expected}, otrzymano ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Nieprawidłowe dane wejściowe: oczekiwano ${N(t.values[0])}` : `Nieprawidłowa opcja: oczekiwano jednej z wartości ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Za duża wartość: oczekiwano, że ${t.origin ?? "wartość"} będzie mieć ${o}${t.maximum.toString()} ${a.unit ?? "elementów"}` : `Zbyt duż(y/a/e): oczekiwano, że ${t.origin ?? "wartość"} będzie wynosić ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Za mała wartość: oczekiwano, że ${t.origin ?? "wartość"} będzie mieć ${o}${t.minimum.toString()} ${a.unit ?? "elementów"}` : `Zbyt mał(y/a/e): oczekiwano, że ${t.origin ?? "wartość"} będzie wynosić ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Nieprawidłowy ciąg znaków: musi zaczynać się od "${o.prefix}"` : o.format === "ends_with" ? `Nieprawidłowy ciąg znaków: musi kończyć się na "${o.suffix}"` : o.format === "includes" ? `Nieprawidłowy ciąg znaków: musi zawierać "${o.includes}"` : o.format === "regex" ? `Nieprawidłowy ciąg znaków: musi odpowiadać wzorcowi ${o.pattern}` : `Nieprawidłow(y/a/e) ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Nieprawidłowa liczba: musi być wielokrotnością ${t.divisor}`;
      case "unrecognized_keys":
        return `Nierozpoznane klucze${t.keys.length > 1 ? "s" : ""}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Nieprawidłowy klucz w ${t.origin}`;
      case "invalid_union":
        return "Nieprawidłowe dane wejściowe";
      case "invalid_element":
        return `Nieprawidłowa wartość w ${t.origin}`;
      default:
        return "Nieprawidłowe dane wejściowe";
    }
  };
};
function hf() {
  return {
    localeError: vf()
  };
}
const bf = () => {
  const e = {
    string: { unit: "caracteres", verb: "ter" },
    file: { unit: "bytes", verb: "ter" },
    array: { unit: "itens", verb: "ter" },
    set: { unit: "itens", verb: "ter" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "número";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "nulo";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "padrão",
    email: "endereço de e-mail",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "data e hora ISO",
    date: "data ISO",
    time: "hora ISO",
    duration: "duração ISO",
    ipv4: "endereço IPv4",
    ipv6: "endereço IPv6",
    cidrv4: "faixa de IPv4",
    cidrv6: "faixa de IPv6",
    base64: "texto codificado em base64",
    base64url: "URL codificada em base64",
    json_string: "texto JSON",
    e164: "número E.164",
    jwt: "JWT",
    template_literal: "entrada"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Tipo inválido: esperado ${t.expected}, recebido ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Entrada inválida: esperado ${N(t.values[0])}` : `Opção inválida: esperada uma das ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Muito grande: esperado que ${t.origin ?? "valor"} tivesse ${o}${t.maximum.toString()} ${a.unit ?? "elementos"}` : `Muito grande: esperado que ${t.origin ?? "valor"} fosse ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Muito pequeno: esperado que ${t.origin} tivesse ${o}${t.minimum.toString()} ${a.unit}` : `Muito pequeno: esperado que ${t.origin} fosse ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Texto inválido: deve começar com "${o.prefix}"` : o.format === "ends_with" ? `Texto inválido: deve terminar com "${o.suffix}"` : o.format === "includes" ? `Texto inválido: deve incluir "${o.includes}"` : o.format === "regex" ? `Texto inválido: deve corresponder ao padrão ${o.pattern}` : `${i[o.format] ?? t.format} inválido`;
      }
      case "not_multiple_of":
        return `Número inválido: deve ser múltiplo de ${t.divisor}`;
      case "unrecognized_keys":
        return `Chave${t.keys.length > 1 ? "s" : ""} desconhecida${t.keys.length > 1 ? "s" : ""}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Chave inválida em ${t.origin}`;
      case "invalid_union":
        return "Entrada inválida";
      case "invalid_element":
        return `Valor inválido em ${t.origin}`;
      default:
        return "Campo inválido";
    }
  };
};
function _f() {
  return {
    localeError: bf()
  };
}
function Do(e, n, r, i) {
  const t = Math.abs(e), o = t % 10, a = t % 100;
  return a >= 11 && a <= 19 ? i : o === 1 ? n : o >= 2 && o <= 4 ? r : i;
}
const yf = () => {
  const e = {
    string: {
      unit: {
        one: "символ",
        few: "символа",
        many: "символов"
      },
      verb: "иметь"
    },
    file: {
      unit: {
        one: "байт",
        few: "байта",
        many: "байт"
      },
      verb: "иметь"
    },
    array: {
      unit: {
        one: "элемент",
        few: "элемента",
        many: "элементов"
      },
      verb: "иметь"
    },
    set: {
      unit: {
        one: "элемент",
        few: "элемента",
        many: "элементов"
      },
      verb: "иметь"
    }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "число";
      case "object": {
        if (Array.isArray(t))
          return "массив";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "ввод",
    email: "email адрес",
    url: "URL",
    emoji: "эмодзи",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO дата и время",
    date: "ISO дата",
    time: "ISO время",
    duration: "ISO длительность",
    ipv4: "IPv4 адрес",
    ipv6: "IPv6 адрес",
    cidrv4: "IPv4 диапазон",
    cidrv6: "IPv6 диапазон",
    base64: "строка в формате base64",
    base64url: "строка в формате base64url",
    json_string: "JSON строка",
    e164: "номер E.164",
    jwt: "JWT",
    template_literal: "ввод"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Неверный ввод: ожидалось ${t.expected}, получено ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Неверный ввод: ожидалось ${N(t.values[0])}` : `Неверный вариант: ожидалось одно из ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        if (a) {
          const u = Number(t.maximum), s = Do(u, a.unit.one, a.unit.few, a.unit.many);
          return `Слишком большое значение: ожидалось, что ${t.origin ?? "значение"} будет иметь ${o}${t.maximum.toString()} ${s}`;
        }
        return `Слишком большое значение: ожидалось, что ${t.origin ?? "значение"} будет ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        if (a) {
          const u = Number(t.minimum), s = Do(u, a.unit.one, a.unit.few, a.unit.many);
          return `Слишком маленькое значение: ожидалось, что ${t.origin} будет иметь ${o}${t.minimum.toString()} ${s}`;
        }
        return `Слишком маленькое значение: ожидалось, что ${t.origin} будет ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Неверная строка: должна начинаться с "${o.prefix}"` : o.format === "ends_with" ? `Неверная строка: должна заканчиваться на "${o.suffix}"` : o.format === "includes" ? `Неверная строка: должна содержать "${o.includes}"` : o.format === "regex" ? `Неверная строка: должна соответствовать шаблону ${o.pattern}` : `Неверный ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Неверное число: должно быть кратным ${t.divisor}`;
      case "unrecognized_keys":
        return `Нераспознанн${t.keys.length > 1 ? "ые" : "ый"} ключ${t.keys.length > 1 ? "и" : ""}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Неверный ключ в ${t.origin}`;
      case "invalid_union":
        return "Неверные входные данные";
      case "invalid_element":
        return `Неверное значение в ${t.origin}`;
      default:
        return "Неверные входные данные";
    }
  };
};
function Sf() {
  return {
    localeError: yf()
  };
}
const If = () => {
  const e = {
    string: { unit: "znakov", verb: "imeti" },
    file: { unit: "bajtov", verb: "imeti" },
    array: { unit: "elementov", verb: "imeti" },
    set: { unit: "elementov", verb: "imeti" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "število";
      case "object": {
        if (Array.isArray(t))
          return "tabela";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "vnos",
    email: "e-poštni naslov",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datum in čas",
    date: "ISO datum",
    time: "ISO čas",
    duration: "ISO trajanje",
    ipv4: "IPv4 naslov",
    ipv6: "IPv6 naslov",
    cidrv4: "obseg IPv4",
    cidrv6: "obseg IPv6",
    base64: "base64 kodiran niz",
    base64url: "base64url kodiran niz",
    json_string: "JSON niz",
    e164: "E.164 številka",
    jwt: "JWT",
    template_literal: "vnos"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Neveljaven vnos: pričakovano ${t.expected}, prejeto ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Neveljaven vnos: pričakovano ${N(t.values[0])}` : `Neveljavna možnost: pričakovano eno izmed ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Preveliko: pričakovano, da bo ${t.origin ?? "vrednost"} imelo ${o}${t.maximum.toString()} ${a.unit ?? "elementov"}` : `Preveliko: pričakovano, da bo ${t.origin ?? "vrednost"} ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Premajhno: pričakovano, da bo ${t.origin} imelo ${o}${t.minimum.toString()} ${a.unit}` : `Premajhno: pričakovano, da bo ${t.origin} ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Neveljaven niz: mora se začeti z "${o.prefix}"` : o.format === "ends_with" ? `Neveljaven niz: mora se končati z "${o.suffix}"` : o.format === "includes" ? `Neveljaven niz: mora vsebovati "${o.includes}"` : o.format === "regex" ? `Neveljaven niz: mora ustrezati vzorcu ${o.pattern}` : `Neveljaven ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Neveljavno število: mora biti večkratnik ${t.divisor}`;
      case "unrecognized_keys":
        return `Neprepoznan${t.keys.length > 1 ? "i ključi" : " ključ"}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Neveljaven ključ v ${t.origin}`;
      case "invalid_union":
        return "Neveljaven vnos";
      case "invalid_element":
        return `Neveljavna vrednost v ${t.origin}`;
      default:
        return "Neveljaven vnos";
    }
  };
};
function $f() {
  return {
    localeError: If()
  };
}
const Ef = () => {
  const e = {
    string: { unit: "tecken", verb: "att ha" },
    file: { unit: "bytes", verb: "att ha" },
    array: { unit: "objekt", verb: "att innehålla" },
    set: { unit: "objekt", verb: "att innehålla" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "antal";
      case "object": {
        if (Array.isArray(t))
          return "lista";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "reguljärt uttryck",
    email: "e-postadress",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO-datum och tid",
    date: "ISO-datum",
    time: "ISO-tid",
    duration: "ISO-varaktighet",
    ipv4: "IPv4-intervall",
    ipv6: "IPv6-intervall",
    cidrv4: "IPv4-spektrum",
    cidrv6: "IPv6-spektrum",
    base64: "base64-kodad sträng",
    base64url: "base64url-kodad sträng",
    json_string: "JSON-sträng",
    e164: "E.164-nummer",
    jwt: "JWT",
    template_literal: "mall-literal"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Ogiltig inmatning: förväntat ${t.expected}, fick ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Ogiltig inmatning: förväntat ${N(t.values[0])}` : `Ogiltigt val: förväntade en av ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `För stor(t): förväntade ${t.origin ?? "värdet"} att ha ${o}${t.maximum.toString()} ${a.unit ?? "element"}` : `För stor(t): förväntat ${t.origin ?? "värdet"} att ha ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `För lite(t): förväntade ${t.origin ?? "värdet"} att ha ${o}${t.minimum.toString()} ${a.unit}` : `För lite(t): förväntade ${t.origin ?? "värdet"} att ha ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Ogiltig sträng: måste börja med "${o.prefix}"` : o.format === "ends_with" ? `Ogiltig sträng: måste sluta med "${o.suffix}"` : o.format === "includes" ? `Ogiltig sträng: måste innehålla "${o.includes}"` : o.format === "regex" ? `Ogiltig sträng: måste matcha mönstret "${o.pattern}"` : `Ogiltig(t) ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Ogiltigt tal: måste vara en multipel av ${t.divisor}`;
      case "unrecognized_keys":
        return `${t.keys.length > 1 ? "Okända nycklar" : "Okänd nyckel"}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Ogiltig nyckel i ${t.origin ?? "värdet"}`;
      case "invalid_union":
        return "Ogiltig input";
      case "invalid_element":
        return `Ogiltigt värde i ${t.origin ?? "värdet"}`;
      default:
        return "Ogiltig input";
    }
  };
};
function kf() {
  return {
    localeError: Ef()
  };
}
const Nf = () => {
  const e = {
    string: { unit: "எழுத்துக்கள்", verb: "கொண்டிருக்க வேண்டும்" },
    file: { unit: "பைட்டுகள்", verb: "கொண்டிருக்க வேண்டும்" },
    array: { unit: "உறுப்புகள்", verb: "கொண்டிருக்க வேண்டும்" },
    set: { unit: "உறுப்புகள்", verb: "கொண்டிருக்க வேண்டும்" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "எண் அல்லாதது" : "எண்";
      case "object": {
        if (Array.isArray(t))
          return "அணி";
        if (t === null)
          return "வெறுமை";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "உள்ளீடு",
    email: "மின்னஞ்சல் முகவரி",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO தேதி நேரம்",
    date: "ISO தேதி",
    time: "ISO நேரம்",
    duration: "ISO கால அளவு",
    ipv4: "IPv4 முகவரி",
    ipv6: "IPv6 முகவரி",
    cidrv4: "IPv4 வரம்பு",
    cidrv6: "IPv6 வரம்பு",
    base64: "base64-encoded சரம்",
    base64url: "base64url-encoded சரம்",
    json_string: "JSON சரம்",
    e164: "E.164 எண்",
    jwt: "JWT",
    template_literal: "input"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `தவறான உள்ளீடு: எதிர்பார்க்கப்பட்டது ${t.expected}, பெறப்பட்டது ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `தவறான உள்ளீடு: எதிர்பார்க்கப்பட்டது ${N(t.values[0])}` : `தவறான விருப்பம்: எதிர்பார்க்கப்பட்டது ${I(t.values, "|")} இல் ஒன்று`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `மிக பெரியது: எதிர்பார்க்கப்பட்டது ${t.origin ?? "மதிப்பு"} ${o}${t.maximum.toString()} ${a.unit ?? "உறுப்புகள்"} ஆக இருக்க வேண்டும்` : `மிக பெரியது: எதிர்பார்க்கப்பட்டது ${t.origin ?? "மதிப்பு"} ${o}${t.maximum.toString()} ஆக இருக்க வேண்டும்`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `மிகச் சிறியது: எதிர்பார்க்கப்பட்டது ${t.origin} ${o}${t.minimum.toString()} ${a.unit} ஆக இருக்க வேண்டும்` : `மிகச் சிறியது: எதிர்பார்க்கப்பட்டது ${t.origin} ${o}${t.minimum.toString()} ஆக இருக்க வேண்டும்`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `தவறான சரம்: "${o.prefix}" இல் தொடங்க வேண்டும்` : o.format === "ends_with" ? `தவறான சரம்: "${o.suffix}" இல் முடிவடைய வேண்டும்` : o.format === "includes" ? `தவறான சரம்: "${o.includes}" ஐ உள்ளடக்க வேண்டும்` : o.format === "regex" ? `தவறான சரம்: ${o.pattern} முறைபாட்டுடன் பொருந்த வேண்டும்` : `தவறான ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `தவறான எண்: ${t.divisor} இன் பலமாக இருக்க வேண்டும்`;
      case "unrecognized_keys":
        return `அடையாளம் தெரியாத விசை${t.keys.length > 1 ? "கள்" : ""}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `${t.origin} இல் தவறான விசை`;
      case "invalid_union":
        return "தவறான உள்ளீடு";
      case "invalid_element":
        return `${t.origin} இல் தவறான மதிப்பு`;
      default:
        return "தவறான உள்ளீடு";
    }
  };
};
function Of() {
  return {
    localeError: Nf()
  };
}
const Tf = () => {
  const e = {
    string: { unit: "ตัวอักษร", verb: "ควรมี" },
    file: { unit: "ไบต์", verb: "ควรมี" },
    array: { unit: "รายการ", verb: "ควรมี" },
    set: { unit: "รายการ", verb: "ควรมี" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "ไม่ใช่ตัวเลข (NaN)" : "ตัวเลข";
      case "object": {
        if (Array.isArray(t))
          return "อาร์เรย์ (Array)";
        if (t === null)
          return "ไม่มีค่า (null)";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "ข้อมูลที่ป้อน",
    email: "ที่อยู่อีเมล",
    url: "URL",
    emoji: "อิโมจิ",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "วันที่เวลาแบบ ISO",
    date: "วันที่แบบ ISO",
    time: "เวลาแบบ ISO",
    duration: "ช่วงเวลาแบบ ISO",
    ipv4: "ที่อยู่ IPv4",
    ipv6: "ที่อยู่ IPv6",
    cidrv4: "ช่วง IP แบบ IPv4",
    cidrv6: "ช่วง IP แบบ IPv6",
    base64: "ข้อความแบบ Base64",
    base64url: "ข้อความแบบ Base64 สำหรับ URL",
    json_string: "ข้อความแบบ JSON",
    e164: "เบอร์โทรศัพท์ระหว่างประเทศ (E.164)",
    jwt: "โทเคน JWT",
    template_literal: "ข้อมูลที่ป้อน"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `ประเภทข้อมูลไม่ถูกต้อง: ควรเป็น ${t.expected} แต่ได้รับ ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `ค่าไม่ถูกต้อง: ควรเป็น ${N(t.values[0])}` : `ตัวเลือกไม่ถูกต้อง: ควรเป็นหนึ่งใน ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "ไม่เกิน" : "น้อยกว่า", a = n(t.origin);
        return a ? `เกินกำหนด: ${t.origin ?? "ค่า"} ควรมี${o} ${t.maximum.toString()} ${a.unit ?? "รายการ"}` : `เกินกำหนด: ${t.origin ?? "ค่า"} ควรมี${o} ${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? "อย่างน้อย" : "มากกว่า", a = n(t.origin);
        return a ? `น้อยกว่ากำหนด: ${t.origin} ควรมี${o} ${t.minimum.toString()} ${a.unit}` : `น้อยกว่ากำหนด: ${t.origin} ควรมี${o} ${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `รูปแบบไม่ถูกต้อง: ข้อความต้องขึ้นต้นด้วย "${o.prefix}"` : o.format === "ends_with" ? `รูปแบบไม่ถูกต้อง: ข้อความต้องลงท้ายด้วย "${o.suffix}"` : o.format === "includes" ? `รูปแบบไม่ถูกต้อง: ข้อความต้องมี "${o.includes}" อยู่ในข้อความ` : o.format === "regex" ? `รูปแบบไม่ถูกต้อง: ต้องตรงกับรูปแบบที่กำหนด ${o.pattern}` : `รูปแบบไม่ถูกต้อง: ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `ตัวเลขไม่ถูกต้อง: ต้องเป็นจำนวนที่หารด้วย ${t.divisor} ได้ลงตัว`;
      case "unrecognized_keys":
        return `พบคีย์ที่ไม่รู้จัก: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `คีย์ไม่ถูกต้องใน ${t.origin}`;
      case "invalid_union":
        return "ข้อมูลไม่ถูกต้อง: ไม่ตรงกับรูปแบบยูเนียนที่กำหนดไว้";
      case "invalid_element":
        return `ข้อมูลไม่ถูกต้องใน ${t.origin}`;
      default:
        return "ข้อมูลไม่ถูกต้อง";
    }
  };
};
function wf() {
  return {
    localeError: Tf()
  };
}
const Af = (e) => {
  const n = typeof e;
  switch (n) {
    case "number":
      return Number.isNaN(e) ? "NaN" : "number";
    case "object": {
      if (Array.isArray(e))
        return "array";
      if (e === null)
        return "null";
      if (Object.getPrototypeOf(e) !== Object.prototype && e.constructor)
        return e.constructor.name;
    }
  }
  return n;
}, Uf = () => {
  const e = {
    string: { unit: "karakter", verb: "olmalı" },
    file: { unit: "bayt", verb: "olmalı" },
    array: { unit: "öğe", verb: "olmalı" },
    set: { unit: "öğe", verb: "olmalı" }
  };
  function n(i) {
    return e[i] ?? null;
  }
  const r = {
    regex: "girdi",
    email: "e-posta adresi",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO tarih ve saat",
    date: "ISO tarih",
    time: "ISO saat",
    duration: "ISO süre",
    ipv4: "IPv4 adresi",
    ipv6: "IPv6 adresi",
    cidrv4: "IPv4 aralığı",
    cidrv6: "IPv6 aralığı",
    base64: "base64 ile şifrelenmiş metin",
    base64url: "base64url ile şifrelenmiş metin",
    json_string: "JSON dizesi",
    e164: "E.164 sayısı",
    jwt: "JWT",
    template_literal: "Şablon dizesi"
  };
  return (i) => {
    switch (i.code) {
      case "invalid_type":
        return `Geçersiz değer: beklenen ${i.expected}, alınan ${Af(i.input)}`;
      case "invalid_value":
        return i.values.length === 1 ? `Geçersiz değer: beklenen ${N(i.values[0])}` : `Geçersiz seçenek: aşağıdakilerden biri olmalı: ${I(i.values, "|")}`;
      case "too_big": {
        const t = i.inclusive ? "<=" : "<", o = n(i.origin);
        return o ? `Çok büyük: beklenen ${i.origin ?? "değer"} ${t}${i.maximum.toString()} ${o.unit ?? "öğe"}` : `Çok büyük: beklenen ${i.origin ?? "değer"} ${t}${i.maximum.toString()}`;
      }
      case "too_small": {
        const t = i.inclusive ? ">=" : ">", o = n(i.origin);
        return o ? `Çok küçük: beklenen ${i.origin} ${t}${i.minimum.toString()} ${o.unit}` : `Çok küçük: beklenen ${i.origin} ${t}${i.minimum.toString()}`;
      }
      case "invalid_format": {
        const t = i;
        return t.format === "starts_with" ? `Geçersiz metin: "${t.prefix}" ile başlamalı` : t.format === "ends_with" ? `Geçersiz metin: "${t.suffix}" ile bitmeli` : t.format === "includes" ? `Geçersiz metin: "${t.includes}" içermeli` : t.format === "regex" ? `Geçersiz metin: ${t.pattern} desenine uymalı` : `Geçersiz ${r[t.format] ?? i.format}`;
      }
      case "not_multiple_of":
        return `Geçersiz sayı: ${i.divisor} ile tam bölünebilmeli`;
      case "unrecognized_keys":
        return `Tanınmayan anahtar${i.keys.length > 1 ? "lar" : ""}: ${I(i.keys, ", ")}`;
      case "invalid_key":
        return `${i.origin} içinde geçersiz anahtar`;
      case "invalid_union":
        return "Geçersiz değer";
      case "invalid_element":
        return `${i.origin} içinde geçersiz değer`;
      default:
        return "Geçersiz değer";
    }
  };
};
function Pf() {
  return {
    localeError: Uf()
  };
}
const Df = () => {
  const e = {
    string: { unit: "символів", verb: "матиме" },
    file: { unit: "байтів", verb: "матиме" },
    array: { unit: "елементів", verb: "матиме" },
    set: { unit: "елементів", verb: "матиме" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "число";
      case "object": {
        if (Array.isArray(t))
          return "масив";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "вхідні дані",
    email: "адреса електронної пошти",
    url: "URL",
    emoji: "емодзі",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "дата та час ISO",
    date: "дата ISO",
    time: "час ISO",
    duration: "тривалість ISO",
    ipv4: "адреса IPv4",
    ipv6: "адреса IPv6",
    cidrv4: "діапазон IPv4",
    cidrv6: "діапазон IPv6",
    base64: "рядок у кодуванні base64",
    base64url: "рядок у кодуванні base64url",
    json_string: "рядок JSON",
    e164: "номер E.164",
    jwt: "JWT",
    template_literal: "вхідні дані"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Неправильні вхідні дані: очікується ${t.expected}, отримано ${r(t.input)}`;
      // return `Неправильні вхідні дані: очікується ${issue.expected}, отримано ${util.getParsedType(issue.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Неправильні вхідні дані: очікується ${N(t.values[0])}` : `Неправильна опція: очікується одне з ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Занадто велике: очікується, що ${t.origin ?? "значення"} ${a.verb} ${o}${t.maximum.toString()} ${a.unit ?? "елементів"}` : `Занадто велике: очікується, що ${t.origin ?? "значення"} буде ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Занадто мале: очікується, що ${t.origin} ${a.verb} ${o}${t.minimum.toString()} ${a.unit}` : `Занадто мале: очікується, що ${t.origin} буде ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Неправильний рядок: повинен починатися з "${o.prefix}"` : o.format === "ends_with" ? `Неправильний рядок: повинен закінчуватися на "${o.suffix}"` : o.format === "includes" ? `Неправильний рядок: повинен містити "${o.includes}"` : o.format === "regex" ? `Неправильний рядок: повинен відповідати шаблону ${o.pattern}` : `Неправильний ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Неправильне число: повинно бути кратним ${t.divisor}`;
      case "unrecognized_keys":
        return `Нерозпізнаний ключ${t.keys.length > 1 ? "і" : ""}: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Неправильний ключ у ${t.origin}`;
      case "invalid_union":
        return "Неправильні вхідні дані";
      case "invalid_element":
        return `Неправильне значення у ${t.origin}`;
      default:
        return "Неправильні вхідні дані";
    }
  };
};
function Yl() {
  return {
    localeError: Df()
  };
}
function Rf() {
  return Yl();
}
const zf = () => {
  const e = {
    string: { unit: "حروف", verb: "ہونا" },
    file: { unit: "بائٹس", verb: "ہونا" },
    array: { unit: "آئٹمز", verb: "ہونا" },
    set: { unit: "آئٹمز", verb: "ہونا" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "نمبر";
      case "object": {
        if (Array.isArray(t))
          return "آرے";
        if (t === null)
          return "نل";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "ان پٹ",
    email: "ای میل ایڈریس",
    url: "یو آر ایل",
    emoji: "ایموجی",
    uuid: "یو یو آئی ڈی",
    uuidv4: "یو یو آئی ڈی وی 4",
    uuidv6: "یو یو آئی ڈی وی 6",
    nanoid: "نینو آئی ڈی",
    guid: "جی یو آئی ڈی",
    cuid: "سی یو آئی ڈی",
    cuid2: "سی یو آئی ڈی 2",
    ulid: "یو ایل آئی ڈی",
    xid: "ایکس آئی ڈی",
    ksuid: "کے ایس یو آئی ڈی",
    datetime: "آئی ایس او ڈیٹ ٹائم",
    date: "آئی ایس او تاریخ",
    time: "آئی ایس او وقت",
    duration: "آئی ایس او مدت",
    ipv4: "آئی پی وی 4 ایڈریس",
    ipv6: "آئی پی وی 6 ایڈریس",
    cidrv4: "آئی پی وی 4 رینج",
    cidrv6: "آئی پی وی 6 رینج",
    base64: "بیس 64 ان کوڈڈ سٹرنگ",
    base64url: "بیس 64 یو آر ایل ان کوڈڈ سٹرنگ",
    json_string: "جے ایس او این سٹرنگ",
    e164: "ای 164 نمبر",
    jwt: "جے ڈبلیو ٹی",
    template_literal: "ان پٹ"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `غلط ان پٹ: ${t.expected} متوقع تھا، ${r(t.input)} موصول ہوا`;
      case "invalid_value":
        return t.values.length === 1 ? `غلط ان پٹ: ${N(t.values[0])} متوقع تھا` : `غلط آپشن: ${I(t.values, "|")} میں سے ایک متوقع تھا`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `بہت بڑا: ${t.origin ?? "ویلیو"} کے ${o}${t.maximum.toString()} ${a.unit ?? "عناصر"} ہونے متوقع تھے` : `بہت بڑا: ${t.origin ?? "ویلیو"} کا ${o}${t.maximum.toString()} ہونا متوقع تھا`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `بہت چھوٹا: ${t.origin} کے ${o}${t.minimum.toString()} ${a.unit} ہونے متوقع تھے` : `بہت چھوٹا: ${t.origin} کا ${o}${t.minimum.toString()} ہونا متوقع تھا`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `غلط سٹرنگ: "${o.prefix}" سے شروع ہونا چاہیے` : o.format === "ends_with" ? `غلط سٹرنگ: "${o.suffix}" پر ختم ہونا چاہیے` : o.format === "includes" ? `غلط سٹرنگ: "${o.includes}" شامل ہونا چاہیے` : o.format === "regex" ? `غلط سٹرنگ: پیٹرن ${o.pattern} سے میچ ہونا چاہیے` : `غلط ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `غلط نمبر: ${t.divisor} کا مضاعف ہونا چاہیے`;
      case "unrecognized_keys":
        return `غیر تسلیم شدہ کی${t.keys.length > 1 ? "ز" : ""}: ${I(t.keys, "، ")}`;
      case "invalid_key":
        return `${t.origin} میں غلط کی`;
      case "invalid_union":
        return "غلط ان پٹ";
      case "invalid_element":
        return `${t.origin} میں غلط ویلیو`;
      default:
        return "غلط ان پٹ";
    }
  };
};
function Cf() {
  return {
    localeError: zf()
  };
}
const jf = () => {
  const e = {
    string: { unit: "ký tự", verb: "có" },
    file: { unit: "byte", verb: "có" },
    array: { unit: "phần tử", verb: "có" },
    set: { unit: "phần tử", verb: "có" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "số";
      case "object": {
        if (Array.isArray(t))
          return "mảng";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "đầu vào",
    email: "địa chỉ email",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ngày giờ ISO",
    date: "ngày ISO",
    time: "giờ ISO",
    duration: "khoảng thời gian ISO",
    ipv4: "địa chỉ IPv4",
    ipv6: "địa chỉ IPv6",
    cidrv4: "dải IPv4",
    cidrv6: "dải IPv6",
    base64: "chuỗi mã hóa base64",
    base64url: "chuỗi mã hóa base64url",
    json_string: "chuỗi JSON",
    e164: "số E.164",
    jwt: "JWT",
    template_literal: "đầu vào"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Đầu vào không hợp lệ: mong đợi ${t.expected}, nhận được ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Đầu vào không hợp lệ: mong đợi ${N(t.values[0])}` : `Tùy chọn không hợp lệ: mong đợi một trong các giá trị ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Quá lớn: mong đợi ${t.origin ?? "giá trị"} ${a.verb} ${o}${t.maximum.toString()} ${a.unit ?? "phần tử"}` : `Quá lớn: mong đợi ${t.origin ?? "giá trị"} ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Quá nhỏ: mong đợi ${t.origin} ${a.verb} ${o}${t.minimum.toString()} ${a.unit}` : `Quá nhỏ: mong đợi ${t.origin} ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Chuỗi không hợp lệ: phải bắt đầu bằng "${o.prefix}"` : o.format === "ends_with" ? `Chuỗi không hợp lệ: phải kết thúc bằng "${o.suffix}"` : o.format === "includes" ? `Chuỗi không hợp lệ: phải bao gồm "${o.includes}"` : o.format === "regex" ? `Chuỗi không hợp lệ: phải khớp với mẫu ${o.pattern}` : `${i[o.format] ?? t.format} không hợp lệ`;
      }
      case "not_multiple_of":
        return `Số không hợp lệ: phải là bội số của ${t.divisor}`;
      case "unrecognized_keys":
        return `Khóa không được nhận dạng: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Khóa không hợp lệ trong ${t.origin}`;
      case "invalid_union":
        return "Đầu vào không hợp lệ";
      case "invalid_element":
        return `Giá trị không hợp lệ trong ${t.origin}`;
      default:
        return "Đầu vào không hợp lệ";
    }
  };
};
function Lf() {
  return {
    localeError: jf()
  };
}
const xf = () => {
  const e = {
    string: { unit: "字符", verb: "包含" },
    file: { unit: "字节", verb: "包含" },
    array: { unit: "项", verb: "包含" },
    set: { unit: "项", verb: "包含" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "非数字(NaN)" : "数字";
      case "object": {
        if (Array.isArray(t))
          return "数组";
        if (t === null)
          return "空值(null)";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "输入",
    email: "电子邮件",
    url: "URL",
    emoji: "表情符号",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO日期时间",
    date: "ISO日期",
    time: "ISO时间",
    duration: "ISO时长",
    ipv4: "IPv4地址",
    ipv6: "IPv6地址",
    cidrv4: "IPv4网段",
    cidrv6: "IPv6网段",
    base64: "base64编码字符串",
    base64url: "base64url编码字符串",
    json_string: "JSON字符串",
    e164: "E.164号码",
    jwt: "JWT",
    template_literal: "输入"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `无效输入：期望 ${t.expected}，实际接收 ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `无效输入：期望 ${N(t.values[0])}` : `无效选项：期望以下之一 ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `数值过大：期望 ${t.origin ?? "值"} ${o}${t.maximum.toString()} ${a.unit ?? "个元素"}` : `数值过大：期望 ${t.origin ?? "值"} ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `数值过小：期望 ${t.origin} ${o}${t.minimum.toString()} ${a.unit}` : `数值过小：期望 ${t.origin} ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `无效字符串：必须以 "${o.prefix}" 开头` : o.format === "ends_with" ? `无效字符串：必须以 "${o.suffix}" 结尾` : o.format === "includes" ? `无效字符串：必须包含 "${o.includes}"` : o.format === "regex" ? `无效字符串：必须满足正则表达式 ${o.pattern}` : `无效${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `无效数字：必须是 ${t.divisor} 的倍数`;
      case "unrecognized_keys":
        return `出现未知的键(key): ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `${t.origin} 中的键(key)无效`;
      case "invalid_union":
        return "无效输入";
      case "invalid_element":
        return `${t.origin} 中包含无效值(value)`;
      default:
        return "无效输入";
    }
  };
};
function Mf() {
  return {
    localeError: xf()
  };
}
const Zf = () => {
  const e = {
    string: { unit: "字元", verb: "擁有" },
    file: { unit: "位元組", verb: "擁有" },
    array: { unit: "項目", verb: "擁有" },
    set: { unit: "項目", verb: "擁有" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "number";
      case "object": {
        if (Array.isArray(t))
          return "array";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "輸入",
    email: "郵件地址",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO 日期時間",
    date: "ISO 日期",
    time: "ISO 時間",
    duration: "ISO 期間",
    ipv4: "IPv4 位址",
    ipv6: "IPv6 位址",
    cidrv4: "IPv4 範圍",
    cidrv6: "IPv6 範圍",
    base64: "base64 編碼字串",
    base64url: "base64url 編碼字串",
    json_string: "JSON 字串",
    e164: "E.164 數值",
    jwt: "JWT",
    template_literal: "輸入"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `無效的輸入值：預期為 ${t.expected}，但收到 ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `無效的輸入值：預期為 ${N(t.values[0])}` : `無效的選項：預期為以下其中之一 ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `數值過大：預期 ${t.origin ?? "值"} 應為 ${o}${t.maximum.toString()} ${a.unit ?? "個元素"}` : `數值過大：預期 ${t.origin ?? "值"} 應為 ${o}${t.maximum.toString()}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `數值過小：預期 ${t.origin} 應為 ${o}${t.minimum.toString()} ${a.unit}` : `數值過小：預期 ${t.origin} 應為 ${o}${t.minimum.toString()}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `無效的字串：必須以 "${o.prefix}" 開頭` : o.format === "ends_with" ? `無效的字串：必須以 "${o.suffix}" 結尾` : o.format === "includes" ? `無效的字串：必須包含 "${o.includes}"` : o.format === "regex" ? `無效的字串：必須符合格式 ${o.pattern}` : `無效的 ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `無效的數字：必須為 ${t.divisor} 的倍數`;
      case "unrecognized_keys":
        return `無法識別的鍵值${t.keys.length > 1 ? "們" : ""}：${I(t.keys, "、")}`;
      case "invalid_key":
        return `${t.origin} 中有無效的鍵值`;
      case "invalid_union":
        return "無效的輸入值";
      case "invalid_element":
        return `${t.origin} 中有無效的值`;
      default:
        return "無效的輸入值";
    }
  };
};
function Gf() {
  return {
    localeError: Zf()
  };
}
const Ff = () => {
  const e = {
    string: { unit: "àmi", verb: "ní" },
    file: { unit: "bytes", verb: "ní" },
    array: { unit: "nkan", verb: "ní" },
    set: { unit: "nkan", verb: "ní" }
  };
  function n(t) {
    return e[t] ?? null;
  }
  const r = (t) => {
    const o = typeof t;
    switch (o) {
      case "number":
        return Number.isNaN(t) ? "NaN" : "nọ́mbà";
      case "object": {
        if (Array.isArray(t))
          return "akopọ";
        if (t === null)
          return "null";
        if (Object.getPrototypeOf(t) !== Object.prototype && t.constructor)
          return t.constructor.name;
      }
    }
    return o;
  }, i = {
    regex: "ẹ̀rọ ìbáwọlé",
    email: "àdírẹ́sì ìmẹ́lì",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "àkókò ISO",
    date: "ọjọ́ ISO",
    time: "àkókò ISO",
    duration: "àkókò tó pé ISO",
    ipv4: "àdírẹ́sì IPv4",
    ipv6: "àdírẹ́sì IPv6",
    cidrv4: "àgbègbè IPv4",
    cidrv6: "àgbègbè IPv6",
    base64: "ọ̀rọ̀ tí a kọ́ ní base64",
    base64url: "ọ̀rọ̀ base64url",
    json_string: "ọ̀rọ̀ JSON",
    e164: "nọ́mbà E.164",
    jwt: "JWT",
    template_literal: "ẹ̀rọ ìbáwọlé"
  };
  return (t) => {
    switch (t.code) {
      case "invalid_type":
        return `Ìbáwọlé aṣìṣe: a ní láti fi ${t.expected}, àmọ̀ a rí ${r(t.input)}`;
      case "invalid_value":
        return t.values.length === 1 ? `Ìbáwọlé aṣìṣe: a ní láti fi ${N(t.values[0])}` : `Àṣàyàn aṣìṣe: yan ọ̀kan lára ${I(t.values, "|")}`;
      case "too_big": {
        const o = t.inclusive ? "<=" : "<", a = n(t.origin);
        return a ? `Tó pọ̀ jù: a ní láti jẹ́ pé ${t.origin ?? "iye"} ${a.verb} ${o}${t.maximum} ${a.unit}` : `Tó pọ̀ jù: a ní láti jẹ́ ${o}${t.maximum}`;
      }
      case "too_small": {
        const o = t.inclusive ? ">=" : ">", a = n(t.origin);
        return a ? `Kéré ju: a ní láti jẹ́ pé ${t.origin} ${a.verb} ${o}${t.minimum} ${a.unit}` : `Kéré ju: a ní láti jẹ́ ${o}${t.minimum}`;
      }
      case "invalid_format": {
        const o = t;
        return o.format === "starts_with" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ bẹ̀rẹ̀ pẹ̀lú "${o.prefix}"` : o.format === "ends_with" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ parí pẹ̀lú "${o.suffix}"` : o.format === "includes" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ ní "${o.includes}"` : o.format === "regex" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ bá àpẹẹrẹ mu ${o.pattern}` : `Aṣìṣe: ${i[o.format] ?? t.format}`;
      }
      case "not_multiple_of":
        return `Nọ́mbà aṣìṣe: gbọ́dọ̀ jẹ́ èyà pípín ti ${t.divisor}`;
      case "unrecognized_keys":
        return `Bọtìnì àìmọ̀: ${I(t.keys, ", ")}`;
      case "invalid_key":
        return `Bọtìnì aṣìṣe nínú ${t.origin}`;
      case "invalid_union":
        return "Ìbáwọlé aṣìṣe";
      case "invalid_element":
        return `Iye aṣìṣe nínú ${t.origin}`;
      default:
        return "Ìbáwọlé aṣìṣe";
    }
  };
};
function Hf() {
  return {
    localeError: Ff()
  };
}
const Kl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ar: rg,
  az: og,
  be: ug,
  bg: cg,
  ca: mg,
  cs: fg,
  da: vg,
  de: bg,
  en: Bl,
  eo: $g,
  es: kg,
  fa: Og,
  fi: wg,
  fr: Ug,
  frCA: Dg,
  he: zg,
  hu: jg,
  id: xg,
  is: Gg,
  it: Hg,
  ja: Vg,
  ka: Wg,
  kh: qg,
  km: Vl,
  ko: Qg,
  lt: nf,
  mk: of,
  ms: uf,
  nl: sf,
  no: df,
  ota: gf,
  pl: hf,
  ps: pf,
  pt: _f,
  ru: Sf,
  sl: $f,
  sv: kf,
  ta: Of,
  th: wf,
  tr: Pf,
  ua: Rf,
  uk: Yl,
  ur: Cf,
  vi: Lf,
  yo: Hf,
  zhCN: Mf,
  zhTW: Gf
}, Symbol.toStringTag, { value: "Module" }));
var Ro;
const Wl = Symbol("ZodOutput"), Jl = Symbol("ZodInput");
class Dr {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(n, ...r) {
    const i = r[0];
    if (this._map.set(n, i), i && typeof i == "object" && "id" in i) {
      if (this._idmap.has(i.id))
        throw new Error(`ID ${i.id} already exists in the registry`);
      this._idmap.set(i.id, n);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(n) {
    const r = this._map.get(n);
    return r && typeof r == "object" && "id" in r && this._idmap.delete(r.id), this._map.delete(n), this;
  }
  get(n) {
    const r = n._zod.parent;
    if (r) {
      const i = { ...this.get(r) ?? {} };
      delete i.id;
      const t = { ...i, ...this._map.get(n) };
      return Object.keys(t).length ? t : void 0;
    }
    return this._map.get(n);
  }
  has(n) {
    return this._map.has(n);
  }
}
function Rr() {
  return new Dr();
}
(Ro = globalThis).__zod_globalRegistry ?? (Ro.__zod_globalRegistry = Rr());
const ve = globalThis.__zod_globalRegistry;
function ql(e, n) {
  return new e({
    type: "string",
    ...y(n)
  });
}
function Xl(e, n) {
  return new e({
    type: "string",
    coerce: !0,
    ...y(n)
  });
}
function zr(e, n) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function rn(e, n) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function Cr(e, n) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function jr(e, n) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...y(n)
  });
}
function Lr(e, n) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...y(n)
  });
}
function xr(e, n) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...y(n)
  });
}
function vn(e, n) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function Mr(e, n) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function Zr(e, n) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function Gr(e, n) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function Fr(e, n) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function Hr(e, n) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function Br(e, n) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function Vr(e, n) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function Yr(e, n) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function Kr(e, n) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function Ql(e, n) {
  return new e({
    type: "string",
    format: "mac",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function Wr(e, n) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function Jr(e, n) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function qr(e, n) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function Xr(e, n) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function Qr(e, n) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
function ei(e, n) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...y(n)
  });
}
const es = {
  Any: null,
  Minute: -1,
  Second: 0,
  Millisecond: 3,
  Microsecond: 6
};
function ts(e, n) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...y(n)
  });
}
function ns(e, n) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...y(n)
  });
}
function rs(e, n) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...y(n)
  });
}
function is(e, n) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...y(n)
  });
}
function os(e, n) {
  return new e({
    type: "number",
    checks: [],
    ...y(n)
  });
}
function as(e, n) {
  return new e({
    type: "number",
    coerce: !0,
    checks: [],
    ...y(n)
  });
}
function us(e, n) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...y(n)
  });
}
function ls(e, n) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "float32",
    ...y(n)
  });
}
function ss(e, n) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "float64",
    ...y(n)
  });
}
function cs(e, n) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "int32",
    ...y(n)
  });
}
function ds(e, n) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "uint32",
    ...y(n)
  });
}
function ms(e, n) {
  return new e({
    type: "boolean",
    ...y(n)
  });
}
function gs(e, n) {
  return new e({
    type: "boolean",
    coerce: !0,
    ...y(n)
  });
}
function fs(e, n) {
  return new e({
    type: "bigint",
    ...y(n)
  });
}
function ps(e, n) {
  return new e({
    type: "bigint",
    coerce: !0,
    ...y(n)
  });
}
function vs(e, n) {
  return new e({
    type: "bigint",
    check: "bigint_format",
    abort: !1,
    format: "int64",
    ...y(n)
  });
}
function hs(e, n) {
  return new e({
    type: "bigint",
    check: "bigint_format",
    abort: !1,
    format: "uint64",
    ...y(n)
  });
}
function bs(e, n) {
  return new e({
    type: "symbol",
    ...y(n)
  });
}
function _s(e, n) {
  return new e({
    type: "undefined",
    ...y(n)
  });
}
function ys(e, n) {
  return new e({
    type: "null",
    ...y(n)
  });
}
function Ss(e) {
  return new e({
    type: "any"
  });
}
function Is(e) {
  return new e({
    type: "unknown"
  });
}
function $s(e, n) {
  return new e({
    type: "never",
    ...y(n)
  });
}
function Es(e, n) {
  return new e({
    type: "void",
    ...y(n)
  });
}
function ks(e, n) {
  return new e({
    type: "date",
    ...y(n)
  });
}
function Ns(e, n) {
  return new e({
    type: "date",
    coerce: !0,
    ...y(n)
  });
}
function Os(e, n) {
  return new e({
    type: "nan",
    ...y(n)
  });
}
function Ge(e, n) {
  return new Er({
    check: "less_than",
    ...y(n),
    value: e,
    inclusive: !1
  });
}
function he(e, n) {
  return new Er({
    check: "less_than",
    ...y(n),
    value: e,
    inclusive: !0
  });
}
function Fe(e, n) {
  return new kr({
    check: "greater_than",
    ...y(n),
    value: e,
    inclusive: !1
  });
}
function ie(e, n) {
  return new kr({
    check: "greater_than",
    ...y(n),
    value: e,
    inclusive: !0
  });
}
function Ts(e) {
  return Fe(0, e);
}
function ws(e) {
  return Ge(0, e);
}
function As(e) {
  return he(0, e);
}
function Us(e) {
  return ie(0, e);
}
function vt(e, n) {
  return new gu({
    check: "multiple_of",
    ...y(n),
    value: e
  });
}
function hn(e, n) {
  return new vu({
    check: "max_size",
    ...y(n),
    maximum: e
  });
}
function ht(e, n) {
  return new hu({
    check: "min_size",
    ...y(n),
    minimum: e
  });
}
function ti(e, n) {
  return new bu({
    check: "size_equals",
    ...y(n),
    size: e
  });
}
function bn(e, n) {
  return new _u({
    check: "max_length",
    ...y(n),
    maximum: e
  });
}
function rt(e, n) {
  return new yu({
    check: "min_length",
    ...y(n),
    minimum: e
  });
}
function _n(e, n) {
  return new Su({
    check: "length_equals",
    ...y(n),
    length: e
  });
}
function ni(e, n) {
  return new Iu({
    check: "string_format",
    format: "regex",
    ...y(n),
    pattern: e
  });
}
function ri(e) {
  return new $u({
    check: "string_format",
    format: "lowercase",
    ...y(e)
  });
}
function ii(e) {
  return new Eu({
    check: "string_format",
    format: "uppercase",
    ...y(e)
  });
}
function oi(e, n) {
  return new ku({
    check: "string_format",
    format: "includes",
    ...y(n),
    includes: e
  });
}
function ai(e, n) {
  return new Nu({
    check: "string_format",
    format: "starts_with",
    ...y(n),
    prefix: e
  });
}
function ui(e, n) {
  return new Ou({
    check: "string_format",
    format: "ends_with",
    ...y(n),
    suffix: e
  });
}
function Ps(e, n, r) {
  return new Tu({
    check: "property",
    property: e,
    schema: n,
    ...y(r)
  });
}
function li(e, n) {
  return new wu({
    check: "mime_type",
    mime: e,
    ...y(n)
  });
}
function Re(e) {
  return new Au({
    check: "overwrite",
    tx: e
  });
}
function si(e) {
  return Re((n) => n.normalize(e));
}
function ci() {
  return Re((e) => e.trim());
}
function di() {
  return Re((e) => e.toLowerCase());
}
function mi() {
  return Re((e) => e.toUpperCase());
}
function gi() {
  return Re((e) => sa(e));
}
function Ds(e, n, r) {
  return new e({
    type: "array",
    element: n,
    // get element() {
    //   return element;
    // },
    ...y(r)
  });
}
function Bf(e, n, r) {
  return new e({
    type: "union",
    options: n,
    ...y(r)
  });
}
function Vf(e, n, r, i) {
  return new e({
    type: "union",
    options: r,
    discriminator: n,
    ...y(i)
  });
}
function Yf(e, n, r) {
  return new e({
    type: "intersection",
    left: n,
    right: r
  });
}
function Kf(e, n, r, i) {
  const t = r instanceof T, o = t ? i : r, a = t ? r : null;
  return new e({
    type: "tuple",
    items: n,
    rest: a,
    ...y(o)
  });
}
function Wf(e, n, r, i) {
  return new e({
    type: "record",
    keyType: n,
    valueType: r,
    ...y(i)
  });
}
function Jf(e, n, r, i) {
  return new e({
    type: "map",
    keyType: n,
    valueType: r,
    ...y(i)
  });
}
function qf(e, n, r) {
  return new e({
    type: "set",
    valueType: n,
    ...y(r)
  });
}
function Xf(e, n, r) {
  const i = Array.isArray(n) ? Object.fromEntries(n.map((t) => [t, t])) : n;
  return new e({
    type: "enum",
    entries: i,
    ...y(r)
  });
}
function Qf(e, n, r) {
  return new e({
    type: "enum",
    entries: n,
    ...y(r)
  });
}
function ep(e, n, r) {
  return new e({
    type: "literal",
    values: Array.isArray(n) ? n : [n],
    ...y(r)
  });
}
function Rs(e, n) {
  return new e({
    type: "file",
    ...y(n)
  });
}
function tp(e, n) {
  return new e({
    type: "transform",
    transform: n
  });
}
function np(e, n) {
  return new e({
    type: "optional",
    innerType: n
  });
}
function rp(e, n) {
  return new e({
    type: "nullable",
    innerType: n
  });
}
function ip(e, n, r) {
  return new e({
    type: "default",
    innerType: n,
    get defaultValue() {
      return typeof r == "function" ? r() : gn(r);
    }
  });
}
function op(e, n, r) {
  return new e({
    type: "nonoptional",
    innerType: n,
    ...y(r)
  });
}
function ap(e, n) {
  return new e({
    type: "success",
    innerType: n
  });
}
function up(e, n, r) {
  return new e({
    type: "catch",
    innerType: n,
    catchValue: typeof r == "function" ? r : () => r
  });
}
function lp(e, n, r) {
  return new e({
    type: "pipe",
    in: n,
    out: r
  });
}
function sp(e, n) {
  return new e({
    type: "readonly",
    innerType: n
  });
}
function cp(e, n, r) {
  return new e({
    type: "template_literal",
    parts: n,
    ...y(r)
  });
}
function dp(e, n) {
  return new e({
    type: "lazy",
    getter: n
  });
}
function mp(e, n) {
  return new e({
    type: "promise",
    innerType: n
  });
}
function zs(e, n, r) {
  const i = y(r);
  return i.abort ?? (i.abort = !0), new e({
    type: "custom",
    check: "custom",
    fn: n,
    ...i
  });
}
function Cs(e, n, r) {
  return new e({
    type: "custom",
    check: "custom",
    fn: n,
    ...y(r)
  });
}
function js(e) {
  const n = Ls((r) => (r.addIssue = (i) => {
    if (typeof i == "string")
      r.issues.push(tt(i, r.value, n._zod.def));
    else {
      const t = i;
      t.fatal && (t.continue = !1), t.code ?? (t.code = "custom"), t.input ?? (t.input = r.value), t.inst ?? (t.inst = n), t.continue ?? (t.continue = !n._zod.def.abort), r.issues.push(tt(t));
    }
  }, e(r.value, r)));
  return n;
}
function Ls(e, n) {
  const r = new M({
    check: "custom",
    ...y(n)
  });
  return r._zod.check = e, r;
}
function xs(e) {
  const n = new M({ check: "describe" });
  return n._zod.onattach = [
    (r) => {
      const i = ve.get(r) ?? {};
      ve.add(r, { ...i, description: e });
    }
  ], n._zod.check = () => {
  }, n;
}
function Ms(e) {
  const n = new M({ check: "meta" });
  return n._zod.onattach = [
    (r) => {
      const i = ve.get(r) ?? {};
      ve.add(r, { ...i, ...e });
    }
  ], n._zod.check = () => {
  }, n;
}
function Zs(e, n) {
  const r = y(n);
  let i = r.truthy ?? ["true", "1", "yes", "on", "y", "enabled"], t = r.falsy ?? ["false", "0", "no", "off", "n", "disabled"];
  r.case !== "sensitive" && (i = i.map((_) => typeof _ == "string" ? _.toLowerCase() : _), t = t.map((_) => typeof _ == "string" ? _.toLowerCase() : _));
  const o = new Set(i), a = new Set(t), u = e.Codec ?? Pr, s = e.Boolean ?? Tr, l = e.String ?? At, f = new l({ type: "string", error: r.error }), c = new s({ type: "boolean", error: r.error }), p = new u({
    type: "pipe",
    in: f,
    out: c,
    transform: (_, h) => {
      let $ = _;
      return r.case !== "sensitive" && ($ = $.toLowerCase()), o.has($) ? !0 : a.has($) ? !1 : (h.issues.push({
        code: "invalid_value",
        expected: "stringbool",
        values: [...o, ...a],
        input: h.value,
        inst: p,
        continue: !1
      }), {});
    },
    reverseTransform: (_, h) => _ === !0 ? i[0] || "true" : t[0] || "false",
    error: r.error
  });
  return p;
}
function Ut(e, n, r, i = {}) {
  const t = y(i), o = {
    ...y(i),
    check: "string_format",
    type: "string",
    format: n,
    fn: typeof r == "function" ? r : (u) => r.test(u),
    ...t
  };
  return r instanceof RegExp && (o.pattern = r), new e(o);
}
class nr {
  constructor(n) {
    this.counter = 0, this.metadataRegistry = (n == null ? void 0 : n.metadata) ?? ve, this.target = (n == null ? void 0 : n.target) ?? "draft-2020-12", this.unrepresentable = (n == null ? void 0 : n.unrepresentable) ?? "throw", this.override = (n == null ? void 0 : n.override) ?? (() => {
    }), this.io = (n == null ? void 0 : n.io) ?? "output", this.seen = /* @__PURE__ */ new Map();
  }
  process(n, r = { path: [], schemaPath: [] }) {
    var c, p, _;
    var i;
    const t = n._zod.def, o = {
      guid: "uuid",
      url: "uri",
      datetime: "date-time",
      json_string: "json-string",
      regex: ""
      // do not set
    }, a = this.seen.get(n);
    if (a)
      return a.count++, r.schemaPath.includes(n) && (a.cycle = r.path), a.schema;
    const u = { schema: {}, count: 1, cycle: void 0, path: r.path };
    this.seen.set(n, u);
    const s = (p = (c = n._zod).toJSONSchema) == null ? void 0 : p.call(c);
    if (s)
      u.schema = s;
    else {
      const h = {
        ...r,
        schemaPath: [...r.schemaPath, n],
        path: r.path
      }, $ = n._zod.parent;
      if ($)
        u.ref = $, this.process($, h), this.seen.get($).isParent = !0;
      else {
        const v = u.schema;
        switch (t.type) {
          case "string": {
            const m = v;
            m.type = "string";
            const { minimum: g, maximum: S, format: k, patterns: E, contentEncoding: A } = n._zod.bag;
            if (typeof g == "number" && (m.minLength = g), typeof S == "number" && (m.maxLength = S), k && (m.format = o[k] ?? k, m.format === "" && delete m.format), A && (m.contentEncoding = A), E && E.size > 0) {
              const z = [...E];
              z.length === 1 ? m.pattern = z[0].source : z.length > 1 && (u.schema.allOf = [
                ...z.map((te) => ({
                  ...this.target === "draft-7" || this.target === "draft-4" || this.target === "openapi-3.0" ? { type: "string" } : {},
                  pattern: te.source
                }))
              ]);
            }
            break;
          }
          case "number": {
            const m = v, { minimum: g, maximum: S, format: k, multipleOf: E, exclusiveMaximum: A, exclusiveMinimum: z } = n._zod.bag;
            typeof k == "string" && k.includes("int") ? m.type = "integer" : m.type = "number", typeof z == "number" && (this.target === "draft-4" || this.target === "openapi-3.0" ? (m.minimum = z, m.exclusiveMinimum = !0) : m.exclusiveMinimum = z), typeof g == "number" && (m.minimum = g, typeof z == "number" && this.target !== "draft-4" && (z >= g ? delete m.minimum : delete m.exclusiveMinimum)), typeof A == "number" && (this.target === "draft-4" || this.target === "openapi-3.0" ? (m.maximum = A, m.exclusiveMaximum = !0) : m.exclusiveMaximum = A), typeof S == "number" && (m.maximum = S, typeof A == "number" && this.target !== "draft-4" && (A <= S ? delete m.maximum : delete m.exclusiveMaximum)), typeof E == "number" && (m.multipleOf = E);
            break;
          }
          case "boolean": {
            const m = v;
            m.type = "boolean";
            break;
          }
          case "bigint": {
            if (this.unrepresentable === "throw")
              throw new Error("BigInt cannot be represented in JSON Schema");
            break;
          }
          case "symbol": {
            if (this.unrepresentable === "throw")
              throw new Error("Symbols cannot be represented in JSON Schema");
            break;
          }
          case "null": {
            this.target === "openapi-3.0" ? (v.type = "string", v.nullable = !0, v.enum = [null]) : v.type = "null";
            break;
          }
          case "any":
            break;
          case "unknown":
            break;
          case "undefined": {
            if (this.unrepresentable === "throw")
              throw new Error("Undefined cannot be represented in JSON Schema");
            break;
          }
          case "void": {
            if (this.unrepresentable === "throw")
              throw new Error("Void cannot be represented in JSON Schema");
            break;
          }
          case "never": {
            v.not = {};
            break;
          }
          case "date": {
            if (this.unrepresentable === "throw")
              throw new Error("Date cannot be represented in JSON Schema");
            break;
          }
          case "array": {
            const m = v, { minimum: g, maximum: S } = n._zod.bag;
            typeof g == "number" && (m.minItems = g), typeof S == "number" && (m.maxItems = S), m.type = "array", m.items = this.process(t.element, { ...h, path: [...h.path, "items"] });
            break;
          }
          case "object": {
            const m = v;
            m.type = "object", m.properties = {};
            const g = t.shape;
            for (const E in g)
              m.properties[E] = this.process(g[E], {
                ...h,
                path: [...h.path, "properties", E]
              });
            const S = new Set(Object.keys(g)), k = new Set([...S].filter((E) => {
              const A = t.shape[E]._zod;
              return this.io === "input" ? A.optin === void 0 : A.optout === void 0;
            }));
            k.size > 0 && (m.required = Array.from(k)), ((_ = t.catchall) == null ? void 0 : _._zod.def.type) === "never" ? m.additionalProperties = !1 : t.catchall ? t.catchall && (m.additionalProperties = this.process(t.catchall, {
              ...h,
              path: [...h.path, "additionalProperties"]
            })) : this.io === "output" && (m.additionalProperties = !1);
            break;
          }
          case "union": {
            const m = v, g = t.discriminator !== void 0, S = t.options.map((k, E) => this.process(k, {
              ...h,
              path: [...h.path, g ? "oneOf" : "anyOf", E]
            }));
            g ? m.oneOf = S : m.anyOf = S;
            break;
          }
          case "intersection": {
            const m = v, g = this.process(t.left, {
              ...h,
              path: [...h.path, "allOf", 0]
            }), S = this.process(t.right, {
              ...h,
              path: [...h.path, "allOf", 1]
            }), k = (A) => "allOf" in A && Object.keys(A).length === 1, E = [
              ...k(g) ? g.allOf : [g],
              ...k(S) ? S.allOf : [S]
            ];
            m.allOf = E;
            break;
          }
          case "tuple": {
            const m = v;
            m.type = "array";
            const g = this.target === "draft-2020-12" ? "prefixItems" : "items", S = this.target === "draft-2020-12" || this.target === "openapi-3.0" ? "items" : "additionalItems", k = t.items.map((te, j) => this.process(te, {
              ...h,
              path: [...h.path, g, j]
            })), E = t.rest ? this.process(t.rest, {
              ...h,
              path: [...h.path, S, ...this.target === "openapi-3.0" ? [t.items.length] : []]
            }) : null;
            this.target === "draft-2020-12" ? (m.prefixItems = k, E && (m.items = E)) : this.target === "openapi-3.0" ? (m.items = {
              anyOf: k
            }, E && m.items.anyOf.push(E), m.minItems = k.length, E || (m.maxItems = k.length)) : (m.items = k, E && (m.additionalItems = E));
            const { minimum: A, maximum: z } = n._zod.bag;
            typeof A == "number" && (m.minItems = A), typeof z == "number" && (m.maxItems = z);
            break;
          }
          case "record": {
            const m = v;
            m.type = "object", (this.target === "draft-7" || this.target === "draft-2020-12") && (m.propertyNames = this.process(t.keyType, {
              ...h,
              path: [...h.path, "propertyNames"]
            })), m.additionalProperties = this.process(t.valueType, {
              ...h,
              path: [...h.path, "additionalProperties"]
            });
            break;
          }
          case "map": {
            if (this.unrepresentable === "throw")
              throw new Error("Map cannot be represented in JSON Schema");
            break;
          }
          case "set": {
            if (this.unrepresentable === "throw")
              throw new Error("Set cannot be represented in JSON Schema");
            break;
          }
          case "enum": {
            const m = v, g = sr(t.entries);
            g.every((S) => typeof S == "number") && (m.type = "number"), g.every((S) => typeof S == "string") && (m.type = "string"), m.enum = g;
            break;
          }
          case "literal": {
            const m = v, g = [];
            for (const S of t.values)
              if (S === void 0) {
                if (this.unrepresentable === "throw")
                  throw new Error("Literal `undefined` cannot be represented in JSON Schema");
              } else if (typeof S == "bigint") {
                if (this.unrepresentable === "throw")
                  throw new Error("BigInt literals cannot be represented in JSON Schema");
                g.push(Number(S));
              } else
                g.push(S);
            if (g.length !== 0) if (g.length === 1) {
              const S = g[0];
              m.type = S === null ? "null" : typeof S, this.target === "draft-4" || this.target === "openapi-3.0" ? m.enum = [S] : m.const = S;
            } else
              g.every((S) => typeof S == "number") && (m.type = "number"), g.every((S) => typeof S == "string") && (m.type = "string"), g.every((S) => typeof S == "boolean") && (m.type = "string"), g.every((S) => S === null) && (m.type = "null"), m.enum = g;
            break;
          }
          case "file": {
            const m = v, g = {
              type: "string",
              format: "binary",
              contentEncoding: "binary"
            }, { minimum: S, maximum: k, mime: E } = n._zod.bag;
            S !== void 0 && (g.minLength = S), k !== void 0 && (g.maxLength = k), E ? E.length === 1 ? (g.contentMediaType = E[0], Object.assign(m, g)) : m.anyOf = E.map((A) => ({ ...g, contentMediaType: A })) : Object.assign(m, g);
            break;
          }
          case "transform": {
            if (this.unrepresentable === "throw")
              throw new Error("Transforms cannot be represented in JSON Schema");
            break;
          }
          case "nullable": {
            const m = this.process(t.innerType, h);
            this.target === "openapi-3.0" ? (u.ref = t.innerType, v.nullable = !0) : v.anyOf = [m, { type: "null" }];
            break;
          }
          case "nonoptional": {
            this.process(t.innerType, h), u.ref = t.innerType;
            break;
          }
          case "success": {
            const m = v;
            m.type = "boolean";
            break;
          }
          case "default": {
            this.process(t.innerType, h), u.ref = t.innerType, v.default = JSON.parse(JSON.stringify(t.defaultValue));
            break;
          }
          case "prefault": {
            this.process(t.innerType, h), u.ref = t.innerType, this.io === "input" && (v._prefault = JSON.parse(JSON.stringify(t.defaultValue)));
            break;
          }
          case "catch": {
            this.process(t.innerType, h), u.ref = t.innerType;
            let m;
            try {
              m = t.catchValue(void 0);
            } catch {
              throw new Error("Dynamic catch values are not supported in JSON Schema");
            }
            v.default = m;
            break;
          }
          case "nan": {
            if (this.unrepresentable === "throw")
              throw new Error("NaN cannot be represented in JSON Schema");
            break;
          }
          case "template_literal": {
            const m = v, g = n._zod.pattern;
            if (!g)
              throw new Error("Pattern not found in template literal");
            m.type = "string", m.pattern = g.source;
            break;
          }
          case "pipe": {
            const m = this.io === "input" ? t.in._zod.def.type === "transform" ? t.out : t.in : t.out;
            this.process(m, h), u.ref = m;
            break;
          }
          case "readonly": {
            this.process(t.innerType, h), u.ref = t.innerType, v.readOnly = !0;
            break;
          }
          // passthrough types
          case "promise": {
            this.process(t.innerType, h), u.ref = t.innerType;
            break;
          }
          case "optional": {
            this.process(t.innerType, h), u.ref = t.innerType;
            break;
          }
          case "lazy": {
            const m = n._zod.innerType;
            this.process(m, h), u.ref = m;
            break;
          }
          case "custom": {
            if (this.unrepresentable === "throw")
              throw new Error("Custom types cannot be represented in JSON Schema");
            break;
          }
          case "function": {
            if (this.unrepresentable === "throw")
              throw new Error("Function types cannot be represented in JSON Schema");
            break;
          }
        }
      }
    }
    const l = this.metadataRegistry.get(n);
    return l && Object.assign(u.schema, l), this.io === "input" && q(n) && (delete u.schema.examples, delete u.schema.default), this.io === "input" && u.schema._prefault && ((i = u.schema).default ?? (i.default = u.schema._prefault)), delete u.schema._prefault, this.seen.get(n).schema;
  }
  emit(n, r) {
    var f, c, p, _, h, $;
    const i = {
      cycles: (r == null ? void 0 : r.cycles) ?? "ref",
      reused: (r == null ? void 0 : r.reused) ?? "inline",
      // unrepresentable: _params?.unrepresentable ?? "throw",
      // uri: _params?.uri ?? ((id) => `${id}`),
      external: (r == null ? void 0 : r.external) ?? void 0
    }, t = this.seen.get(n);
    if (!t)
      throw new Error("Unprocessed schema. This is a bug in Zod.");
    const o = (v) => {
      var E;
      const m = this.target === "draft-2020-12" ? "$defs" : "definitions";
      if (i.external) {
        const A = (E = i.external.registry.get(v[0])) == null ? void 0 : E.id, z = i.external.uri ?? ((j) => j);
        if (A)
          return { ref: z(A) };
        const te = v[1].defId ?? v[1].schema.id ?? `schema${this.counter++}`;
        return v[1].defId = te, { defId: te, ref: `${z("__shared")}#/${m}/${te}` };
      }
      if (v[1] === t)
        return { ref: "#" };
      const S = `#/${m}/`, k = v[1].schema.id ?? `__schema${this.counter++}`;
      return { defId: k, ref: S + k };
    }, a = (v) => {
      if (v[1].schema.$ref)
        return;
      const m = v[1], { ref: g, defId: S } = o(v);
      m.def = { ...m.schema }, S && (m.defId = S);
      const k = m.schema;
      for (const E in k)
        delete k[E];
      k.$ref = g;
    };
    if (i.cycles === "throw")
      for (const v of this.seen.entries()) {
        const m = v[1];
        if (m.cycle)
          throw new Error(`Cycle detected: #/${(f = m.cycle) == null ? void 0 : f.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
      }
    for (const v of this.seen.entries()) {
      const m = v[1];
      if (n === v[0]) {
        a(v);
        continue;
      }
      if (i.external) {
        const S = (c = i.external.registry.get(v[0])) == null ? void 0 : c.id;
        if (n !== v[0] && S) {
          a(v);
          continue;
        }
      }
      if ((p = this.metadataRegistry.get(v[0])) == null ? void 0 : p.id) {
        a(v);
        continue;
      }
      if (m.cycle) {
        a(v);
        continue;
      }
      if (m.count > 1 && i.reused === "ref") {
        a(v);
        continue;
      }
    }
    const u = (v, m) => {
      const g = this.seen.get(v), S = g.def ?? g.schema, k = { ...S };
      if (g.ref === null)
        return;
      const E = g.ref;
      if (g.ref = null, E) {
        u(E, m);
        const A = this.seen.get(E).schema;
        A.$ref && (m.target === "draft-7" || m.target === "draft-4" || m.target === "openapi-3.0") ? (S.allOf = S.allOf ?? [], S.allOf.push(A)) : (Object.assign(S, A), Object.assign(S, k));
      }
      g.isParent || this.override({
        zodSchema: v,
        jsonSchema: S,
        path: g.path ?? []
      });
    };
    for (const v of [...this.seen.entries()].reverse())
      u(v[0], { target: this.target });
    const s = {};
    if (this.target === "draft-2020-12" ? s.$schema = "https://json-schema.org/draft/2020-12/schema" : this.target === "draft-7" ? s.$schema = "http://json-schema.org/draft-07/schema#" : this.target === "draft-4" ? s.$schema = "http://json-schema.org/draft-04/schema#" : this.target === "openapi-3.0" || console.warn(`Invalid target: ${this.target}`), (_ = i.external) != null && _.uri) {
      const v = (h = i.external.registry.get(n)) == null ? void 0 : h.id;
      if (!v)
        throw new Error("Schema is missing an `id` property");
      s.$id = i.external.uri(v);
    }
    Object.assign(s, t.def);
    const l = (($ = i.external) == null ? void 0 : $.defs) ?? {};
    for (const v of this.seen.entries()) {
      const m = v[1];
      m.def && m.defId && (l[m.defId] = m.def);
    }
    i.external || Object.keys(l).length > 0 && (this.target === "draft-2020-12" ? s.$defs = l : s.definitions = l);
    try {
      return JSON.parse(JSON.stringify(s));
    } catch {
      throw new Error("Error converting schema to JSON.");
    }
  }
}
function Gs(e, n) {
  if (e instanceof Dr) {
    const i = new nr(n), t = {};
    for (const u of e._idmap.entries()) {
      const [s, l] = u;
      i.process(l);
    }
    const o = {}, a = {
      registry: e,
      uri: n == null ? void 0 : n.uri,
      defs: t
    };
    for (const u of e._idmap.entries()) {
      const [s, l] = u;
      o[s] = i.emit(l, {
        ...n,
        external: a
      });
    }
    if (Object.keys(t).length > 0) {
      const u = i.target === "draft-2020-12" ? "$defs" : "definitions";
      o.__shared = {
        [u]: t
      };
    }
    return { schemas: o };
  }
  const r = new nr(n);
  return r.process(e), r.emit(e, n);
}
function q(e, n) {
  const r = n ?? { seen: /* @__PURE__ */ new Set() };
  if (r.seen.has(e))
    return !1;
  r.seen.add(e);
  const i = e._zod.def;
  if (i.type === "transform")
    return !0;
  if (i.type === "array")
    return q(i.element, r);
  if (i.type === "set")
    return q(i.valueType, r);
  if (i.type === "lazy")
    return q(i.getter(), r);
  if (i.type === "promise" || i.type === "optional" || i.type === "nonoptional" || i.type === "nullable" || i.type === "readonly" || i.type === "default" || i.type === "prefault")
    return q(i.innerType, r);
  if (i.type === "intersection")
    return q(i.left, r) || q(i.right, r);
  if (i.type === "record" || i.type === "map")
    return q(i.keyType, r) || q(i.valueType, r);
  if (i.type === "pipe")
    return q(i.in, r) || q(i.out, r);
  if (i.type === "object") {
    for (const t in i.shape)
      if (q(i.shape[t], r))
        return !0;
    return !1;
  }
  if (i.type === "union") {
    for (const t of i.options)
      if (q(t, r))
        return !0;
    return !1;
  }
  if (i.type === "tuple") {
    for (const t of i.items)
      if (q(t, r))
        return !0;
    return !!(i.rest && q(i.rest, r));
  }
  return !1;
}
const gp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), fp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  $ZodAny: dl,
  $ZodArray: vl,
  $ZodAsyncError: xe,
  $ZodBase64: Qu,
  $ZodBase64URL: tl,
  $ZodBigInt: wr,
  $ZodBigIntFormat: ul,
  $ZodBoolean: Tr,
  $ZodCIDRv4: qu,
  $ZodCIDRv6: Xu,
  $ZodCUID: xu,
  $ZodCUID2: Mu,
  $ZodCatch: Cl,
  $ZodCheck: M,
  $ZodCheckBigIntFormat: pu,
  $ZodCheckEndsWith: Ou,
  $ZodCheckGreaterThan: kr,
  $ZodCheckIncludes: ku,
  $ZodCheckLengthEquals: Su,
  $ZodCheckLessThan: Er,
  $ZodCheckLowerCase: $u,
  $ZodCheckMaxLength: _u,
  $ZodCheckMaxSize: vu,
  $ZodCheckMimeType: wu,
  $ZodCheckMinLength: yu,
  $ZodCheckMinSize: hu,
  $ZodCheckMultipleOf: gu,
  $ZodCheckNumberFormat: fu,
  $ZodCheckOverwrite: Au,
  $ZodCheckProperty: Tu,
  $ZodCheckRegex: Iu,
  $ZodCheckSizeEquals: bu,
  $ZodCheckStartsWith: Nu,
  $ZodCheckStringFormat: wt,
  $ZodCheckUpperCase: Eu,
  $ZodCodec: Pr,
  $ZodCustom: Hl,
  $ZodCustomStringFormat: ol,
  $ZodDate: pl,
  $ZodDefault: Pl,
  $ZodDiscriminatedUnion: Sl,
  $ZodE164: nl,
  $ZodEmail: zu,
  $ZodEmoji: ju,
  $ZodEncodeError: dn,
  $ZodEnum: Nl,
  $ZodError: dr,
  $ZodFile: Tl,
  $ZodFunction: Zl,
  $ZodGUID: Du,
  $ZodIPv4: Ku,
  $ZodIPv6: Wu,
  $ZodISODate: Bu,
  $ZodISODateTime: Hu,
  $ZodISODuration: Yu,
  $ZodISOTime: Vu,
  $ZodIntersection: Il,
  $ZodJWT: il,
  $ZodKSUID: Fu,
  $ZodLazy: Fl,
  $ZodLiteral: Ol,
  $ZodMAC: Ju,
  $ZodMap: El,
  $ZodNaN: jl,
  $ZodNanoID: Lu,
  $ZodNever: gl,
  $ZodNonOptional: Rl,
  $ZodNull: cl,
  $ZodNullable: Ul,
  $ZodNumber: Or,
  $ZodNumberFormat: al,
  $ZodObject: _l,
  $ZodObjectJIT: yl,
  $ZodOptional: Al,
  $ZodPipe: Ll,
  $ZodPrefault: Dl,
  $ZodPromise: Gl,
  $ZodReadonly: xl,
  $ZodRealError: oe,
  $ZodRecord: $l,
  $ZodRegistry: Dr,
  $ZodSet: kl,
  $ZodString: At,
  $ZodStringFormat: C,
  $ZodSuccess: zl,
  $ZodSymbol: ll,
  $ZodTemplateLiteral: Ml,
  $ZodTransform: wl,
  $ZodTuple: Ur,
  $ZodType: T,
  $ZodULID: Zu,
  $ZodURL: Cu,
  $ZodUUID: Ru,
  $ZodUndefined: sl,
  $ZodUnion: Ar,
  $ZodUnknown: ml,
  $ZodVoid: fl,
  $ZodXID: Gu,
  $brand: ua,
  $constructor: d,
  $input: Jl,
  $output: Wl,
  Doc: Uu,
  JSONSchema: gp,
  JSONSchemaGenerator: nr,
  NEVER: aa,
  TimePrecision: es,
  _any: Ss,
  _array: Ds,
  _base64: qr,
  _base64url: Xr,
  _bigint: fs,
  _boolean: ms,
  _catch: up,
  _check: Ls,
  _cidrv4: Wr,
  _cidrv6: Jr,
  _coercedBigint: ps,
  _coercedBoolean: gs,
  _coercedDate: Ns,
  _coercedNumber: as,
  _coercedString: Xl,
  _cuid: Gr,
  _cuid2: Fr,
  _custom: zs,
  _date: ks,
  _decode: pr,
  _decodeAsync: hr,
  _default: ip,
  _discriminatedUnion: Vf,
  _e164: Qr,
  _email: zr,
  _emoji: Mr,
  _encode: fr,
  _encodeAsync: vr,
  _endsWith: ui,
  _enum: Xf,
  _file: Rs,
  _float32: ls,
  _float64: ss,
  _gt: Fe,
  _gte: ie,
  _guid: rn,
  _includes: oi,
  _int: us,
  _int32: cs,
  _int64: vs,
  _intersection: Yf,
  _ipv4: Yr,
  _ipv6: Kr,
  _isoDate: ns,
  _isoDateTime: ts,
  _isoDuration: is,
  _isoTime: rs,
  _jwt: ei,
  _ksuid: Vr,
  _lazy: dp,
  _length: _n,
  _literal: ep,
  _lowercase: ri,
  _lt: Ge,
  _lte: he,
  _mac: Ql,
  _map: Jf,
  _max: he,
  _maxLength: bn,
  _maxSize: hn,
  _mime: li,
  _min: ie,
  _minLength: rt,
  _minSize: ht,
  _multipleOf: vt,
  _nan: Os,
  _nanoid: Zr,
  _nativeEnum: Qf,
  _negative: ws,
  _never: $s,
  _nonnegative: Us,
  _nonoptional: op,
  _nonpositive: As,
  _normalize: si,
  _null: ys,
  _nullable: rp,
  _number: os,
  _optional: np,
  _overwrite: Re,
  _parse: $t,
  _parseAsync: Et,
  _pipe: lp,
  _positive: Ts,
  _promise: mp,
  _property: Ps,
  _readonly: sp,
  _record: Wf,
  _refine: Cs,
  _regex: ni,
  _safeDecode: _r,
  _safeDecodeAsync: Sr,
  _safeEncode: br,
  _safeEncodeAsync: yr,
  _safeParse: kt,
  _safeParseAsync: Nt,
  _set: qf,
  _size: ti,
  _slugify: gi,
  _startsWith: ai,
  _string: ql,
  _stringFormat: Ut,
  _stringbool: Zs,
  _success: ap,
  _superRefine: js,
  _symbol: bs,
  _templateLiteral: cp,
  _toLowerCase: di,
  _toUpperCase: mi,
  _transform: tp,
  _trim: ci,
  _tuple: Kf,
  _uint32: ds,
  _uint64: hs,
  _ulid: Hr,
  _undefined: _s,
  _union: Bf,
  _unknown: Is,
  _uppercase: ii,
  _url: vn,
  _uuid: Cr,
  _uuidv4: jr,
  _uuidv6: Lr,
  _uuidv7: xr,
  _void: Es,
  _xid: Br,
  clone: se,
  config: ee,
  decode: km,
  decodeAsync: Om,
  describe: xs,
  encode: Em,
  encodeAsync: Nm,
  flattenError: mr,
  formatError: gr,
  globalConfig: Qt,
  globalRegistry: ve,
  isValidBase64: Nr,
  isValidBase64URL: el,
  isValidJWT: rl,
  locales: Kl,
  meta: Ms,
  parse: Qn,
  parseAsync: er,
  prettifyError: Ta,
  regexes: $r,
  registry: Rr,
  safeDecode: wm,
  safeDecodeAsync: Um,
  safeEncode: Tm,
  safeEncodeAsync: Am,
  safeParse: wa,
  safeParseAsync: Aa,
  toDotPath: Oa,
  toJSONSchema: Gs,
  treeifyError: Na,
  util: Ea,
  version: Pu
}, Symbol.toStringTag, { value: "Module" })), fi = /* @__PURE__ */ d("ZodISODateTime", (e, n) => {
  Hu.init(e, n), L.init(e, n);
});
function Fs(e) {
  return ts(fi, e);
}
const pi = /* @__PURE__ */ d("ZodISODate", (e, n) => {
  Bu.init(e, n), L.init(e, n);
});
function Hs(e) {
  return ns(pi, e);
}
const vi = /* @__PURE__ */ d("ZodISOTime", (e, n) => {
  Vu.init(e, n), L.init(e, n);
});
function Bs(e) {
  return rs(vi, e);
}
const hi = /* @__PURE__ */ d("ZodISODuration", (e, n) => {
  Yu.init(e, n), L.init(e, n);
});
function Vs(e) {
  return is(hi, e);
}
const pp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ZodISODate: pi,
  ZodISODateTime: fi,
  ZodISODuration: hi,
  ZodISOTime: vi,
  date: Hs,
  datetime: Fs,
  duration: Vs,
  time: Bs
}, Symbol.toStringTag, { value: "Module" })), Ys = (e, n) => {
  dr.init(e, n), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (r) => gr(e, r)
      // enumerable: false,
    },
    flatten: {
      value: (r) => mr(e, r)
      // enumerable: false,
    },
    addIssue: {
      value: (r) => {
        e.issues.push(r), e.message = JSON.stringify(e.issues, en, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (r) => {
        e.issues.push(...r), e.message = JSON.stringify(e.issues, en, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, vp = d("ZodError", Ys), ae = d("ZodError", Ys, {
  Parent: Error
}), Ks = /* @__PURE__ */ $t(ae), Ws = /* @__PURE__ */ Et(ae), Js = /* @__PURE__ */ kt(ae), qs = /* @__PURE__ */ Nt(ae), Xs = /* @__PURE__ */ fr(ae), Qs = /* @__PURE__ */ pr(ae), ec = /* @__PURE__ */ vr(ae), tc = /* @__PURE__ */ hr(ae), nc = /* @__PURE__ */ br(ae), rc = /* @__PURE__ */ _r(ae), ic = /* @__PURE__ */ yr(ae), oc = /* @__PURE__ */ Sr(ae), w = /* @__PURE__ */ d("ZodType", (e, n) => (T.init(e, n), e.def = n, e.type = n.type, Object.defineProperty(e, "_def", { value: n }), e.check = (...r) => e.clone(Te(n, {
  checks: [
    ...n.checks ?? [],
    ...r.map((i) => typeof i == "function" ? { _zod: { check: i, def: { check: "custom" }, onattach: [] } } : i)
  ]
})), e.clone = (r, i) => se(e, r, i), e.brand = () => e, e.register = (r, i) => (r.add(e, i), e), e.parse = (r, i) => Ks(e, r, i, { callee: e.parse }), e.safeParse = (r, i) => Js(e, r, i), e.parseAsync = async (r, i) => Ws(e, r, i, { callee: e.parseAsync }), e.safeParseAsync = async (r, i) => qs(e, r, i), e.spa = e.safeParseAsync, e.encode = (r, i) => Xs(e, r, i), e.decode = (r, i) => Qs(e, r, i), e.encodeAsync = async (r, i) => ec(e, r, i), e.decodeAsync = async (r, i) => tc(e, r, i), e.safeEncode = (r, i) => nc(e, r, i), e.safeDecode = (r, i) => rc(e, r, i), e.safeEncodeAsync = async (r, i) => ic(e, r, i), e.safeDecodeAsync = async (r, i) => oc(e, r, i), e.refine = (r, i) => e.check(Fc(r, i)), e.superRefine = (r) => e.check(Hc(r)), e.overwrite = (r) => e.check(Re(r)), e.optional = () => an(e), e.nullable = () => un(e), e.nullish = () => an(un(e)), e.nonoptional = (r) => Uc(e, r), e.array = () => D(e), e.or = (r) => re([e, r]), e.and = (r) => hc(e, r), e.transform = (r) => ln(e, Mi(r)), e.default = (r) => Tc(e, r), e.prefault = (r) => Ac(e, r), e.catch = (r) => Rc(e, r), e.pipe = (r) => ln(e, r), e.readonly = () => jc(e), e.describe = (r) => {
  const i = e.clone();
  return ve.add(i, { description: r }), i;
}, Object.defineProperty(e, "description", {
  get() {
    var r;
    return (r = ve.get(e)) == null ? void 0 : r.description;
  },
  configurable: !0
}), e.meta = (...r) => {
  if (r.length === 0)
    return ve.get(e);
  const i = e.clone();
  return ve.add(i, r[0]), i;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), bi = /* @__PURE__ */ d("_ZodString", (e, n) => {
  At.init(e, n), w.init(e, n);
  const r = e._zod.bag;
  e.format = r.format ?? null, e.minLength = r.minimum ?? null, e.maxLength = r.maximum ?? null, e.regex = (...i) => e.check(ni(...i)), e.includes = (...i) => e.check(oi(...i)), e.startsWith = (...i) => e.check(ai(...i)), e.endsWith = (...i) => e.check(ui(...i)), e.min = (...i) => e.check(rt(...i)), e.max = (...i) => e.check(bn(...i)), e.length = (...i) => e.check(_n(...i)), e.nonempty = (...i) => e.check(rt(1, ...i)), e.lowercase = (i) => e.check(ri(i)), e.uppercase = (i) => e.check(ii(i)), e.trim = () => e.check(ci()), e.normalize = (...i) => e.check(si(...i)), e.toLowerCase = () => e.check(di()), e.toUpperCase = () => e.check(mi()), e.slugify = () => e.check(gi());
}), yn = /* @__PURE__ */ d("ZodString", (e, n) => {
  At.init(e, n), bi.init(e, n), e.email = (r) => e.check(zr(_i, r)), e.url = (r) => e.check(vn(Sn, r)), e.jwt = (r) => e.check(ei(Ri, r)), e.emoji = (r) => e.check(Mr(yi, r)), e.guid = (r) => e.check(rn(on, r)), e.uuid = (r) => e.check(Cr(ke, r)), e.uuidv4 = (r) => e.check(jr(ke, r)), e.uuidv6 = (r) => e.check(Lr(ke, r)), e.uuidv7 = (r) => e.check(xr(ke, r)), e.nanoid = (r) => e.check(Zr(Si, r)), e.guid = (r) => e.check(rn(on, r)), e.cuid = (r) => e.check(Gr(Ii, r)), e.cuid2 = (r) => e.check(Fr($i, r)), e.ulid = (r) => e.check(Hr(Ei, r)), e.base64 = (r) => e.check(qr(Ui, r)), e.base64url = (r) => e.check(Xr(Pi, r)), e.xid = (r) => e.check(Br(ki, r)), e.ksuid = (r) => e.check(Vr(Ni, r)), e.ipv4 = (r) => e.check(Yr(Oi, r)), e.ipv6 = (r) => e.check(Kr(Ti, r)), e.cidrv4 = (r) => e.check(Wr(wi, r)), e.cidrv6 = (r) => e.check(Jr(Ai, r)), e.e164 = (r) => e.check(Qr(Di, r)), e.datetime = (r) => e.check(Fs(r)), e.date = (r) => e.check(Hs(r)), e.time = (r) => e.check(Bs(r)), e.duration = (r) => e.check(Vs(r));
});
function b(e) {
  return ql(yn, e);
}
const L = /* @__PURE__ */ d("ZodStringFormat", (e, n) => {
  C.init(e, n), bi.init(e, n);
}), _i = /* @__PURE__ */ d("ZodEmail", (e, n) => {
  zu.init(e, n), L.init(e, n);
});
function hp(e) {
  return zr(_i, e);
}
const on = /* @__PURE__ */ d("ZodGUID", (e, n) => {
  Du.init(e, n), L.init(e, n);
});
function bp(e) {
  return rn(on, e);
}
const ke = /* @__PURE__ */ d("ZodUUID", (e, n) => {
  Ru.init(e, n), L.init(e, n);
});
function _p(e) {
  return Cr(ke, e);
}
function yp(e) {
  return jr(ke, e);
}
function Sp(e) {
  return Lr(ke, e);
}
function Ip(e) {
  return xr(ke, e);
}
const Sn = /* @__PURE__ */ d("ZodURL", (e, n) => {
  Cu.init(e, n), L.init(e, n);
});
function $p(e) {
  return vn(Sn, e);
}
function Ep(e) {
  return vn(Sn, {
    protocol: /^https?$/,
    hostname: Wa,
    ...y(e)
  });
}
const yi = /* @__PURE__ */ d("ZodEmoji", (e, n) => {
  ju.init(e, n), L.init(e, n);
});
function kp(e) {
  return Mr(yi, e);
}
const Si = /* @__PURE__ */ d("ZodNanoID", (e, n) => {
  Lu.init(e, n), L.init(e, n);
});
function Np(e) {
  return Zr(Si, e);
}
const Ii = /* @__PURE__ */ d("ZodCUID", (e, n) => {
  xu.init(e, n), L.init(e, n);
});
function Op(e) {
  return Gr(Ii, e);
}
const $i = /* @__PURE__ */ d("ZodCUID2", (e, n) => {
  Mu.init(e, n), L.init(e, n);
});
function Tp(e) {
  return Fr($i, e);
}
const Ei = /* @__PURE__ */ d("ZodULID", (e, n) => {
  Zu.init(e, n), L.init(e, n);
});
function wp(e) {
  return Hr(Ei, e);
}
const ki = /* @__PURE__ */ d("ZodXID", (e, n) => {
  Gu.init(e, n), L.init(e, n);
});
function Ap(e) {
  return Br(ki, e);
}
const Ni = /* @__PURE__ */ d("ZodKSUID", (e, n) => {
  Fu.init(e, n), L.init(e, n);
});
function Up(e) {
  return Vr(Ni, e);
}
const Oi = /* @__PURE__ */ d("ZodIPv4", (e, n) => {
  Ku.init(e, n), L.init(e, n);
});
function Pp(e) {
  return Yr(Oi, e);
}
const ac = /* @__PURE__ */ d("ZodMAC", (e, n) => {
  Ju.init(e, n), L.init(e, n);
});
function Dp(e) {
  return Ql(ac, e);
}
const Ti = /* @__PURE__ */ d("ZodIPv6", (e, n) => {
  Wu.init(e, n), L.init(e, n);
});
function Rp(e) {
  return Kr(Ti, e);
}
const wi = /* @__PURE__ */ d("ZodCIDRv4", (e, n) => {
  qu.init(e, n), L.init(e, n);
});
function zp(e) {
  return Wr(wi, e);
}
const Ai = /* @__PURE__ */ d("ZodCIDRv6", (e, n) => {
  Xu.init(e, n), L.init(e, n);
});
function Cp(e) {
  return Jr(Ai, e);
}
const Ui = /* @__PURE__ */ d("ZodBase64", (e, n) => {
  Qu.init(e, n), L.init(e, n);
});
function jp(e) {
  return qr(Ui, e);
}
const Pi = /* @__PURE__ */ d("ZodBase64URL", (e, n) => {
  tl.init(e, n), L.init(e, n);
});
function Lp(e) {
  return Xr(Pi, e);
}
const Di = /* @__PURE__ */ d("ZodE164", (e, n) => {
  nl.init(e, n), L.init(e, n);
});
function xp(e) {
  return Qr(Di, e);
}
const Ri = /* @__PURE__ */ d("ZodJWT", (e, n) => {
  il.init(e, n), L.init(e, n);
});
function Mp(e) {
  return ei(Ri, e);
}
const Pt = /* @__PURE__ */ d("ZodCustomStringFormat", (e, n) => {
  ol.init(e, n), L.init(e, n);
});
function Zp(e, n, r = {}) {
  return Ut(Pt, e, n, r);
}
function Gp(e) {
  return Ut(Pt, "hostname", Ka, e);
}
function Fp(e) {
  return Ut(Pt, "hex", du, e);
}
function Hp(e, n) {
  const r = (n == null ? void 0 : n.enc) ?? "hex", i = `${e}_${r}`, t = $r[i];
  if (!t)
    throw new Error(`Unrecognized hash format: ${i}`);
  return Ut(Pt, i, t, n);
}
const In = /* @__PURE__ */ d("ZodNumber", (e, n) => {
  Or.init(e, n), w.init(e, n), e.gt = (i, t) => e.check(Fe(i, t)), e.gte = (i, t) => e.check(ie(i, t)), e.min = (i, t) => e.check(ie(i, t)), e.lt = (i, t) => e.check(Ge(i, t)), e.lte = (i, t) => e.check(he(i, t)), e.max = (i, t) => e.check(he(i, t)), e.int = (i) => e.check(rr(i)), e.safe = (i) => e.check(rr(i)), e.positive = (i) => e.check(Fe(0, i)), e.nonnegative = (i) => e.check(ie(0, i)), e.negative = (i) => e.check(Ge(0, i)), e.nonpositive = (i) => e.check(he(0, i)), e.multipleOf = (i, t) => e.check(vt(i, t)), e.step = (i, t) => e.check(vt(i, t)), e.finite = () => e;
  const r = e._zod.bag;
  e.minValue = Math.max(r.minimum ?? Number.NEGATIVE_INFINITY, r.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(r.maximum ?? Number.POSITIVE_INFINITY, r.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (r.format ?? "").includes("int") || Number.isSafeInteger(r.multipleOf ?? 0.5), e.isFinite = !0, e.format = r.format ?? null;
});
function K(e) {
  return os(In, e);
}
const ut = /* @__PURE__ */ d("ZodNumberFormat", (e, n) => {
  al.init(e, n), In.init(e, n);
});
function rr(e) {
  return us(ut, e);
}
function Bp(e) {
  return ls(ut, e);
}
function Vp(e) {
  return ss(ut, e);
}
function Yp(e) {
  return cs(ut, e);
}
function Kp(e) {
  return ds(ut, e);
}
const $n = /* @__PURE__ */ d("ZodBoolean", (e, n) => {
  Tr.init(e, n), w.init(e, n);
});
function H(e) {
  return ms($n, e);
}
const En = /* @__PURE__ */ d("ZodBigInt", (e, n) => {
  wr.init(e, n), w.init(e, n), e.gte = (i, t) => e.check(ie(i, t)), e.min = (i, t) => e.check(ie(i, t)), e.gt = (i, t) => e.check(Fe(i, t)), e.gte = (i, t) => e.check(ie(i, t)), e.min = (i, t) => e.check(ie(i, t)), e.lt = (i, t) => e.check(Ge(i, t)), e.lte = (i, t) => e.check(he(i, t)), e.max = (i, t) => e.check(he(i, t)), e.positive = (i) => e.check(Fe(BigInt(0), i)), e.negative = (i) => e.check(Ge(BigInt(0), i)), e.nonpositive = (i) => e.check(he(BigInt(0), i)), e.nonnegative = (i) => e.check(ie(BigInt(0), i)), e.multipleOf = (i, t) => e.check(vt(i, t));
  const r = e._zod.bag;
  e.minValue = r.minimum ?? null, e.maxValue = r.maximum ?? null, e.format = r.format ?? null;
});
function Wp(e) {
  return fs(En, e);
}
const zi = /* @__PURE__ */ d("ZodBigIntFormat", (e, n) => {
  ul.init(e, n), En.init(e, n);
});
function Jp(e) {
  return vs(zi, e);
}
function qp(e) {
  return hs(zi, e);
}
const uc = /* @__PURE__ */ d("ZodSymbol", (e, n) => {
  ll.init(e, n), w.init(e, n);
});
function Xp(e) {
  return bs(uc, e);
}
const lc = /* @__PURE__ */ d("ZodUndefined", (e, n) => {
  sl.init(e, n), w.init(e, n);
});
function bt(e) {
  return _s(lc, e);
}
const sc = /* @__PURE__ */ d("ZodNull", (e, n) => {
  cl.init(e, n), w.init(e, n);
});
function lt(e) {
  return ys(sc, e);
}
const cc = /* @__PURE__ */ d("ZodAny", (e, n) => {
  dl.init(e, n), w.init(e, n);
});
function Qp() {
  return Ss(cc);
}
const dc = /* @__PURE__ */ d("ZodUnknown", (e, n) => {
  ml.init(e, n), w.init(e, n);
});
function it() {
  return Is(dc);
}
const mc = /* @__PURE__ */ d("ZodNever", (e, n) => {
  gl.init(e, n), w.init(e, n);
});
function Ci(e) {
  return $s(mc, e);
}
const gc = /* @__PURE__ */ d("ZodVoid", (e, n) => {
  fl.init(e, n), w.init(e, n);
});
function ev(e) {
  return Es(gc, e);
}
const ji = /* @__PURE__ */ d("ZodDate", (e, n) => {
  pl.init(e, n), w.init(e, n), e.min = (i, t) => e.check(ie(i, t)), e.max = (i, t) => e.check(he(i, t));
  const r = e._zod.bag;
  e.minDate = r.minimum ? new Date(r.minimum) : null, e.maxDate = r.maximum ? new Date(r.maximum) : null;
});
function tv(e) {
  return ks(ji, e);
}
const fc = /* @__PURE__ */ d("ZodArray", (e, n) => {
  vl.init(e, n), w.init(e, n), e.element = n.element, e.min = (r, i) => e.check(rt(r, i)), e.nonempty = (r) => e.check(rt(1, r)), e.max = (r, i) => e.check(bn(r, i)), e.length = (r, i) => e.check(_n(r, i)), e.unwrap = () => e.element;
});
function D(e, n) {
  return Ds(fc, e, n);
}
function nv(e) {
  const n = e._zod.def.shape;
  return _e(Object.keys(n));
}
const kn = /* @__PURE__ */ d("ZodObject", (e, n) => {
  yl.init(e, n), w.init(e, n), U(e, "shape", () => n.shape), e.keyof = () => _e(Object.keys(e._zod.def.shape)), e.catchall = (r) => e.clone({ ...e._zod.def, catchall: r }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: it() }), e.loose = () => e.clone({ ...e._zod.def, catchall: it() }), e.strict = () => e.clone({ ...e._zod.def, catchall: Ci() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (r) => ha(e, r), e.safeExtend = (r) => ba(e, r), e.merge = (r) => _a(e, r), e.pick = (r) => pa(e, r), e.omit = (r) => va(e, r), e.partial = (...r) => ya(Zi, e, r[0]), e.required = (...r) => Sa(Gi, e, r[0]);
});
function O(e, n) {
  const r = {
    type: "object",
    shape: e ?? {},
    ...y(n)
  };
  return new kn(r);
}
function rv(e, n) {
  return new kn({
    type: "object",
    shape: e,
    catchall: Ci(),
    ...y(n)
  });
}
function iv(e, n) {
  return new kn({
    type: "object",
    shape: e,
    catchall: it(),
    ...y(n)
  });
}
const Li = /* @__PURE__ */ d("ZodUnion", (e, n) => {
  Ar.init(e, n), w.init(e, n), e.options = n.options;
});
function re(e, n) {
  return new Li({
    type: "union",
    options: e,
    ...y(n)
  });
}
const pc = /* @__PURE__ */ d("ZodDiscriminatedUnion", (e, n) => {
  Li.init(e, n), Sl.init(e, n);
});
function ov(e, n, r) {
  return new pc({
    type: "union",
    options: n,
    discriminator: e,
    ...y(r)
  });
}
const vc = /* @__PURE__ */ d("ZodIntersection", (e, n) => {
  Il.init(e, n), w.init(e, n);
});
function hc(e, n) {
  return new vc({
    type: "intersection",
    left: e,
    right: n
  });
}
const bc = /* @__PURE__ */ d("ZodTuple", (e, n) => {
  Ur.init(e, n), w.init(e, n), e.rest = (r) => e.clone({
    ...e._zod.def,
    rest: r
  });
});
function _c(e, n, r) {
  const i = n instanceof T, t = i ? r : n, o = i ? n : null;
  return new bc({
    type: "tuple",
    items: e,
    rest: o,
    ...y(t)
  });
}
const xi = /* @__PURE__ */ d("ZodRecord", (e, n) => {
  $l.init(e, n), w.init(e, n), e.keyType = n.keyType, e.valueType = n.valueType;
});
function yc(e, n, r) {
  return new xi({
    type: "record",
    keyType: e,
    valueType: n,
    ...y(r)
  });
}
function av(e, n, r) {
  const i = se(e);
  return i._zod.values = void 0, new xi({
    type: "record",
    keyType: i,
    valueType: n,
    ...y(r)
  });
}
const Sc = /* @__PURE__ */ d("ZodMap", (e, n) => {
  El.init(e, n), w.init(e, n), e.keyType = n.keyType, e.valueType = n.valueType;
});
function uv(e, n, r) {
  return new Sc({
    type: "map",
    keyType: e,
    valueType: n,
    ...y(r)
  });
}
const Ic = /* @__PURE__ */ d("ZodSet", (e, n) => {
  kl.init(e, n), w.init(e, n), e.min = (...r) => e.check(ht(...r)), e.nonempty = (r) => e.check(ht(1, r)), e.max = (...r) => e.check(hn(...r)), e.size = (...r) => e.check(ti(...r));
});
function lv(e, n) {
  return new Ic({
    type: "set",
    valueType: e,
    ...y(n)
  });
}
const _t = /* @__PURE__ */ d("ZodEnum", (e, n) => {
  Nl.init(e, n), w.init(e, n), e.enum = n.entries, e.options = Object.values(n.entries);
  const r = new Set(Object.keys(n.entries));
  e.extract = (i, t) => {
    const o = {};
    for (const a of i)
      if (r.has(a))
        o[a] = n.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new _t({
      ...n,
      checks: [],
      ...y(t),
      entries: o
    });
  }, e.exclude = (i, t) => {
    const o = { ...n.entries };
    for (const a of i)
      if (r.has(a))
        delete o[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new _t({
      ...n,
      checks: [],
      ...y(t),
      entries: o
    });
  };
});
function _e(e, n) {
  const r = Array.isArray(e) ? Object.fromEntries(e.map((i) => [i, i])) : e;
  return new _t({
    type: "enum",
    entries: r,
    ...y(n)
  });
}
function sv(e, n) {
  return new _t({
    type: "enum",
    entries: e,
    ...y(n)
  });
}
const $c = /* @__PURE__ */ d("ZodLiteral", (e, n) => {
  Ol.init(e, n), w.init(e, n), e.values = new Set(n.values), Object.defineProperty(e, "value", {
    get() {
      if (n.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return n.values[0];
    }
  });
});
function Y(e, n) {
  return new $c({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...y(n)
  });
}
const Ec = /* @__PURE__ */ d("ZodFile", (e, n) => {
  Tl.init(e, n), w.init(e, n), e.min = (r, i) => e.check(ht(r, i)), e.max = (r, i) => e.check(hn(r, i)), e.mime = (r, i) => e.check(li(Array.isArray(r) ? r : [r], i));
});
function cv(e) {
  return Rs(Ec, e);
}
const kc = /* @__PURE__ */ d("ZodTransform", (e, n) => {
  wl.init(e, n), w.init(e, n), e._zod.parse = (r, i) => {
    if (i.direction === "backward")
      throw new dn(e.constructor.name);
    r.addIssue = (o) => {
      if (typeof o == "string")
        r.issues.push(tt(o, r.value, n));
      else {
        const a = o;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = r.value), a.inst ?? (a.inst = e), r.issues.push(tt(a));
      }
    };
    const t = n.transform(r.value, r);
    return t instanceof Promise ? t.then((o) => (r.value = o, r)) : (r.value = t, r);
  };
});
function Mi(e) {
  return new kc({
    type: "transform",
    transform: e
  });
}
const Zi = /* @__PURE__ */ d("ZodOptional", (e, n) => {
  Al.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function an(e) {
  return new Zi({
    type: "optional",
    innerType: e
  });
}
const Nc = /* @__PURE__ */ d("ZodNullable", (e, n) => {
  Ul.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function un(e) {
  return new Nc({
    type: "nullable",
    innerType: e
  });
}
function dv(e) {
  return an(un(e));
}
const Oc = /* @__PURE__ */ d("ZodDefault", (e, n) => {
  Pl.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Tc(e, n) {
  return new Oc({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof n == "function" ? n() : gn(n);
    }
  });
}
const wc = /* @__PURE__ */ d("ZodPrefault", (e, n) => {
  Dl.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function Ac(e, n) {
  return new wc({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof n == "function" ? n() : gn(n);
    }
  });
}
const Gi = /* @__PURE__ */ d("ZodNonOptional", (e, n) => {
  Rl.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function Uc(e, n) {
  return new Gi({
    type: "nonoptional",
    innerType: e,
    ...y(n)
  });
}
const Pc = /* @__PURE__ */ d("ZodSuccess", (e, n) => {
  zl.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function mv(e) {
  return new Pc({
    type: "success",
    innerType: e
  });
}
const Dc = /* @__PURE__ */ d("ZodCatch", (e, n) => {
  Cl.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Rc(e, n) {
  return new Dc({
    type: "catch",
    innerType: e,
    catchValue: typeof n == "function" ? n : () => n
  });
}
const zc = /* @__PURE__ */ d("ZodNaN", (e, n) => {
  jl.init(e, n), w.init(e, n);
});
function gv(e) {
  return Os(zc, e);
}
const Fi = /* @__PURE__ */ d("ZodPipe", (e, n) => {
  Ll.init(e, n), w.init(e, n), e.in = n.in, e.out = n.out;
});
function ln(e, n) {
  return new Fi({
    type: "pipe",
    in: e,
    out: n
    // ...util.normalizeParams(params),
  });
}
const Hi = /* @__PURE__ */ d("ZodCodec", (e, n) => {
  Fi.init(e, n), Pr.init(e, n);
});
function fv(e, n, r) {
  return new Hi({
    type: "pipe",
    in: e,
    out: n,
    transform: r.decode,
    reverseTransform: r.encode
  });
}
const Cc = /* @__PURE__ */ d("ZodReadonly", (e, n) => {
  xl.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function jc(e) {
  return new Cc({
    type: "readonly",
    innerType: e
  });
}
const Lc = /* @__PURE__ */ d("ZodTemplateLiteral", (e, n) => {
  Ml.init(e, n), w.init(e, n);
});
function pv(e, n) {
  return new Lc({
    type: "template_literal",
    parts: e,
    ...y(n)
  });
}
const xc = /* @__PURE__ */ d("ZodLazy", (e, n) => {
  Fl.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.getter();
});
function Mc(e) {
  return new xc({
    type: "lazy",
    getter: e
  });
}
const Zc = /* @__PURE__ */ d("ZodPromise", (e, n) => {
  Gl.init(e, n), w.init(e, n), e.unwrap = () => e._zod.def.innerType;
});
function vv(e) {
  return new Zc({
    type: "promise",
    innerType: e
  });
}
const Gc = /* @__PURE__ */ d("ZodFunction", (e, n) => {
  Zl.init(e, n), w.init(e, n);
});
function zo(e) {
  return new Gc({
    type: "function",
    input: Array.isArray(e == null ? void 0 : e.input) ? _c(e == null ? void 0 : e.input) : (e == null ? void 0 : e.input) ?? D(it()),
    output: (e == null ? void 0 : e.output) ?? it()
  });
}
const Nn = /* @__PURE__ */ d("ZodCustom", (e, n) => {
  Hl.init(e, n), w.init(e, n);
});
function hv(e) {
  const n = new M({
    check: "custom"
    // ...util.normalizeParams(params),
  });
  return n._zod.check = e, n;
}
function bv(e, n) {
  return zs(Nn, e ?? (() => !0), n);
}
function Fc(e, n = {}) {
  return Cs(Nn, e, n);
}
function Hc(e) {
  return js(e);
}
const _v = xs, yv = Ms;
function Sv(e, n = {
  error: `Input not instance of ${e.name}`
}) {
  const r = new Nn({
    type: "custom",
    check: "custom",
    fn: (i) => i instanceof e,
    abort: !0,
    ...y(n)
  });
  return r._zod.bag.Class = e, r;
}
const Iv = (...e) => Zs({
  Codec: Hi,
  Boolean: $n,
  String: yn
}, ...e);
function $v(e) {
  const n = Mc(() => re([b(e), K(), H(), lt(), D(n), yc(b(), n)]));
  return n;
}
function Ev(e, n) {
  return ln(Mi(e), n);
}
const kv = {
  invalid_type: "invalid_type",
  too_big: "too_big",
  too_small: "too_small",
  invalid_format: "invalid_format",
  not_multiple_of: "not_multiple_of",
  unrecognized_keys: "unrecognized_keys",
  invalid_union: "invalid_union",
  invalid_key: "invalid_key",
  invalid_element: "invalid_element",
  invalid_value: "invalid_value",
  custom: "custom"
};
function Nv(e) {
  ee({
    customError: e
  });
}
function Ov() {
  return ee().customError;
}
var ir;
ir || (ir = {});
function me(e) {
  return Xl(yn, e);
}
function Tv(e) {
  return as(In, e);
}
function wv(e) {
  return gs($n, e);
}
function Av(e) {
  return ps(En, e);
}
function Uv(e) {
  return Ns(ji, e);
}
const Pv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bigint: Av,
  boolean: wv,
  date: Uv,
  number: Tv,
  string: me
}, Symbol.toStringTag, { value: "Module" }));
ee(Bl());
const R = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  $brand: ua,
  $input: Jl,
  $output: Wl,
  NEVER: aa,
  TimePrecision: es,
  ZodAny: cc,
  ZodArray: fc,
  ZodBase64: Ui,
  ZodBase64URL: Pi,
  ZodBigInt: En,
  ZodBigIntFormat: zi,
  ZodBoolean: $n,
  ZodCIDRv4: wi,
  ZodCIDRv6: Ai,
  ZodCUID: Ii,
  ZodCUID2: $i,
  ZodCatch: Dc,
  ZodCodec: Hi,
  ZodCustom: Nn,
  ZodCustomStringFormat: Pt,
  ZodDate: ji,
  ZodDefault: Oc,
  ZodDiscriminatedUnion: pc,
  ZodE164: Di,
  ZodEmail: _i,
  ZodEmoji: yi,
  ZodEnum: _t,
  ZodError: vp,
  ZodFile: Ec,
  get ZodFirstPartyTypeKind() {
    return ir;
  },
  ZodFunction: Gc,
  ZodGUID: on,
  ZodIPv4: Oi,
  ZodIPv6: Ti,
  ZodISODate: pi,
  ZodISODateTime: fi,
  ZodISODuration: hi,
  ZodISOTime: vi,
  ZodIntersection: vc,
  ZodIssueCode: kv,
  ZodJWT: Ri,
  ZodKSUID: Ni,
  ZodLazy: xc,
  ZodLiteral: $c,
  ZodMAC: ac,
  ZodMap: Sc,
  ZodNaN: zc,
  ZodNanoID: Si,
  ZodNever: mc,
  ZodNonOptional: Gi,
  ZodNull: sc,
  ZodNullable: Nc,
  ZodNumber: In,
  ZodNumberFormat: ut,
  ZodObject: kn,
  ZodOptional: Zi,
  ZodPipe: Fi,
  ZodPrefault: wc,
  ZodPromise: Zc,
  ZodReadonly: Cc,
  ZodRealError: ae,
  ZodRecord: xi,
  ZodSet: Ic,
  ZodString: yn,
  ZodStringFormat: L,
  ZodSuccess: Pc,
  ZodSymbol: uc,
  ZodTemplateLiteral: Lc,
  ZodTransform: kc,
  ZodTuple: bc,
  ZodType: w,
  ZodULID: Ei,
  ZodURL: Sn,
  ZodUUID: ke,
  ZodUndefined: lc,
  ZodUnion: Li,
  ZodUnknown: dc,
  ZodVoid: gc,
  ZodXID: ki,
  _ZodString: bi,
  _default: Tc,
  _function: zo,
  any: Qp,
  array: D,
  base64: jp,
  base64url: Lp,
  bigint: Wp,
  boolean: H,
  catch: Rc,
  check: hv,
  cidrv4: zp,
  cidrv6: Cp,
  clone: se,
  codec: fv,
  coerce: Pv,
  config: ee,
  core: fp,
  cuid: Op,
  cuid2: Tp,
  custom: bv,
  date: tv,
  decode: Qs,
  decodeAsync: tc,
  describe: _v,
  discriminatedUnion: ov,
  e164: xp,
  email: hp,
  emoji: kp,
  encode: Xs,
  encodeAsync: ec,
  endsWith: ui,
  enum: _e,
  file: cv,
  flattenError: mr,
  float32: Bp,
  float64: Vp,
  formatError: gr,
  function: zo,
  getErrorMap: Ov,
  globalRegistry: ve,
  gt: Fe,
  gte: ie,
  guid: bp,
  hash: Hp,
  hex: Fp,
  hostname: Gp,
  httpUrl: Ep,
  includes: oi,
  instanceof: Sv,
  int: rr,
  int32: Yp,
  int64: Jp,
  intersection: hc,
  ipv4: Pp,
  ipv6: Rp,
  iso: pp,
  json: $v,
  jwt: Mp,
  keyof: nv,
  ksuid: Up,
  lazy: Mc,
  length: _n,
  literal: Y,
  locales: Kl,
  looseObject: iv,
  lowercase: ri,
  lt: Ge,
  lte: he,
  mac: Dp,
  map: uv,
  maxLength: bn,
  maxSize: hn,
  meta: yv,
  mime: li,
  minLength: rt,
  minSize: ht,
  multipleOf: vt,
  nan: gv,
  nanoid: Np,
  nativeEnum: sv,
  negative: ws,
  never: Ci,
  nonnegative: Us,
  nonoptional: Uc,
  nonpositive: As,
  normalize: si,
  null: lt,
  nullable: un,
  nullish: dv,
  number: K,
  object: O,
  optional: an,
  overwrite: Re,
  parse: Ks,
  parseAsync: Ws,
  partialRecord: av,
  pipe: ln,
  positive: Ts,
  prefault: Ac,
  preprocess: Ev,
  prettifyError: Ta,
  promise: vv,
  property: Ps,
  readonly: jc,
  record: yc,
  refine: Fc,
  regex: ni,
  regexes: $r,
  registry: Rr,
  safeDecode: rc,
  safeDecodeAsync: oc,
  safeEncode: nc,
  safeEncodeAsync: ic,
  safeParse: Js,
  safeParseAsync: qs,
  set: lv,
  setErrorMap: Nv,
  size: ti,
  slugify: gi,
  startsWith: ai,
  strictObject: rv,
  string: b,
  stringFormat: Zp,
  stringbool: Iv,
  success: mv,
  superRefine: Hc,
  symbol: Xp,
  templateLiteral: pv,
  toJSONSchema: Gs,
  toLowerCase: di,
  toUpperCase: mi,
  transform: Mi,
  treeifyError: Na,
  trim: ci,
  tuple: _c,
  uint32: Kp,
  uint64: qp,
  ulid: wp,
  undefined: bt,
  union: re,
  unknown: it,
  uppercase: ii,
  url: $p,
  util: Ea,
  uuid: _p,
  uuidv4: yp,
  uuidv6: Sp,
  uuidv7: Ip,
  void: ev,
  xid: Ap
}, Symbol.toStringTag, { value: "Module" })), Dv = O({
  bundle: _e(["Ultimate", "Extra", "Core"]).nullable(),
  accountType: _e(["individual", "school", "multi-school"]),
  isAdmin: H().nullable(),
  isStaff: H()
}), ot = O({
  userId: b(),
  schoolId: b().nullable(),
  educationProgramme: b(),
  jwt: O({
    token: b(),
    expiration: b().datetime()
  }),
  metadata: O({
    careerId: me(),
    countyId: me(),
    dateCreated: b(),
    language: O({
      id: me(),
      code: b()
    }),
    country: O({
      id: me(),
      code: b()
    }),
    subscription: O({
      id: b(),
      bundle: O({
        id: b(),
        name: _e(["Ultimate", "Extra", "Core"])
      }),
      typeId: b().optional().nullable(),
      paid: b().optional().nullable(),
      offerCode: b().optional().nullable(),
      packageIds: D(b()).optional()
    }).nullable()
  }).optional(),
  persona: Dv
}), Bc = ot.extend({
  persona: ot.shape.persona.extend({
    accountType: Y("school")
  })
}), Rv = Bc.extend({
  jwt: bt()
}), zv = re([
  Bc,
  Rv
]), Cv = ot.extend({
  persona: ot.shape.persona.extend({
    accountType: Y("multi-school")
  })
}), Wt = ot.extend({
  persona: ot.shape.persona.extend({
    isStaff: Y(!1),
    accountType: Y("individual")
  })
}), jv = Wt.extend({
  persona: Wt.shape.persona.extend({
    isStaff: Y(!0),
    bundle: Wt.shape.persona.shape.bundle.nullable()
  })
}), Lv = re([
  zv,
  Cv,
  Wt,
  jv
]), Gn = "CA_JWT", ne = {
  /**
   * @param token the CA auth token to set in the local storage
   */
  setToken: (e) => {
    e ? localStorage.setItem(Gn, e) : localStorage.removeItem(Gn);
  },
  /**
   * @returns the CA auth token from the local storage
   */
  getToken: () => localStorage.getItem(Gn),
  /**
   * @returns if the token exists, it will return the token in the Bearer format
   */
  getBearerHeader: () => ({
    Authorization: `Bearer ${ne.getToken()}`
  })
}, Xe = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Ae = globalThis, ft = "9.47.1";
function Vc() {
  return Bi(Ae), Ae;
}
function Bi(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || ft, n[ft] = n[ft] || {};
}
function Vi(e, n, r = Ae) {
  const i = r.__SENTRY__ = r.__SENTRY__ || {}, t = i[ft] = i[ft] || {};
  return t[e] || (t[e] = n());
}
const xv = "Sentry Logger ", Co = {};
function Mv(e) {
  if (!("console" in Ae))
    return e();
  const n = Ae.console, r = {}, i = Object.keys(Co);
  i.forEach((t) => {
    const o = Co[t];
    r[t] = n[t], n[t] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((t) => {
      n[t] = r[t];
    });
  }
}
function Zv() {
  Ki().enabled = !0;
}
function Gv() {
  Ki().enabled = !1;
}
function Yc() {
  return Ki().enabled;
}
function Fv(...e) {
  Yi("log", ...e);
}
function Hv(...e) {
  Yi("warn", ...e);
}
function Bv(...e) {
  Yi("error", ...e);
}
function Yi(e, ...n) {
  Xe && Yc() && Mv(() => {
    Ae.console[e](`${xv}[${e}]:`, ...n);
  });
}
function Ki() {
  return Xe ? Vi("loggerSettings", () => ({ enabled: !1 })) : { enabled: !1 };
}
const Jt = {
  /** Enable logging. */
  enable: Zv,
  /** Disable logging. */
  disable: Gv,
  /** Check if logging is enabled. */
  isEnabled: Yc,
  /** Log a message. */
  log: Fv,
  /** Log a warning. */
  warn: Hv,
  /** Log an error. */
  error: Bv
}, Vv = Object.prototype.toString;
function Yv(e, n) {
  return Vv.call(e) === `[object ${n}]`;
}
function Kv(e) {
  return Yv(e, "Object");
}
function Wv(e) {
  return !!(e != null && e.then && typeof e.then == "function");
}
function Jv(e, n = 0) {
  return typeof e != "string" || n === 0 || e.length <= n ? e : `${e.slice(0, n)}...`;
}
function qv(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    Xe && Jt.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
function Xv() {
  const e = Ae;
  return e.crypto || e.msCrypto;
}
function pt(e = Xv()) {
  let n = () => Math.random() * 16;
  try {
    if (e != null && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e != null && e.getRandomValues && (n = () => {
      const r = new Uint8Array(1);
      return e.getRandomValues(r), r[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (r) => (
      // eslint-disable-next-line no-bitwise
      (r ^ (n() & 15) >> r / 4).toString(16)
    )
  );
}
const Kc = 1e3;
function Wc() {
  return Date.now() / Kc;
}
function Qv() {
  const { performance: e } = Ae;
  if (!(e != null && e.now) || !e.timeOrigin)
    return Wc;
  const n = e.timeOrigin;
  return () => (n + e.now()) / Kc;
}
let jo;
function eh() {
  return (jo ?? (jo = Qv()))();
}
function th(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || eh(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : pt()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
function Jc(e, n, r = 2) {
  if (!n || typeof n != "object" || r <= 0)
    return n;
  if (e && Object.keys(n).length === 0)
    return e;
  const i = { ...e };
  for (const t in n)
    Object.prototype.hasOwnProperty.call(n, t) && (i[t] = Jc(i[t], n[t], r - 1));
  return i;
}
function Lo() {
  return pt();
}
const or = "_sentrySpan";
function xo(e, n) {
  n ? qv(e, or, n) : delete e[or];
}
function Mo(e) {
  return e[or];
}
const nh = 100;
class Ue {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
      traceId: Lo(),
      sampleRand: Math.random()
    };
  }
  /**
   * Clone all data from this scope into a new scope.
   */
  clone() {
    const n = new Ue();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, this._contexts.flags && (n._contexts.flags = {
      values: [...this._contexts.flags.values]
    }), n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, xo(n, Mo(this)), n;
  }
  /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * Get the client assigned to this scope.
   */
  getClient() {
    return this._client;
  }
  /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * Add an event processor that will be called before an event is sent.
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && th(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * Get the user from this scope.
   */
  getUser() {
    return this._user;
  }
  /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single tag that will be sent as tags data with the event.
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the level on the scope for future events.
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * Set the session for the scope.
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * Get the session from the scope.
   */
  getSession() {
    return this._session;
  }
  /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, i = r instanceof Ue ? r.getScopeData() : Kv(r) ? n : void 0, { tags: t, extra: o, user: a, contexts: u, level: s, fingerprint: l = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...t }, this._extra = { ...this._extra, ...o }, this._contexts = { ...this._contexts, ...u }, a && Object.keys(a).length && (this._user = a), s && (this._level = s), l.length && (this._fingerprint = l), f && (this._propagationContext = f), this;
  }
  /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._session = void 0, xo(this, void 0), this._attachments = [], this.setPropagationContext({ traceId: Lo(), sampleRand: Math.random() }), this._notifyScopeListeners(), this;
  }
  /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */
  addBreadcrumb(n, r) {
    var o;
    const i = typeof r == "number" ? r : nh;
    if (i <= 0)
      return this;
    const t = {
      timestamp: Wc(),
      ...n,
      // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
      message: n.message ? Jv(n.message, 2048) : n.message
    };
    return this._breadcrumbs.push(t), this._breadcrumbs.length > i && (this._breadcrumbs = this._breadcrumbs.slice(-i), (o = this._client) == null || o.recordDroppedEvent("buffer_overflow", "log_item")), this._notifyScopeListeners(), this;
  }
  /**
   * Get the last breadcrumb of the scope.
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * Clear all breadcrumbs from the scope.
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * Add an attachment to the scope.
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * Clear all attachments from the scope.
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /**
   * Get the data of this scope, which should be applied to an event during processing.
   */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Mo(this)
    };
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = Jc(this._sdkProcessingMetadata, n, 2), this;
  }
  /**
   * Add propagation context to the scope, used for distributed tracing
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * Get propagation context from the scope, used for distributed tracing
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */
  captureException(n, r) {
    const i = (r == null ? void 0 : r.event_id) || pt();
    if (!this._client)
      return Xe && Jt.warn("No client configured on scope - will not capture exception!"), i;
    const t = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: t,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */
  captureMessage(n, r, i) {
    const t = (i == null ? void 0 : i.event_id) || pt();
    if (!this._client)
      return Xe && Jt.warn("No client configured on scope - will not capture message!"), t;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: t
      },
      this
    ), t;
  }
  /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */
  captureEvent(n, r) {
    const i = (r == null ? void 0 : r.event_id) || pt();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (Xe && Jt.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
function rh() {
  return Vi("defaultCurrentScope", () => new Ue());
}
function ih() {
  return Vi("defaultIsolationScope", () => new Ue());
}
class oh {
  constructor(n, r) {
    let i;
    n ? i = n : i = new Ue();
    let t;
    r ? t = r : t = new Ue(), this._stack = [{ scope: i }], this._isolationScope = t;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (t) {
      throw this._popScope(), t;
    }
    return Wv(i) ? i.then(
      (t) => (this._popScope(), t),
      (t) => {
        throw this._popScope(), t;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function at() {
  const e = Vc(), n = Bi(e);
  return n.stack = n.stack || new oh(rh(), ih());
}
function ah(e) {
  return at().withScope(e);
}
function uh(e, n) {
  const r = at();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function Zo(e) {
  return at().withScope(() => e(at().getIsolationScope()));
}
function lh() {
  return {
    withIsolationScope: Zo,
    withScope: ah,
    withSetScope: uh,
    withSetIsolationScope: (e, n) => Zo(n),
    getCurrentScope: () => at().getScope(),
    getIsolationScope: () => at().getIsolationScope()
  };
}
function sh(e) {
  const n = Bi(e);
  return n.acs ? n.acs : lh();
}
function ch() {
  const e = Vc();
  return sh(e).getCurrentScope();
}
function dh(e) {
  if (e)
    return mh(e) ? { captureContext: e } : fh(e) ? {
      captureContext: e
    } : e;
}
function mh(e) {
  return e instanceof Ue || typeof e == "function";
}
const gh = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "propagationContext"
];
function fh(e) {
  return Object.keys(e).some((n) => gh.includes(n));
}
function fe(e, n) {
  return ch().captureException(e, dh(n));
}
class Q extends Error {
  constructor(r, i, t) {
    super(r);
    xt(this, "status");
    xt(this, "data");
    this.name = "ApiError", this.status = i, this.data = t || null;
  }
}
class qc extends Q {
  constructor(r, i, t) {
    super(r, i);
    xt(this, "error");
    this.name = "UnknownApiError", this.error = t;
  }
}
const ph = (e) => {
  let n = null;
  switch (e.status) {
    case 400:
      n = "Bad Request";
      break;
    case 401:
      n = "Unauthorized";
      break;
    case 403:
      n = "Forbidden";
      break;
    case 404:
      n = "Not Found";
      break;
    case 409:
      n = "Conflict";
      break;
    case 500:
      n = "Internal Server Error";
      break;
  }
  return n === null ? new qc(
    "Unknown API error",
    e.status,
    n
  ) : new Q(n, e.status);
}, Fn = (e) => typeof e == "object" && e !== null && "status" in e && typeof e.status == "number", X = async ({
  agentName: e,
  fetchOptions: n,
  processErrorResponse: r,
  processInvalidData: i,
  processValidData: t,
  queryParams: o,
  schema: a,
  url: u
}) => {
  var s;
  try {
    let l;
    try {
      l = Td(u);
    } catch (v) {
      throw new Error(`Invalid targetURL: ${u}`, { cause: v });
    }
    o && Object.entries(o).forEach(([v, m]) => {
      l.searchParams.append(v, m.toString());
    });
    const f = (n == null ? void 0 : n.headers) || [];
    ["twinklResourceApi"].includes(e) || Object.assign(f, {
      "Content-Type": "application/json"
    }), delete n.headers;
    const c = async () => await fetch(l.toString(), {
      method: "GET",
      ...n,
      headers: {
        ...f
      }
    }), p = await c();
    if (!p.ok) {
      const v = await (r == null ? void 0 : r({
        response: p,
        request: c
      }));
      if (v) {
        const m = new Error(`configureAgent(${e}) processed error response (${p.status} ${p.statusText})`);
        v instanceof Error && (m.cause = v);
        const g = v instanceof Error ? {
          kind: "error",
          name: v.name,
          message: v.message
        } : {
          kind: typeof v,
          isNull: v === null
        };
        return fe(m, {
          tags: {
            agent: e,
            cause: "fetch"
          },
          extra: {
            responseStatus: p.status,
            responseStatusText: p.statusText,
            processedErrorResponseSummary: g,
            url: l.toString(),
            method: n.method
          },
          level: "warning"
        }), v;
      }
      return fe(new Error("Default error response"), {
        tags: {
          agent: e,
          cause: "fetch"
        },
        extra: {
          responseStatus: p.status,
          responseStatusText: p.statusText,
          url: l.toString(),
          method: n.method
        },
        level: "error"
      }), ph(p);
    }
    const _ = (await p.json()).data, h = a.safeParse(_);
    if (!h.success) {
      const v = i == null ? void 0 : i({
        data: h.error
      });
      return v ? (fe(
        new Error("Custom processed invalid data", {
          cause: v
        }),
        {
          tags: {
            agent: e,
            cause: "customInvalidDataProcessor"
          },
          extra: {
            responseData: _,
            schema: a.description
          },
          level: "warning"
        }
      ), v) : (fe(
        new Error("Default Invalid data process", {
          cause: h.error
        }),
        {
          tags: {
            agent: e,
            cause: "zod"
          },
          extra: {
            responseData: _,
            schema: a.description
          },
          level: "error"
        }
      ), h.error);
    }
    const $ = t == null ? void 0 : t({
      response: h.data
    });
    return $ || h.data;
  } catch (l) {
    let f = `Agent Error: ${e}`, c = "", p = null;
    if (l instanceof Error)
      f = l.message, c = l.toString(), Fn(l) && (p = l.status);
    else if (typeof l == "string")
      f = l;
    else if (Fn(l)) {
      p = l.status;
      try {
        c = JSON.stringify(l);
      } catch {
        c = String(l);
      }
    }
    if (fe(
      new Error(`${e} agent failed: ${f}`, { cause: l }),
      {
        tags: {
          agent: e,
          cause: "uncaught-exception"
        },
        extra: {
          errorType: l instanceof Error ? l.constructor.name : typeof l,
          errorMessage: f,
          errorDetails: c,
          responseStatus: p,
          url: ((s = u == null ? void 0 : u.toString) == null ? void 0 : s.call(u)) || String(u),
          method: n.method || "GET"
        },
        level: "error"
      }
    ), l instanceof Error)
      return l;
    const _ = Fn(l) ? l.status : null;
    return new qc("Unknown error", _, l);
  }
}, vh = {
  fetch: () => X({
    agentName: "currentUser",
    url: W.CURRENT_USER_PATH,
    fetchOptions: {
      method: "GET",
      credentials: "include"
    },
    schema: Lv,
    processValidData: ({ response: e }) => {
      var n;
      ne.setToken((n = e == null ? void 0 : e.jwt) == null ? void 0 : n.token);
    }
  })
}, hh = "currentUser", bb = () => {
  const e = hh, {
    // we always want to be able to return something, even if it's an empty array
    data: n = null,
    error: r,
    isLoading: i,
    mutate: t
  } = Pe(e, () => vh.fetch(), {
    // @see https://swr.vercel.app/docs/api#options
    // We only want to fetch this data once, and never revalidate it
    revalidateIfStale: !1,
    revalidateOnFocus: !1,
    revalidateOnReconnect: !1
  }), o = async () => {
    await t();
  }, a = n instanceof Error ? null : n, u = n instanceof Error ? n : r;
  return {
    data: a,
    isLoading: i,
    error: u,
    actions: {
      refresh: {
        apply: o,
        isLoading: i,
        error: r
      }
    }
  };
}, On = R.enum(["active", "archived"]), Tn = R.enum([
  "not_yet_planned",
  "planned",
  "planning_in_progress"
]), Xc = R.object({
  id: R.string(),
  ownerId: R.string(),
  ownerType: R.enum(["USER", "SCHOOL"]),
  displayLabel: R.string(),
  status: On,
  progress: Tn,
  description: R.string().optional(),
  createdAt: R.string()
}), bh = R.object({
  curriculumId: R.string()
}), _h = R.object({
  displayLabel: R.string(),
  status: On,
  progress: Tn,
  description: R.string().optional(),
  private: R.boolean().optional()
}), yh = R.object({
  message: R.string()
}), Sh = R.object({
  id: R.string(),
  displayLabel: R.string().optional(),
  description: R.string().optional(),
  status: On.optional(),
  progress: Tn.optional()
}), _b = R.object({
  displayLabel: R.string().optional(),
  status: On.optional(),
  progress: Tn.optional(),
  description: R.string().optional(),
  // true or undefined, as false would mean "make public" which is not supported
  public: R.literal(!0).optional()
}), Ih = R.object({
  curriculumId: R.string()
}), yb = _h.extend({
  curriculumIdToDuplicate: R.string()
}), wn = {
  fetch: async ({ id: e }) => await X({
    agentName: "curriculum",
    url: W.CURRICULUM_PATH(e),
    fetchOptions: {
      headers: {
        "Content-Type": "application/json",
        ...ne.getBearerHeader()
      }
    },
    schema: Xc
  }),
  create: async ({
    payload: e,
    type: n = "create"
  }) => {
    const r = n === "create" ? bh : Ih, i = n === "create" ? W.CURRICULUM_PATH(null) : W.DUPLICATE_CURRICULUM_PATH;
    return await X({
      agentName: "curriculum",
      url: i,
      fetchOptions: {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...ne.getBearerHeader()
        },
        body: JSON.stringify(e)
      },
      schema: r
    });
  },
  update: async ({
    id: e,
    payload: n
  }) => await X({
    agentName: "curriculum",
    url: W.CURRICULUM_PATH(e),
    fetchOptions: {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...ne.getBearerHeader()
      },
      body: JSON.stringify(n)
    },
    schema: Sh
  }),
  delete: async ({ id: e }) => await X({
    agentName: "curriculum",
    url: W.CURRICULUM_PATH(e),
    fetchOptions: {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        ...ne.getBearerHeader()
      }
    },
    schema: yh
  })
}, $h = {
  /**
   * Fetch the list of curriculums
   * @returns The list of curriculums
   */
  fetch: () => X({
    agentName: "fetchCurriculumList",
    url: W.CURRICULUM_LIST_PATH,
    fetchOptions: {
      method: "GET",
      headers: {
        ...ne.getBearerHeader()
      }
    },
    schema: Xc.array()
  })
}, Go = "curriculumList", Wi = () => {
  const e = [Go], {
    // we always want to be able to return something, even if it's an empty array
    data: n = [],
    error: r,
    isLoading: i,
    mutate: t
  } = Pe(e, () => $h.fetch()), { mutate: o } = cn(), a = async (l) => {
    if (l)
      return await o(
        (f) => Array.isArray(f) && f.includes(Go)
      );
    await t();
  }, u = n instanceof Error ? [] : n, s = n instanceof Error ? n : r;
  return {
    data: u,
    isLoading: i,
    error: s,
    actions: {
      refresh: {
        apply: a,
        isLoading: i,
        error: s
      }
    }
  };
}, Fo = "curriculum", Sb = ({ id: e } = {}) => {
  const n = e ? [Fo, e] : null, { data: r, error: i, isLoading: t, mutate: o } = Pe(
    n,
    () => wn.fetch({ id: e ?? "" })
  ), { mutate: a } = cn(), u = async (v) => {
    v && await a(
      (m) => Array.isArray(m) && m.includes(Fo)
    ), await o();
  }, { isCreating: s, create: l } = kh(o), { isUpdating: f, update: c } = Eh(o), { isDeleting: p, deleteCurriculum: _ } = Nh(o), h = r instanceof Error ? null : r, $ = r instanceof Error ? r : i ?? null;
  return {
    data: h,
    error: $,
    isLoading: t,
    actions: {
      refresh: {
        apply: u,
        isLoading: t,
        error: $
      },
      create: {
        apply: l,
        isLoading: s,
        error: $
      },
      update: {
        apply: c,
        isLoading: f,
        error: $
      },
      delete: {
        apply: _,
        isLoading: p,
        error: $
      }
    }
  };
}, Eh = (e) => {
  const [n, r] = Qe(!1), {
    actions: { refresh: i }
  } = Wi();
  return { update: async ({ id: o, payload: a }) => {
    r(!0);
    const u = await wn.update({ id: o, payload: a });
    return u instanceof Q ? (r(!1), u) : (await e(), await i.apply(), r(!1), u);
  }, isUpdating: n };
}, kh = (e) => {
  const [n, r] = Qe(!1), {
    actions: { refresh: i }
  } = Wi();
  return { create: async ({ payload: o, type: a = "create" }) => {
    r(!0);
    const u = await wn.create({
      payload: o,
      type: a
    });
    return u instanceof Q ? (r(!1), u) : (await e(), await i.apply(), r(!1), u);
  }, isCreating: n };
}, Nh = (e) => {
  const [n, r] = Qe(!1), {
    actions: { refresh: i }
  } = Wi();
  return { deleteCurriculum: async ({ id: o }) => {
    r(!0);
    const a = await wn.delete({ id: o });
    return a instanceof Q ? (r(!1), a) : (await e(), await i.apply(), r(!1), a);
  }, isDeleting: n };
}, Oh = (e) => (n, r, i) => (i.revalidateOnFocus = !1, i.revalidateIfStale = !1, i.revalidateOnReconnect = !1, e(n, r, i)), An = nm(Pe, Oh), st = _e([
  "planned",
  "not_yet_planned",
  "planning_in_progress"
]), Qc = O({
  id: b(),
  slug: b(),
  label: b().optional(),
  systemDefault: Y(!0),
  status: st,
  active: H(),
  subjectPlanId: b(),
  // based on the subject each of the requirements that check  users purchased packages and memberships
  userHasAccess: H().optional(),
  // If the default subject is globally set to coming soon
  comingSoon: H().optional(),
  attributes: O({
    subjects: D(b())
  })
  // commenting out for now as it's not important to CA UI
  // entity: z.literal("curriculum_subject"),
}), Th = O({
  id: b(),
  slug: b(),
  label: b(),
  systemDefault: Y(!1),
  status: st,
  active: H(),
  subjectPlanId: b(),
  attributes: O({
    subjects: D(b())
  })
  // commenting out for now as it's not important to CA UI
  // entity: z.literal("curriculum_subject"),
}), ed = re([
  Qc,
  Th
]), td = Qc.omit({
  subjectPlanId: !0
}), Ib = O({
  status: st
}), wh = O({
  id: b(),
  status: st
}), nd = {
  /**
   * Fetch the list of subjects
   * @returns The list of subjects
   */
  fetch: ({ subjectId: e }) => X({
    agentName: "fetchGenericSubject",
    url: W.GENERIC_SUBJECT_PATH(e),
    fetchOptions: {
      method: "GET",
      headers: {
        ...ne.getBearerHeader()
      }
    },
    schema: td
  })
}, Ho = Object.values(le).map(
  (e) => e.monolithId
), Bo = Object.values(le).map(
  (e) => e.slug
), rd = _e([
  Ho[0],
  ...Ho.slice(0)
]), id = _e([
  Bo[0],
  ...Bo.slice(0)
]), Dt = O({
  id: b(),
  title: b(),
  description: b(),
  slug: b(),
  path: b(),
  preview: O({
    path: b(),
    url: b().url(),
    width: K().int(),
    height: K().int()
  }).nullable(),
  cover: O({
    path: b(),
    url: b().url(),
    width: K().int(),
    height: K().int()
  }).nullable().optional(),
  type: re([
    O({
      id: rd
    }),
    lt()
  ]),
  linkedResources: D(b()).optional(),
  order: K().int().optional(),
  enabled: H().optional(),
  approved: H().optional(),
  keyStages: D(b()).optional(),
  keyArt: O({
    url: b().url(),
    path: b(),
    width: K().int(),
    height: K().int()
  }).optional(),
  threads: D(b()).optional()
}), od = Dt.extend({
  linkedResources: D(b()),
  enabled: Y(!0)
}), ad = od.extend({
  approved: Y(!0)
}), Ji = Dt.extend({
  type: O({
    id: Y(le.LESSON_PACK.monolithId)
  }),
  order: K().int(),
  enabled: Y(!0)
}), Ah = Dt.extend({
  type: re([
    O({
      id: rd.refine(
        (e) => e !== le.LESSON_PACK.monolithId
      )
    }),
    lt()
  ]),
  order: K().int().optional()
}), Uh = Dt.extend({
  type: O({
    id: Y(le.LESSON_PACK.monolithId)
  }),
  enabled: bt()
}), Ph = re([
  Ah,
  Uh
]), Me = {
  fetch: ({ id: e }) => X({
    agentName: "twinklResourceApi",
    url: W.external.TWINKL_RESOURCE_API_URL(e),
    fetchOptions: {
      method: "GET"
    },
    schema: Dt
  })
}, Dh = O(
  {
    id: me(),
    order: me(),
    cs_title: b(),
    cs_approved: H(),
    cs_key_art: b(),
    cs_education_programme: me(),
    cs_subject: me(),
    // todo: not sure if this should be options or empty array if no threads
    cs_threads: D(me()).optional(),
    cs_key_stages: D(me())
  },
  {
    error: "Invalid Search Hit"
  }
), Rh = D(Dh, {
  error: "Unexpected Search Data Structure"
}), ud = {
  fetch: async (e) => {
    const n = {
      educationProgramme: "1",
      // Bug: KS are bound only to the JIT default rows. If the user deletes a JIT row, the KS are not bound to them so the resources are missing as far as the user is concerned.
      // keyStages: params?.keyStages?.join(",") || "",
      subject: (e == null ? void 0 : e.subjects) && e.subjects[0] || "",
      // subjects: params?.subjects?.join(",") || "", TODO Need Search API to fix support for this
      limit: "200"
    };
    return Object.keys(n).forEach(
      (r) => n[r] === "" && delete n[r]
    ), await X({
      agentName: "twinklSearchApi",
      url: W.external.TWINKL_SEARCH_API_URL(
        new URLSearchParams(n)
      ),
      fetchOptions: {
        method: "GET"
      },
      schema: Rh
    });
  }
}, sn = (e, n) => {
  fe(
    new Error(
      `Missing linked resource (${n}): ${e}`,
      {
        cause: {
          from: n,
          missing_resource: e
        }
      }
    )
  );
}, zh = (e, n) => {
  fe(
    new Error(
      `Search and resource unit approved mismatch for search unit: ${e} and resource unit: ${n}`,
      {
        cause: {
          search_unit_id: e,
          resource_unit_id: n
        }
      }
    )
  );
}, Yt = {
  1: "en-gb-key-stage-1",
  2: "en-gb-key-stage-2",
  "2,3": "en-gb-key-stage-2",
  "2,4": "en-gb-key-stage-2",
  "2,3,4": "en-gb-key-stage-2",
  "3,4": "en-gb-key-stage-2",
  3: "en-gb-key-stage-lower-2",
  4: "en-gb-key-stage-upper-2",
  "1,2": "en-gb-key-stage-1-and-2",
  "1,2,3,4": "en-gb-key-stage-1-and-2",
  "1,2,3": "en-gb-key-stage-1-and-2",
  "1,2,4": "en-gb-key-stage-1-and-2",
  "1,3,4": "en-gb-key-stage-1-and-2",
  // New year-based key stages (independent)
  5: "year-1",
  6: "year-2",
  7: "year-3",
  8: "year-4",
  9: "year-5",
  10: "year-6",
  // New key stages
  11: "eyfs",
  12: "nursery",
  13: "reception"
}, Ch = /* @__PURE__ */ new Set(["1,3", "1,4"]), qi = (e) => {
  const n = e.slice().sort((o, a) => Number(o) - Number(a)), r = n.filter(
    (o) => Number(o) >= 1 && Number(o) <= 4
  ), i = n.filter(
    (o) => Number(o) >= 5 && Number(o) <= 13
  ), t = [];
  if (i.length > 0 && t.push(
    ...i.map((o) => Yt[o]).filter(Boolean)
  ), r.length > 0) {
    const o = r.join(",");
    Ch.has(o) ? t.push(
      ...r.map((a) => Yt[a]).filter(Boolean)
    ) : Yt[o] && t.push(Yt[o]);
  }
  return t;
}, ld = {
  ONE_TO_ONE_DEVICES: {
    id: 1,
    label: "1:1 Devices",
    slug: "one-to-one-devices",
    order: 1
  },
  TWO_PARTS: {
    id: 2,
    label: "2 Parts",
    slug: "two-parts",
    order: 2
  },
  TWENTIETH_CENTURY: {
    id: 3,
    label: "20th Century",
    slug: "twentieth-century",
    order: 3
  },
  TWENTY_FIRST_CENTURY: {
    id: 4,
    label: "21st Century",
    slug: "twenty-first-century",
    order: 4
  },
  THREE_OR_MORE_PARTS: {
    id: 5,
    label: "3 Or More Parts",
    slug: "three-or-more-parts",
    order: 5
  },
  THREE_D_DESIGN: {
    id: 6,
    label: "3D Design",
    slug: "three-d-design",
    order: 6
  },
  ABSTRACT_ART: {
    id: 7,
    label: "Abstract Art",
    slug: "abstract-art",
    order: 7
  },
  ABSTRACTION: {
    id: 8,
    label: "Abstraction",
    slug: "abstraction",
    order: 8
  },
  ACRYLIC_PAINT: {
    id: 9,
    label: "Acrylic Paint",
    slug: "acrylic-paint",
    order: 9
  },
  ACTING_AND_ASKING: {
    id: 10,
    label: "Acting and Asking",
    slug: "acting-and-asking",
    order: 10
  },
  ACTIVE_LISTENING: {
    id: 11,
    label: "Active Listening",
    slug: "active-listening",
    order: 11
  },
  ADAPTABLE_FOR_LOCAL_STUDY: {
    id: 12,
    label: "Adaptable for Local Study",
    slug: "adaptable-for-local-study",
    order: 12
  },
  ADDITION: {
    id: 540,
    label: "Addition",
    slug: "addition",
    order: 13
  },
  ADDITION_AND_SUBTRACTION: {
    id: 539,
    label: "Addition and Subtraction",
    slug: "addition-and-subtraction",
    order: 14
  },
  ADDITION_FACTS: {
    id: 564,
    label: "Addition Facts",
    slug: "addition-facts",
    order: 15
  },
  ADJECTIVE_AGREEMENT: {
    id: 530,
    label: "Adjective Agreement",
    slug: "adjective-agreement",
    order: 16
  },
  ADVANCED_MANUFACTURING: {
    id: 13,
    label: "Advanced Manufacturing",
    slug: "advanced-manufacturing",
    order: 17
  },
  AFRICA: {
    id: 14,
    label: "Africa",
    slug: "africa",
    order: 18
  },
  AFRICAN_HISTORY: {
    id: 15,
    label: "African History",
    slug: "african-history",
    order: 19
  },
  ALGEBRA: {
    id: 551,
    label: "Algebra",
    slug: "algebra",
    order: 20
  },
  ALGORITHMIC_DESIGN: {
    id: 16,
    label: "Algorithmic Design",
    slug: "algorithmic-design",
    order: 21
  },
  ANALYSE: {
    id: 17,
    label: "Analyse",
    slug: "analyse",
    order: 22
  },
  ANATOMY: {
    id: 18,
    label: "Anatomy",
    slug: "anatomy",
    order: 23
  },
  ANCIENT_CIVILISATIONS: {
    id: 19,
    label: "Ancient Civilisations",
    slug: "ancient-civilisations",
    order: 24
  },
  ANCIENT_HISTORY: {
    id: 20,
    label: "Ancient History",
    slug: "ancient-history",
    order: 25
  },
  ANIMALS_INCLUDING_HUMANS: {
    id: 21,
    label: "Animals Including Humans",
    slug: "animals-including-humans",
    order: 26
  },
  ANIMATION: {
    id: 22,
    label: "Animation",
    slug: "animation",
    order: 27
  },
  ANTARCTICA: {
    id: 23,
    label: "Antarctica",
    slug: "antarctica",
    order: 28
  },
  AQUATIC_PRINCIPLES: {
    id: 24,
    label: "Aquatic Principles",
    slug: "aquatic-principles",
    order: 29
  },
  AREA: {
    id: 556,
    label: "Area",
    slug: "area",
    order: 30
  },
  ART_DECO: {
    id: 25,
    label: "Art Deco",
    slug: "art-deco",
    order: 31
  },
  ART_HISTORY: {
    id: 26,
    label: "Art History",
    slug: "art-history",
    order: 32
  },
  ART_NOUVEAU: {
    id: 27,
    label: "Art Nouveau",
    slug: "art-nouveau",
    order: 33
  },
  ARTEFACTS: {
    id: 28,
    label: "Artefacts",
    slug: "artefacts",
    order: 34
  },
  ARTIFICIAL_INTELLIGENCE: {
    id: 29,
    label: "Artificial Intelligence",
    slug: "artificial-intelligence",
    order: 35
  },
  ASIA: {
    id: 30,
    label: "Asia",
    slug: "asia",
    order: 36
  },
  ASK_QUESTIONS: {
    id: 31,
    label: "Ask Questions",
    slug: "ask-questions",
    order: 37
  },
  ASKING_QUESTIONS: {
    id: 32,
    label: "Asking Questions",
    slug: "asking-questions",
    order: 38
  },
  ATHLETICS: {
    id: 519,
    label: "Athletics",
    slug: "athletics",
    order: 39
  },
  AUDACITY: {
    id: 33,
    label: "Audacity",
    slug: "audacity",
    order: 40
  },
  AUDIO_RECORDING: {
    id: 34,
    label: "Audio Recording",
    slug: "audio-recording",
    order: 41
  },
  AUTHENTIC_MATERIALS: {
    id: 35,
    label: "Authentic Materials",
    slug: "authentic-materials",
    order: 42
  },
  BBC_MICRO_BIT: {
    id: 36,
    label: "BBC Micro:bit",
    slug: "bbc-micro-bit",
    order: 43
  },
  BEAT_PULSE: {
    id: 37,
    label: "Beat/Pulse",
    slug: "beat-pulse",
    order: 44
  },
  BEE_BOT: {
    id: 38,
    label: "Bee-Bot",
    slug: "bee-bot",
    order: 45
  },
  BELIEVING: {
    id: 39,
    label: "Believing",
    slug: "believing",
    order: 46
  },
  BEYOND_LIVING_MEMORY: {
    id: 40,
    label: "Beyond Living Memory",
    slug: "beyond-living-memory",
    order: 47
  },
  BIG_PROJECT: {
    id: 41,
    label: "Big Project",
    slug: "big-project",
    order: 48
  },
  BIG_QUESTION: {
    id: 42,
    label: "Big Question",
    slug: "big-question",
    order: 49
  },
  BIODIVERSITY: {
    id: 43,
    label: "Biodiversity",
    slug: "biodiversity",
    order: 50
  },
  BIOLOGY: {
    id: 44,
    label: "Biology",
    slug: "biology",
    order: 51
  },
  BLENDING: {
    id: 45,
    label: "Blending",
    slug: "blending",
    order: 52
  },
  BLOCK_BASED_CODING: {
    id: 46,
    label: "Block-Based Coding",
    slug: "block-based-coding",
    order: 53
  },
  BODY_AWARENESS: {
    id: 47,
    label: "Body Awareness",
    slug: "body-awareness",
    order: 54
  },
  BORROWING_MONEY_AND_FINANCIAL_RISKS: {
    id: 48,
    label: "Borrowing Money and Financial Risks",
    slug: "borrowing-money-and-financial-risks",
    order: 55
  },
  BREATHING: {
    id: 49,
    label: "Breathing",
    slug: "breathing",
    order: 56
  },
  BRITISH_EMPIRE: {
    id: 50,
    label: "British Empire",
    slug: "british-empire",
    order: 57
  },
  BRITISH_HISTORY: {
    id: 51,
    label: "British History",
    slug: "british-history",
    order: 58
  },
  BRITISH_SCIENCE_WEEK: {
    id: 52,
    label: "British Science Week",
    slug: "british-science-week",
    order: 59
  },
  BUDDHISM: {
    id: 53,
    label: "Buddhism",
    slug: "buddhism",
    order: 60
  },
  CAD_CAM: {
    id: 54,
    label: "CAD/CAM",
    slug: "cad-cam",
    order: 61
  },
  CAMERA_NEEDED: {
    id: 55,
    label: "Camera Needed",
    slug: "camera-needed",
    order: 62
  },
  CAPACITY: {
    id: 555,
    label: "Capacity",
    slug: "capacity",
    order: 63
  },
  CARVING: {
    id: 56,
    label: "Carving",
    slug: "carving",
    order: 64
  },
  CATHOLICISM: {
    id: 57,
    label: "Catholicism",
    slug: "catholicism",
    order: 65
  },
  CAUSE_AND_CONSEQUENCE: {
    id: 58,
    label: "Cause and Consequence",
    slug: "cause-and-consequence",
    order: 66
  },
  CELEBRATING: {
    id: 59,
    label: "Celebrating",
    slug: "celebrating",
    order: 67
  },
  CELEBRATION_LESSON: {
    id: 60,
    label: "Celebration Lesson",
    slug: "celebration-lesson",
    order: 68
  },
  CELEBRATIONS_AND_EVENTS: {
    id: 61,
    label: "Celebrations and Events",
    slug: "celebrations-and-events",
    order: 69
  },
  CERAMICS: {
    id: 62,
    label: "Ceramics",
    slug: "ceramics",
    order: 70
  },
  CHALLENGE_LESSON: {
    id: 63,
    label: "Challenge Lesson",
    slug: "challenge-lesson",
    order: 71
  },
  CHARCOAL: {
    id: 64,
    label: "Charcoal",
    slug: "charcoal",
    order: 72
  },
  CHEMISTRY: {
    id: 65,
    label: "Chemistry",
    slug: "chemistry",
    order: 73
  },
  CHIAROSCURO: {
    id: 66,
    label: "Chiaroscuro",
    slug: "chiaroscuro",
    order: 74
  },
  CHRISTIANITY: {
    id: 67,
    label: "Christianity",
    slug: "christianity",
    order: 75
  },
  CHROMEBOOKS: {
    id: 68,
    label: "Chromebooks",
    slug: "chromebooks",
    order: 76
  },
  CHRONOLOGICAL_UNDERSTANDING: {
    id: 69,
    label: "Chronological Understanding",
    slug: "chronological-understanding",
    order: 77
  },
  CIVILISATION_AND_SOCIETY: {
    id: 70,
    label: "Civilisation and Society",
    slug: "civilisation-and-society",
    order: 78
  },
  CLASSROOM_INSTRUCTIONS: {
    id: 71,
    label: "Classroom Instructions",
    slug: "classroom-instructions",
    order: 79
  },
  CLAY: {
    id: 72,
    label: "Clay",
    slug: "clay",
    order: 80
  },
  CLIMATE_CHANGE: {
    id: 73,
    label: "Climate Change",
    slug: "climate-change",
    order: 81
  },
  CLIMATE_CHANGE_AND_SUSTAINABILITY: {
    id: 534,
    label: "Climate Change and Sustainability",
    slug: "climate-change-and-sustainability",
    order: 82
  },
  COLLABORATION_AND_TEAMWORK: {
    id: 74,
    label: "Collaboration And Teamwork",
    slug: "collaboration-and-teamwork",
    order: 83
  },
  COLLAGE: {
    id: 75,
    label: "Collage",
    slug: "collage",
    order: 84
  },
  COLLECT_DATA: {
    id: 76,
    label: "Collect Data",
    slug: "collect-data",
    order: 85
  },
  COLOUR: {
    id: 77,
    label: "Colour",
    slug: "colour",
    order: 86
  },
  COLOURED_PENCIL: {
    id: 78,
    label: "Coloured Pencil",
    slug: "coloured-pencil",
    order: 87
  },
  COMBINING_AND_APPLYING_MOVEMENT_SKILLS: {
    id: 79,
    label: "Combining and Applying Movement Skills",
    slug: "combining-and-applying-movement-skills",
    order: 88
  },
  COMMANDS_IMPERATIVE: {
    id: 528,
    label: "Commands (Imperative)",
    slug: "commands-imperative",
    order: 89
  },
  COMMUNICATION_SKILLS: {
    id: 80,
    label: "Communication Skills",
    slug: "communication-skills",
    order: 90
  },
  COMPARATIVE_AND_FAIR_TESTING: {
    id: 81,
    label: "Comparative and Fair Testing",
    slug: "comparative-and-fair-testing",
    order: 91
  },
  COMPARE_AND_CONTRAST: {
    id: 82,
    label: "Compare and Contrast",
    slug: "compare-and-contrast",
    order: 92
  },
  COMPASS_POINTS: {
    id: 83,
    label: "Compass Points",
    slug: "compass-points",
    order: 93
  },
  COMPETITION_LESSON: {
    id: 84,
    label: "Competition Lesson",
    slug: "competition-lesson",
    order: 94
  },
  COMPOSITION: {
    id: 85,
    label: "Composition",
    slug: "composition",
    order: 95
  },
  COMPREHENSION_SKILLS: {
    id: 86,
    label: "Comprehension Skills",
    slug: "comprehension-skills",
    order: 96
  },
  COMPUTATIONAL_THINKING: {
    id: 87,
    label: "Computational Thinking",
    slug: "computational-thinking",
    order: 97
  },
  COMPUTER_SCIENCE: {
    id: 88,
    label: "Computer Science",
    slug: "computer-science",
    order: 98
  },
  COMPUTER_SYSTEMS_AND_NETWORKS: {
    id: 89,
    label: "Computer Systems And Networks",
    slug: "computer-systems-and-networks",
    order: 99
  },
  CONDITIONAL: {
    id: 531,
    label: "Conditional",
    slug: "conditional",
    order: 100
  },
  CONFLICT_AND_WAR: {
    id: 90,
    label: "Conflict & War",
    slug: "conflict-and-war",
    order: 101
  },
  CONJUGATING_VERBS: {
    id: 91,
    label: "Conjugating Verbs",
    slug: "conjugating-verbs",
    order: 102
  },
  CONNECTIONS_SIMILARITIES_AND_DIFFERENCES: {
    id: 92,
    label: "Connections, Similarities and Differences",
    slug: "connections-similarities-and-differences",
    order: 103
  },
  CONSTRAINT_BASED_DESIGN: {
    id: 93,
    label: "Constraint-Based Design",
    slug: "constraint-based-design",
    order: 104
  },
  CONTEMPORARY_ART: {
    id: 94,
    label: "Contemporary Art",
    slug: "contemporary-art",
    order: 105
  },
  CONTINUITY_AND_CHANGE: {
    id: 95,
    label: "Continuity and Change",
    slug: "continuity-and-change",
    order: 106
  },
  CONTOURS: {
    id: 96,
    label: "Contours",
    slug: "contours",
    order: 107
  },
  CONTRASTING_PLACES: {
    id: 97,
    label: "Contrasting Places",
    slug: "contrasting-places",
    order: 108
  },
  CONVERTING_UNITS: {
    id: 560,
    label: "Converting Units",
    slug: "converting-units",
    order: 109
  },
  COOKING_AND_NUTRITION: {
    id: 98,
    label: "Cooking & Nutrition",
    slug: "cooking-and-nutrition",
    order: 110
  },
  COPYRIGHT_AND_OWNERSHIP: {
    id: 99,
    label: "Copyright And Ownership",
    slug: "copyright-and-ownership",
    order: 111
  },
  CREATING_MEDIA: {
    id: 100,
    label: "Creating Media",
    slug: "creating-media",
    order: 112
  },
  CREATIVE_AND_CRITICAL_THINKING: {
    id: 101,
    label: "Creative and Critical Thinking",
    slug: "creative-and-critical-thinking",
    order: 113
  },
  CREATIVITY: {
    id: 102,
    label: "Creativity",
    slug: "creativity",
    order: 114
  },
  CRITICAL_THINKING: {
    id: 103,
    label: "Critical Thinking",
    slug: "critical-thinking",
    order: 115
  },
  CRITICAL_THINKING_ONLINE: {
    id: 104,
    label: "Critical Thinking Online",
    slug: "critical-thinking-online",
    order: 116
  },
  CROSS_CURRICULAR: {
    id: 105,
    label: "Cross-Curricular",
    slug: "cross-curricular",
    order: 117
  },
  CROSS_CURRICULAR_LINKS: {
    id: 106,
    label: "Cross-Curricular Links",
    slug: "cross-curricular-links",
    order: 118
  },
  CROSS_HATCHING: {
    id: 107,
    label: "Cross-hatching",
    slug: "cross-hatching",
    order: 119
  },
  CUBISM: {
    id: 108,
    label: "Cubism",
    slug: "cubism",
    order: 120
  },
  CULTURAL: {
    id: 109,
    label: "Cultural",
    slug: "cultural",
    order: 121
  },
  CULTURAL_CAPITAL: {
    id: 110,
    label: "Cultural Capital",
    slug: "cultural-capital",
    order: 122
  },
  DADA: {
    id: 111,
    label: "Dada",
    slug: "dada",
    order: 123
  },
  DANCE: {
    id: 512,
    label: "Dance",
    slug: "dance",
    order: 124
  },
  DATA_AND_INFORMATION: {
    id: 112,
    label: "Data And Information",
    slug: "data-and-information",
    order: 125
  },
  DEBUGGING: {
    id: 113,
    label: "Debugging",
    slug: "debugging",
    order: 126
  },
  DECIMALS: {
    id: 545,
    label: "Decimals",
    slug: "decimals",
    order: 127
  },
  DECISION_MAKING: {
    id: 114,
    label: "Decision-Making",
    slug: "decision-making",
    order: 128
  },
  DECOMPOSITION: {
    id: 115,
    label: "Decomposition",
    slug: "decomposition",
    order: 129
  },
  DEMOCRACY: {
    id: 116,
    label: "Democracy",
    slug: "democracy",
    order: 130
  },
  DESIGN: {
    id: 117,
    label: "Design",
    slug: "design",
    order: 131
  },
  DESKTOP_PCS: {
    id: 118,
    label: "Desktop PCs",
    slug: "desktop-pcs",
    order: 132
  },
  DICTIONARY_SKILLS: {
    id: 119,
    label: "Dictionary Skills",
    slug: "dictionary-skills",
    order: 133
  },
  DIGITAL: {
    id: 120,
    label: "Digital",
    slug: "digital",
    order: 134
  },
  DIGITAL_ART: {
    id: 121,
    label: "Digital Art",
    slug: "digital-art",
    order: 135
  },
  DIGITAL_CITIZENSHIP: {
    id: 122,
    label: "Digital Citizenship",
    slug: "digital-citizenship",
    order: 136
  },
  DIGITAL_CONTENT_CREATION: {
    id: 123,
    label: "Digital Content Creation",
    slug: "digital-content-creation",
    order: 137
  },
  DIGITAL_FOOTPRINT: {
    id: 124,
    label: "Digital Footprint",
    slug: "digital-footprint",
    order: 138
  },
  DIGITAL_FOUNDATIONS: {
    id: 125,
    label: "Digital Foundations",
    slug: "digital-foundations",
    order: 139
  },
  DIGITAL_LITERACY: {
    id: 126,
    label: "Digital Literacy",
    slug: "digital-literacy",
    order: 140
  },
  DIGITAL_SKILLS: {
    id: 127,
    label: "Digital Skills",
    slug: "digital-skills",
    order: 141
  },
  DIGITAL_TECHNOLOGIES: {
    id: 128,
    label: "Digital Technologies",
    slug: "digital-technologies",
    order: 142
  },
  DIGITAL_CONTROL_SYSTEMS: {
    id: 129,
    label: "Digital/Control Systems",
    slug: "digital-control-systems",
    order: 143
  },
  DISCIPLINARY: {
    id: 130,
    label: "Disciplinary",
    slug: "disciplinary",
    order: 144
  },
  DIVERSITY: {
    id: 131,
    label: "Diversity",
    slug: "diversity",
    order: 145
  },
  DIVISION: {
    id: 544,
    label: "Division",
    slug: "division",
    order: 146
  },
  DOT_NOTATION: {
    id: 132,
    label: "Dot Notation",
    slug: "dot-notation",
    order: 147
  },
  DRAWING: {
    id: 133,
    label: "Drawing",
    slug: "drawing",
    order: 148
  },
  DRAWING_CONCLUSIONS: {
    id: 134,
    label: "Drawing Conclusions",
    slug: "drawing-conclusions",
    order: 149
  },
  DYNAMIC_ART: {
    id: 135,
    label: "Dynamic Art",
    slug: "dynamic-art",
    order: 150
  },
  DYNAMICS: {
    id: 136,
    label: "Dynamics",
    slug: "dynamics",
    order: 151
  },
  EARTH_AND_SPACE: {
    id: 138,
    label: "Earth and Space",
    slug: "earth-and-space",
    order: 152
  },
  EARTH_PROCESSES: {
    id: 137,
    label: "Earth Processes",
    slug: "earth-processes",
    order: 153
  },
  EARTHS_CLIMATE_CYCLES: {
    id: 139,
    label: "Earth’s Climate & Cycles",
    slug: "earths-climate-cycles",
    order: 154
  },
  EDUCATIONAL_VISIT_OPPORTUNITY: {
    id: 140,
    label: "Educational Visit Opportunity",
    slug: "educational-visit-opportunity",
    order: 155
  },
  ELECTRICAL_SYSTEMS: {
    id: 141,
    label: "Electrical Systems",
    slug: "electrical-systems",
    order: 156
  },
  ELECTRICITY: {
    id: 142,
    label: "Electricity",
    slug: "electricity",
    order: 157
  },
  ELEMENTS_OF_DANCE: {
    id: 143,
    label: "Elements of Dance",
    slug: "elements-of-dance",
    order: 158
  },
  EMOTIONAL_REGULATION: {
    id: 144,
    label: "Emotional Regulation",
    slug: "emotional-regulation",
    order: 159
  },
  EMOTIONS: {
    id: 145,
    label: "Emotions",
    slug: "emotions",
    order: 160
  },
  EMPIRE: {
    id: 146,
    label: "Empire",
    slug: "empire",
    order: 161
  },
  ENERGY: {
    id: 147,
    label: "Energy",
    slug: "energy",
    order: 162
  },
  ENERGY_SYSTEMS: {
    id: 148,
    label: "Energy Systems",
    slug: "energy-systems",
    order: 163
  },
  ENGLISH_HISTORY: {
    id: 149,
    label: "English History",
    slug: "english-history",
    order: 164
  },
  ENQUIRY: {
    id: 150,
    label: "Enquiry",
    slug: "enquiry",
    order: 165
  },
  ENTERPRISE: {
    id: 151,
    label: "Enterprise",
    slug: "enterprise",
    order: 166
  },
  ENVIRONMENT: {
    id: 152,
    label: "Environment",
    slug: "environment",
    order: 167
  },
  ENVIRONMENTAL_HISTORY: {
    id: 153,
    label: "Environmental History",
    slug: "environmental-history",
    order: 168
  },
  ENVIRONMENTAL_HISTORY_AND_SUSTAINABILITY: {
    id: 154,
    label: "Environmental History and Sustainability",
    slug: "environmental-history-and-sustainability",
    order: 169
  },
  ENVIRONMENTAL_IMPACT_SUSTAINABILITY: {
    id: 155,
    label: "Environmental Impact / Sustainability",
    slug: "environmental-impact-sustainability",
    order: 170
  },
  ERGONOMICS_SAFETY: {
    id: 156,
    label: "Ergonomics & Safety",
    slug: "ergonomics-safety",
    order: 171
  },
  ETHICAL_DESIGN: {
    id: 157,
    label: "Ethical Design",
    slug: "ethical-design",
    order: 172
  },
  EUROPE: {
    id: 158,
    label: "Europe",
    slug: "europe",
    order: 173
  },
  EUROPEAN_HISTORY: {
    id: 159,
    label: "European History",
    slug: "european-history",
    order: 174
  },
  EVALUATE: {
    id: 160,
    label: "Evaluate",
    slug: "evaluate",
    order: 175
  },
  EVALUATING_AN_ENQUIRY: {
    id: 162,
    label: "Evaluating an Enquiry",
    slug: "evaluating-an-enquiry",
    order: 176
  },
  EVALUATING_ONLINE_CONTENT: {
    id: 161,
    label: "Evaluating Online Content",
    slug: "evaluating-online-content",
    order: 177
  },
  EVALUATION: {
    id: 163,
    label: "Evaluation",
    slug: "evaluation",
    order: 178
  },
  EVALUATION_AND_REFLECTION: {
    id: 164,
    label: "Evaluation and Reflection",
    slug: "evaluation-and-reflection",
    order: 179
  },
  EVENTS_LESSON: {
    id: 165,
    label: "Events Lesson",
    slug: "events-lesson",
    order: 180
  },
  EVOLUTION_AND_INHERITANCE: {
    id: 166,
    label: "Evolution and Inheritance",
    slug: "evolution-and-inheritance",
    order: 181
  },
  EXECUTION_OF_MOVEMENT: {
    id: 167,
    label: "Execution of Movement",
    slug: "execution-of-movement",
    order: 182
  },
  EXPLORING_MUSICAL_GENRES: {
    id: 521,
    label: "Exploring Musical Genres",
    slug: "exploring-musical-genres",
    order: 183
  },
  EXPRESSING: {
    id: 168,
    label: "Expressing",
    slug: "expressing",
    order: 184
  },
  EXPRESSIONISM: {
    id: 169,
    label: "Expressionism",
    slug: "expressionism",
    order: 185
  },
  FAILURE_ANALYSIS: {
    id: 170,
    label: "Failure Analysis",
    slug: "failure-analysis",
    order: 186
  },
  FAUVISM: {
    id: 171,
    label: "Fauvism",
    slug: "fauvism",
    order: 187
  },
  FELT_PENS: {
    id: 172,
    label: "Felt Pens",
    slug: "felt-pens",
    order: 188
  },
  FESTIVAL_OF_FIELDWORK: {
    id: 173,
    label: "Festival of Fieldwork",
    slug: "festival-of-fieldwork",
    order: 189
  },
  FESTIVALS_AND_EVENTS: {
    id: 174,
    label: "Festivals and Events",
    slug: "festivals-and-events",
    order: 190
  },
  FIELD_TRIP_OPPORTUNITY: {
    id: 175,
    label: "Field Trip Opportunity",
    slug: "field-trip-opportunity",
    order: 191
  },
  FIELDWORK_ENQUIRY: {
    id: 176,
    label: "Fieldwork Enquiry",
    slug: "fieldwork-enquiry",
    order: 192
  },
  FILE_MANAGEMENT: {
    id: 177,
    label: "File Management",
    slug: "file-management",
    order: 193
  },
  FINANCIAL_EDUCATION: {
    id: 178,
    label: "Financial Education",
    slug: "financial-education",
    order: 194
  },
  FINANCIAL_LITERACY: {
    id: 537,
    label: "Financial Literacy",
    slug: "financial-literacy",
    order: 195
  },
  FINE_MOTOR_SKILLS: {
    id: 179,
    label: "Fine Motor Skills",
    slug: "fine-motor-skills",
    order: 196
  },
  FLOTATION: {
    id: 180,
    label: "Flotation",
    slug: "flotation",
    order: 197
  },
  FORCES: {
    id: 181,
    label: "Forces",
    slug: "forces",
    order: 198
  },
  FORCES_MOTION: {
    id: 182,
    label: "Forces & Motion",
    slug: "forces-motion",
    order: 199
  },
  FORCES_AND_MAGNETS: {
    id: 535,
    label: "Forces and Magnets",
    slug: "forces-and-magnets",
    order: 200
  },
  FORM: {
    id: 183,
    label: "Form",
    slug: "form",
    order: 201
  },
  FOUNDATIONAL_KNOWLEDGE: {
    id: 565,
    label: "Foundational Knowledge",
    slug: "foundational-knowledge",
    order: 202
  },
  FRACTIONS: {
    id: 546,
    label: "Fractions",
    slug: "fractions",
    order: 203
  },
  FUNDAMENTAL_MOVEMENT_SKILLS: {
    id: 517,
    label: "Fundamental Movement Skills",
    slug: "fundamental-movement-skills",
    order: 204
  },
  FUTURE_TECHNOLOGIES: {
    id: 184,
    label: "Future Technologies",
    slug: "future-technologies",
    order: 205
  },
  FUTURISM: {
    id: 185,
    label: "Futurism",
    slug: "futurism",
    order: 206
  },
  GATHERING_DATA: {
    id: 188,
    label: "Gathering Data",
    slug: "gathering-data",
    order: 207
  },
  GEORGIANS: {
    id: 189,
    label: "Georgians",
    slug: "georgians",
    order: 208
  },
  GIFS: {
    id: 186,
    label: "GIFs",
    slug: "gifs",
    order: 209
  },
  GIS: {
    id: 187,
    label: "GIS",
    slug: "gis",
    order: 210
  },
  GLASS: {
    id: 190,
    label: "Glass",
    slug: "glass",
    order: 211
  },
  GLOBAL_CITIZENSHIP: {
    id: 191,
    label: "Global Citizenship",
    slug: "global-citizenship",
    order: 212
  },
  GOOGLE_DOCS: {
    id: 192,
    label: "Google Docs",
    slug: "google-docs",
    order: 213
  },
  GOOGLE_DRIVE: {
    id: 193,
    label: "Google Drive",
    slug: "google-drive",
    order: 214
  },
  GOOGLE_SHEETS: {
    id: 194,
    label: "Google Sheets",
    slug: "google-sheets",
    order: 215
  },
  GOOGLE_SLIDES: {
    id: 195,
    label: "Google Slides",
    slug: "google-slides",
    order: 216
  },
  GOTHIC_ART: {
    id: 196,
    label: "Gothic Art",
    slug: "gothic-art",
    order: 217
  },
  GOUACHE: {
    id: 197,
    label: "Gouache",
    slug: "gouache",
    order: 218
  },
  GRAMMAR: {
    id: 198,
    label: "Grammar",
    slug: "grammar",
    order: 219
  },
  GRAPHIC_SCORES: {
    id: 199,
    label: "Graphic Scores",
    slug: "graphic-scores",
    order: 220
  },
  GREEN_CAREERS: {
    id: 200,
    label: "Green Careers",
    slug: "green-careers",
    order: 221
  },
  GRID_REFERENCES: {
    id: 201,
    label: "Grid References",
    slug: "grid-references",
    order: 222
  },
  GROSS_MOTOR_SKILLS: {
    id: 202,
    label: "Gross Motor Skills",
    slug: "gross-motor-skills",
    order: 223
  },
  GYMNASTICS: {
    id: 513,
    label: "Gymnastics",
    slug: "gymnastics",
    order: 224
  },
  HARDWARE: {
    id: 203,
    label: "Hardware",
    slug: "hardware",
    order: 225
  },
  HEALTH_AND_FITNESS: {
    id: 518,
    label: "Health and Fitness",
    slug: "health-and-fitness",
    order: 226
  },
  HEALTH_AND_WELLBEING: {
    id: 207,
    label: "Health and Wellbeing",
    slug: "health-and-wellbeing",
    order: 227
  },
  HEALTH_WELLBEING_AND_LIFESTYLE: {
    id: 204,
    label: "Health, Wellbeing And Lifestyle",
    slug: "health-wellbeing-and-lifestyle",
    order: 228
  },
  HEALTHY_AND_ACTIVE_LIFESTYLE: {
    id: 206,
    label: "Healthy and Active Lifestyle",
    slug: "healthy-and-active-lifestyle",
    order: 229
  },
  HEALTHY_PARTICIPATION_FOCUS: {
    id: 205,
    label: "Healthy Participation Focus",
    slug: "healthy-participation-focus",
    order: 230
  },
  HIGH_FREQUENCY_VERBS: {
    id: 208,
    label: "High-Frequency Verbs",
    slug: "high-frequency-verbs",
    order: 231
  },
  HINDU_DHARMA: {
    id: 209,
    label: "Hindu Dharma",
    slug: "hindu-dharma",
    order: 232
  },
  HISTORICAL: {
    id: 210,
    label: "Historical",
    slug: "historical",
    order: 233
  },
  HISTORICAL_INTERPRETATIONS: {
    id: 211,
    label: "Historical Interpretations",
    slug: "historical-interpretations",
    order: 234
  },
  HISTORICAL_INVESTIGATIONS: {
    id: 212,
    label: "Historical Investigations",
    slug: "historical-investigations",
    order: 235
  },
  HISTORICAL_SIGNIFICANCE: {
    id: 213,
    label: "Historical Significance",
    slug: "historical-significance",
    order: 236
  },
  HISTORY: {
    id: 511,
    label: "History",
    slug: "history",
    order: 237
  },
  HISTORY_OF_DISABILITY: {
    id: 214,
    label: "History of Disability",
    slug: "history-of-disability",
    order: 238
  },
  HUMAN_AND_PHYSICAL_FEATURES: {
    id: 216,
    label: "Human and Physical Features",
    slug: "human-and-physical-features",
    order: 239
  },
  HUMAN_AND_PHYSICAL_GEOGRAPHY: {
    id: 217,
    label: "Human and Physical Geography",
    slug: "human-and-physical-geography",
    order: 240
  },
  HUMAN_FACTORS_ERGONOMICS: {
    id: 215,
    label: "Human Factors / Ergonomics",
    slug: "human-factors-ergonomics",
    order: 241
  },
  HUMAN_GEOGRAPHY: {
    id: 508,
    label: "Human Geography",
    slug: "human-geography",
    order: 242
  },
  HUMANISM: {
    id: 218,
    label: "Humanism",
    slug: "humanism",
    order: 243
  },
  IDENTIFYING_GROUPING_AND_CLASSIFYING: {
    id: 219,
    label: "Identifying, Grouping and Classifying",
    slug: "identifying-grouping-and-classifying",
    order: 244
  },
  IDENTITY_AND_EXPRESSION: {
    id: 524,
    label: "Identity and Expression",
    slug: "identity-and-expression",
    order: 245
  },
  IMAGINATION: {
    id: 220,
    label: "Imagination",
    slug: "imagination",
    order: 246
  },
  IMPASTO: {
    id: 221,
    label: "Impasto",
    slug: "impasto",
    order: 247
  },
  IMPRESSIONISM: {
    id: 222,
    label: "Impressionism",
    slug: "impressionism",
    order: 248
  },
  IMPROVISING_WITH_INSTRUMENTS: {
    id: 223,
    label: "Improvising With Instruments",
    slug: "improvising-with-instruments",
    order: 249
  },
  IMPROVISING_WITH_VOICE: {
    id: 224,
    label: "Improvising With Voice",
    slug: "improvising-with-voice",
    order: 250
  },
  INDEPENDENT_READING: {
    id: 225,
    label: "Independent Reading",
    slug: "independent-reading",
    order: 251
  },
  INDEPENDENT_STUDY: {
    id: 226,
    label: "Independent Study",
    slug: "independent-study",
    order: 252
  },
  INDEPENDENT_WRITING: {
    id: 227,
    label: "Independent Writing",
    slug: "independent-writing",
    order: 253
  },
  INDIVIDUAL: {
    id: 228,
    label: "Individual",
    slug: "individual",
    order: 254
  },
  INDIVIDUAL_LIBERTY: {
    id: 229,
    label: "Individual Liberty",
    slug: "individual-liberty",
    order: 255
  },
  INDUSTRIAL_REVOLUTION: {
    id: 230,
    label: "Industrial Revolution",
    slug: "industrial-revolution",
    order: 256
  },
  INFORMATION_TECHNOLOGY: {
    id: 231,
    label: "Information Technology",
    slug: "information-technology",
    order: 257
  },
  INK: {
    id: 232,
    label: "Ink",
    slug: "ink",
    order: 258
  },
  INNOVATION: {
    id: 233,
    label: "Innovation",
    slug: "innovation",
    order: 259
  },
  INPUTS_AND_OUTPUTS: {
    id: 234,
    label: "Inputs and Outputs",
    slug: "inputs-and-outputs",
    order: 260
  },
  INQUIRY_BASED: {
    id: 235,
    label: "Inquiry-Based",
    slug: "inquiry-based",
    order: 261
  },
  INSTALLATION_ART: {
    id: 236,
    label: "Installation Art",
    slug: "installation-art",
    order: 262
  },
  INTONATION: {
    id: 237,
    label: "Intonation",
    slug: "intonation",
    order: 263
  },
  INVASION_GAMES: {
    id: 514,
    label: "Invasion Games",
    slug: "invasion-games",
    order: 264
  },
  ISLAM: {
    id: 238,
    label: "Islam",
    slug: "islam",
    order: 265
  },
  ITERATION: {
    id: 239,
    label: "Iteration",
    slug: "iteration",
    order: 266
  },
  JOBS_AND_ASPIRATIONS: {
    id: 240,
    label: "Jobs and Aspirations",
    slug: "jobs-and-aspirations",
    order: 267
  },
  JUDAISM: {
    id: 241,
    label: "Judaism",
    slug: "judaism",
    order: 268
  },
  LANGUAGE_CONVENTIONS: {
    id: 243,
    label: "Language Conventions",
    slug: "language-conventions",
    order: 269
  },
  LANGUAGE_LEARNING_STRATEGIES: {
    id: 244,
    label: "Language-learning Strategies",
    slug: "language-learning-strategies",
    order: 270
  },
  LAPTOPS: {
    id: 245,
    label: "Laptops",
    slug: "laptops",
    order: 271
  },
  LEADING: {
    id: 246,
    label: "Leading",
    slug: "leading",
    order: 272
  },
  LENGTH: {
    id: 552,
    label: "Length",
    slug: "length",
    order: 273
  },
  LGBTQ_HISTORY: {
    id: 242,
    label: "LGBTQ+ History",
    slug: "lgbtq-history",
    order: 274
  },
  LIFE_DRAWING: {
    id: 247,
    label: "Life Drawing",
    slug: "life-drawing",
    order: 275
  },
  LIFESTYLE_AND_WELLBEING: {
    id: 523,
    label: "Lifestyle and Wellbeing",
    slug: "lifestyle-and-wellbeing",
    order: 276
  },
  LIGHT: {
    id: 248,
    label: "Light",
    slug: "light",
    order: 277
  },
  LINE: {
    id: 249,
    label: "Line",
    slug: "line",
    order: 278
  },
  LINK_TO_MUSEUM: {
    id: 250,
    label: "Link to Museum",
    slug: "link-to-museum",
    order: 279
  },
  LISTENING: {
    id: 251,
    label: "Listening",
    slug: "listening",
    order: 280
  },
  LIVING_THINGS_AND_THEIR_HABITATS: {
    id: 252,
    label: "Living Things and Their Habitats",
    slug: "living-things-and-their-habitats",
    order: 281
  },
  LOCAL_AREA: {
    id: 253,
    label: "Local Area",
    slug: "local-area",
    order: 282
  },
  LOCAL_HISTORY_OPPORTUNITY: {
    id: 254,
    label: "Local History Opportunity",
    slug: "local-history-opportunity",
    order: 283
  },
  LOCAL_STUDY: {
    id: 255,
    label: "Local Study",
    slug: "local-study",
    order: 284
  },
  LOCATIONAL_KNOWLEDGE: {
    id: 256,
    label: "Locational Knowledge",
    slug: "locational-knowledge",
    order: 285
  },
  LOCOMOTOR_SKILLS: {
    id: 257,
    label: "Locomotor Skills",
    slug: "locomotor-skills",
    order: 286
  },
  LOGICAL_REASONING: {
    id: 258,
    label: "Logical Reasoning",
    slug: "logical-reasoning",
    order: 287
  },
  LOGICAL_THINKING: {
    id: 259,
    label: "Logical Thinking",
    slug: "logical-thinking",
    order: 288
  },
  LOGO: {
    id: 260,
    label: "Logo",
    slug: "logo",
    order: 289
  },
  MAGNETS: {
    id: 261,
    label: "Magnets",
    slug: "magnets",
    order: 290
  },
  MAJOR_CHORDS: {
    id: 262,
    label: "Major Chords",
    slug: "major-chords",
    order: 291
  },
  MAKE: {
    id: 263,
    label: "Make",
    slug: "make",
    order: 292
  },
  MAKECODE: {
    id: 264,
    label: "MakeCode",
    slug: "makecode",
    order: 293
  },
  MAKING_OF_GREAT_BRITAIN: {
    id: 266,
    label: "Making of Great Britain",
    slug: "making-of-great-britain",
    order: 294
  },
  MAKING_OF_THE_UK: {
    id: 267,
    label: "Making of the UK",
    slug: "making-of-the-uk",
    order: 295
  },
  MAKING_PREDICTIONS: {
    id: 265,
    label: "Making Predictions",
    slug: "making-predictions",
    order: 296
  },
  MANAGING_ONLINE_INFORMATION: {
    id: 268,
    label: "Managing Online Information",
    slug: "managing-online-information",
    order: 297
  },
  MANIPULATIVE_SKILLS: {
    id: 269,
    label: "Manipulative Skills",
    slug: "manipulative-skills",
    order: 298
  },
  MAP_SKILLS: {
    id: 270,
    label: "Map Skills",
    slug: "map-skills",
    order: 299
  },
  MASS: {
    id: 554,
    label: "Mass",
    slug: "mass",
    order: 300
  },
  MASS_AND_CAPACITY: {
    id: 553,
    label: "Mass and Capacity",
    slug: "mass-and-capacity",
    order: 301
  },
  MATERIAL_PROPERTIES: {
    id: 271,
    label: "Material Properties",
    slug: "material-properties",
    order: 302
  },
  MATERIALS: {
    id: 272,
    label: "Materials",
    slug: "materials",
    order: 303
  },
  MATHS_LINKS: {
    id: 273,
    label: "Maths Links",
    slug: "maths-links",
    order: 304
  },
  MECHANISMS: {
    id: 274,
    label: "Mechanisms",
    slug: "mechanisms",
    order: 305
  },
  MEDIEVAL_HISTORY: {
    id: 275,
    label: "Medieval History",
    slug: "medieval-history",
    order: 306
  },
  MELODIC_COMPOSITION: {
    id: 276,
    label: "Melodic Composition",
    slug: "melodic-composition",
    order: 307
  },
  MEMORY_SKILLS: {
    id: 277,
    label: "Memory Skills",
    slug: "memory-skills",
    order: 308
  },
  MICROCONTROLLERS: {
    id: 278,
    label: "Microcontrollers",
    slug: "microcontrollers",
    order: 309
  },
  MICROPHONE_NEEDED: {
    id: 279,
    label: "Microphone Needed",
    slug: "microphone-needed",
    order: 310
  },
  MICROSOFT_EXCEL: {
    id: 280,
    label: "Microsoft Excel",
    slug: "microsoft-excel",
    order: 311
  },
  MICROSOFT_POWERPOINT: {
    id: 281,
    label: "Microsoft PowerPoint",
    slug: "microsoft-powerpoint",
    order: 312
  },
  MICROSOFT_WORD: {
    id: 282,
    label: "Microsoft Word",
    slug: "microsoft-word",
    order: 313
  },
  MIGRATION_SETTLEMENT_INVASION: {
    id: 283,
    label: "Migration, Settlement & Invasion",
    slug: "migration-settlement-invasion",
    order: 314
  },
  MINOR_CHORDS: {
    id: 284,
    label: "Minor Chords",
    slug: "minor-chords",
    order: 315
  },
  MODELLING: {
    id: 285,
    label: "Modelling",
    slug: "modelling",
    order: 316
  },
  MODERN_HISTORY: {
    id: 286,
    label: "Modern History",
    slug: "modern-history",
    order: 317
  },
  MONEY: {
    id: 559,
    label: "Money",
    slug: "money",
    order: 318
  },
  MONEY_OURSELVES_AND_OUR_ENVIRONMENT: {
    id: 287,
    label: "Money, Ourselves and Our Environment",
    slug: "money-ourselves-and-our-environment",
    order: 319
  },
  MORAL: {
    id: 288,
    label: "Moral",
    slug: "moral",
    order: 320
  },
  MOTOR_COMPETENCE_FOCUS: {
    id: 289,
    label: "Motor Competence Focus",
    slug: "motor-competence-focus",
    order: 321
  },
  MOUSE_AND_KEYBOARD_SKILLS: {
    id: 290,
    label: "Mouse and Keyboard Skills",
    slug: "mouse-and-keyboard-skills",
    order: 322
  },
  MOVING_TO_MUSIC: {
    id: 291,
    label: "Moving to Music",
    slug: "moving-to-music",
    order: 323
  },
  MULTILINGUALISM: {
    id: 292,
    label: "Multilingualism",
    slug: "multilingualism",
    order: 324
  },
  MULTIPLICATION: {
    id: 543,
    label: "Multiplication",
    slug: "multiplication",
    order: 325
  },
  MULTIPLICATION_AND_DIVISION: {
    id: 542,
    label: "Multiplication and Division",
    slug: "multiplication-and-division",
    order: 326
  },
  MUSIC_AROUND_THE_WORLD: {
    id: 293,
    label: "Music Around the World",
    slug: "music-around-the-world",
    order: 327
  },
  MUTUAL_RESPECT: {
    id: 294,
    label: "Mutual Respect",
    slug: "mutual-respect",
    order: 328
  },
  NATURAL_MATERIALS: {
    id: 295,
    label: "Natural Materials",
    slug: "natural-materials",
    order: 329
  },
  NEAR_FUTURE: {
    id: 527,
    label: "Near Future",
    slug: "near-future",
    order: 330
  },
  NET_AND_WALL: {
    id: 515,
    label: "Net and Wall",
    slug: "net-and-wall",
    order: 331
  },
  NON_RELIGIOUS_WORLDVIEWS: {
    id: 296,
    label: "Non Religious Worldviews",
    slug: "non-religious-worldviews",
    order: 332
  },
  NON_EUROPEAN_SOCIETY: {
    id: 297,
    label: "Non-European Society",
    slug: "non-european-society",
    order: 333
  },
  NORTH_AMERICA: {
    id: 298,
    label: "North America",
    slug: "north-america",
    order: 334
  },
  OAA: {
    id: 520,
    label: "OAA",
    slug: "oaa",
    order: 335
  },
  OBSERVE: {
    id: 299,
    label: "Observe",
    slug: "observe",
    order: 336
  },
  OBSERVING_OVER_TIME: {
    id: 300,
    label: "Observing Over Time",
    slug: "observing-over-time",
    order: 337
  },
  OCEANIA: {
    id: 301,
    label: "Oceania",
    slug: "oceania",
    order: 338
  },
  OIL_PASTEL: {
    id: 302,
    label: "Oil Pastel",
    slug: "oil-pastel",
    order: 339
  },
  ONEDRIVE: {
    id: 303,
    label: "OneDrive",
    slug: "onedrive",
    order: 340
  },
  ONLINE_BULLYING: {
    id: 304,
    label: "Online Bullying",
    slug: "online-bullying",
    order: 341
  },
  ONLINE_FINANCIAL_SAFETY: {
    id: 305,
    label: "Online Financial Safety",
    slug: "online-financial-safety",
    order: 342
  },
  ONLINE_RELATIONSHIPS: {
    id: 306,
    label: "Online Relationships",
    slug: "online-relationships",
    order: 343
  },
  ONLINE_REPUTATION: {
    id: 307,
    label: "Online Reputation",
    slug: "online-reputation",
    order: 344
  },
  ONLINE_SAFETY: {
    id: 308,
    label: "Online Safety",
    slug: "online-safety",
    order: 345
  },
  ONLINE_SAFETY_AND_AWARENESS: {
    id: 309,
    label: "Online Safety and Awareness",
    slug: "online-safety-and-awareness",
    order: 346
  },
  OPINIONS: {
    id: 310,
    label: "Opinions",
    slug: "opinions",
    order: 347
  },
  OPPORTUNITIES_FOR_LOCAL_STUDY: {
    id: 311,
    label: "Opportunities for Local Study",
    slug: "opportunities-for-local-study",
    order: 348
  },
  OPTIMISATION: {
    id: 312,
    label: "Optimisation",
    slug: "optimisation",
    order: 349
  },
  ORACY_COGNITION: {
    id: 313,
    label: "Oracy: Cognition",
    slug: "oracy-cognition",
    order: 350
  },
  ORACY_COLLABORATION: {
    id: 314,
    label: "Oracy: Collaboration",
    slug: "oracy-collaboration",
    order: 351
  },
  ORACY_COMMUNICATION: {
    id: 315,
    label: "Oracy: Communication",
    slug: "oracy-communication",
    order: 352
  },
  ORACY_CONFIDENCE: {
    id: 316,
    label: "Oracy: Confidence",
    slug: "oracy-confidence",
    order: 353
  },
  ORACY_CONTENT: {
    id: 317,
    label: "Oracy: Content",
    slug: "oracy-content",
    order: 354
  },
  ORDNANCE_SURVEY_MAPS: {
    id: 318,
    label: "Ordnance Survey Maps",
    slug: "ordnance-survey-maps",
    order: 355
  },
  OUTDOOR_LEARNING: {
    id: 319,
    label: "Outdoor Learning",
    slug: "outdoor-learning",
    order: 356
  },
  PAGANISM: {
    id: 322,
    label: "Paganism",
    slug: "paganism",
    order: 357
  },
  PAINT: {
    id: 323,
    label: "Paint",
    slug: "paint",
    order: 358
  },
  PAINTING: {
    id: 325,
    label: "Painting",
    slug: "painting",
    order: 359
  },
  PAINTZ: {
    id: 324,
    label: "PaintZ",
    slug: "paintz",
    order: 360
  },
  PARTNER_SONGS: {
    id: 326,
    label: "Partner Songs",
    slug: "partner-songs",
    order: 361
  },
  PAST_TENSE: {
    id: 532,
    label: "Past Tense",
    slug: "past-tense",
    order: 362
  },
  PATTERN_RECOGNITION: {
    id: 327,
    label: "Pattern Recognition",
    slug: "pattern-recognition",
    order: 363
  },
  PATTERN_SEEKING: {
    id: 328,
    label: "Pattern Seeking",
    slug: "pattern-seeking",
    order: 364
  },
  PERCENTAGES: {
    id: 547,
    label: "Percentages",
    slug: "percentages",
    order: 365
  },
  PERFORMANCE: {
    id: 329,
    label: "Performance",
    slug: "performance",
    order: 366
  },
  PERFORMANCE_LESSON: {
    id: 330,
    label: "Performance Lesson",
    slug: "performance-lesson",
    order: 367
  },
  PERFORMING_KS2: {
    id: 331,
    label: "Performing (KS2)",
    slug: "performing-ks2",
    order: 368
  },
  PERIMETER: {
    id: 557,
    label: "Perimeter",
    slug: "perimeter",
    order: 369
  },
  PHILOSOPHY: {
    id: 332,
    label: "Philosophy",
    slug: "philosophy",
    order: 370
  },
  PHONICS: {
    id: 333,
    label: "Phonics",
    slug: "phonics",
    order: 371
  },
  PHOTO_EDITING: {
    id: 334,
    label: "Photo Editing",
    slug: "photo-editing",
    order: 372
  },
  PHOTOGRAPHY: {
    id: 335,
    label: "Photography",
    slug: "photography",
    order: 373
  },
  PHOTOREALISM: {
    id: 336,
    label: "Photorealism",
    slug: "photorealism",
    order: 374
  },
  PHYSICAL_COMPUTING: {
    id: 337,
    label: "Physical Computing",
    slug: "physical-computing",
    order: 375
  },
  PHYSICAL_GEOGRAPHY: {
    id: 507,
    label: "Physical Geography",
    slug: "physical-geography",
    order: 376
  },
  PHYSICS: {
    id: 338,
    label: "Physics",
    slug: "physics",
    order: 377
  },
  PILGRIMAGE: {
    id: 339,
    label: "Pilgrimage",
    slug: "pilgrimage",
    order: 378
  },
  PITCH: {
    id: 340,
    label: "Pitch",
    slug: "pitch",
    order: 379
  },
  PITCHED_INSTRUMENTS: {
    id: 341,
    label: "Pitched Instruments",
    slug: "pitched-instruments",
    order: 380
  },
  PLACE: {
    id: 342,
    label: "Place",
    slug: "place",
    order: 381
  },
  PLACE_KNOWLEDGE: {
    id: 343,
    label: "Place Knowledge",
    slug: "place-knowledge",
    order: 382
  },
  PLACE_VALUE: {
    id: 538,
    label: "Place Value",
    slug: "place-value",
    order: 383
  },
  PLAN: {
    id: 344,
    label: "Plan",
    slug: "plan",
    order: 384
  },
  PLANNING_AN_ENQUIRY: {
    id: 345,
    label: "Planning an Enquiry",
    slug: "planning-an-enquiry",
    order: 385
  },
  PLANNING_KEEPING_TRACK_AND_SAVING_MONEY: {
    id: 346,
    label: "Planning, Keeping Track and Saving Money",
    slug: "planning-keeping-track-and-saving-money",
    order: 386
  },
  PLANTS: {
    id: 347,
    label: "Plants",
    slug: "plants",
    order: 387
  },
  PLUGGED: {
    id: 536,
    label: "Plugged",
    slug: "plugged",
    order: 388
  },
  POINTILLISM: {
    id: 348,
    label: "Pointillism",
    slug: "pointillism",
    order: 389
  },
  POP_ART: {
    id: 349,
    label: "Pop Art",
    slug: "pop-art",
    order: 390
  },
  POSITION_AND_DIRECTION: {
    id: 562,
    label: "Position and Direction",
    slug: "position-and-direction",
    order: 391
  },
  POWER_AND_GOVERNMENT: {
    id: 350,
    label: "Power and Government",
    slug: "power-and-government",
    order: 392
  },
  PRACTICAL: {
    id: 351,
    label: "Practical",
    slug: "practical",
    order: 393
  },
  PRACTICES_AND_RITUALS: {
    id: 352,
    label: "Practices and Rituals",
    slug: "practices-and-rituals",
    order: 394
  },
  PRE_HISTORY: {
    id: 353,
    label: "Pre History",
    slug: "pre-history",
    order: 395
  },
  PRECISION_TOLERANCE: {
    id: 354,
    label: "Precision & Tolerance",
    slug: "precision-tolerance",
    order: 396
  },
  PRESENT: {
    id: 355,
    label: "Present",
    slug: "present",
    order: 397
  },
  PRESENTING_DATA: {
    id: 356,
    label: "Presenting Data",
    slug: "presenting-data",
    order: 398
  },
  PRIMM: {
    id: 320,
    label: "PRIMM",
    slug: "primm",
    order: 399
  },
  PRINTING: {
    id: 357,
    label: "Printing",
    slug: "printing",
    order: 400
  },
  PRIVACY_AND_SECURITY: {
    id: 358,
    label: "Privacy And Security",
    slug: "privacy-and-security",
    order: 401
  },
  PROBLEM_SOLVING: {
    id: 359,
    label: "Problem Solving",
    slug: "problem-solving",
    order: 402
  },
  PRODUCTIVE_SKILLS: {
    id: 360,
    label: "Productive Skills",
    slug: "productive-skills",
    order: 403
  },
  PROGRAMMABLE_TOYS: {
    id: 361,
    label: "Programmable Toys",
    slug: "programmable-toys",
    order: 404
  },
  PROGRAMMING: {
    id: 362,
    label: "Programming",
    slug: "programming",
    order: 405
  },
  PROJECT_BASED: {
    id: 363,
    label: "Project-Based",
    slug: "project-based",
    order: 406
  },
  PRONUNCIATION: {
    id: 364,
    label: "Pronunciation",
    slug: "pronunciation",
    order: 407
  },
  PROPORTION: {
    id: 550,
    label: "Proportion",
    slug: "proportion",
    order: 408
  },
  PSHE: {
    id: 321,
    label: "PSHE",
    slug: "pshe",
    order: 409
  },
  PYTHON: {
    id: 365,
    label: "Python",
    slug: "python",
    order: 410
  },
  RATIO: {
    id: 549,
    label: "Ratio",
    slug: "ratio",
    order: 411
  },
  RATIO_AND_PROPORTION: {
    id: 548,
    label: "Ratio and Proportion",
    slug: "ratio-and-proportion",
    order: 412
  },
  READING: {
    id: 366,
    label: "Reading",
    slug: "reading",
    order: 413
  },
  READING_ALOUD: {
    id: 367,
    label: "Reading Aloud",
    slug: "reading-aloud",
    order: 414
  },
  READING_NOTATION: {
    id: 368,
    label: "Reading Notation",
    slug: "reading-notation",
    order: 415
  },
  REAL_WORLD_APPLICATIONS: {
    id: 369,
    label: "Real-World Applications",
    slug: "real-world-applications",
    order: 416
  },
  REALISM: {
    id: 370,
    label: "Realism",
    slug: "realism",
    order: 417
  },
  RECEPTIVE_SKILLS: {
    id: 371,
    label: "Receptive Skills",
    slug: "receptive-skills",
    order: 418
  },
  RECORD: {
    id: 372,
    label: "Record",
    slug: "record",
    order: 419
  },
  RECORDING_DATA: {
    id: 373,
    label: "Recording Data",
    slug: "recording-data",
    order: 420
  },
  REFLECTION_IMPROVEMENT: {
    id: 374,
    label: "Reflection & Improvement",
    slug: "reflection-improvement",
    order: 421
  },
  REFLEXIVE_VERBS: {
    id: 529,
    label: "Reflexive Verbs",
    slug: "reflexive-verbs",
    order: 422
  },
  REGIONAL: {
    id: 375,
    label: "Regional",
    slug: "regional",
    order: 423
  },
  RENAISSANCE: {
    id: 376,
    label: "Renaissance",
    slug: "renaissance",
    order: 424
  },
  REPETITION: {
    id: 377,
    label: "Repetition",
    slug: "repetition",
    order: 425
  },
  RESEARCH: {
    id: 378,
    label: "Research",
    slug: "research",
    order: 426
  },
  RESEARCHING: {
    id: 379,
    label: "Researching",
    slug: "researching",
    order: 427
  },
  RESILIENCE: {
    id: 380,
    label: "Resilience",
    slug: "resilience",
    order: 428
  },
  RHYTHM: {
    id: 381,
    label: "Rhythm",
    slug: "rhythm",
    order: 429
  },
  RHYTHMIC_COMPOSITION: {
    id: 382,
    label: "Rhythmic Composition",
    slug: "rhythmic-composition",
    order: 430
  },
  RHYTHMIC_NOTATION: {
    id: 383,
    label: "Rhythmic Notation",
    slug: "rhythmic-notation",
    order: 431
  },
  ROCKS: {
    id: 384,
    label: "Rocks",
    slug: "rocks",
    order: 432
  },
  ROMANTICISM: {
    id: 385,
    label: "Romanticism",
    slug: "romanticism",
    order: 433
  },
  ROTATION: {
    id: 386,
    label: "Rotation",
    slug: "rotation",
    order: 434
  },
  ROUND_SINGING: {
    id: 387,
    label: "Round Singing",
    slug: "round-singing",
    order: 435
  },
  RULES: {
    id: 388,
    label: "Rules",
    slug: "rules",
    order: 436
  },
  RULES_STRATEGY_AND_TACTICS_FOCUS: {
    id: 389,
    label: "Rules, Strategy and Tactics Focus",
    slug: "rules-strategy-and-tactics-focus",
    order: 437
  },
  SACRED_PLACES: {
    id: 392,
    label: "Sacred Places",
    slug: "sacred-places",
    order: 438
  },
  SAFE_SEARCHING_ONLINE: {
    id: 393,
    label: "Safe Searching Online",
    slug: "safe-searching-online",
    order: 439
  },
  SCALE: {
    id: 394,
    label: "Scale",
    slug: "scale",
    order: 440
  },
  SCALE_PROPORTION: {
    id: 395,
    label: "Scale & Proportion",
    slug: "scale-proportion",
    order: 441
  },
  SCHOOL_GROUNDS: {
    id: 396,
    label: "School Grounds",
    slug: "school-grounds",
    order: 442
  },
  SCIENCE_CAPITAL: {
    id: 397,
    label: "Science Capital",
    slug: "science-capital",
    order: 443
  },
  SCIENCE_CAREERS: {
    id: 398,
    label: "Science Careers",
    slug: "science-careers",
    order: 444
  },
  SCIENTISTS_AND_INVENTORS: {
    id: 399,
    label: "Scientists and Inventors",
    slug: "scientists-and-inventors",
    order: 445
  },
  SCOTTISH_HISTORY: {
    id: 400,
    label: "Scottish History",
    slug: "scottish-history",
    order: 446
  },
  SCRATCH: {
    id: 401,
    label: "Scratch",
    slug: "scratch",
    order: 447
  },
  SCRATCHJR: {
    id: 402,
    label: "ScratchJr",
    slug: "scratchjr",
    order: 448
  },
  SCULPTURE: {
    id: 403,
    label: "Sculpture",
    slug: "sculpture",
    order: 449
  },
  SEASONAL_CHANGES: {
    id: 404,
    label: "Seasonal Changes",
    slug: "seasonal-changes",
    order: 450
  },
  SELECTION: {
    id: 405,
    label: "Selection",
    slug: "selection",
    order: 451
  },
  SELF_IMAGE_AND_IDENTITY: {
    id: 406,
    label: "Self-Image And Identity",
    slug: "self-image-and-identity",
    order: 452
  },
  SENTENCE_BUILDING: {
    id: 407,
    label: "Sentence Building",
    slug: "sentence-building",
    order: 453
  },
  SEQUENCE: {
    id: 408,
    label: "Sequence",
    slug: "sequence",
    order: 454
  },
  SGRAFFITO: {
    id: 409,
    label: "Sgraffito",
    slug: "sgraffito",
    order: 455
  },
  SHADING: {
    id: 410,
    label: "Shading",
    slug: "shading",
    order: 456
  },
  SHAPE: {
    id: 411,
    label: "Shape",
    slug: "shape",
    order: 457
  },
  SHARED_DEVICES: {
    id: 412,
    label: "Shared Devices",
    slug: "shared-devices",
    order: 458
  },
  SIGNIFICANT_EVENT: {
    id: 413,
    label: "Significant Event",
    slug: "significant-event",
    order: 459
  },
  SIGNIFICANT_INDIVIDUAL: {
    id: 414,
    label: "Significant Individual",
    slug: "significant-individual",
    order: 460
  },
  SIGNIFICANT_PLACE: {
    id: 415,
    label: "Significant Place",
    slug: "significant-place",
    order: 461
  },
  SIKHI: {
    id: 416,
    label: "Sikhi",
    slug: "sikhi",
    order: 462
  },
  SIMILARITY_AND_DIFFERENCE: {
    id: 417,
    label: "Similarity and Difference",
    slug: "similarity-and-difference",
    order: 463
  },
  SINGING: {
    id: 418,
    label: "Singing",
    slug: "singing",
    order: 464
  },
  SKETCH_MAPS: {
    id: 419,
    label: "Sketch Maps",
    slug: "sketch-maps",
    order: 465
  },
  SKETCHING: {
    id: 420,
    label: "Sketching",
    slug: "sketching",
    order: 466
  },
  SMALL_GROUP: {
    id: 421,
    label: "Small Group",
    slug: "small-group",
    order: 467
  },
  SOCIAL: {
    id: 422,
    label: "Social",
    slug: "social",
    order: 468
  },
  SOCIAL_SCIENCE: {
    id: 423,
    label: "Social Science",
    slug: "social-science",
    order: 469
  },
  SOCIETY_AND_GLOBAL_ISSUES: {
    id: 526,
    label: "Society and Global Issues",
    slug: "society-and-global-issues",
    order: 470
  },
  SOFT_PASTEL: {
    id: 424,
    label: "Soft Pastel",
    slug: "soft-pastel",
    order: 471
  },
  SOFTWARE: {
    id: 425,
    label: "Software",
    slug: "software",
    order: 472
  },
  SOUND: {
    id: 426,
    label: "Sound",
    slug: "sound",
    order: 473
  },
  SOURCE_ANALYSIS: {
    id: 427,
    label: "Source Analysis",
    slug: "source-analysis",
    order: 474
  },
  SOUTH_AMERICA: {
    id: 428,
    label: "South America",
    slug: "south-america",
    order: 475
  },
  SOUTH_AMERICAN_HISTORY: {
    id: 429,
    label: "South American History",
    slug: "south-american-history",
    order: 476
  },
  SPACE: {
    id: 430,
    label: "Space",
    slug: "space",
    order: 477
  },
  SPEAKING: {
    id: 431,
    label: "Speaking",
    slug: "speaking",
    order: 478
  },
  SPENDING_MONEY: {
    id: 432,
    label: "Spending Money",
    slug: "spending-money",
    order: 479
  },
  SPIRITUAL: {
    id: 433,
    label: "Spiritual",
    slug: "spiritual",
    order: 480
  },
  STABILITY_SKILLS: {
    id: 434,
    label: "Stability Skills",
    slug: "stability-skills",
    order: 481
  },
  STAFF_NOTATION: {
    id: 435,
    label: "Staff Notation",
    slug: "staff-notation",
    order: 482
  },
  STAKEHOLDER_BRIEFS: {
    id: 436,
    label: "Stakeholder Briefs",
    slug: "stakeholder-briefs",
    order: 483
  },
  STAR_VALUES: {
    id: 390,
    label: "STAR Values",
    slug: "star-values",
    order: 484
  },
  STATES_OF_MATTER: {
    id: 437,
    label: "States of Matter",
    slug: "states-of-matter",
    order: 485
  },
  STATISTICS: {
    id: 561,
    label: "Statistics",
    slug: "statistics",
    order: 486
  },
  STEM_CAREERS: {
    id: 391,
    label: "STEM Careers",
    slug: "stem-careers",
    order: 487
  },
  STICK_NOTATION: {
    id: 438,
    label: "Stick Notation",
    slug: "stick-notation",
    order: 488
  },
  STILL_LIFE: {
    id: 439,
    label: "Still Life",
    slug: "still-life",
    order: 489
  },
  STIPPLING: {
    id: 440,
    label: "Stippling",
    slug: "stippling",
    order: 490
  },
  STORIES_SONGS_POEMS_AND_RHYMES: {
    id: 441,
    label: "Stories, Songs, Poems and Rhymes",
    slug: "stories-songs-poems-and-rhymes",
    order: 491
  },
  STRATEGY_AND_TACTICS: {
    id: 442,
    label: "Strategy and Tactics",
    slug: "strategy-and-tactics",
    order: 492
  },
  STRIKING_AND_FIELDING: {
    id: 516,
    label: "Striking and Fielding",
    slug: "striking-and-fielding",
    order: 493
  },
  STROKE_DEVELOPMENT: {
    id: 443,
    label: "Stroke Development",
    slug: "stroke-development",
    order: 494
  },
  STRUCTURE: {
    id: 444,
    label: "Structure",
    slug: "structure",
    order: 495
  },
  STRUCTURES: {
    id: 445,
    label: "Structures",
    slug: "structures",
    order: 496
  },
  STUARTS: {
    id: 446,
    label: "Stuarts",
    slug: "stuarts",
    order: 497
  },
  STUDY_AND_EMPLOYABILITY: {
    id: 525,
    label: "Study and Employability",
    slug: "study-and-employability",
    order: 498
  },
  STUDY_BEYOND_1066: {
    id: 447,
    label: "Study beyond 1066",
    slug: "study-beyond-1066",
    order: 499
  },
  SUBTRACTION: {
    id: 541,
    label: "Subtraction",
    slug: "subtraction",
    order: 500
  },
  SURVEY: {
    id: 448,
    label: "Survey",
    slug: "survey",
    order: 501
  },
  SUSTAINABILITY: {
    id: 449,
    label: "Sustainability",
    slug: "sustainability",
    order: 502
  },
  SUSTAINABILITY_AND_ENVIRONMENT: {
    id: 509,
    label: "Sustainability and Environment",
    slug: "sustainability-and-environment",
    order: 503
  },
  SYMBOLISM: {
    id: 450,
    label: "Symbolism",
    slug: "symbolism",
    order: 504
  },
  SYSTEMS: {
    id: 451,
    label: "Systems",
    slug: "systems",
    order: 505
  },
  TABLETS: {
    id: 452,
    label: "Tablets",
    slug: "tablets",
    order: 506
  },
  TEACHING: {
    id: 453,
    label: "Teaching",
    slug: "teaching",
    order: 507
  },
  TEAMWORK: {
    id: 454,
    label: "Teamwork",
    slug: "teamwork",
    order: 508
  },
  TEAMWORK_AND_COMMUNICATION: {
    id: 455,
    label: "Teamwork and Communication",
    slug: "teamwork-and-communication",
    order: 509
  },
  TECTONIC_PLACES: {
    id: 456,
    label: "Tectonic Places",
    slug: "tectonic-places",
    order: 510
  },
  TEMPERA: {
    id: 457,
    label: "Tempera",
    slug: "tempera",
    order: 511
  },
  TEMPO: {
    id: 458,
    label: "Tempo",
    slug: "tempo",
    order: 512
  },
  TESTING_PROTOTYPING: {
    id: 459,
    label: "Testing & Prototyping",
    slug: "testing-prototyping",
    order: 513
  },
  TEXT_BASED_CODING: {
    id: 460,
    label: "Text-Based Coding",
    slug: "text-based-coding",
    order: 514
  },
  TEXTILES: {
    id: 461,
    label: "Textiles",
    slug: "textiles",
    order: 515
  },
  TEXTURE: {
    id: 462,
    label: "Texture",
    slug: "texture",
    order: 516
  },
  THE_RULE_OF_LAW: {
    id: 463,
    label: "The Rule of Law",
    slug: "the-rule-of-law",
    order: 517
  },
  THEMATIC_STUDY: {
    id: 510,
    label: "Thematic Study",
    slug: "thematic-study",
    order: 518
  },
  THEOLOGY: {
    id: 464,
    label: "Theology",
    slug: "theology",
    order: 519
  },
  THEORETICAL: {
    id: 465,
    label: "Theoretical",
    slug: "theoretical",
    order: 520
  },
  TIMBRE: {
    id: 466,
    label: "Timbre",
    slug: "timbre",
    order: 521
  },
  TIME: {
    id: 467,
    label: "Time",
    slug: "time",
    order: 522
  },
  TIMES_TABLES: {
    id: 563,
    label: "Times Tables",
    slug: "times-tables",
    order: 523
  },
  TINKERCAD: {
    id: 468,
    label: "Tinkercad",
    slug: "tinkercad",
    order: 524
  },
  TOLERANCE: {
    id: 469,
    label: "Tolerance",
    slug: "tolerance",
    order: 525
  },
  TONE: {
    id: 470,
    label: "Tone",
    slug: "tone",
    order: 526
  },
  TRADE_AND_TECHNOLOGY: {
    id: 471,
    label: "Trade and Technology",
    slug: "trade-and-technology",
    order: 527
  },
  TUDORS: {
    id: 472,
    label: "Tudors",
    slug: "tudors",
    order: 528
  },
  TURNING_POINT_IN_HISTORY: {
    id: 473,
    label: "Turning Point in History",
    slug: "turning-point-in-history",
    order: 529
  },
  UNDERSTANDING_AND_APPLICATION_OF_KNOWLEGDE: {
    id: 475,
    label: "Understanding and Application of Knowlegde",
    slug: "understanding-and-application-of-knowlegde",
    order: 530
  },
  UNDERSTANDING_DIFFERENT_PERSPECTIVES: {
    id: 474,
    label: "Understanding Different Perspectives",
    slug: "understanding-different-perspectives",
    order: 531
  },
  UNISON_SINGING: {
    id: 476,
    label: "Unison Singing",
    slug: "unison-singing",
    order: 532
  },
  UNITED_KINGDOM: {
    id: 477,
    label: "United Kingdom",
    slug: "united-kingdom",
    order: 533
  },
  UNPLUGGED: {
    id: 478,
    label: "Unplugged",
    slug: "unplugged",
    order: 534
  },
  UNPLUGGED_NO_DEVICES: {
    id: 479,
    label: "Unplugged (No Devices)",
    slug: "unplugged-no-devices",
    order: 535
  },
  UNTUNED_PERCUSSION: {
    id: 480,
    label: "Untuned Percussion",
    slug: "untuned-percussion",
    order: 536
  },
  USER_CENTRED_DESIGN: {
    id: 481,
    label: "User‑Centred Design",
    slug: "user-centred-design",
    order: 537
  },
  USING_CHORDS: {
    id: 482,
    label: "Using Chords",
    slug: "using-chords",
    order: 538
  },
  USING_DIFFERENT_TENSES: {
    id: 483,
    label: "Using Different Tenses",
    slug: "using-different-tenses",
    order: 539
  },
  USING_NOTATION: {
    id: 522,
    label: "Using Notation",
    slug: "using-notation",
    order: 540
  },
  USING_REFERENCE_TOOLS: {
    id: 484,
    label: "Using Reference Tools",
    slug: "using-reference-tools",
    order: 541
  },
  USING_SOURCES_OF_EVIDENCE: {
    id: 485,
    label: "Using sources of evidence",
    slug: "using-sources-of-evidence",
    order: 542
  },
  VARIABLES: {
    id: 486,
    label: "Variables",
    slug: "variables",
    order: 543
  },
  VICTORIANS: {
    id: 487,
    label: "Victorians",
    slug: "victorians",
    order: 544
  },
  VIDEO_EDITING: {
    id: 488,
    label: "Video Editing",
    slug: "video-editing",
    order: 545
  },
  VIDEO_EDITING_SOFTWARE: {
    id: 489,
    label: "Video Editing Software",
    slug: "video-editing-software",
    order: 546
  },
  VOCABULARY: {
    id: 490,
    label: "Vocabulary",
    slug: "vocabulary",
    order: 547
  },
  VOLUME: {
    id: 558,
    label: "Volume",
    slug: "volume",
    order: 548
  },
  VOTES_FOR_WOMEN: {
    id: 491,
    label: "Votes for Women",
    slug: "votes-for-women",
    order: 549
  },
  WASTE: {
    id: 492,
    label: "Waste",
    slug: "waste",
    order: 550
  },
  WATER_LIFE_BELOW_WATER: {
    id: 493,
    label: "Water & Life Below Water",
    slug: "water-life-below-water",
    order: 551
  },
  WATER_CONFIDENCE: {
    id: 494,
    label: "Water Confidence",
    slug: "water-confidence",
    order: 552
  },
  WATER_SAFETY: {
    id: 495,
    label: "Water Safety",
    slug: "water-safety",
    order: 553
  },
  WATERCOLOUR: {
    id: 496,
    label: "Watercolour",
    slug: "watercolour",
    order: 554
  },
  WEB_DESIGN: {
    id: 497,
    label: "Web Design",
    slug: "web-design",
    order: 555
  },
  WELLBEING: {
    id: 498,
    label: "Wellbeing",
    slug: "wellbeing",
    order: 556
  },
  WELLBEING_ONLINE: {
    id: 499,
    label: "Wellbeing Online",
    slug: "wellbeing-online",
    order: 557
  },
  WELSH_HISTORY: {
    id: 500,
    label: "Welsh History",
    slug: "welsh-history",
    order: 558
  },
  WHOLE_CLASS_ENSEMBLE: {
    id: 501,
    label: "Whole Class / Ensemble",
    slug: "whole-class-ensemble",
    order: 559
  },
  WIRE: {
    id: 502,
    label: "Wire",
    slug: "wire",
    order: 560
  },
  WITHIN_LIVING_MEMORY: {
    id: 503,
    label: "Within Living Memory",
    slug: "within-living-memory",
    order: 561
  },
  WOMEN_IN_HISTORY: {
    id: 504,
    label: "Women in History",
    slug: "women-in-history",
    order: 562
  },
  WORLD_HISTORY: {
    id: 505,
    label: "World History",
    slug: "world-history",
    order: 563
  },
  WRITING: {
    id: 506,
    label: "Writing",
    slug: "writing",
    order: 564
  },
  YOUNGER_LEARNERS: {
    id: 533,
    label: "Younger Learners",
    slug: "younger-learners",
    order: 565
  }
}, Rt = (e) => e.map((r) => {
  var t;
  return (t = Object.values(ld).find(
    (o) => String(o.id) === r
  )) == null ? void 0 : t.slug;
}).filter((r) => typeof r == "string"), jh = async ({
  subjectId: e
}) => {
  const n = await nd.fetch({ subjectId: e });
  if (n instanceof Error)
    return (!(n instanceof Q) || n.status === null || n.status >= 500) && fe(n, {
      fingerprint: ["explore-subject-scheme-orchestration", "generic-subject-fetch-error"],
      tags: {
        action: "load",
        area: "subject-scheme",
        source: "orchestration"
      },
      extra: {
        subjectId: e,
        status: n instanceof Q ? n.status : null
      }
    }), console.error(n), n;
  const r = await ud.fetch({
    subjects: n.attributes.subjects
  });
  if (r instanceof Error)
    return r;
  const i = await Promise.allSettled(
    r.map(async (o) => {
      var $, v;
      const a = await Me.fetch({
        id: o.id
      });
      if (a instanceof Error)
        throw a;
      const { data: u, error: s, success: l } = od.safeParse(a);
      if (!l)
        throw s;
      if (o.cs_approved && u.approved !== !0 && zh(o.id, u.id), !u.approved)
        return null;
      const f = await Promise.allSettled(
        u.linkedResources.map(async (m) => {
          const g = await Me.fetch({ id: m });
          if (g instanceof Q && g.status === 404)
            return sn(m, o.id), null;
          if (g instanceof Error)
            throw g;
          return g;
        })
      ), c = [], p = [];
      for (const m of f)
        m.status === "fulfilled" && m.value ? c.push(m.value) : m.status === "rejected" && p.push(m.reason);
      if (p.length > 0)
        throw p[0];
      const _ = [];
      for (const m of c)
        if ((($ = m.type) == null ? void 0 : $.id) === le.LESSON_PACK.monolithId && m.enabled) {
          const g = Ji.safeParse(m);
          g.success && _.push(g.data);
        }
      _.sort((m, g) => (m.order ?? 0) - (g.order ?? 0));
      const h = o.cs_threads || [];
      return {
        monolithUnitId: u.id,
        threads: h,
        keyStages: o.cs_key_stages,
        keyStagesSlug: qi(o.cs_key_stages),
        threadSlugs: Rt(h),
        keyArtUrl: ((v = u.keyArt) == null ? void 0 : v.url) || null,
        title: u.title,
        description: u.description,
        learningSequence: _
      };
    })
  ), t = [];
  for (const o of i) {
    if (o.status === "rejected")
      return o.reason instanceof Error ? o.reason : new Error("Unknown error processing unit");
    o.value && t.push(o.value);
  }
  return {
    subject: n,
    units: t
  };
}, Lh = "exploreSubjectUnit", $b = ({ subjectId: e }) => {
  const n = [Lh, e], {
    // we always want to be able to return something, even if it's an empty array
    data: r,
    error: i = null,
    isLoading: t,
    mutate: o
  } = An(n, () => jh({ subjectId: e })), a = async () => {
    await o();
  }, u = r instanceof Error ? void 0 : r, s = r instanceof Error ? r : i;
  return {
    data: u,
    isLoading: t,
    error: s,
    actions: {
      refresh: {
        apply: a,
        isLoading: t,
        error: i
      }
    }
  };
}, xh = "genericSubject", Eb = ({ id: e }) => {
  const n = [xh, e], { data: r, error: i, isLoading: t } = An(
    n,
    () => nd.fetch({
      subjectId: e
    })
  ), o = r instanceof Error ? void 0 : r, a = r instanceof Error ? r : i;
  return {
    data: o,
    isLoading: t,
    error: a
  };
}, Mh = D(ed), Zh = D(td), Gh = {
  /**
   * Fetch the list of subjects
   * @returns The list of subjects
   */
  fetch: () => X({
    agentName: "fetchSubjectList",
    url: W.GENERIC_SUBJECT_LIST_PATH(),
    fetchOptions: {
      method: "GET",
      headers: {
        ...ne.getBearerHeader()
      }
    },
    schema: Zh
  })
}, Fh = "subjectList", kb = () => {
  const e = [Fh], {
    // we always want to be able to return something, even if it's an empty array
    data: n = [],
    error: r,
    isLoading: i
  } = Pe(e, () => Gh.fetch()), t = n instanceof Error ? [] : n, o = n instanceof Error ? n : r;
  return {
    data: t,
    isLoading: i,
    error: o
  };
}, Xi = {
  fetch: ({
    subjectId: e,
    curriculumId: n
  }) => X({
    agentName: "subject",
    url: W.SUBJECT_PATH(n, e),
    fetchOptions: {
      headers: {
        "Content-Type": "application/json",
        ...ne.getBearerHeader()
      }
    },
    schema: ed
  }),
  update: ({
    curriculumId: e,
    subjectId: n,
    payload: r
  }) => X({
    agentName: "subject",
    url: W.SUBJECT_PATH(e, n),
    fetchOptions: {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...ne.getBearerHeader()
      },
      body: JSON.stringify(r)
    },
    schema: wh
  })
}, Hh = "subject", Nb = (e) => {
  const { subjectId: n, curriculumId: r } = e || {}, i = n && r ? [Hh, n, r] : null, t = n && r ? () => Xi.fetch({ curriculumId: r, subjectId: n }) : null, {
    // we always want to be able to return something, even if it's an empty array
    data: o = null,
    error: a,
    isLoading: u,
    mutate: s
  } = Pe(i, t), { isUpdating: l, update: f } = Bh(s), c = o instanceof Error ? null : o, p = o instanceof Error ? o : a;
  return {
    data: c,
    error: p,
    isLoading: u,
    actions: {
      update: {
        apply: f,
        isLoading: l
      }
    }
  };
}, Bh = (e) => {
  const [n, r] = Qe(!1);
  return { update: async ({
    curriculumId: t,
    subjectId: o,
    payload: a
  }) => {
    r(!0);
    const u = await Xi.update({
      curriculumId: t,
      subjectId: o,
      payload: a
    });
    return u instanceof Q ? (r(!1), u) : (await e(), r(!1), u);
  }, isUpdating: n };
}, Vh = {
  /**
   * Fetch the list of subjects
   * @returns The list of subjects
   */
  fetch: ({ curriculumId: e }) => X({
    agentName: "fetchSubjectList",
    url: W.SUBJECT_LIST_PATH(e),
    fetchOptions: {
      method: "GET",
      headers: {
        ...ne.getBearerHeader()
      }
    },
    schema: Mh
  })
}, Vo = "subjectList", Ob = ({ curriculumId: e }) => {
  const n = [Vo], {
    // we always want to be able to return something, even if it's an empty array
    data: r = [],
    error: i,
    isLoading: t,
    mutate: o
  } = Pe(n, () => Vh.fetch({ curriculumId: e })), { mutate: a } = cn(), u = async (f) => {
    if (f)
      return await a(
        (c) => Array.isArray(c) && c.includes(Vo)
      );
    await o();
  }, s = r instanceof Error ? [] : r, l = r instanceof Error ? r : i;
  return {
    data: s,
    isLoading: t,
    error: l,
    actions: {
      refresh: {
        apply: u,
        isLoading: t,
        error: i
      }
    }
  };
}, sd = R.enum([
  "eyfs",
  "en-gb-key-stage-1",
  "en-gb-key-stage-2",
  "en-gb-key-stage-lower-2",
  "en-gb-key-stage-upper-2",
  "en-gb-key-stage-1-and-2",
  "nursery",
  "reception",
  "year-1",
  "year-2",
  "year-3",
  "year-4",
  "year-5",
  "year-6"
]), Yh = O({
  rowId: b(),
  order: K(),
  displayLabel: b().min(1),
  slug: b(),
  attributes: O({
    keyStages: D(b())
  })
}), zt = O({
  rows: D(Yh),
  columns: D(
    O({
      columnId: b(),
      order: K(),
      displayLabel: b().min(1),
      slug: b()
    })
  ).min(1),
  cells: D(
    re([
      O({
        cellId: b(),
        resourceId: b(),
        rowId: b(),
        columnId: b(),
        span: K().optional(),
        adaptationNote: b().optional()
      }),
      O({
        cellId: b(),
        isCustom: Y(!0),
        rowId: b(),
        columnId: b(),
        span: K().optional(),
        title: b().min(1),
        description: b().max(2e3).optional()
      })
    ])
  ).optional()
}), Tb = O({
  value: zt,
  version: b(),
  id: b(),
  // e.g. "2025-12-31T24:59:59.001Z"
  updatedAt: b()
}), Kh = Object.values(ld).map((e) => e.slug), cd = _e(Kh), Wh = O({
  resourceId: b(),
  title: b().min(1),
  keyArtUrl: b(),
  order: b(),
  approved: H(),
  keyStages: D(b()),
  keyStagesSlug: D(sd),
  educationProgramme: b(),
  isComingSoon: H().optional(),
  threadSlugs: D(cd).optional()
}), Jh = O({
  id: b(),
  slug: b(),
  label: b(),
  displayLabel: b().min(1).optional(),
  systemDefault: Y(!0),
  status: st,
  active: H(),
  subjectPlanId: b(),
  attributes: O({
    subjects: D(b())
  })
}), qh = O({
  id: b(),
  slug: b(),
  label: b(),
  displayLabel: b().min(1),
  systemDefault: Y(!0),
  status: st,
  active: H(),
  subjectPlanId: b(),
  attributes: O({
    subjects: D(b())
  })
}), dd = re([
  Jh,
  qh
]), wb = O({
  subjectPlanId: b(),
  subject: dd,
  plan: zt
}), Xh = zt, Qh = O({
  subject: dd,
  plan: O({
    value: zt,
    version: b(),
    id: b()
  }),
  resources: D(Wh).optional()
});
O({
  value: zt,
  clientVersion: b(),
  override: H().optional()
});
const md = {
  fetch: ({
    curriculumId: e,
    subjectId: n
  }) => X({
    agentName: "getSubjectPlan",
    url: W.SUBJECT_PLAN_PATH(e, n),
    fetchOptions: {
      method: "GET",
      headers: {
        ...ne.getBearerHeader()
      }
    },
    schema: Qh
  }),
  update: ({
    data: e,
    curriculumId: n,
    subjectId: r
  }) => X({
    agentName: "putSubjectPlan",
    url: W.SUBJECT_PLAN_PATH(n, r),
    fetchOptions: {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...ne.getBearerHeader()
      },
      body: JSON.stringify(e)
    },
    schema: Xh,
    async processErrorResponse(i) {
      if (i.response.status === 409) {
        const t = await i.response.json();
        return new Q("Conflict", 409, t.error.latestRecord);
      }
    }
  })
}, eb = [], tb = new Set(eb), nb = async ({
  // educationProgramme,
  // keyStageIds,
  curriculumId: e,
  subjectId: n
}) => {
  const r = await md.fetch({
    curriculumId: e,
    subjectId: n
  });
  if (r instanceof Error)
    return (!(r instanceof Q) || r.status === null || r.status >= 500) && fe(r, {
      fingerprint: ["subject-plan-orchestration", "agent-fetch-error"],
      tags: {
        action: "load",
        area: "subject-plan",
        source: "orchestration"
      },
      extra: {
        curriculumId: e,
        subjectId: n
      }
    }), console.error(r), r;
  const i = r.plan.value.rows.reduce(
    (u, s) => (s.attributes.keyStages.forEach((l) => u.add(l)), u),
    /* @__PURE__ */ new Set()
  ), t = await ud.fetch({
    keyStages: Array.from(i),
    subjects: r.subject.attributes.subjects
  });
  if (t instanceof Error)
    return (!(t instanceof Q) || t.status === null || t.status >= 500) && fe(t, {
      fingerprint: ["subject-plan-orchestration", "search-units-fetch-error"],
      tags: {
        action: "load",
        area: "subject-plan",
        source: "orchestration"
      },
      extra: {
        curriculumId: e,
        subjectId: n
      }
    }), console.error(t), t;
  const o = t.map((u) => ({
    resourceId: u.id,
    title: u.cs_title,
    order: u.order,
    keyArtUrl: u.cs_key_art,
    approved: u.cs_approved,
    educationProgramme: u.cs_education_programme.toString(),
    keyStages: [...u.cs_key_stages],
    isComingSoon: tb.has(u.id),
    keyStagesSlug: qi(u.cs_key_stages),
    threadSlugs: Rt((u == null ? void 0 : u.cs_threads) || [])
  }));
  return {
    ...r,
    resources: o
  };
}, rb = "subjectPlan", Ab = ({ curriculumId: e, subjectId: n }) => {
  const r = [rb, e, n], {
    // we always want to be able to return something, even if it's an empty array
    data: i = null,
    error: t,
    isLoading: o,
    mutate: a
  } = Pe(r, () => nb({ curriculumId: e, subjectId: n })), u = i instanceof Error ? null : i, s = i instanceof Error ? i : t, l = async () => {
    await a();
  }, f = ib(a, e, n);
  return {
    data: u,
    isLoading: o,
    error: s,
    actions: {
      refresh: {
        apply: l,
        // isLoading and error are handled by the root useSWR at the top of this agent
        isLoading: o,
        error: t
      },
      update: f
    }
  };
}, ib = (e, n, r) => {
  const [i, t] = Qe(!1), [o, a] = Qe(null);
  return {
    apply: async ({ data: s }) => {
      if (i) return;
      a(null), t(!0);
      const l = await md.update({
        curriculumId: n,
        subjectId: r,
        data: s
      });
      return l instanceof Error ? a(l) : await e(), t(!1), l;
    },
    isLoading: i,
    error: o
  };
}, Yo = ({
  isTopLevel: e,
  resources: n
}) => n.filter((r) => {
  var t, o, a;
  const i = Ph.safeParse(r);
  if (!i.success) {
    if ((t = r == null ? void 0 : r.type) != null && t.id && !(((o = r == null ? void 0 : r.type) == null ? void 0 : o.id) === le.LESSON_PACK.monolithId && (r != null && r.enabled))) {
      const u = ((a = r.type) == null ? void 0 : a.id) ?? "unknown-resource-type";
      fe(
        new Error("mapBasicResource parse failure", {
          cause: i.error
        }),
        {
          level: "warning",
          fingerprint: [
            "map-basic-resource",
            "parse-failure",
            u
          ],
          tags: {
            action: "parse",
            area: "resource-mapping",
            source: "orchestration"
          },
          extra: {
            resourceId: r.id,
            resourceType: u
          }
        }
      ), console.error(
        "PARSE_FAILED",
        {
          resourceId: r.id,
          resourceType: u
        },
        i.error
      );
    }
    return !1;
  }
  return i.success;
}).map((r) => {
  var t, o;
  const i = Object.values(le).find(
    (a) => {
      var u;
      return a.monolithId === ((u = r.type) == null ? void 0 : u.id);
    }
  );
  return {
    type: (i == null ? void 0 : i.slug) || null,
    title: r.title,
    description: r.description,
    order: r == null ? void 0 : r.order,
    resourceId: r.id,
    isAdditional: e && !(i != null && i.isPinned),
    // find the unit in the unitInfo json array, and get the pinned status from there
    isPinned: e && (i == null ? void 0 : i.isPinned) || !1,
    previewImageUrl: ((t = r.preview) == null ? void 0 : t.url) || ((o = r.cover) == null ? void 0 : o.url) || "",
    canonicalUrl: r.path,
    threads: Rt(r.threads || [])
  };
}), ob = async ({
  curriculumId: e,
  subjectId: n,
  unitId: r
}) => {
  var m;
  const i = await Xi.fetch({
    curriculumId: e,
    subjectId: n
  });
  if (i instanceof Error)
    return i;
  const t = await Me.fetch({
    id: r
  });
  if (t instanceof Error)
    return t;
  const o = ad.safeParse(t);
  if (!o.success)
    return o.error;
  const a = Object.values(le).find(
    (g) => {
      var S;
      return g.monolithId === ((S = o.data.type) == null ? void 0 : S.id);
    }
  ), u = {
    monolithUnitId: r,
    subject: {
      slug: i.slug,
      displayLabel: i.label,
      subjectId: n
    },
    unitTitle: o.data.title,
    unitDescription: o.data.description,
    type: (a == null ? void 0 : a.slug) ?? null,
    keyArt: (m = o.data.keyArt) == null ? void 0 : m.url,
    // resources are mapped in the return statement
    resources: [],
    canonicalUrl: o.data.path
  }, s = await Promise.all(
    (o.data.linkedResources ?? []).map(async (g) => {
      const S = await Me.fetch({
        id: g
      });
      if (S instanceof Q && S.status === 404) {
        sn(g, r);
        return;
      }
      return S;
    }).filter(Boolean)
  );
  if (s.some((g) => g instanceof Error))
    return s.find((g) => g instanceof Error) || new Error("Unknown error in top-level resources");
  const l = s.filter(
    (g) => !(g instanceof Error)
  ), f = l.filter(
    (g) => {
      var S;
      return !!(((S = g.type) == null ? void 0 : S.id) === le.LESSON_PACK.monolithId && g.enabled);
    }
  ), c = await Promise.all(
    f.flatMap(
      (g) => {
        var S;
        return (S = g.linkedResources) == null ? void 0 : S.map(async (k) => {
          if (l.some((A) => A.id === k))
            return;
          const E = await Me.fetch({
            id: k
          });
          if (E instanceof Q && E.status === 404) {
            sn(k, r);
            return;
          }
          return E instanceof Error, E;
        });
      }
    ).filter(Boolean)
  );
  if (c.some((g) => g instanceof Error))
    return c.find(
      (g) => g instanceof Error
    ) || new Error("Unknown error in linked resources");
  const p = c.filter(
    (g) => !(g instanceof Error)
  ), _ = Yo({
    resources: l,
    isTopLevel: !0
  }), h = Yo({
    resources: p,
    isTopLevel: !1
  }), v = f.filter(
    (g) => Ji.safeParse(g).success
  ).map((g) => {
    var S;
    return {
      type: "lesson-pack",
      title: g.title,
      description: g.description,
      order: g.order,
      resources: g.linkedResources || [],
      resourceId: g.id,
      previewImageUrl: ((S = g.preview) == null ? void 0 : S.url) || "",
      canonicalUrl: g.path,
      isPinned: void 0,
      isAdditional: void 0,
      threads: Rt(g.threads || [])
    };
  });
  return v.sort((g, S) => (g.order ?? 0) - (S.order ?? 0)), {
    ...u,
    resources: [
      ..._,
      ...h,
      ...v
    ]
  };
}, ab = "unitPlan", Ub = ({
  curriculumId: e,
  subjectId: n,
  unitId: r
}) => {
  const i = [ab, e, n, r], {
    // we always want to be able to return something, even if it's an empty array
    data: t,
    error: o = null,
    isLoading: a,
    mutate: u
  } = An(
    i,
    () => ob({ curriculumId: e, subjectId: n, unitId: r })
  ), s = async () => {
    await u();
  }, l = t instanceof Error ? void 0 : t, f = t instanceof Error ? t : o;
  return {
    data: l,
    isLoading: a,
    error: f,
    actions: {
      refresh: {
        apply: s,
        isLoading: a,
        error: o
      }
    }
  };
}, ub = (e, n) => {
  var r, i, t;
  return {
    id: e.id,
    title: e.title,
    linkTo: e.path,
    description: e.description,
    bannerImage: ((r = e == null ? void 0 : e.cover) == null ? void 0 : r.url) || ((i = e.preview) == null ? void 0 : i.url) || "",
    resources: n ?? [],
    isComingSoon: n === void 0 || n.length === 0,
    keyStageSlug: qi((e == null ? void 0 : e.keyStages) ?? []),
    threads: Rt((e == null ? void 0 : e.threads) || []),
    keyArtUrl: ((t = e == null ? void 0 : e.keyArt) == null ? void 0 : t.url) || ""
  };
}, lb = async (e) => {
  const n = await Me.fetch({
    id: e
  });
  if (n instanceof Error)
    return n;
  const r = ad.safeParse(
    n
  );
  if (!r.success)
    return r.error;
  const i = await Promise.all(
    (r.data.linkedResources ?? []).map(async (l) => {
      const f = await Me.fetch({
        id: l
      });
      if (f instanceof Q && f.status === 404) {
        sn(l, e);
        return;
      }
      return f;
    }).filter(Boolean)
  );
  if (i.some((l) => l instanceof Error))
    return i.find((l) => l instanceof Error) || new Error("Unknown error in top-level resources");
  const u = i.filter(
    (l) => !(l instanceof Error)
  ).filter(
    (l) => {
      var f;
      return !!(((f = l.type) == null ? void 0 : f.id) === le.LESSON_PACK.monolithId && l.enabled);
    }
  ).filter(
    (l) => Ji.safeParse(l).success
  ).map((l) => ({
    title: l.title,
    order: l.order,
    resourceId: l.id
  }));
  return u.sort((l, f) => (l.order ?? 0) - (f.order ?? 0)), ub(
    n,
    u
  );
}, sb = "unitPreview", Pb = ({ id: e }) => {
  const n = [sb, e], {
    // we always want to be able to return something, even if it's an empty array
    data: r,
    error: i,
    isLoading: t,
    mutate: o
  } = An(n, () => lb(e)), a = async () => {
    await o();
  }, u = r instanceof Error ? void 0 : r, s = r instanceof Error ? r : i;
  return {
    data: u,
    isLoading: t,
    error: s,
    actions: {
      refresh: {
        apply: a,
        isLoading: t,
        error: i
      }
    }
  };
}, gd = O({
  resourceId: b(),
  order: K().optional(),
  title: b(),
  description: b(),
  previewImageUrl: b(),
  threads: D(b()).optional()
}), cb = gd.merge(
  O({
    canonicalUrl: b(),
    isPinned: H(),
    isAdditional: H().optional(),
    type: re([id, lt()])
  })
), fd = gd.merge(
  O({
    canonicalUrl: b(),
    isPinned: bt(),
    isAdditional: bt(),
    resources: D(b()),
    type: Y(le.LESSON_PACK.slug)
  })
), db = re([
  cb,
  fd
]), pd = O({
  slug: b().min(2),
  subjectId: b().min(1),
  displayLabel: b().min(1).optional()
}), Db = O({
  monolithUnitId: b().min(1),
  subject: pd,
  unitTitle: b(),
  unitDescription: b().optional(),
  resources: D(db),
  canonicalUrl: b(),
  type: re([id, lt()]),
  keyArt: b().optional()
});
O({
  monolithUnitId: b().min(1),
  subject: pd,
  unitTitle: b()
});
const mb = fd.pick({
  resourceId: !0,
  title: !0,
  order: !0
}), Rb = O({
  id: b(),
  title: b(),
  description: b().optional(),
  linkTo: b(),
  bannerImage: b().optional(),
  resources: mb.array(),
  isComingSoon: H(),
  keyStageSlug: D(sd),
  threads: D(cd).optional(),
  keyArtUrl: b().optional()
}), zb = _e(["upcoming", "complete"]), Cb = ({
  children: e
}) => /* @__PURE__ */ wd(im, { value: { provider: () => /* @__PURE__ */ new Map() }, children: e });
export {
  Q as ApiError,
  Tb as ConflictingPlanErrorResponseSchema,
  _h as CreateCurriculumPayloadSchema,
  bh as CreateCurriculumResponseSchema,
  Lv as CurrentUserSchema,
  Xc as CurriculumSchema,
  yh as DeleteCurriculumResponseSchema,
  Cb as DomainCacheProvider,
  yb as DuplicateCurriculumPayloadSchema,
  Wt as IndividualUserSchema,
  sd as KeyStagesSlugSchema,
  fd as LessonPackResourceSchema,
  zb as LessonStatusSchema,
  cb as LinkedResourceSchema,
  Cv as MultiSchoolUserSchema,
  id as ResourceTypeSlugSchema,
  zv as SchoolUserSchema,
  jv as StaffUserSchema,
  Mh as SubjectListSchema,
  ed as SubjectSchema,
  st as SubjectStatusSchema,
  cd as ThreadSlugSchema,
  Db as UnitPlanSchema,
  Rb as UnitPreviewSchema,
  qc as UnknownApiError,
  _b as UpdateCurriculumPayloadSchema,
  Ib as UpdateSubjectStatusPayloadSchema,
  Qh as getSubjectPlanSchema,
  Xh as updateSubjectPlanResponseSchema,
  wb as updateSubjectPlanSchema,
  bb as useCurrentUser,
  Sb as useCurriculum,
  Wi as useCurriculumList,
  $b as useExploreSubjectUnit,
  Eb as useGenericSubject,
  kb as useGenericSubjectList,
  Nb as useSubject,
  Ob as useSubjectList,
  Ab as useSubjectPlan,
  Ub as useUnitPlan,
  Pb as useUnitPreview
};
//# sourceMappingURL=index.js.map
